<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="500"
    height="500"
    id="milestone-virtual"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 351.3 359.1"
    role="presentation"
    aria-labelledby="firstvirtualjamstack"
  >
    <title id="firstvirtualjamstack">First Virtual Jamstack Conf Event</title>
    <g id="Conference">
      <g id="FloatingPaper">
        <g id="XMLID_5848" data-name="XMLID 5848">
          <g id="XMLID_5853" data-name="XMLID 5853">
            <path
              id="XMLID_5854"
              data-name="XMLID 5854"
              class="cls-1"
              d="M326.8,282l-4.6-2.7a1.4,1.4,0,0,1-.6-1.2v-8c0-.4.3-.7.6-.5l4.6,2.7a1.4,1.4,0,0,1,.6,1.2v8C327.4,282,327.1,282.2,326.8,282Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5849" data-name="XMLID 5849">
            <path
              id="XMLID_5850"
              data-name="XMLID 5850"
              class="cls-1"
              d="M327,282.5h-.4l-4.6-2.7a1.8,1.8,0,0,1-.8-1.5v-8c0-.4.1-.7.4-.8a1.1,1.1,0,0,1,.8,0l4.6,2.7a1.8,1.8,0,0,1,.8,1.5v8c0,.4-.1.7-.4.8Zm0-.8h0v-8a.9.9,0,0,0-.4-.8l-4.6-2.7h0v8a.9.9,0,0,0,.4.8Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_5825" data-name="XMLID 5825">
          <g id="XMLID_5841" data-name="XMLID 5841">
            <g id="XMLID_5846" data-name="XMLID 5846">
              <path
                id="XMLID_5847"
                data-name="XMLID 5847"
                class="cls-2"
                d="M324.5,292.5,313,285.9a1.1,1.1,0,0,1-.5-.9V270.1c0-.4.2-.5.5-.4l11.5,6.6a1.1,1.1,0,0,1,.5.9v14.9C325,292.5,324.8,292.7,324.5,292.5Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_5842" data-name="XMLID 5842">
              <path
                id="XMLID_5843"
                data-name="XMLID 5843"
                class="cls-1"
                d="M324.7,293h-.4l-11.5-6.6a1.7,1.7,0,0,1-.7-1.3v-15a.7.7,0,0,1,.4-.7h.7l11.5,6.6a1.7,1.7,0,0,1,.7,1.3v14.9a.7.7,0,0,1-.4.7ZM313,270.1V285a.9.9,0,0,0,.3.6l11.4,6.6V277.3a.9.9,0,0,0-.3-.6Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_5838" data-name="XMLID 5838">
            <g id="XMLID_5839" data-name="XMLID 5839">
              <path
                id="XMLID_5840"
                data-name="XMLID 5840"
                class="cls-1"
                d="M315,274.1l-.4.7,8,4.6.4-.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_5835" data-name="XMLID 5835">
            <g id="XMLID_5836" data-name="XMLID 5836">
              <path
                id="XMLID_5837"
                data-name="XMLID 5837"
                class="cls-1"
                d="M315.1,276.3l-.4.7,7.9,4.6.4-.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_5832" data-name="XMLID 5832">
            <g id="XMLID_5833" data-name="XMLID 5833">
              <path
                id="XMLID_5834"
                data-name="XMLID 5834"
                class="cls-1"
                d="M315,278.4l-.4.7,8,4.6.4-.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_5829" data-name="XMLID 5829">
            <g id="XMLID_5830" data-name="XMLID 5830">
              <path
                id="XMLID_5831"
                data-name="XMLID 5831"
                class="cls-1"
                d="M315.1,280.6l-.4.7,8,4.6.4-.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_5826" data-name="XMLID 5826">
            <g id="XMLID_5827" data-name="XMLID 5827">
              <path
                id="XMLID_5828"
                data-name="XMLID 5828"
                class="cls-1"
                d="M315,282.7l-.4.7,8,4.6.4-.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Misc">
        <g id="XMLID_5801" data-name="XMLID 5801">
          <g id="XMLID_5806" data-name="XMLID 5806">
            <path
              id="XMLID_5807"
              data-name="XMLID 5807"
              class="cls-2"
              d="M280.5,213.1l-4.6-2.7a1.4,1.4,0,0,1-.6-1.2v-7c0-.4.3-.7.6-.5l4.6,2.7a1.4,1.4,0,0,1,.6,1.2v7C281.1,213,280.9,213.3,280.5,213.1Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5802" data-name="XMLID 5802">
            <path
              id="XMLID_5803"
              data-name="XMLID 5803"
              class="cls-1"
              d="M280.8,213.5h-.4l-4.6-2.7a1.8,1.8,0,0,1-.8-1.5v-7c0-.4.1-.7.4-.8h.8l4.6,2.7a1.8,1.8,0,0,1,.8,1.5v7c0,.4-.1.7-.4.8Zm-.1-.8h0v-7a.9.9,0,0,0-.4-.8l-4.6-2.7h0v7a.9.9,0,0,0,.4.8Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_5792" data-name="XMLID 5792">
          <g id="XMLID_5799" data-name="XMLID 5799">
            <path
              id="XMLID_5800"
              data-name="XMLID 5800"
              class="cls-1"
              d="M284.9,220.6l-6.3-3.6a.9.9,0,0,1-.3-.7v-9c0-.3.2-.4.3-.3l6.3,3.6a.9.9,0,0,1,.3.7v9Q285.2,220.8,284.9,220.6Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5793" data-name="XMLID 5793">
            <path
              id="XMLID_5794"
              data-name="XMLID 5794"
              class="cls-1"
              d="M285,221.1h-.3l-6.3-3.6a1.2,1.2,0,0,1-.5-1v-9a.7.7,0,0,1,.3-.6h.6l6.3,3.6a1.2,1.2,0,0,1,.5,1v9a.7.7,0,0,1-.3.6Zm.1-.8-.2.3Zm-6.5-12.7v8.7c0,.1.1.3.2.3l6.1,3.5v-8.7c0-.1-.1-.3-.2-.3Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </g>
      <g id="ThreeDots_2" data-name="ThreeDots 2">
        <g id="XMLID_5489" data-name="XMLID 5489">
          <g id="XMLID_5494" data-name="XMLID 5494">
            <path
              id="XMLID_5495"
              data-name="XMLID 5495"
              class="cls-3"
              d="M105,187.9h0l-4.2-2.4-.5-.3c-1.7-.8-4.1-.4-6.7,1.4a19.4,19.4,0,0,0-7.5,13.2,7.4,7.4,0,0,0,1.4,5.6l5.3,5.9,4.2,2.4h.1l.3-9.9a19.3,19.3,0,0,0,5.8-11.7l.2-.2Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5490" data-name="XMLID 5490">
            <path
              id="XMLID_5491"
              data-name="XMLID 5491"
              class="cls-1"
              d="M97,213.9h-.2l-4.3-2.4-5.4-6a8.2,8.2,0,0,1-1.3-5.7,19.7,19.7,0,0,1,7.7-13.5c2.6-1.8,5.1-2.3,7.1-1.4l.5.3,4.1,2.3a.5.5,0,0,1,.2.6l-1.8,3.8h-.1a20.4,20.4,0,0,1-5.8,11.8l-.3,10H97Zm-4-3.1,3.6,2,.3-9.5H97a18.9,18.9,0,0,0,5.7-11.5h0l.2-.3,1.6-3.4-3.9-2.2-.5-.3c-1.7-.8-3.9-.3-6.3,1.3a19,19,0,0,0-7.4,12.9,7.1,7.1,0,0,0,1.3,5.3Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_5482" data-name="XMLID 5482">
          <g id="XMLID_5487" data-name="XMLID 5487">
            <path
              id="XMLID_5488"
              data-name="XMLID 5488"
              class="cls-2"
              d="M101.4,197.2l.2-.5a14.9,14.9,0,0,0,1.3-6.9.9.9,0,0,0-.1-.5l1.6-1.5v-.2l-3.7-2.2-.3-.2c-1.3-.7-2.9-.6-4.8.2a14.4,14.4,0,0,0-5.8,5.1Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5483" data-name="XMLID 5483">
            <path
              id="XMLID_5484"
              data-name="XMLID 5484"
              class="cls-1"
              d="M101.6,197.8l-12.3-7.2.3-.4a14.3,14.3,0,0,1,6-5.2,6.1,6.1,0,0,1,5.1-.2l.3.2,3.8,2.2a.5.5,0,0,1,.2.4c0,.2,0,.3-.2.4l-1.5,1.4v.3a15.7,15.7,0,0,1-1.3,7.1Zm-11.2-7.4,10.8,6.3h.1a14.1,14.1,0,0,0,1.3-6.7.9.9,0,0,0-.1-.5v-.2l1.5-1.4-3.5-2-.3-.2a5.2,5.2,0,0,0-4.4.2A13.1,13.1,0,0,0,90.4,190.4Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_5452" data-name="XMLID 5452">
          <g id="XMLID_5475" data-name="XMLID 5475">
            <g id="XMLID_5480" data-name="XMLID 5480">
              <path
                id="XMLID_5481"
                data-name="XMLID 5481"
                class="cls-1"
                d="M91.7,207.6c-1-1.2-1.5-3.1-1.4-5.6a19.4,19.4,0,0,1,7.5-13.2c5.1-3.6,9.5-1.5,9.5,4.3a18.3,18.3,0,0,1-8.5,14.8l-.4.2a14.9,14.9,0,0,0-.3,4.2c.1.7-.8,1.6-1.2,1.2Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_5476" data-name="XMLID 5476">
              <path
                id="XMLID_5477"
                data-name="XMLID 5477"
                class="cls-1"
                d="M97.2,214l-.5-.2-5.3-5.9a8,8,0,0,1-1.4-5.8,19.7,19.7,0,0,1,7.7-13.5c2.6-1.9,5.3-2.3,7.2-1.3s2.9,3.1,2.9,6c0,5.6-3.9,12.3-8.7,15.1h-.3a9.7,9.7,0,0,0-.2,3.8,1.5,1.5,0,0,1-.9,1.6ZM92,207.4l5.3,5.9.2-.2c.2-.2.3-.4.2-.6a10.5,10.5,0,0,1,.3-4.3V208h.1l.4-.2c4.6-2.7,8.3-9.1,8.3-14.4,0-2.6-.9-4.4-2.4-5.3s-4-.4-6.4,1.3a19,19,0,0,0-7.4,12.9,8.4,8.4,0,0,0,1.4,5.1Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_5453" data-name="XMLID 5453">
            <g id="XMLID_5468" data-name="XMLID 5468">
              <g id="XMLID_5473" data-name="XMLID 5473">
                <path
                  id="XMLID_5474"
                  data-name="XMLID 5474"
                  class="cls-1"
                  d="M101.8,196.5c0,.9.7,1.3,1.5.8a3.3,3.3,0,0,0,1.5-2.5c0-.9-.7-1.3-1.5-.8A2.9,2.9,0,0,0,101.8,196.5Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_5469" data-name="XMLID 5469">
                <path
                  id="XMLID_5470"
                  data-name="XMLID 5470"
                  class="cls-3"
                  d="M102.6,198l-.6-.2a1.4,1.4,0,0,1-.6-1.3,3.7,3.7,0,0,1,1.7-2.9,1.4,1.4,0,0,1,1.4-.1,1.4,1.4,0,0,1,.6,1.3,3.7,3.7,0,0,1-1.7,2.9A1.1,1.1,0,0,1,102.6,198Zm1.3-3.8h-.5a2.9,2.9,0,0,0-1.3,2.2,1.4,1.4,0,0,0,.2.6c.1.1.4,0,.6-.1a2.9,2.9,0,0,0,1.3-2.2,1.4,1.4,0,0,0-.2-.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_5461" data-name="XMLID 5461">
              <g id="XMLID_5466" data-name="XMLID 5466">
                <path
                  id="XMLID_5467"
                  data-name="XMLID 5467"
                  class="cls-1"
                  d="M97.4,199.1c0,.9.7,1.3,1.5.8a3.3,3.3,0,0,0,1.5-2.5c0-.9-.7-1.3-1.5-.8A2.9,2.9,0,0,0,97.4,199.1Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_5462" data-name="XMLID 5462">
                <path
                  id="XMLID_5463"
                  data-name="XMLID 5463"
                  class="cls-3"
                  d="M98.2,200.5l-.6-.2A1.4,1.4,0,0,1,97,199a3.7,3.7,0,0,1,1.7-2.9,1.4,1.4,0,0,1,1.4-.1,1.4,1.4,0,0,1,.6,1.3,3.7,3.7,0,0,1-1.7,2.9A1.1,1.1,0,0,1,98.2,200.5Zm1.3-3.8H99a2.9,2.9,0,0,0-1.3,2.2,1.4,1.4,0,0,0,.2.6c.1.1.4,0,.6-.1a2.9,2.9,0,0,0,1.3-2.2,1.4,1.4,0,0,0-.2-.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_5454" data-name="XMLID 5454">
              <g id="XMLID_5459" data-name="XMLID 5459">
                <path
                  id="XMLID_5460"
                  data-name="XMLID 5460"
                  class="cls-1"
                  d="M93,201.6c0,.9.7,1.3,1.5.8a3.3,3.3,0,0,0,1.5-2.5c0-.9-.7-1.3-1.5-.8A2.9,2.9,0,0,0,93,201.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_5455" data-name="XMLID 5455">
                <path
                  id="XMLID_5456"
                  data-name="XMLID 5456"
                  class="cls-3"
                  d="M93.8,203l-.6-.2a1.4,1.4,0,0,1-.6-1.3,3.7,3.7,0,0,1,1.7-2.9,1.4,1.4,0,0,1,1.4-.1,1.4,1.4,0,0,1,.6,1.3,3.7,3.7,0,0,1-1.7,2.9A1.1,1.1,0,0,1,93.8,203Zm1.3-3.8h-.5a2.9,2.9,0,0,0-1.3,2.2,1.4,1.4,0,0,0,.2.6c.1.1.4,0,.6-.1a2.9,2.9,0,0,0,1.3-2.2,1.4,1.4,0,0,0-.2-.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_5447" data-name="XMLID 5447">
          <g id="XMLID_5450" data-name="XMLID 5450">
            <path
              id="XMLID_5451"
              data-name="XMLID 5451"
              class="cls-3"
              d="M87.1,204.8l5.3,3Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5448" data-name="XMLID 5448">
            <path
              id="XMLID_5449"
              data-name="XMLID 5449"
              class="cls-1"
              d="M87.4,204.5l-.4.7,5.3,3,.4-.7Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_5442" data-name="XMLID 5442">
          <g id="XMLID_5445" data-name="XMLID 5445">
            <path
              id="XMLID_5446"
              data-name="XMLID 5446"
              class="cls-3"
              d="M86.1,200.4l5.3,3Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5443" data-name="XMLID 5443">
            <path
              id="XMLID_5444"
              data-name="XMLID 5444"
              class="cls-1"
              d="M86.3,200l-.4.7,5.3,3,.4-.7Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_5437" data-name="XMLID 5437">
          <g id="XMLID_5440" data-name="XMLID 5440">
            <path
              id="XMLID_5441"
              data-name="XMLID 5441"
              class="cls-3"
              d="M95.5,185.3l5.3,3Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_5438" data-name="XMLID 5438">
            <path
              id="XMLID_5439"
              data-name="XMLID 5439"
              class="cls-1"
              d="M95.7,184.9l-.4.7,5.3,3,.4-.7Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </g>
      <g id="ThreeDots_1" data-name="ThreeDots 1">
        <g id="XMLID_4823" data-name="XMLID 4823">
          <g id="XMLID_4829" data-name="XMLID 4829">
            <path
              id="XMLID_4830"
              data-name="XMLID 4830"
              class="cls-3"
              d="M176.1,239.6a.6.6,0,0,0-.1-.4l1.4-1.3h0l-3.3-1.9h-.3a4.3,4.3,0,0,0-4,.2c-4.3,1.9-7.9,7.8-7.9,12.7,0,2.2.8,3.8,2,4.5l3.6,2h.1l.7-1.5-.7-.4,1.3-.6.3-.2a5,5,0,0,1,.2,3.2c0,.3.1.4.2.4l3.3,1.9h.1l.3-.9-.2-3.9h-1.8l3.3-7.5A11.5,11.5,0,0,0,176.1,239.6Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_4825" data-name="XMLID 4825">
            <path
              id="XMLID_4826"
              data-name="XMLID 4826"
              class="cls-1"
              d="M173.2,258.3H173l-3.3-1.9a.6.6,0,0,1-.4-.7h0a7,7,0,0,0-.1-2.5l-.6.3.3.2-.9,1.8-.3.3h-.4l-3.6-2c-1.4-.9-2.2-2.6-2.2-4.9,0-5,3.8-11.1,8.1-13a5.2,5.2,0,0,1,4.4-.2l.3.2,3.2,1.9a.5.5,0,0,1,.2.4.6.6,0,0,1-.1.4l-1.2,1.2v.2a10.8,10.8,0,0,1-1.2,6.1l-3.1,7h1.6l.2,4.4-.4,1-.3.3C173.3,258.3,173.2,258.3,173.2,258.3Zm-3.2-2.6,3,1.7.2-.5v-3.5h-2l3.6-8.1a12.4,12.4,0,0,0,1.1-5.7V239l1.2-1.2-2.9-1.7h-.3a4,4,0,0,0-3.7.2c-4.1,1.8-7.6,7.6-7.6,12.3,0,2,.6,3.5,1.8,4.2l3.3,1.9.4-.8-1.1-.6.8-.3,1.3-.6.3-.2.4-.2.2.4a7.8,7.8,0,0,1,.1,3.4Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_4816" data-name="XMLID 4816">
          <g id="XMLID_4821" data-name="XMLID 4821">
            <path
              id="XMLID_4822"
              data-name="XMLID 4822"
              class="cls-2"
              d="M174.8,246l.2-.5a13.2,13.2,0,0,0,1.1-5.9.6.6,0,0,0-.1-.4l1.4-1.3h0l-3.3-1.9h-.3a4.3,4.3,0,0,0-4,.2,12.2,12.2,0,0,0-4.9,4.4Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_4817" data-name="XMLID 4817">
            <path
              id="XMLID_4818"
              data-name="XMLID 4818"
              class="cls-1"
              d="M174.9,246.5l-10.6-6.2.3-.4a13,13,0,0,1,5.1-4.5,5.2,5.2,0,0,1,4.4-.2l.3.2,3.2,1.9a.5.5,0,0,1,.2.4c0,.2,0,.3-.1.4l-1.2,1.2v.3a10.8,10.8,0,0,1-1.2,6.1Zm-9.4-6.4,9.1,5.3a12.4,12.4,0,0,0,1.1-5.7v-.6l1.2-1.2-2.9-1.7h-.3a4,4,0,0,0-3.7.2,10.8,10.8,0,0,0-4.5,3.7Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_4808" data-name="XMLID 4808">
          <g id="XMLID_4813" data-name="XMLID 4813">
            <path
              id="XMLID_4814"
              data-name="XMLID 4814"
              class="cls-1"
              d="M178.4,247.5a13.2,13.2,0,0,0,1.1-5.9c-.3-3.6-2.9-5.2-6.2-3.7s-7.9,7.8-7.9,12.7,3.2,6.3,7.1,4.1l.3-.2a5,5,0,0,1,.2,3.2c-.1.7.7.6,1-.1Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_4809" data-name="XMLID 4809">
            <path
              id="XMLID_4810"
              data-name="XMLID 4810"
              class="cls-1"
              d="M173.3,258.4h-.2a.7.7,0,0,1-.5-.8h0a7,7,0,0,0-.1-2.5c-2,1.1-3.9,1.3-5.3.5s-2.3-2.6-2.3-4.9c0-5,3.8-11.1,8.1-13a5,5,0,0,1,4.6-.1,4.8,4.8,0,0,1,2.2,4.1,10.8,10.8,0,0,1-1.2,6.1l-4.4,9.9A.9.9,0,0,1,173.3,258.4Zm-.3-4.6.2.4a9.3,9.3,0,0,1,.3,3.3l.2-.3,4.4-9.9a12.4,12.4,0,0,0,1.1-5.7,4.4,4.4,0,0,0-1.8-3.5,4.1,4.1,0,0,0-3.9.1c-4.1,1.8-7.6,7.6-7.6,12.3,0,2,.7,3.5,1.9,4.2s2.8.5,4.6-.5l.3-.2Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_4782" data-name="XMLID 4782">
          <g id="XMLID_4800" data-name="XMLID 4800">
            <g id="XMLID_4805" data-name="XMLID 4805">
              <path
                id="XMLID_4806"
                data-name="XMLID 4806"
                class="cls-1"
                d="M170,247.9a2.6,2.6,0,0,1-1.2,2.1c-.7.4-1.2.1-1.2-.7a2.6,2.6,0,0,1,1.2-2.1C169.5,246.8,170,247.1,170,247.9Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_4801" data-name="XMLID 4801">
              <path
                id="XMLID_4802"
                data-name="XMLID 4802"
                class="cls-3"
                d="M168.3,250.5h-.5a1.1,1.1,0,0,1-.6-1.1,2.9,2.9,0,0,1,1.4-2.4,1.2,1.2,0,0,1,1.3-.1,1.1,1.1,0,0,1,.6,1.1,2.9,2.9,0,0,1-1.4,2.4A1.1,1.1,0,0,1,168.3,250.5Zm1.1-3.1h-.3a2.2,2.2,0,0,0-1,1.8c0,.2.1.4.2.4h.5a2.2,2.2,0,0,0,1-1.8c0-.2-.1-.4-.2-.4Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_4792" data-name="XMLID 4792">
            <g id="XMLID_4797" data-name="XMLID 4797">
              <path
                id="XMLID_4798"
                data-name="XMLID 4798"
                class="cls-1"
                d="M173.7,245.7a2.6,2.6,0,0,1-1.2,2.1c-.7.4-1.2.1-1.2-.7a2.6,2.6,0,0,1,1.2-2.1C173.2,244.7,173.7,245,173.7,245.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_4793" data-name="XMLID 4793">
              <path
                id="XMLID_4794"
                data-name="XMLID 4794"
                class="cls-3"
                d="M171.9,248.4h-.5a1.1,1.1,0,0,1-.6-1.1,2.9,2.9,0,0,1,1.4-2.4,1.2,1.2,0,0,1,1.3-.1,1.1,1.1,0,0,1,.6,1.1,2.9,2.9,0,0,1-1.4,2.4Zm1.1-3.1h-.3a2.2,2.2,0,0,0-1,1.8c0,.2.1.4.2.4h.5a2.2,2.2,0,0,0,1-1.8c0-.2-.1-.4-.2-.4Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_4783" data-name="XMLID 4783">
            <g id="XMLID_4789" data-name="XMLID 4789">
              <path
                id="XMLID_4790"
                data-name="XMLID 4790"
                class="cls-1"
                d="M177.3,243.7a2.6,2.6,0,0,1-1.2,2.1c-.7.4-1.2.1-1.2-.7a2.6,2.6,0,0,1,1.2-2.1C176.8,242.6,177.3,242.9,177.3,243.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_4785" data-name="XMLID 4785">
              <path
                id="XMLID_4786"
                data-name="XMLID 4786"
                class="cls-3"
                d="M175.6,246.3h-.5a1.1,1.1,0,0,1-.6-1.1,2.9,2.9,0,0,1,1.4-2.4,1.2,1.2,0,0,1,1.3-.1,1.1,1.1,0,0,1,.6,1.1,2.9,2.9,0,0,1-1.4,2.4Zm1.1-3.1h-.3a2.2,2.2,0,0,0-1,1.8c0,.2.1.4.2.4h.5a2.2,2.2,0,0,0,1-1.8c0-.2-.1-.4-.2-.4Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_4285" data-name="XMLID 4285">
          <g id="XMLID_4780" data-name="XMLID 4780">
            <path
              id="XMLID_4781"
              data-name="XMLID 4781"
              class="cls-3"
              d="M162,249.5l3.4,2Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_4778" data-name="XMLID 4778">
            <path
              id="XMLID_4779"
              data-name="XMLID 4779"
              class="cls-1"
              d="M162.3,249.1l-.4.7,3.5,2,.4-.7Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_4279" data-name="XMLID 4279">
          <g id="XMLID_4283" data-name="XMLID 4283">
            <path
              id="XMLID_4284"
              data-name="XMLID 4284"
              class="cls-3"
              d="M170.1,235.8l3.4,2Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_4280" data-name="XMLID 4280">
            <path
              id="XMLID_4281"
              data-name="XMLID 4281"
              class="cls-1"
              d="M170.3,235.4l-.4.7,3.5,2,.4-.7Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </g>
      <g id="Screen">
        <path
          id="Shadows"
          class="cls-1"
          d="M166.6,175.3l27,15.7-.9.6L165.5,176Zm34.6,10.6a1.6,1.6,0,0,1-.6.8l-27-15.6,1.1-.4Zm-2.1,1.9-1.1.6-27-15.5.9-.7Zm-2.8,1.7-1,.4-27-15.5.9-.6Zm-19.8,11.3h-.3l-26.4-15.2.5-.7,18.5,10.7.3-.2,53.5,31v.2l-.8.4Zm-11-3.3,1-.6L220.2,228l-1,.6Zm-2.8,1.6,1-.5,53.5,30.9v.2l-.7.4Zm-2.6,1.5.9-.4,53.7,30.9-.9.6Zm-2.8,1.6.9-.5,53.7,31.1-.9.4Zm-2.6,1.7.9-.6,53.7,31-.9.5Zm-2.8,1.5.9-.6,53.7,31.1h-.2l-.7.5Zm-2.7,1.6,1-.6,53.7,31-1,.6Zm-2.8,1.6,1-.5L200.9,239h-.1l-.7.5Zm-2.8,1.5,1.1-.5,53.6,30.9v.2l-1,.5Zm-1.8,2.2.4-.8,53.3,30.7-.2.2-.9.3Zm-.5,1.7,50.5,29.2h-2.1l-48.2-27.8A3.2,3.2,0,0,0,141.3,214Zm49.1-21.1H190l-27-15.6,1-.7,19.7,11.5h.6l49.5,28.6c0,.3.2.8,0,1.1Zm-2.8,1.7h-.3l-27.1-15.5,1-.7,18.6,10.7h.3L233.2,220l-.6.8Zm42.5,27.6-45.2-26.1-.3.2-27.1-15.7,1-.5L177,190.9l.3-.2L231,221.6Zm-48-24.5h-.3l-27-15.5.9-.6,18.5,10.7h.3l53.7,31-.9.5Zm-2.6,1.5-.3.3-27-15.6.9-.7L171.6,194l.3-.2,53.7,31.1-.9.4Zm33.8,3,27.1,15.6-1,.7-27.1-15.7ZM248,212.7c-.2.3-.3.6-.7.8l-27-15.5,1.1-.5Zm-2.2,1.9-1.1.6-27-15.5.9-.6Zm-2.8,1.7-.9.5-27-15.6.9-.6Zm-19.7,11.3c-.2,0-.2.2-.3.2l-26.4-15.2a2,2,0,0,1,.4-.8l18.5,10.7.3-.2,53.6,30.9-.2.2-.7.5Zm-11-3.2.9-.7,53.7,31.1-.9.6Zm-2.8,1.5.9-.4L264,256.3l-.2.2-.6.5Zm-2.7,1.6,1-.5,53.7,30.9-1,.6ZM204,229l1-.4,53.7,31-1,.5Zm-2.6,1.7.9-.6L256,261.2l-.9.4Zm-2.8,1.6.9-.6,53.7,31v.2l-.8.4Zm-2.6,1.5.9-.6,53.7,31.1-.9.6Zm-2.8,1.6.9-.5,53.6,30.9-.2.2-.6.4Zm-2.8,1.5,1.1-.4L245,267.4h0l-.9.5Zm-1.9,2.2a3.5,3.5,0,0,1,.5-.8l53.2,30.8h-.1a1.7,1.7,0,0,1-1,.3Zm-.5,1.7L238.5,270h-2l-48.3-27.8a3.2,3.2,0,0,0-.2-1.4Zm49.1-21.1-.3.2-27-15.7.9-.6L230.4,215h.6l49.6,28.6v1.1Zm-2.8,1.7-.3.2-27-15.7.9-.6L226.5,216l.4-.2,53,30.9a1.6,1.6,0,0,1-.6.8ZM276.8,249l-45.1-26h-.3l-27.2-15.7,1.1-.4,18.4,10.7.4-.2,53.7,30.9Zm-47.9-24.5-.3.2-27.1-15.5,1-.7L221,219.2h.3l53.7,31-1,.5Zm-2.7,1.6-.3.3-27-15.7.9-.6,18.5,10.7.3-.2,53.7,31.1-.9.4Z"
          transform="translate(0 0)"
        />
        <g>
          <path
            class="cls-2"
            d="M169.5,219.7a.7.7,0,0,0,.4.5l49.6,28.6a3.5,3.5,0,0,0,3-.1l9.5-5.5-27.3-15.8L180,213.2l-9.9,5.7A.9.9,0,0,0,169.5,219.7Zm52.3,26.9,4.3-2.7.4.7-4.3,2.7-1.2.3a2,2,0,0,1-1.1-.3l-42.7-24.4.4-.7,42.7,24.4A1.4,1.4,0,0,0,221.8,246.6Zm-49.1-27.9,4.4-2.6.4.7-4.4,2.6c-.1,0-.1.2-.1.2v.2l3.2,1.8-.4.7-3.2-1.8a1.1,1.1,0,0,1-.3-1.5l.3-.3Z"
            transform="translate(0 0)"
          />
          <rect class="cls-3" x="220.5" y="249.7" width="0.6" height="2.9" />
          <rect class="cls-3" x="171" y="221.5" width="0.6" height="2.9" />
          <polygon
            class="cls-2"
            points="157.9 111.7 161 109.9 159.4 108.9 156.3 110.8 157.9 111.7"
          />
          <path
            class="cls-2"
            d="M155.5,110.3l3.1-1.8-5.6-3.2h-.2c-.1,0-.2,0-.2.1l-3,1.6Z"
            transform="translate(0 0)"
          />
          <polygon
            class="cls-2"
            points="261.9 176.3 261.9 249.3 265 247.4 265 174.8 262 176.5 261.9 176.3"
          />
          <path
            class="cls-2"
            d="M264.1,169.6,161.8,110.3l-3.1,1.9,101.9,58.9a2.9,2.9,0,0,1,1.3,2.4v2.2l3.1-1.9v-2.5a1.3,1.3,0,0,0-.1-.6l-3.1,1.8-.4-.6,3.2-1.9C264.4,169.8,264.3,169.6,264.1,169.6Z"
            transform="translate(0 0)"
          />
          <polygon
            class="cls-2"
            points="261.9 250 261.9 252.2 265 250.3 265 248.4 262 250.2 261.9 250"
          />
          <path
            class="cls-2"
            d="M261.9,253.1v5.3l2.9-1.6a.8.8,0,0,0,.2-.5v-5.1Z"
            transform="translate(0 0)"
          />
          <path class="cls-3" d="M260.1,252.4V172.6L149.5,108.8v79.7Z" transform="translate(0 0)" />
          <rect
            class="cls-3"
            x="205.5"
            y="214.9"
            width="0.6"
            height="16.66"
            transform="translate(-90.3 290.4) rotate(-60.1)"
          />
          <polygon
            class="cls-3"
            points="235.2 244.7 232.8 243.3 232.5 243.8 234.9 245.2 235.2 244.7"
          />
          <path
            class="cls-1"
            d="M177.2,222.9l42.7,24.4a2,2,0,0,0,1.1.3l1.2-.3,4.3-2.7-.4-.7-4.3,2.7a1.4,1.4,0,0,1-1.5,0l-42.7-24.4Z"
            transform="translate(0 0)"
          />
          <path
            class="cls-1"
            d="M172.2,219.6a1.1,1.1,0,0,0,.5.9l3.2,1.8.4-.7-3.2-1.8v-.2s0-.2.1-.2l4.4-2.6-.4-.7-4.4,2.6A1.1,1.1,0,0,0,172.2,219.6Z"
            transform="translate(0 0)"
          />
          <path
            class="cls-1"
            d="M265.8,174.3v-3a1.8,1.8,0,0,0-.2-1h.1l-.4-.7h0a1.8,1.8,0,0,0-.8-.7L153.3,104.7a.9.9,0,0,0-1.2,0l-3.6,2h-.1a1.1,1.1,0,0,0-.6,1.2v85a2.9,2.9,0,0,0,1.3,2.4l30.1,17.3-9.5,5.5a2,2,0,0,0-1,1.5h.1v3.4a1.3,1.3,0,0,0,.8,1.2l49.6,28.6,1.7.6a3.8,3.8,0,0,0,2.1-.5l13-7.5,24.2,14h.2l.5.3h.5l.3-.2,3.6-2a1.7,1.7,0,0,0,.5-1.2v-8.3h0Zm-113-69.1h.2l5.6,3.2-3.1,1.8-5.9-3.4,3-1.6Zm109,67.3,3.1-1.8a1.3,1.3,0,0,1,.1.6v2.5l-3.1,1.9v-2.2a2.9,2.9,0,0,0-1.3-2.4L158.7,112.2l3.1-1.9,102.3,59.3c.2,0,.3.2.5.4l-3.2,1.9ZM161,109.9l-3.1,1.8-1.6-.9,3.1-1.9Zm51.2,118-.3.5-14.4-8.3.3-.5ZM149.5,108.8,260,172.6v79.8L149.5,188.5Zm55.2,118.6L232,243.2l-9.5,5.5a3.5,3.5,0,0,1-3,.1l-49.6-28.6a.7.7,0,0,1-.4-.5.9.9,0,0,1,.6-.8l9.9-5.7ZM171,221.5h.6v2.9H171Zm49.5,28.2h.6v2.9h-.6Zm12-5.9.3-.5,2.4,1.4-.3.5Zm32.3,13-2.9,1.6v-5.3l3.1-1.9v5.1a.8.8,0,0,1-.2.5Zm.2-6.5-3.1,1.9v-2l3-1.8Zm0-2.9-3.1,1.9V176.4l.2.2,2.9-1.8Z"
            transform="translate(0 0)"
          />
          <rect
            class="cls-1"
            x="227.3"
            y="140.8"
            width="0.8"
            height="7.9"
            transform="translate(-11.5 269.5) rotate(-60)"
          />
          <rect
            class="cls-1"
            x="245.7"
            y="141.3"
            width="0.8"
            height="28.2"
            transform="translate(-11.6 290.8) rotate(-60)"
          />
          <rect class="cls-1" x="267.7" y="238.2" width="0.8" height="16" />
        </g>
      </g>
      <g id="Screen_Illustrations" data-name="Screen Illustrations">
        <g id="XMLID_2527" data-name="XMLID 2527">
          <g id="XMLID_2532" data-name="XMLID 2532">
            <path
              id="XMLID_2533"
              data-name="XMLID 2533"
              class="cls-3"
              d="M229.8,224.3l-64-36.9a3,3,0,0,1-1.2-2.2V126.9c0-.8.5-1.2,1.2-.9l64,36.9a3,3,0,0,1,1.2,2.2v58.3C230.9,224.3,230.4,224.6,229.8,224.3Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_2528" data-name="XMLID 2528">
            <path
              id="XMLID_2529"
              data-name="XMLID 2529"
              class="cls-2"
              d="M230.2,224.7l-.6-.2-64-36.9a3.1,3.1,0,0,1-1.3-2.5V126.9a1.1,1.1,0,0,1,.6-1.2.9.9,0,0,1,1.1.1l64,36.9a3.1,3.1,0,0,1,1.3,2.5v58.2a1.1,1.1,0,0,1-.6,1.2Zm-.3-.7h.5c.2-.1.2-.3.2-.7V165.1a2.6,2.6,0,0,0-1-1.9l-64-36.9h-.5c-.2.1-.2.3-.2.7v58.3a2.6,2.6,0,0,0,1,1.9Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_2520" data-name="XMLID 2520">
          <g id="XMLID_2525" data-name="XMLID 2525">
            <path
              id="XMLID_2526"
              data-name="XMLID 2526"
              class="cls-3"
              d="M228.3,163.5v55.6c0,.8-.6,1.1-1.2.7L166,184.5c-.7-.4-1.2-.1-1.2.7a2.6,2.6,0,0,0,1.2,2.1l63.8,36.8c.7.4,1.2.1,1.2-.7V165a2.6,2.6,0,0,0-1.2-2.1h-.2C228.8,162.4,228.3,162.7,228.3,163.5Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_2521" data-name="XMLID 2521">
            <path
              id="XMLID_2522"
              data-name="XMLID 2522"
              class="cls-2"
              d="M230.3,224.7l-.7-.2-63.8-36.8a2.9,2.9,0,0,1-1.4-2.4,1.6,1.6,0,0,1,.5-1.1,1,1,0,0,1,1.2.1l61.1,35.3a.7.7,0,0,0,.6.1.8.8,0,0,0,.2-.5V163.5a1.6,1.6,0,0,1,.5-1.1,1,1,0,0,1,1.2.1h.2a2.9,2.9,0,0,1,1.4,2.4v58.5a1.6,1.6,0,0,1-.5,1.1Zm-64.9-40h-.2a.8.8,0,0,0-.2.5,2.7,2.7,0,0,0,1.1,1.9l63.8,36.8a.7.7,0,0,0,.6.1.8.8,0,0,0,.2-.5V165a2.7,2.7,0,0,0-1.1-1.9h-.2a.7.7,0,0,0-.6-.1.8.8,0,0,0-.2.5v55.6a1.6,1.6,0,0,1-.5,1.1,1,1,0,0,1-1.2-.1l-61.1-35.2Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_2319" data-name="XMLID 2319">
          <g id="XMLID_2469" data-name="XMLID 2469">
            <path
              id="XMLID_2470"
              data-name="XMLID 2470"
              class="cls-2"
              d="M253.6,237.6H253v-.5h.6Zm0-1.1H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253v-1.3h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253V217h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253V206h.6Zm0-1.8H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253V195h.6Zm0-1.8H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253V184h.6Zm0-1.8H253v-1.2h.6Zm0-1.8H253v-1.2h.6Zm0-1.9H253v-1.2h.6Zm0-1.8H253v-1.2h.6Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_2282" data-name="XMLID 2282">
          <g id="XMLID_2312" data-name="XMLID 2312">
            <g id="XMLID_2317" data-name="XMLID 2317">
              <path
                id="XMLID_2318"
                data-name="XMLID 2318"
                class="cls-3"
                d="M161.2,184.7l-1.9-1.1a3,3,0,0,1-1.2-2.2V123.1c0-.8.5-1.2,1.2-.9l1.9,1.1a3,3,0,0,1,1.2,2.2v58.3C162.4,184.7,161.8,185,161.2,184.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2313" data-name="XMLID 2313">
              <path
                id="XMLID_2314"
                data-name="XMLID 2314"
                class="cls-2"
                d="M161.7,185.1l-.6-.2-1.9-1.1a3.1,3.1,0,0,1-1.3-2.5V123.1a1.1,1.1,0,0,1,.6-1.2.9.9,0,0,1,1.1.1l1.9,1.1a3.1,3.1,0,0,1,1.3,2.5v58.3a1.1,1.1,0,0,1-.6,1.2Zm-2.9-62.7h-.1c-.2.1-.2.3-.2.7v58.3a2.6,2.6,0,0,0,1,1.9l1.9,1.1h.4c.2-.1.2-.3.2-.7V125.5a2.6,2.6,0,0,0-1-1.9l-1.9-1.1Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2283" data-name="XMLID 2283">
            <g id="XMLID_2284" data-name="XMLID 2284">
              <path
                id="XMLID_2285"
                data-name="XMLID 2285"
                class="cls-2"
                d="M160.5,179.7h-.6v-.6h.6Zm0-1.2h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.9h-.6v-1.2h.6Zm0-1.8h-.6V170h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.9h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.9h-.6V159h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.9h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.9h-.6V148h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.9h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Zm0-1.9h-.6v-1.2h.6Zm0-1.8h-.6v-1.2h.6Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_2238" data-name="XMLID 2238">
          <g id="XMLID_2239" data-name="XMLID 2239">
            <path
              id="XMLID_2240"
              data-name="XMLID 2240"
              class="cls-2"
              d="M229.6,228.2l-.4-.2.3-.5.4.2Zm-1-.5-1.1-.6.3-.5,1.1.6Zm-1.5-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-1-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.5-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-1-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.5-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-1-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.5-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-1-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1-.6.3-.5,1.1.6Zm-1.5-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-1-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.5-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-1-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1.1-.6.3-.5,1.1.6Zm-1.6-.9-1-.6.3-.5,1.1.6Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
        <g id="XMLID_2208" data-name="XMLID 2208">
          <g id="XMLID_2231" data-name="XMLID 2231">
            <g id="XMLID_2236" data-name="XMLID 2236">
              <path
                id="XMLID_2237"
                data-name="XMLID 2237"
                class="cls-3"
                d="M183.2,169.3a13,13,0,0,0-6.1-10.4c-3.1-1.7-5.7-.2-5.8,3.3a12.8,12.8,0,0,0,5.9,10.5,5.6,5.6,0,0,0,2.3,3.7c.2.1.3,0,.2-.2a2.9,2.9,0,0,1,.3-2.7C182,173.4,183.2,171.9,183.2,169.3Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2232" data-name="XMLID 2232">
              <path
                id="XMLID_2233"
                data-name="XMLID 2233"
                class="cls-2"
                d="M179.7,176.8h-.3A6,6,0,0,1,177,173a13.3,13.3,0,0,1-6-10.7,4.4,4.4,0,0,1,1.9-3.9,4.2,4.2,0,0,1,4.3.3,13.4,13.4,0,0,1,6.3,10.7c0,2.6-1.2,4.3-3.2,4.5a2.4,2.4,0,0,0-.2,2.3.7.7,0,0,1-.1.6Zm-5-18.3a2.3,2.3,0,0,0-1.4.4,3.9,3.9,0,0,0-1.6,3.4,12.9,12.9,0,0,0,5.8,10.2h.1v.2a5.3,5.3,0,0,0,1.9,3.3,2.9,2.9,0,0,1,.5-2.7h.2c1.7-.1,2.8-1.6,2.8-3.9s-2.7-8.4-6-10.1A4,4,0,0,0,174.7,158.5Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2209" data-name="XMLID 2209">
            <g id="XMLID_2224" data-name="XMLID 2224">
              <g id="XMLID_2229" data-name="XMLID 2229">
                <path
                  id="XMLID_2230"
                  data-name="XMLID 2230"
                  class="cls-3"
                  d="M175.3,164.8c0,.6-.4.9-1,.5a2,2,0,0,1-1-1.6c0-.6.4-.9,1-.5A1.8,1.8,0,0,1,175.3,164.8Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_2225" data-name="XMLID 2225">
                <path
                  id="XMLID_2226"
                  data-name="XMLID 2226"
                  class="cls-2"
                  d="M174.8,165.8l-.6-.2a2.7,2.7,0,0,1-1.1-1.9,1.5,1.5,0,0,1,.4-.9c.3-.2.6-.1,1,.1a2.7,2.7,0,0,1,1.1,1.9,1.5,1.5,0,0,1-.4.9Zm-.9-2.5c-.2.1-.2.2-.2.4a1.8,1.8,0,0,0,.8,1.4h.4c.1,0,.1-.2.1-.4a1.8,1.8,0,0,0-.8-1.4Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2217" data-name="XMLID 2217">
              <g id="XMLID_2222" data-name="XMLID 2222">
                <path
                  id="XMLID_2223"
                  data-name="XMLID 2223"
                  class="cls-3"
                  d="M178.3,166.5c0,.6-.4.9-1,.6a2,2,0,0,1-1-1.6c0-.6.4-.9,1-.5A1.8,1.8,0,0,1,178.3,166.5Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_2218" data-name="XMLID 2218">
                <path
                  id="XMLID_2219"
                  data-name="XMLID 2219"
                  class="cls-2"
                  d="M177.7,167.5l-.6-.2a2.7,2.7,0,0,1-1.1-1.9,1.5,1.5,0,0,1,.4-.9c.3-.2.6-.1,1,.1a2.7,2.7,0,0,1,1.1,1.9,1.5,1.5,0,0,1-.4.9Zm-.8-2.5h0c-.2.1-.2.2-.2.4a1.8,1.8,0,0,0,.8,1.4h.4c.1,0,.1-.2.1-.4a1.8,1.8,0,0,0-.8-1.4Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2210" data-name="XMLID 2210">
              <g id="XMLID_2215" data-name="XMLID 2215">
                <path
                  id="XMLID_2216"
                  data-name="XMLID 2216"
                  class="cls-3"
                  d="M181.2,168.2c0,.6-.4.9-1,.5a2,2,0,0,1-1-1.6c0-.6.4-.9,1-.6A2.1,2.1,0,0,1,181.2,168.2Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_2211" data-name="XMLID 2211">
                <path
                  id="XMLID_2212"
                  data-name="XMLID 2212"
                  class="cls-2"
                  d="M180.7,169.2l-.6-.2a2.7,2.7,0,0,1-1.1-1.9,1.5,1.5,0,0,1,.4-.9c.3-.2.6-.1,1,.1a2.7,2.7,0,0,1,1.1,1.9,1.5,1.5,0,0,1-.4.9Zm-.9-2.5c-.2.1-.2.2-.2.4a1.8,1.8,0,0,0,.8,1.4h.4c.1,0,.1-.2.1-.4a1.8,1.8,0,0,0-.8-1.4Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_2190" data-name="XMLID 2190">
          <g id="XMLID_2201" data-name="XMLID 2201">
            <g id="XMLID_2206" data-name="XMLID 2206">
              <path
                id="XMLID_2207"
                data-name="XMLID 2207"
                class="cls-3"
                d="M186.5,150.2a9.1,9.1,0,0,0-4.3-7.3c-2.2-1.2-4-.1-4.1,2.4a9.2,9.2,0,0,0,4.2,7.4,4,4,0,0,0,1.6,2.6c.1.1.2,0,.2-.2s-.3-1.4.2-1.9S186.5,152.1,186.5,150.2Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2202" data-name="XMLID 2202">
              <path
                id="XMLID_2203"
                data-name="XMLID 2203"
                class="cls-2"
                d="M184.1,155.6h-.3a3.5,3.5,0,0,1-1.7-2.7,9.6,9.6,0,0,1-4.2-7.6,2.9,2.9,0,0,1,1.4-2.8,3.1,3.1,0,0,1,3.1.2,9.5,9.5,0,0,1,4.5,7.6c0,1.9-.9,3.1-2.3,3.3a2,2,0,0,0-.1,1.5.4.4,0,0,1-.1.5Zm-3.6-12.9-1,.2a2.4,2.4,0,0,0-1.1,2.3,8.9,8.9,0,0,0,4,7.1h.1v.2a3.6,3.6,0,0,0,1.1,2.1,1.8,1.8,0,0,1,.4-1.7h.2c1.2-.1,1.9-1.1,1.9-2.7a9.1,9.1,0,0,0-4.2-7.1A3.3,3.3,0,0,0,180.5,142.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2191" data-name="XMLID 2191">
            <g id="XMLID_2198" data-name="XMLID 2198">
              <g id="XMLID_2199" data-name="XMLID 2199">
                <path
                  id="XMLID_2200"
                  data-name="XMLID 2200"
                  class="cls-2"
                  d="M180.9,147.1c0,.4-.3.6-.7.4a1.4,1.4,0,0,1-.7-1.2c0-.4.3-.6.7-.4A1.4,1.4,0,0,1,180.9,147.1Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2195" data-name="XMLID 2195">
              <g id="XMLID_2196" data-name="XMLID 2196">
                <path
                  id="XMLID_2197"
                  data-name="XMLID 2197"
                  class="cls-2"
                  d="M183,148.3c0,.4-.3.6-.7.4a1.4,1.4,0,0,1-.7-1.2c0-.4.3-.6.7-.4A1.4,1.4,0,0,1,183,148.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2192" data-name="XMLID 2192">
              <g id="XMLID_2193" data-name="XMLID 2193">
                <path
                  id="XMLID_2194"
                  data-name="XMLID 2194"
                  class="cls-2"
                  d="M185.1,149.5c0,.4-.3.6-.7.4a1.4,1.4,0,0,1-.7-1.2c0-.4.3-.6.7-.4A1.5,1.5,0,0,1,185.1,149.5Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_2172" data-name="XMLID 2172">
          <g id="XMLID_2183" data-name="XMLID 2183">
            <g id="XMLID_2188" data-name="XMLID 2188">
              <path
                id="XMLID_2189"
                data-name="XMLID 2189"
                class="cls-3"
                d="M218.5,171.4c0-1.8,1.3-2.6,2.9-1.6a6.7,6.7,0,0,1,2.8,4.8c0,1.9-1.2,2.6-2.8,1.7,0,0-.1,1-1.1.5s-.1-.2-.1-.2a1.6,1.6,0,0,0-.2-1.5A5.6,5.6,0,0,1,218.5,171.4Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2184" data-name="XMLID 2184">
              <path
                id="XMLID_2185"
                data-name="XMLID 2185"
                class="cls-2"
                d="M220.7,177.3l-.6-.2c-.2-.1-.4-.4-.2-.6s.2-.5-.1-1.2a7,7,0,0,1-1.5-3.9,2.3,2.3,0,0,1,1-2.1,2.1,2.1,0,0,1,2.4.3,6.4,6.4,0,0,1,2.9,5,1.9,1.9,0,0,1-1.4,2.4,1.8,1.8,0,0,1-1.6-.2l-.4.4Zm-.2-.7h.4l.2-.4v-.4l.4.2c.7.4,1.3.5,1.7.2a2.2,2.2,0,0,0,.7-1.7,5.9,5.9,0,0,0-2.6-4.5,1.4,1.4,0,0,0-2.1.1,1.2,1.2,0,0,0-.4,1.3,5.2,5.2,0,0,0,1.4,3.5h.1a3.2,3.2,0,0,1,.2,1.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2173" data-name="XMLID 2173">
            <g id="XMLID_2180" data-name="XMLID 2180">
              <g id="XMLID_2181" data-name="XMLID 2181">
                <path
                  id="XMLID_2182"
                  data-name="XMLID 2182"
                  class="cls-2"
                  d="M222.3,173.7a1,1,0,0,0,.5.8c.3.1.5,0,.5-.3a1,1,0,0,0-.5-.8C222.5,173.3,222.3,173.4,222.3,173.7Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2177" data-name="XMLID 2177">
              <g id="XMLID_2178" data-name="XMLID 2178">
                <path
                  id="XMLID_2179"
                  data-name="XMLID 2179"
                  class="cls-2"
                  d="M220.9,172.9a1,1,0,0,0,.5.8c.3.1.5,0,.5-.3a1,1,0,0,0-.5-.8C221.1,172.5,220.9,172.6,220.9,172.9Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2174" data-name="XMLID 2174">
              <g id="XMLID_2175" data-name="XMLID 2175">
                <path
                  id="XMLID_2176"
                  data-name="XMLID 2176"
                  class="cls-2"
                  d="M219.5,172.1a1,1,0,0,0,.5.8c.3.1.5,0,.5-.3a1,1,0,0,0-.5-.8C219.7,171.6,219.5,171.8,219.5,172.1Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_2157" data-name="XMLID 2157">
          <g id="XMLID_2165" data-name="XMLID 2165">
            <g id="XMLID_2170" data-name="XMLID 2170">
              <path
                id="XMLID_2171"
                data-name="XMLID 2171"
                class="cls-3"
                d="M248.3,226.7l-12.5-7.2c-.6-.3-1,0-1,.8V226a2.6,2.6,0,0,0,1,2l1.4.8a4.5,4.5,0,0,0,2.2,3.2h.1a4.1,4.1,0,0,1-.2-1.9l8.9,5.2c.6.3,1,0,1-.8v-5.7A2.2,2.2,0,0,0,248.3,226.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2166" data-name="XMLID 2166">
              <path
                id="XMLID_2167"
                data-name="XMLID 2167"
                class="cls-2"
                d="M248.7,235.6l-.6-.2-8.5-4.9a5.9,5.9,0,0,0,.2,1.3.4.4,0,0,1-.1.5h-.4A4.9,4.9,0,0,1,237,229l-1.3-.8a2.7,2.7,0,0,1-1.2-2.2v-5.7a1.6,1.6,0,0,1,.5-1.1c.3-.2.6-.1,1,.1l12.5,7.2a2.7,2.7,0,0,1,1.2,2.2v5.7a1.6,1.6,0,0,1-.5,1.1Zm-9.5-6.1,9.3,5.4h.4a1.4,1.4,0,0,0,.2-.6v-5.7a2.2,2.2,0,0,0-.9-1.7l-12.5-7.2h-.4a1.4,1.4,0,0,0-.2.6V226a2.2,2.2,0,0,0,.9,1.7l1.6.9h0a4.7,4.7,0,0,0,1.6,2.7,3.8,3.8,0,0,1,0-1.5Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2158" data-name="XMLID 2158">
            <g id="XMLID_2162" data-name="XMLID 2162">
              <g id="XMLID_2163" data-name="XMLID 2163">
                <path
                  id="XMLID_2164"
                  data-name="XMLID 2164"
                  class="cls-2"
                  d="M237.9,223.7l-.3.5,8.6,5,.3-.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2159" data-name="XMLID 2159">
              <g id="XMLID_2160" data-name="XMLID 2160">
                <path
                  id="XMLID_2161"
                  data-name="XMLID 2161"
                  class="cls-2"
                  d="M237.9,225.6l-.3.6,8.6,4.9.3-.5Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_2133" data-name="XMLID 2133">
          <g id="XMLID_2149" data-name="XMLID 2149">
            <g id="XMLID_2155" data-name="XMLID 2155">
              <path
                id="XMLID_2156"
                data-name="XMLID 2156"
                class="cls-3"
                d="M248.3,173.2,235.8,166c-.6-.3-1,0-1,.8v12.7a2.3,2.3,0,0,0,1,1.9l1.8,1a4.5,4.5,0,0,0,2.2,3.2h.1a6.2,6.2,0,0,1-.2-1.9l8.6,5c.6.3,1,0,1-.8V175.2A2.6,2.6,0,0,0,248.3,173.2Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2150" data-name="XMLID 2150">
              <path
                id="XMLID_2151"
                data-name="XMLID 2151"
                class="cls-2"
                d="M248.7,189.1l-.6-.2-8.2-4.7a5.9,5.9,0,0,0,.2,1.3.4.4,0,0,1-.1.5h-.4a4.9,4.9,0,0,1-2.3-3.3l-1.7-1a2.7,2.7,0,0,1-1.2-2.2V166.8a1.6,1.6,0,0,1,.5-1.1c.3-.2.6-.1,1,.1l12.5,7.2a2.7,2.7,0,0,1,1.2,2.2v12.7a1.6,1.6,0,0,1-.5,1.1Zm-9.2-5.9,8.9,5.2h.4a1.4,1.4,0,0,0,.2-.6V175.2a2.2,2.2,0,0,0-.9-1.7l-12.5-7.2h-.4a1.4,1.4,0,0,0-.2.6v12.7a2.2,2.2,0,0,0,.9,1.7l1.9,1.1h0a4.7,4.7,0,0,0,1.6,2.7,3.3,3.3,0,0,1,0-1.4Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2134" data-name="XMLID 2134">
            <g id="XMLID_2142" data-name="XMLID 2142">
              <g id="XMLID_2146" data-name="XMLID 2146">
                <g id="XMLID_2147" data-name="XMLID 2147">
                  <path
                    id="XMLID_2148"
                    data-name="XMLID 2148"
                    class="cls-2"
                    d="M237.9,171.4l-.3.5,8.6,5,.3-.6Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_2143" data-name="XMLID 2143">
                <g id="XMLID_2144" data-name="XMLID 2144">
                  <path
                    id="XMLID_2145"
                    data-name="XMLID 2145"
                    class="cls-2"
                    d="M237.9,173.3l-.3.6,8.6,4.9.3-.5Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_2135" data-name="XMLID 2135">
              <g id="XMLID_2139" data-name="XMLID 2139">
                <g id="XMLID_2140" data-name="XMLID 2140">
                  <path
                    id="XMLID_2141"
                    data-name="XMLID 2141"
                    class="cls-2"
                    d="M237.9,175.3l-.3.5,8.6,5,.3-.5Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_2136" data-name="XMLID 2136">
                <g id="XMLID_2137" data-name="XMLID 2137">
                  <path
                    id="XMLID_2138"
                    data-name="XMLID 2138"
                    class="cls-2"
                    d="M238,177.3l-.3.5,8.5,5,.3-.6Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_2110" data-name="XMLID 2110">
          <g id="XMLID_2126" data-name="XMLID 2126">
            <g id="XMLID_2131" data-name="XMLID 2131">
              <path
                id="XMLID_2132"
                data-name="XMLID 2132"
                class="cls-3"
                d="M248.3,208.8l-12.5-7.3c-.6-.3-1,0-1,.8V213a2.6,2.6,0,0,0,1,2l7.8,4.5a2,2,0,0,1-.2,1.7c0,.1,0,.2.1.2,1.6.9,2.1-.2,2.2-.7l2.6,1.5c.6.3,1,0,1-.8V210.7A2.6,2.6,0,0,0,248.3,208.8Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2127" data-name="XMLID 2127">
              <path
                id="XMLID_2128"
                data-name="XMLID 2128"
                class="cls-2"
                d="M248.7,222.6l-.6-.2-2.3-1.3a1.6,1.6,0,0,1-.8.8,1.9,1.9,0,0,1-1.8-.3l-.3-.3V221a2,2,0,0,0,.2-1.3l-7.6-4.4a2.7,2.7,0,0,1-1.2-2.2V202.3a1.6,1.6,0,0,1,.5-1.1c.3-.2.6-.1,1,.1l12.5,7.2a2.7,2.7,0,0,1,1.2,2.2v10.7a1.6,1.6,0,0,1-.5,1.1Zm-3.2-2.4,2.9,1.7h.4a1.4,1.4,0,0,0,.2-.6V210.7a2.2,2.2,0,0,0-.9-1.7l-12.5-7.2h-.4a1.4,1.4,0,0,0-.2.6v10.7a2.2,2.2,0,0,0,.9,1.7l7.9,4.5h0a3.7,3.7,0,0,1-.1,1.8,1.4,1.4,0,0,0,1.1.2c.4-.1.5-.6.6-.8Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2111" data-name="XMLID 2111">
            <g id="XMLID_2119" data-name="XMLID 2119">
              <g id="XMLID_2123" data-name="XMLID 2123">
                <g id="XMLID_2124" data-name="XMLID 2124">
                  <path
                    id="XMLID_2125"
                    data-name="XMLID 2125"
                    class="cls-2"
                    d="M237.9,206.2l-.3.5,8.6,5,.3-.5Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_2120" data-name="XMLID 2120">
                <g id="XMLID_2121" data-name="XMLID 2121">
                  <path
                    id="XMLID_2122"
                    data-name="XMLID 2122"
                    class="cls-2"
                    d="M237.9,208.1l-.3.6,8.6,4.9.3-.5Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_2112" data-name="XMLID 2112">
              <g id="XMLID_2116" data-name="XMLID 2116">
                <g id="XMLID_2117" data-name="XMLID 2117">
                  <path
                    id="XMLID_2118"
                    data-name="XMLID 2118"
                    class="cls-2"
                    d="M237.9,210.1l-.3.5,8.6,5,.3-.5Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_2113" data-name="XMLID 2113">
                <g id="XMLID_2114" data-name="XMLID 2114">
                  <path
                    id="XMLID_2115"
                    data-name="XMLID 2115"
                    class="cls-2"
                    d="M238,212.1l-.3.5,8.5,4.9.3-.5Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="XMLID_2099" data-name="XMLID 2099">
          <g id="XMLID_2103" data-name="XMLID 2103">
            <g id="XMLID_2108" data-name="XMLID 2108">
              <path
                id="XMLID_2109"
                data-name="XMLID 2109"
                class="cls-3"
                d="M248.3,192.8l-12.5-7.2c-.6-.3-1,0-1,.8v.9a2.3,2.3,0,0,0,1,1.9l8.9,5.1a2,2,0,0,1-.2,1.7c0,.1,0,.2.1.2,1.7,1,2.1-.3,2.2-.7l1.4.8c.6.3,1,0,1-.8v-.9A2.1,2.1,0,0,0,248.3,192.8Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2104" data-name="XMLID 2104">
              <path
                id="XMLID_2105"
                data-name="XMLID 2105"
                class="cls-2"
                d="M245.7,197a1.7,1.7,0,0,1-1.2-.4l-.3-.3V196a1.7,1.7,0,0,0,.1-1.4l-8.8-5.1a2.7,2.7,0,0,1-1.2-2.2v-.9a1.6,1.6,0,0,1,.5-1.1c.3-.2.6-.1,1,.1l12.5,7.2a2.7,2.7,0,0,1,1.2,2.2v.9a1.6,1.6,0,0,1-.5,1.1c-.3.2-.6.1-1-.1l-1.1-.6a1.1,1.1,0,0,1-.8.8Zm-.9-.9a1.4,1.4,0,0,0,1.1.2,1.6,1.6,0,0,0,.6-.8v-.4l1.8,1h.4a1.4,1.4,0,0,0,.2-.6v-.9a2.2,2.2,0,0,0-.9-1.7l-12.4-7.1h-.4a1.4,1.4,0,0,0-.2.6v.9a2.2,2.2,0,0,0,.9,1.7l9,5.2h0a2.1,2.1,0,0,1-.1,1.9Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2100" data-name="XMLID 2100">
            <g id="XMLID_2101" data-name="XMLID 2101">
              <path
                id="XMLID_2102"
                data-name="XMLID 2102"
                class="cls-2"
                d="M237.9,188.3l-.3.5,8.6,5,.3-.6Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_2088" data-name="XMLID 2088">
          <g id="XMLID_2092" data-name="XMLID 2092">
            <g id="XMLID_2097" data-name="XMLID 2097">
              <path
                id="XMLID_2098"
                data-name="XMLID 2098"
                class="cls-3"
                d="M248.3,200.8l-12.5-7.2c-.6-.3-1,0-1,.8v.9a2.3,2.3,0,0,0,1,1.9l2,1.2a4.5,4.5,0,0,0,2.2,3.2h.1a4.1,4.1,0,0,1-.2-1.9l8.3,4.8c.6.3,1,0,1-.8v-.9A2.2,2.2,0,0,0,248.3,200.8Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2093" data-name="XMLID 2093">
              <path
                id="XMLID_2094"
                data-name="XMLID 2094"
                class="cls-2"
                d="M248.7,204.8l-.6-.2-7.9-4.6a5.9,5.9,0,0,0,.2,1.3.4.4,0,0,1-.1.5h-.4a4.9,4.9,0,0,1-2.3-3.3l-1.9-1.1a2.7,2.7,0,0,1-1.2-2.2v-.8a1.6,1.6,0,0,1,.5-1.1c.3-.2.6-.1,1,.1l12.5,7.2a2.7,2.7,0,0,1,1.2,2.2v.9a1.6,1.6,0,0,1-.5,1.1Zm-8.9-5.7,8.7,5h.4a1.4,1.4,0,0,0,.2-.6v-.9a2.2,2.2,0,0,0-.9-1.7l-12.5-7.2h-.4a1.4,1.4,0,0,0-.2.6v.9a2.2,2.2,0,0,0,.9,1.7l2.2,1.2h0a4.7,4.7,0,0,0,1.6,2.7,3.8,3.8,0,0,1,0-1.5Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2089" data-name="XMLID 2089">
            <g id="XMLID_2090" data-name="XMLID 2090">
              <path
                id="XMLID_2091"
                data-name="XMLID 2091"
                class="cls-2"
                d="M238,196.3l-.3.5,8.5,4.9.3-.5Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_2017" data-name="XMLID 2017">
          <g id="XMLID_2081" data-name="XMLID 2081">
            <g id="XMLID_2086" data-name="XMLID 2086">
              <path
                id="XMLID_2087"
                data-name="XMLID 2087"
                class="cls-3"
                d="M201.9,191.2s9.9,2.6,16.3,23.6l-40.7-23.5s-1.5-16.2,13.9-7l8.9,6.2Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2082" data-name="XMLID 2082">
              <path
                id="XMLID_2083"
                data-name="XMLID 2083"
                class="cls-2"
                d="M218.8,215.5l-41.5-23.9v-.2c0-.3-.6-6.9,3.2-9.3s6.2-.9,11.1,2l8.9,6.2,1.5.7c.7.2,10.2,3.2,16.5,23.8Zm-40.9-24.4,39.8,23c-6.3-19.9-15.8-22.7-15.9-22.7l-1.6-.7-8.9-6.2c-4.6-2.8-8.2-3.4-10.4-2S177.8,190.1,177.9,191.1Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2074" data-name="XMLID 2074">
            <g id="XMLID_2079" data-name="XMLID 2079">
              <path
                id="XMLID_2080"
                data-name="XMLID 2080"
                class="cls-3"
                d="M192,170.5c-.6-4.2,2.8-6.8,6.3-8.4s11.4,5.1,12.2,12.2a18.4,18.4,0,0,1-.4,6.6c-.8,2.9-2.1,5.7-4.4,7.5a11.7,11.7,0,0,1-4.6-2.6,17.3,17.3,0,0,0,1.2,7.8s.2,3.8-4.8,1.5-7.1-9.3-7.1-9.3A33.1,33.1,0,0,0,192,170.5Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2075" data-name="XMLID 2075">
              <path
                id="XMLID_2076"
                data-name="XMLID 2076"
                class="cls-2"
                d="M200.1,196.2a6.9,6.9,0,0,1-2.8-.8c-5.1-2.3-7.2-9.2-7.3-9.5h0a31,31,0,0,0,1.6-15.1c-.5-3.6,1.7-6.6,6.5-8.7,1.5-.7,3.2-.4,5.1.7a16.3,16.3,0,0,1,7.5,11.8,19.4,19.4,0,0,1-.4,6.8c-.9,3.5-2.4,6.1-4.5,7.7h-.2a11.5,11.5,0,0,1-4.2-2.3,16.7,16.7,0,0,0,1.2,7h0a2.3,2.3,0,0,1-1,2.1Zm-9.5-10.4c.3.9,2.4,7,6.9,9,1.7.8,2.9.9,3.7.4a2,2,0,0,0,.7-1.6,17.7,17.7,0,0,1-1.2-7.9v-.6l.4.4a10.4,10.4,0,0,0,4.3,2.5,13.8,13.8,0,0,0,4.2-7.3,20.2,20.2,0,0,0,.4-6.5,16.6,16.6,0,0,0-7.2-11.3c-1.2-.7-3-1.4-4.6-.6-4.6,2-6.6,4.8-6.1,8.1A31,31,0,0,1,190.6,185.8Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2071" data-name="XMLID 2071">
            <g id="XMLID_2072" data-name="XMLID 2072">
              <path
                id="XMLID_2073"
                data-name="XMLID 2073"
                class="cls-2"
                d="M207,183.7h-.4a3.9,3.9,0,0,1-2.4-2.1l.6-.3a3.3,3.3,0,0,0,1.7,1.6v-3.8h.6v4.7Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2068" data-name="XMLID 2068">
            <g id="XMLID_2069" data-name="XMLID 2069">
              <path
                id="XMLID_2070"
                data-name="XMLID 2070"
                class="cls-2"
                d="M200.8,186.1a17.6,17.6,0,0,1-2.4-3l.5-.3c1.2,1.8,2.3,2.9,2.3,3Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2065" data-name="XMLID 2065">
            <g id="XMLID_2066" data-name="XMLID 2066">
              <path
                id="XMLID_2067"
                data-name="XMLID 2067"
                class="cls-2"
                d="M203.9,175.9c0,.9-.4,1.5-.9,1.2a3.1,3.1,0,0,1-.9-2.2c0-.9.4-1.5.9-1.2A3.1,3.1,0,0,1,203.9,175.9Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2062" data-name="XMLID 2062">
            <g id="XMLID_2063" data-name="XMLID 2063">
              <path
                id="XMLID_2064"
                data-name="XMLID 2064"
                class="cls-2"
                d="M210,179.4c0,.9-.4,1.5-.9,1.2a3.1,3.1,0,0,1-.9-2.2c0-.9.4-1.5.9-1.2A3.1,3.1,0,0,1,210,179.4Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2048" data-name="XMLID 2048">
            <g id="XMLID_2049" data-name="XMLID 2049">
              <path
                id="XMLID_2050"
                data-name="XMLID 2050"
                class="cls-2"
                d="M195.4,197.1l-.3-.2.4-.5.3.2Zm-.7-.7-.9-.8.4-.4.9.8Zm-1.4-1.2-.9-.9.4-.4.8.9Zm-1.3-1.4-.8-.9.5-.4.8.9Zm-1.2-1.3-.8-1,.5-.4.8.9Zm-1.1-1.5a3.6,3.6,0,0,1-.7-1l.5-.3.7,1Zm-1.1-1.5a6.1,6.1,0,0,0-.7-1l.5-.3a3.6,3.6,0,0,0,.7,1Zm-1-1.6-.6-1.1.5-.3.6,1.1Zm-.9-1.6-.5-1.1.6-.3a5.4,5.4,0,0,1,.5,1.1Zm-.7-1.7a5.4,5.4,0,0,0-.5-1.1l.6-.2.5,1.1Zm-.7-1.7a5.6,5.6,0,0,1-.4-1.2h.6a4.9,4.9,0,0,0,.4,1.1Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2041" data-name="XMLID 2041">
            <g id="XMLID_2046" data-name="XMLID 2046">
              <path
                id="XMLID_2047"
                data-name="XMLID 2047"
                class="cls-3"
                d="M210.4,173.8s3.9,1.6,4.3-3.7-3.8-11-3.8-11-.9,5.7-6.1.3-13.8-7.8-15.6-2.1,0,9.1.7,11.1a4.4,4.4,0,0,1,.2,2c-.3,1.7.7,4,2.2,5.5l.6-1.8a14.6,14.6,0,0,0,.6-5.1c-.1-1.1,0-2.4.8-2.6s3.4,3.5,3.4,3.5S203.8,166.6,210.4,173.8Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2042" data-name="XMLID 2042">
              <path
                id="XMLID_2043"
                data-name="XMLID 2043"
                class="cls-2"
                d="M192.4,176.5l-.3-.3c-1.6-1.6-2.6-4-2.3-5.8a3.7,3.7,0,0,0-.2-1.8c-.7-1.9-2-6.9-.7-11.3a4.7,4.7,0,0,1,3.5-3.3c3.5-.8,8.8,1.4,12.6,5.3,1.7,1.7,3.1,2.5,4.1,2.2s1.5-2.3,1.5-2.3v-.7l.4.6c.2.2,4.2,5.9,3.9,11.2a4.6,4.6,0,0,1-1.7,3.8,3.9,3.9,0,0,1-3,.2h-.1c-6.3-6.9-12.2-3.9-12.4-3.8l-.3.2v-.3c-.7-1.5-2.1-3.7-3.1-3.4s-.7,1.5-.6,2.3a11.5,11.5,0,0,1-.6,5.2Zm1.5-22.1-1.4.2a4,4,0,0,0-3.1,2.9c-1.3,4.2,0,9.1.7,10.9a3.8,3.8,0,0,1,.2,2.1,6.4,6.4,0,0,0,1.8,4.9l.4-1.3a12,12,0,0,0,.5-5c-.1-1.7.2-2.7,1-2.9s3.2,2.4,3.7,3.4c1.3-.6,7-2.4,12.8,4a2.9,2.9,0,0,0,2.4-.2c.8-.5,1.3-1.6,1.4-3.3.3-4.2-2.4-8.7-3.4-10.2a2.9,2.9,0,0,1-1.8,2.1c-1.2.4-2.8-.4-4.7-2.3s-7.3-5.3-10.5-5.3Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2038" data-name="XMLID 2038">
            <g id="XMLID_2039" data-name="XMLID 2039">
              <path
                id="XMLID_2040"
                data-name="XMLID 2040"
                class="cls-2"
                d="M204.8,185.7a4.4,4.4,0,0,1-1.7-1.6l.5-.3a3.4,3.4,0,0,0,1.5,1.4Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2035" data-name="XMLID 2035">
            <g id="XMLID_2036" data-name="XMLID 2036">
              <path
                id="XMLID_2037"
                data-name="XMLID 2037"
                class="cls-2"
                d="M195.5,174.2c-.1,0-1.9-.9-2.4-4.4h.6c.4,3.1,2,3.9,2,3.9Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2032" data-name="XMLID 2032">
            <g id="XMLID_2033" data-name="XMLID 2033">
              <path
                id="XMLID_2034"
                data-name="XMLID 2034"
                class="cls-2"
                d="M193.7,170.6h-.6c0-.8.2-1.3.7-1.5a3.7,3.7,0,0,1,2,.5l-.4.5a2.4,2.4,0,0,0-1.4-.5C193.8,169.7,193.7,170.2,193.7,170.6Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2029" data-name="XMLID 2029">
            <g id="XMLID_2030" data-name="XMLID 2030">
              <path
                id="XMLID_2031"
                data-name="XMLID 2031"
                class="cls-2"
                d="M212.3,168.3a5.9,5.9,0,0,1-1.9-.5c-5-2.1-14.3-11-14.7-11.4l.4-.4c.1.1,9.6,9.1,14.5,11.2.8.3,1.9.6,2.4.1s.1-3.2-.2-4l.6-.2c.1.4,1.3,3.5,0,4.7S212.8,168.3,212.3,168.3Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2026" data-name="XMLID 2026">
            <g id="XMLID_2027" data-name="XMLID 2027">
              <path
                id="XMLID_2028"
                data-name="XMLID 2028"
                class="cls-2"
                d="M189.7,169.3c-.4-4.5.1-7.2,1.6-8.2a2.7,2.7,0,0,1,2.3-.1l-.3.5a1.5,1.5,0,0,0-1.7.1c-.9.6-1.8,2.4-1.3,7.6Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_2018" data-name="XMLID 2018">
            <g id="XMLID_2019" data-name="XMLID 2019">
              <path
                id="XMLID_2020"
                data-name="XMLID 2020"
                class="cls-2"
                d="M201.6,200v-.6h.7v.6Zm1.4-.2v-.6l1.1-.4.3.6Zm1.8-.8-.3-.5.9-.7.4.5Zm1.5-1.2-.5-.4.7-.9.5.3A3.6,3.6,0,0,1,206.3,197.8Zm1.1-1.5-.5-.3a3.6,3.6,0,0,0,.4-1.1h.6Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Drawer">
        <path
          class="cls-3"
          d="M302.7,243.2l6.4,3.7.6.2v-3.9L306,241a1.7,1.7,0,0,1-.7-1.3V229.5a.7.7,0,0,1,.4-.7h.7l3.3,2v-5.3a1.6,1.6,0,0,1-.9-.3l-7.9-4.6V237l.4.3a3.2,3.2,0,0,1,1.9,2.7h0a.5.5,0,0,1,0,.5Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M299.4,218.6a.5.5,0,0,0,.3.5l9.4,5.5a2,2,0,0,0,2.1,0l14.9-8.6a.6.6,0,0,0,.2-.8l-.2-.2-3.4-2.1-11.1,6.4a2.3,2.3,0,0,1-1.4.4h-.5l-1-.3-5.5-3.2-3.5,2C299.5,218.3,299.4,218.4,299.4,218.6Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M326.6,214.2l-3-1.8,2.8-1.6a1.5,1.5,0,0,0,.7-1.2h0V208a.8.8,0,0,0,.2-.7,1.5,1.5,0,0,0-.7-1.2l-8.5-5,.3-3a.8.8,0,0,0-.2-.5h0a1.8,1.8,0,0,0-1-1.1,4.7,4.7,0,0,0-4.3,0,2,2,0,0,0-1,1.5.8.8,0,0,0,.2.5l.2,2.6-.6-.3-10.1,5.5,1.4.7-3.6,2.1a1.2,1.2,0,0,0-.7,1.1v2.6a1.2,1.2,0,0,0,.7,1.1l3,1.7-2.9,1.7a1.3,1.3,0,0,0-.6,1l-.2.3h0v5.7h0v11.9a8.8,8.8,0,0,0-2.8-.1h-.4a11.4,11.4,0,0,0-2.6.9,3.2,3.2,0,0,0-1.9,2.7h0a1.9,1.9,0,0,0,.2.7l1.4,7.6c0,1.1,1.2,2.1,3,2.6l1.6.2h1.7c1.8-.4,3-1.4,3-2.6l.8-4.2,6.2,3.6,1,.3h.7l1.2-.4,14.8-8.5.5-.5a1.1,1.1,0,0,0,.3-.8v-22a.9.9,0,0,0,.1-.5A1.5,1.5,0,0,0,326.6,214.2Zm-31,35.9c-1.5-.4-2.4-1.1-2.4-1.9l-1.1-6,.6.5a8,8,0,0,0,4.3,1h.8l-.3,6.6Zm17.3-50.8a5.4,5.4,0,0,0,2.2.5,5.4,5.4,0,0,0,2.1-.5h.1l-.6,6.2c0,.2-.3.5-1,.7h-1.3c-.7-.1-1-.4-1-.7l-.6-6.2Zm-.5,2.4.3,3.6c0,.7.6,1.3,1.6,1.5h.8l1-.2c1-.2,1.6-.8,1.6-1.4v-.4l2.4,1.5-8.5,4.8-8.5-4.9,8.6-4.9Zm-.7,10.4,10-5.6-3.9-2.3.2-2.2,8.1,4.8a.6.6,0,0,1,.2.8l-.2.2-14.9,8.6a2,2,0,0,1-2.1,0l-9.4-5.5a.6.6,0,0,1-.2-.8l.2-.2,4.1-2.4Zm-10.7.3,7.8,4.6.9.3v1.6l-.6-.2L301,214Zm7.7,6.9,1,.3h.5a2.3,2.3,0,0,0,1.4-.4l11.1-6.4,3.4,2.1a.6.6,0,0,1,.2.8l-.2.2-14.9,8.6a2,2,0,0,1-2.1,0l-9.4-5.5a.6.6,0,0,1-.2-.8l.2-.2,3.5-2Zm-12.2,20.2a.8.8,0,1,1-.8-.8h0a.9.9,0,0,1,.8.8Zm4.8,1.2a.8.8,0,1,1-.8-.8.9.9,0,0,1,.8.8Zm-2.6-.5.2.4h0a1.3,1.3,0,0,0,.8,1.3,7.1,7.1,0,0,1-6-.7.4.4,0,0,1-.1-.3c0-.1,0-.2.2-.3l.6-.3a1.7,1.7,0,0,0,1.3.7,1.6,1.6,0,0,0,1.6-1.6h0a1.9,1.9,0,0,0-.2-.8l1.2.3.2.2h0Zm21.6-15.1H320l-1.9,1.1a1.7,1.7,0,0,0-.7,1.3v.2h-.7v-.3a2.3,2.3,0,0,1,1.1-1.8l1.9-1.1a1,1,0,0,1,.9-.1.9.9,0,0,1,.4.8v.3h-.6v-.2C320.4,225.2,320.4,225.1,320.3,225.1Zm5.1.6.3.5-13.1,7.6v-.7Zm-5.1,7.2H320l-1.9,1.1a1.7,1.7,0,0,0-.7,1.3v.3h-.7v-.3a2.3,2.3,0,0,1,1.1-1.8l1.9-1.1a1,1,0,0,1,.9-.1.9.9,0,0,1,.4.8v.3h-.6v-.3C320.4,233,320.4,232.9,320.3,232.9Zm5.1.9.3.5-13.1,7.6v-.7Zm-14-1a.9.9,0,0,1,.3.6v10.1l-5.4-3.3a.9.9,0,0,1-.3-.6V229.5Zm-10.5,5.1a2.3,2.3,0,0,1,1.5,2,1.6,1.6,0,0,1-.3.9h0a1.6,1.6,0,0,0-1.6-1.6h0a1.3,1.3,0,0,0-1,.4v-.3a1.1,1.1,0,0,0-.8-.9l-1.6-.4a.9.9,0,0,0-.7.1H296v-1h1.2a8,8,0,0,1,3.7.8Zm2.3,2.2h0a3.2,3.2,0,0,0-1.9-2.7l-.4-.3V220.6l7.9,4.6a1.6,1.6,0,0,0,.9.3v5.3l-3.3-2h-.7a.7.7,0,0,0-.4.7v10.2a1.7,1.7,0,0,0,.7,1.3l3.7,2.2v3.9l-.6-.2-6.4-3.7.5-2.6A.5.5,0,0,0,303.2,240.1Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M309.1,218.7l.6.2v-1.6l-.9-.3-7.8-4.6V214Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M299.4,210.4a.5.5,0,0,0,.3.5l9.4,5.5a2,2,0,0,0,2.1,0l14.9-8.6a.6.6,0,0,0,.2-.8l-.2-.2L318,202l-.2,2.2,3.9,2.3-10,5.6-7.9-4.6-4.1,2.4A.5.5,0,0,0,299.4,210.4Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M312.6,233.4v.4l13.1-7.6-.3-.5-12.8,7.4Z"
          transform="translate(0 0)"
        />
        <polygon
          class="cls-3"
          points="312.6 241.9 325.6 234.3 325.4 233.8 312.6 241.2 312.6 241.9"
        />
        <path
          class="cls-3"
          d="M321,225.6v-.3a.9.9,0,0,0-.4-.8,1,1,0,0,0-.9.1l-1.9,1.1a2.3,2.3,0,0,0-1.1,1.8v.3h.7v-.2a1.7,1.7,0,0,1,.7-1.3l1.9-1.1h.3c.1,0,.1.1.1.3v.2Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M321,233.5v-.3a.9.9,0,0,0-.4-.8,1,1,0,0,0-.9.1l-1.9,1.1a2.3,2.3,0,0,0-1.1,1.8v.3h.7v-.3a1.7,1.7,0,0,1,.7-1.3L320,233h.3c.1,0,.1.1.1.3v.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M303.2,206.3l8.5,4.9,8.5-4.8-2.4-1.5v.4c0,.6-.6,1.2-1.6,1.4l-1,.2h-.8c-1-.2-1.6-.8-1.6-1.5l-.3-3.6-.6-.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M306,229.5v10.1a.9.9,0,0,0,.3.6l5.4,3.3V233.4a.9.9,0,0,0-.3-.6Zm4.5,3.8a1,1,0,0,1,.5.8c0,.3-.2.4-.5.3a1,1,0,0,1-.5-.8C310,233.3,310.2,233.2,310.5,233.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M310,233.6a1,1,0,0,0,.5.8c.3.1.5,0,.5-.3a1,1,0,0,0-.5-.8C310.2,233.2,310,233.3,310,233.6Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M313.4,205.4c0,.3.3.6,1,.7h1.3c.7-.2,1-.5,1-.7l.6-6.2h-.1a5.4,5.4,0,0,1-2.1.5,5.4,5.4,0,0,1-2.2-.5h-.1Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M297.8,243.6H297a8,8,0,0,1-4.3-1l-.6-.5,1.1,6c0,.8.9,1.5,2.4,1.9h1.9Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M297,237h-1.2v.8h.4a.9.9,0,0,1,.7-.1l1.6.4a1.1,1.1,0,0,1,.8.9v.3a1.3,1.3,0,0,1,1-.4,1.6,1.6,0,0,1,1.6,1.6h0a1.6,1.6,0,0,0,.3-.9,2.3,2.3,0,0,0-1.5-2A7.8,7.8,0,0,0,297,237Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M298.3,239l-1.2-.3a1.9,1.9,0,0,1,.2.8,1.6,1.6,0,0,1-1.6,1.6h0a1.7,1.7,0,0,1-1.3-.7l-.6.3c-.2.1-.2.2-.2.3a.4.4,0,0,0,.1.3,7.1,7.1,0,0,0,6,.7,1.3,1.3,0,0,1-.8-1.3h0l-.2-.4-.2-1c.1-.1,0-.2-.1-.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M294.9,239.5a.8.8,0,1,0,.8-.8A.9.9,0,0,0,294.9,239.5Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M300.5,239.9a.8.8,0,1,0,.8.8.9.9,0,0,0-.8-.8Z"
          transform="translate(0 0)"
        />
      </g>
      <g id="Side_Objekt" data-name="Side Objekt">
        <path
          class="cls-3"
          d="M128.1,173.1l3.7,2.2v-9.4l-4,2.3a1.7,1.7,0,0,1-1.2.5h-.5a1.1,1.1,0,0,1-.8-.3l-4.4-2.6h-.2v3.5l6.9,4.1Z"
          transform="translate(0 0)"
        />
        <path class="cls-3" d="M131.8,156.2l-.8-.2-10.3-6v5l11.1,6.5Z" transform="translate(0 0)" />
        <path
          class="cls-3"
          d="M131.8,199.9V180.3l-4,2.3a1.8,1.8,0,0,1-1.2.5h-.5a1.1,1.1,0,0,1-.8-.3l-4.6-2.8v13.6l10.8,6.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M119.4,148a.5.5,0,0,0,.2.4l11.8,6.9a1.7,1.7,0,0,0,1.7,0l.5-.3a.5.5,0,0,0,.1-.7h-.1l-11.8-6.9a1.7,1.7,0,0,0-1.7,0l-.5.3A.5.5,0,0,0,119.4,148Z"
          transform="translate(0 0)"
        />
        <path class="cls-3" d="M125.7,182h.4v-1.1l-.8-.2-10.3-6v.9Z" transform="translate(0 0)" />
        <path
          class="cls-2"
          d="M113.7,172.8a.5.5,0,0,0,.2.4l11.8,6.9a1.7,1.7,0,0,0,1.7,0l1.4-.8-1.3-.8-1.6.9-6.9-4,4.5-2.6,2.6,1.5.7-.5-6.8-3.9a1.7,1.7,0,0,0-1.7,0l-4.4,2.5A.5.5,0,0,0,113.7,172.8Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M122.5,164.8l-.8.5,4,2.4h.4v-1.1l-.8-.2Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M118.3,155.6l-4.4,2.5a.5.5,0,0,0-.1.7h.1l1.6.9.7-.4-1.3-.7,4.5-2.6,6.9,4.1-.9.5,2.1,1.3-4.2,2.4,2.4,1.4a1.7,1.7,0,0,0,1.7,0l4.4-2.5a.5.5,0,0,0,.1-.7h-.1L120,155.6A1.7,1.7,0,0,0,118.3,155.6Z"
          transform="translate(0 0)"
        />
        <polygon
          class="cls-2"
          points="119.7 165.5 125.9 162 124.5 161.2 121.8 162.7 117 159.9 113.5 161.9 119.7 165.5"
        />
        <polygon
          class="cls-2"
          points="120.5 175.4 125.9 178.5 126.7 178 123.1 176 125.2 174.8 123.4 173.8 120.5 175.4"
        />
        <polygon
          class="cls-2"
          points="121.8 161.8 124.6 160.2 119.3 157.1 116.4 158.7 121.8 161.8"
        />
        <polygon class="cls-2" points="128 174.1 124.7 176 130.9 179.6 134.2 177.7 128 174.1" />
        <path
          class="cls-1"
          d="M135.8,177.7l-1.1-.7V154.4a.5.5,0,0,0-.2-.4h0a1,1,0,0,0-.5-.4l-11.8-6.9a2.3,2.3,0,0,0-2.5,0l-.5.3a1.1,1.1,0,0,0-.6,1.1h0v6.5l-.7.3-4.4,2.5a1.1,1.1,0,0,0-.6,1.1h0v1.8h0a.9.9,0,0,0,.3.6l-1.3.7,6.7,3.8v3.2l-.7.3-4.4,2.5a1.1,1.1,0,0,0-.6,1.1h0v1.9a1.1,1.1,0,0,0,.6.9l5.1,3V192h0a1.1,1.1,0,0,0,.6.9l1.4.8h0l10.4,6.1a1.1,1.1,0,0,0,.8.3h1l.8-.2.5-.3a1.1,1.1,0,0,0,.6-1V178.3Zm-21.9-5.3,4.4-2.5a1.7,1.7,0,0,1,1.7,0l6.8,3.9-.7.5-2.6-1.5-4.5,2.6,6.9,4,1.6-.9,1.3.8-1.4.8a1.7,1.7,0,0,1-1.7,0l-11.8-6.9a.5.5,0,0,1-.1-.7Zm7.9-25.1,11.8,6.9a.5.5,0,0,1,.1.7h-.1l-.5.3a1.7,1.7,0,0,1-1.7,0l-11.8-6.9a.5.5,0,0,1-.1-.7h.1l.5-.3A1.7,1.7,0,0,1,121.8,147.3Zm-2.5,9.8,5.3,3.1-2.8,1.6-5.4-3.1Zm1.4,8.7h.2l4.4,2.6a1.1,1.1,0,0,0,.8.3h.5a1.7,1.7,0,0,0,1.2-.5l4-2.3v9.4l-3.7-2.2-.5.3-6.9-4.1Zm0-15.8,10.3,6,.8.2v5.3L120.7,155Zm5.4,17.8h-.4l-4-2.4.8-.5,2.8,1.7.8.2Zm-.9,7-2.1,1.2,3.6,2-.8.5-5.4-3.1,2.9-1.6Zm5.7,4.8-6.2-3.6,3.3-1.9,6.2,3.6Zm-10.9-24,11.8,6.9a.5.5,0,0,1,.1.7h-.1l-4.4,2.5a1.7,1.7,0,0,1-1.7,0l-2.4-1.4,4.2-2.4-2.1-1.3.9-.5-6.9-4.1-4.5,2.6,1.3.7-.7.4-1.6-.9a.5.5,0,0,1-.1-.7h.1l4.4-2.5A1.7,1.7,0,0,1,120,155.6Zm-3,4.3,4.8,2.8,2.7-1.5,1.4.8-6.2,3.5-6.2-3.6Zm-2,14.9,10.3,6,.8.2v1.1h-.4L115,175.8Zm5.7,5.1,4.6,2.8a1.1,1.1,0,0,0,.8.3h.5a1.8,1.8,0,0,0,1.2-.5l4-2.3v19.6h-.4l-10.8-6.3Z"
          transform="translate(0 0)"
        />
      </g>
      <g id="Graph">
        <path class="cls-3" d="M110.4,323.4v3.9l.9.6v-4H111Z" transform="translate(0 0)" />
        <path
          class="cls-3"
          d="M109.7,326.8v-3.9a10.5,10.5,0,0,1-2-2.2v2.1A5.7,5.7,0,0,0,109.7,326.8Z"
          transform="translate(0 0)"
        />
        <polygon
          class="cls-3"
          points="130.9 319.8 133.3 319.2 133.3 315 133.3 315 130.9 315.6 130.9 319.8"
        />
        <path
          class="cls-3"
          d="M129.8,324.3a14.1,14.1,0,0,1-4.4,1.4h-.1v4.2a17,17,0,0,0,4.5-1.5Z"
          transform="translate(0 0)"
        />
        <polygon class="cls-3" points="130.2 315.8 122.1 317.9 128.5 320.4 130.2 320 130.2 315.8" />
        <path
          class="cls-3"
          d="M124.6,325.9a17.3,17.3,0,0,1-3.2.3h-.8l-2.3-.2h-.1a27.2,27.2,0,0,1-6.2-1.7v4a21,21,0,0,0,12.6,1.8Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M133.7,314.3a9.6,9.6,0,0,0-4-2.9c-5.4-2.5-13.3-2.3-18.3.5a9.2,9.2,0,0,0-3.5,3,5.7,5.7,0,0,0-1.1,2.9,3.6,3.6,0,0,0,.2,1v4.1c.1,2.2,1.6,4.2,4.2,5.7,5.5,3.1,14.3,3.1,19.8,0a6.6,6.6,0,0,0,1.7-1.2h.1v-5.3h-.3l-3.1-1.2,4.3-1.1h.2v-5.3Zm-.4.7v4.2l-2.4.6v-4.2Zm-25.6,5.7a10.5,10.5,0,0,0,2,2.2v3.9a5.7,5.7,0,0,1-2-4Zm21.7-8.6a9.2,9.2,0,0,1,3.5,2.4l-11.6,3.2h-.6v.2h.1l-2.6,7.5a25.4,25.4,0,0,1-6.6-2.1c-2.5-1.5-3.8-3.4-3.8-5.4s1.4-4,4-5.4c4.7-2.6,12.3-2.8,17.6-.4Zm-18.1,15.8-.9-.6v-3.9l.6.4h.3Zm9.4-2.4h-2l2-5.5Zm4.6.3h.1a14.1,14.1,0,0,0,4.4-1.4v4.2a17,17,0,0,1-4.5,1.5Zm6.4-3.3a3.9,3.9,0,0,0-1,.8,18,18,0,0,1-5.5,1.9l-3.4-6.6ZM112,328.3v-4a27.2,27.2,0,0,0,6.2,1.7h.1l2.3.2h.8a17.3,17.3,0,0,0,3.2-.3v4.2a21,21,0,0,1-12.6-1.8Zm10.1-10.4,8.1-2.1V320l-1.7.4Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M107.7,318c0,2,1.3,3.9,3.8,5.4a25.4,25.4,0,0,0,6.6,2.1l2.6-7.5h-.1v-.2h.6l11.6-3.2a9.2,9.2,0,0,0-3.5-2.4c-5.3-2.4-12.9-2.2-17.7.5C109.1,314,107.7,315.9,107.7,318Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M121.8,318.6l3.4,6.6a18,18,0,0,0,5.5-1.9,3.9,3.9,0,0,1,1-.8Z"
          transform="translate(0 0)"
        />
        <path class="cls-3" d="M118.7,325.4h2v-5.6Z" transform="translate(0 0)" />
        <path
          class="cls-1"
          d="M126.1,309l.2-.7a16.9,16.9,0,0,0-5.5-.6v.7A15.7,15.7,0,0,1,126.1,309Z"
          transform="translate(0 0)"
        />
        <rect
          class="cls-1"
          x="127.9"
          y="308.6"
          width="0.7"
          height="2.1"
          transform="translate(-206.9 315.5) rotate(-68.5)"
        />
      </g>
      <g id="Hand">
        <path
          class="cls-3"
          d="M229.8,212.3a1.1,1.1,0,0,1,.3.8v.3l1.5-1v-.8l-.4-.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M223.8,190.4h.2a2.2,2.2,0,0,1,1.2,1.6l1.6-1h0a1.8,1.8,0,0,0-.8-1.4h-.7Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M221.5,192.8l-1.4,1a2.2,2.2,0,0,1,.9,1l.3.6,1.1,2.4v-4.9h-.3c-.2-.1-.3-.2-.5-.1Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M231.7,200.2l-.9-.5-1.3.9.5.3a2.6,2.6,0,0,1,1.2,1.7l1.3-.9h0A1.9,1.9,0,0,0,231.7,200.2Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M227.9,195l-.8-.5-1.6,1.1.5.3a2.6,2.6,0,0,1,1.2,1.7l1.5-1v-.2A1.8,1.8,0,0,0,227.9,195Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M229.8,197.7l-.9-.5-1.4.9.5.3a2.6,2.6,0,0,1,1.2,1.7l1.4-1h0A1.8,1.8,0,0,0,229.8,197.7Z"
          transform="translate(0 0)"
        />
        <polygon class="cls-3" points="230.4 211.3 230.4 211.3 230.4 211.3 230.4 211.3" />
        <polygon class="cls-3" points="231.2 211.3 231.6 211 231.7 210.9 231.2 211.3" />
        <path
          class="cls-1"
          d="M232.2,199.3l-.8-.4v-.2a2.5,2.5,0,0,0-1.2-1.9l-.8-.4v-.2a2.5,2.5,0,0,0-1.2-1.9l-.8-.4v-3.1a2.5,2.5,0,0,0-1.2-1.9H226a1.4,1.4,0,0,0-.9-.1l-2.3,1.5c-.2.1-.2.2-.2.3a1.9,1.9,0,0,0-.2.7v1h-.1a1,1,0,0,0-.9-.2h-.1l-2.3,1.5-.2.2h.1l-.2.2a2,2,0,0,0,.1,1.3,19.5,19.5,0,0,1,.8,2.2l.5,1.8a28.2,28.2,0,0,0,1.9,5.1,8.7,8.7,0,0,1,1.1,4.1h-.4a.8.8,0,0,0-.2.5v1.5a.9.9,0,0,0,.4.8l6.5,3.7h.5c.1,0,.2,0,.3-.2s2-1.3,2-1.8v-1.5a.9.9,0,0,0-.4-.8h0l.8-1.1a5,5,0,0,0,.8-2.7v-5.8A2.8,2.8,0,0,0,232.2,199.3Zm-10.1-6.4h.3v4.9l-1.1-2.4-.3-.6a2.2,2.2,0,0,0-.9-1l1.4-1h.1C221.8,192.7,221.9,192.8,222.1,192.9Zm3.9-3.3a1.8,1.8,0,0,1,.8,1.4h0l-1.6,1a2.2,2.2,0,0,0-1.2-1.6h-.2l1.5-1h.7Zm5.6,22.3v.5l-1.5,1v-.3a1.1,1.1,0,0,0-.3-.8l1.3-1,.4.3Zm-1.2-.6Zm.6-2.5-.2-.4,1.6-1.1.2.4Zm1.5-7.1-1.3.9a2.6,2.6,0,0,0-1.2-1.7l-.5-.3,1.3-.9.9.5a1.8,1.8,0,0,1,.8,1.4Zm-1.9-2.6-1.4,1a2.6,2.6,0,0,0-1.2-1.7l-.5-.3,1.4-.9.9.5A1.8,1.8,0,0,1,230.6,199.1Zm-1.9-2.5-1.5,1a2.6,2.6,0,0,0-1.2-1.7l-.5-.3,1.6-1.1.8.5a1.8,1.8,0,0,1,.8,1.4Zm-9.2-1.7c-.2-.4-.2-.7-.1-.8h.2a1.4,1.4,0,0,1,1.1.9l.3.6a18.9,18.9,0,0,1,1.1,2.5l.3.7h-.1v2.5h.6v-1.8h.3v-8.4c0-.1,0-.3.1-.3h.6a1.8,1.8,0,0,1,.8,1.4v3.3h-.1v3.6h.6v-3l.6.4a1.8,1.8,0,0,1,.8,1.4h-.1v3h.6v-2.4l.6.4a1.8,1.8,0,0,1,.8,1.4h-.1v2.6h.6v-1.8l.6.4a1.8,1.8,0,0,1,.8,1.4v5.8a5,5,0,0,1-.6,2.4l-.6.8-5.5-3a16.4,16.4,0,0,0-1-4.9,30.2,30.2,0,0,1-1.9-5l-.5-1.8a20.9,20.9,0,0,0-.8-2.3Zm3.6,14.4,6.3,3.6v1.6l-6.3-3.6v-1.6Zm8.5,1.7-.4.3.5-.4Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M220.8,199a30.2,30.2,0,0,0,1.9,5,16.4,16.4,0,0,1,1,4.9l5.5,3,.6-.8a5,5,0,0,0,.6-2.4v-5.8a1.8,1.8,0,0,0-.8-1.4l-.6-.4v2.1h-.6v-2.6h.1a1.8,1.8,0,0,0-.8-1.4l-.6-.4v2.4h-.6v-3h.1a1.8,1.8,0,0,0-.8-1.4l-.6-.4v3h-.6V196h.1v-3.3a1.8,1.8,0,0,0-.8-1.4h-.6c-.1,0-.1.2-.1.3v8.3h-.3v1.8h-.6v-2.5h.1l-.3-.7A18.9,18.9,0,0,0,221,196l-.3-.6a1.4,1.4,0,0,0-1.1-.9h-.2c-.1.1-.1.4.1.8a20.9,20.9,0,0,1,.8,2.3Z"
          transform="translate(0 0)"
        />
        <path class="cls-2" d="M229.5,214.5v-1.6l-6.3-3.6v1.6Z" transform="translate(0 0)" />
        <polygon class="cls-3" points="232.4 207.3 230.8 208.4 231 208.8 232.6 207.7 232.4 207.3" />
        <rect
          class="cls-2"
          x="221.4"
          y="185.6"
          width="0.6"
          height="3.7"
          transform="translate(-51.5 285.7) rotate(-60)"
        />
        <rect class="cls-2" x="224.9" y="183.4" width="0.6" height="3.4" />
        <rect
          class="cls-2"
          x="222.3"
          y="182.6"
          width="0.6"
          height="4.5"
          transform="translate(-64.4 148.1) rotate(-32.4)"
        />
      </g>
      <g id="Playback">
        <g id="PlaybackBG">
          <path
            class="cls-3"
            d="M55.4,115.9l1,.6,3.5-2,.4-.3a2.9,2.9,0,0,1,2.4.4l38.4,22.2a7.9,7.9,0,0,1,3,3.5h.2a7.7,7.7,0,0,0-3.4-5.9L62.5,112.1a2.4,2.4,0,0,0-2-.3l-.3.2-5.9,3.5Z"
            transform="translate(0 0)"
          />
          <path
            class="cls-2"
            d="M101.1,136.8,62.7,114.6a2.9,2.9,0,0,0-2.4-.4l-.4.3-3.5,2,37.4,21.6a8.9,8.9,0,0,1,3.8,6l6.5-3.8A7.9,7.9,0,0,0,101.1,136.8Z"
            transform="translate(0 0)"
          />
          <path
            class="cls-1"
            d="M101.4,133.6,63,111.4a2.9,2.9,0,0,0-2.7-.4l-.5.3-8,4.6v.2a3.2,3.2,0,0,0-.7,2.3v24.4a8.4,8.4,0,0,0,3.8,6.6l19.9,11.5a8.4,8.4,0,0,1,2.7,2.9l5.3,9a1.7,1.7,0,0,0,1.5,1.2l.4-.2c.3-.1.5-.2.6-.5l5.6-3.2,2.4,1.4a2.8,2.8,0,0,0,2.9.2,1,1,0,0,0,.6-.5l6.8-3.9.5-.2a3,3,0,0,0,1-2.5V140.2A8.3,8.3,0,0,0,101.4,133.6Zm-7.8,37-7.1-4.1a1.2,1.2,0,0,0-1.4,0,1.6,1.6,0,0,0-.6,1.3v4.8c0,.2,0,.3-.1.3a1.2,1.2,0,0,1-.9-.7l-5.3-9a11.1,11.1,0,0,0-3-3.1l-20-11.5a7.4,7.4,0,0,1-3.3-5.9V118.4a2.2,2.2,0,0,1,.8-2l.8-.2,1.3.3,38.4,22.2a7.5,7.5,0,0,1,3.4,5.8v24.4a2.2,2.2,0,0,1-.9,2A2,2,0,0,1,93.6,170.6ZM60.5,111.8a2.4,2.4,0,0,1,2,.3l38.4,22.2a7.7,7.7,0,0,1,3.4,5.9h-.2l-6.5,3.9a8.9,8.9,0,0,0-3.8-6L56.4,116.5l-1-.6-1.1-.4,5.9-3.5Z"
            transform="translate(0 0)"
          />
          <path
            class="cls-3"
            d="M95.7,170.9a2.2,2.2,0,0,0,.9-2V144.5a7.5,7.5,0,0,0-3.4-5.8L54.8,116.5l-1.3-.3-.8.2a2.2,2.2,0,0,0-.8,2v24.3a7.4,7.4,0,0,0,3.3,5.9l20,11.5a11.1,11.1,0,0,1,3,3.1l5.3,9c.3.6.7.8.9.7s.1-.1.1-.3v-4.8a1.6,1.6,0,0,1,.6-1.3,1.2,1.2,0,0,1,1.4,0l7.1,4.1A2,2,0,0,0,95.7,170.9Z"
            transform="translate(0 0)"
          />
        </g>
        <g id="Arrow">
          <g id="XMLID_1850" data-name="XMLID 1850">
            <path
              id="XMLID_1855_2"
              data-name="XMLID 1855 2"
              class="cls-3"
              d="M83.1,146.6,71.5,132.5c-.7-.8-1.6-1.1-2.1-.8L67,133.1c-.1,0-.1.1,0,.2l1.3,2.4v12.2c0,1.5,1.4,3.4,2.6,3.3l8.9-.5,1.4.8,2.4-1.5h0C84.2,149.4,84.2,147.8,83.1,146.6Z"
              transform="translate(0 0)"
            />
            <path
              id="XMLID_1854_2"
              data-name="XMLID 1854 2"
              class="cls-2"
              d="M83.1,148.2l-11.6-14c-.7-.9-1.6-1.2-2.1-.9L67,134.8c-.1,0-.1.1,0,.1l1.3,2.5v12.1c0,1.6,11.1,1.2,11.1,1.2S84.2,149.5,83.1,148.2Z"
              transform="translate(0 0)"
            />
            <path
              id="XMLID_1851"
              data-name="XMLID 1851"
              class="cls-1"
              d="M81.1,152l-1.4-.9-8.8.4a2.5,2.5,0,0,1-1.8-.8,4.6,4.6,0,0,1-1.3-2.9V135.7l-1.3-2.3a.5.5,0,0,1,.1-.7l2.4-1.5a2.2,2.2,0,0,1,2.6,1l11.7,14a4,4,0,0,1,.9,3,1.3,1.3,0,0,1-.6,1.1Zm-1.8-1.8,4.1-2.4-.6-1-11.7-14c-.6-.7-1.2-1-1.5-.8l-2.1,1.3,1.2,2.3v12.2a3,3,0,0,0,1.1,2.3,2.4,2.4,0,0,0,1.1.6Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_1845_2" data-name="XMLID 1845 2">
            <path
              id="XMLID_1849_2"
              data-name="XMLID 1849 2"
              class="cls-2"
              d="M66.4,134.3v14.6c0,1.6,1.4,3.4,2.6,3.3l11.6-.6c1.2-.1,1.2-2.1,0-3.5L69,134C67.8,132.6,66.4,132.8,66.4,134.3Z"
              transform="translate(0 0)"
            />
            <path
              id="XMLID_1846_2"
              data-name="XMLID 1846 2"
              class="cls-1"
              d="M68.9,152.6a2.8,2.8,0,0,1-1.7-.7,4.3,4.3,0,0,1-1.3-3V134.3a1.5,1.5,0,0,1,.9-1.5c.7-.3,1.6.2,2.4,1l11.7,14.1c.8,1.1,1.3,2.5.8,3.4a1.1,1.1,0,0,1-1.1.8Zm-1.6-19.1h-.2c-.3.1-.3.5-.3.7v14.6a3.2,3.2,0,0,0,1.1,2.4,2.2,2.2,0,0,0,1.1.5l11.6-.6a.7.7,0,0,0,.5-.4,2.9,2.9,0,0,0-.7-2.5L68.7,134.1A2.5,2.5,0,0,0,67.3,133.5Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </g>
      <g id="BehindDesk">
        <path
          class="cls-1"
          d="M272.1,289.7h.5l1.2-.7c.2,0,.1-.2,0-.3l-1.2-.7h-.5l-1.2.7c-.2.1-.1.2,0,.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M273.8,292.3l-1.2-.7a.5.5,0,0,0-.5,0l-1.2.7c-.2.1-.1.2,0,.3l1.2.7h.5l1.2-.7Q274.1,292.5,273.8,292.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M276.9,290.5l-1.2-.7h-.5l-1.2.7c-.2.1-.1.2,0,.3l1.2.7a.5.5,0,0,0,.5,0l1.2-.7a.2.2,0,0,0,0-.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M276.7,294l-1.2-.7H275l-1.2.7c-.2.1-.1.2,0,.3l1.2.7a.5.5,0,0,0,.5,0l1.2-.7Q277,294.2,276.7,294Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M278.1,293.2h.5l1.2-.7a.2.2,0,0,0,0-.3h0l-1.2-.7h-.5l-1.2.7c-.2.1-.1.2,0,.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M279.6,295.6l-1.2-.7h-.5l-1.2.7c-.2.1-.1.2,0,.3l1.2.7h.5l1.2-.7C279.8,295.9,279.8,295.7,279.6,295.6Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M281.5,293.2H281l-1.2.7c-.2.1-.1.2,0,.3l1.2.7h.5l1.2-.7a.2.2,0,0,0,0-.3h0Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M284.5,291.4H284l-1.2.7c-.2.1-.1.2,0,.3l1.3.7h.5l1.2-.7c.1-.1.1-.2-.1-.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M287.1,291.3h.5l1.2-.7c.1,0,.1-.2,0-.3l-1.2-.7a.5.5,0,0,0-.5,0l-1.2.7c-.2.1-.1.2,0,.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M290.7,287.9h-.5l-1.2.7c-.2.1-.1.2,0,.3l1.2.7h.5l1.2-.7a.2.2,0,0,0,0-.3h0Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M284.6,294.9h-.5l-1.2.7c-.2.1-.1.2,0,.3l1.2.7h.5l1.2-.7c.1,0,.1-.2,0-.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M287.6,293.2h-.5l-1.2.7c-.2.1-.1.2,0,.3l1.2.7h.5l1.2-.7c.2-.1.1-.2,0-.3Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M290.7,291.4h-.5l-1.2.7c-.2.1-.1.2,0,.3l1.2.7h.5l1.2-.7a.2.2,0,0,0,0-.3h0Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M280.8,289.4v-7.8a1.1,1.1,0,0,1-.8-.3l-6.8-4v7.8l7.2,4.2Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M271.6,285.1l8.3,4.8a1.6,1.6,0,0,0,.9.3h.5l1.2-.2,8.5-4.9c.1,0,.1,0,.1-.1h.2a1.3,1.3,0,0,0,.6-1h0v-8.6a.5.5,0,0,0-.3-.5c-.1-.3-.2-.5-.5-.6l-7.1-4.2.2-2.9a.8.8,0,0,0-.2-.5h0a1.7,1.7,0,0,0-1-1.3,4.7,4.7,0,0,0-4.3,0,2,2,0,0,0-1,1.5c0,.2.1.3.2.5l.3,3.1-6.6,3.8a1.1,1.1,0,0,0-.6,1.1h0v8.7A1.1,1.1,0,0,0,271.6,285.1Zm7.1-16.8a5.4,5.4,0,0,0,2.2.5,5,5,0,0,0,2.1-.5l.2-.2-.6,6.3c0,.2-.3.5-1,.7h-1.3c-.7-.1-1-.4-1-.7Zm1.4,7.6h.8l1-.2c1-.2,1.6-.8,1.6-1.4v-.7l1.8,1.1-5,2.9-3.2-1.8,1.5-.9a3.1,3.1,0,0,0,1.5,1Zm-1.6-1.7-3,1.7,4.8,2.7,6.6-3.8-3.2-1.9.2-1.9,6.8,4a.5.5,0,0,1,.1.7h-.1l-8.5,4.9a1.9,1.9,0,0,1-1.8,0l-8.4-4.9a.5.5,0,0,1-.1-.7h.1l6.2-3.6Zm-5.3,3.1,6.8,4a1.1,1.1,0,0,0,.8.3v7.8h-.5l-7.2-4.2Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M271.8,275.4a.5.5,0,0,0,.2.4l8.4,4.9a1.9,1.9,0,0,0,1.8,0l8.5-4.9a.5.5,0,0,0,.1-.7h-.1l-6.8-4-.2,1.9,3.2,1.9-6.6,3.8-4.8-2.7,3-1.7-.3-2.8L272,275A.5.5,0,0,0,271.8,275.4Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-2"
          d="M280.4,277.7l5-2.9-1.8-1.1v.7c0,.6-.6,1.2-1.6,1.4l-1,.2h-.8a4.2,4.2,0,0,1-1.4-.9l-1.5.9Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-3"
          d="M279.3,274.4c0,.3.3.6,1,.7h1.3c.7-.2,1-.5,1-.7l.6-6.3-.2.2a5,5,0,0,1-2.1.5,5.4,5.4,0,0,1-2.2-.5Z"
          transform="translate(0 0)"
        />
      </g>
      <path
        id="Shadowjm_3"
        data-name="Shadow 3"
        class="cls-1"
        d="M157.2,332.8l.7-.4-18.7-10.8.9-.4,23.6,13.7-.7.3,18.7,10.9-.9.3Zm21.4,15-23.8-13.6.8-.4L136.9,323l.9-.5,23.6,13.8-.7.3,18.7,10.9Zm-26.1-12.2.7-.4L135,324.7c0-.3.2-.5.5-.7l23.6,13.7c-.1.2-.5.2-.8.3l18.9,10.9-.9.5ZM150,337l.9-.5,23.6,13.8-.7.3Zm-2.2,1.4.9-.5,23.6,13.6-.9.5Zm-2.3,1.4.7-.5L170,352.9l-.9.5Zm-2.5,1.4.9-.5,23.6,13.6-.8.5Zm-1.9,1.6a.7.7,0,0,1,.6-.7l23.6,13.6a2.1,2.1,0,0,1-1.1.4ZM161.9,330c.2-.2.6-.2.7-.4l-18.7-10.8.9-.5,23.6,13.6-.7.4,18.2,10.5c-.2.3-.2.5-.5.7Zm21.4,15.2-23.6-13.8.7-.4-18.7-10.8.8-.4,23.6,13.7-.7.3,18.8,10.9Zm-25.4-24.7a1.8,1.8,0,0,1-.2-1l27.5,15.7a2.5,2.5,0,0,1-1.2.2l-10.7-6.1-.9.5-23.6-13.6.9-.6ZM147.2,317l23.7,13.7-.9.5-23.6-13.6Zm11.4,1.1.9-.4L187.7,334l-.9.5-11.2-6.6-.9.5-23.6-13.6.9-.6Zm21.7-12.3a4.1,4.1,0,0,1,1.9.2l9.3,5.4,7.2,4.4h.2l23.6,13.7-.9.5Zm39.9,24.9-.9.5-41.8-24.1.9-.6Zm-45-22.2.7-.6,41.9,24.2-.7.5Zm-2.4,1.4.9-.6,41.8,24.2-.9.5Zm-2.3,1.2.9-.4,41.8,24.2-.9.3Zm-2.4,1.4.8-.4,41.9,24.2-.9.3Zm-2.3,1.4.9-.4,41.8,24.2-.9.3Zm14,11c-.2.2-.2.5-.5.7L155.6,312a2.1,2.1,0,0,1,1.1-.4l6.6,3.9.9-.6L206,339.1a1.1,1.1,0,0,1-.8.3Zm-7.5-1.6,5.6,3.2-.9.5-23.6-13.6.8-.6,6.9,3.9.8-.5L191.2,333a2.2,2.2,0,0,0-1.6,0Zm30.6-9.9a1.8,1.8,0,0,1,1-.4l23,13.3c0,.4-.2.5-.4.7Zm-2.5,1.4.9-.6,23.6,13.7-.8.5Z"
        transform="translate(0 0)"
      />
      <g id="Desk_4" data-name="Desk 4">
        <g id="XMLID_3408" data-name="XMLID 3408">
          <g id="XMLID_3507" data-name="XMLID 3507">
            <g id="XMLID_4044" data-name="XMLID 4044">
              <g id="XMLID_4090" data-name="XMLID 4090">
                <g id="XMLID_4187" data-name="XMLID 4187">
                  <g id="XMLID_4188" data-name="XMLID 4188">
                    <path
                      id="XMLID_4189"
                      data-name="XMLID 4189"
                      class="cls-1"
                      d="M172.7,289.3h-1.8v-7.6a5.3,5.3,0,0,1,1.8-3.9l8.1-7a2.5,2.5,0,0,1,2.6-.4,2.6,2.6,0,0,1,1.4,2.2v6H183v-6c0-.4-.3-.5-.4-.6s-.4-.1-.7.1l-8.1,7a3.3,3.3,0,0,0-1.2,2.5v7.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4184" data-name="XMLID 4184">
                  <g id="XMLID_4185" data-name="XMLID 4185">
                    <path
                      id="XMLID_4186"
                      data-name="XMLID 4186"
                      class="cls-1"
                      d="M202.8,338.1l-.9-1.6,14.5-8.5a4.4,4.4,0,0,0,1.9-3.3V294.5h1.8v30.2a5.8,5.8,0,0,1-2.8,4.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4181" data-name="XMLID 4181">
                  <g id="XMLID_4182" data-name="XMLID 4182">
                    <path
                      id="XMLID_4183"
                      data-name="XMLID 4183"
                      class="cls-1"
                      d="M170.6,319l-.9-1.6,14.5-8.5a4.4,4.4,0,0,0,1.9-3.3V275.4h1.8v30.2a5.8,5.8,0,0,1-2.8,4.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4157" data-name="XMLID 4157">
                  <g id="XMLID_4174" data-name="XMLID 4174">
                    <g id="XMLID_4179" data-name="XMLID 4179">
                      <path
                        id="XMLID_4180"
                        data-name="XMLID 4180"
                        class="cls-3"
                        d="M222.1,307.7v-2.3H222l-5.7-1.6-14-8.2h-.1l-4.9,2.8h-.1l-1.8-.5h-.1v2.2a1,1,0,0,0,.5.8l18.1,10.5a2.4,2.4,0,0,0,2.6,0l5.1-3C221.9,308.4,222.1,308.1,222.1,307.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4175" data-name="XMLID 4175">
                      <path
                        id="XMLID_4176"
                        data-name="XMLID 4176"
                        class="cls-1"
                        d="M215.2,312.3a2.8,2.8,0,0,1-1.5-.4l-18.1-10.5a1.2,1.2,0,0,1-.7-1.1V298a.5.5,0,0,1,.2-.4h.4l1.7.5,4.8-2.8a.5.5,0,0,1,.5,0l14,8.1,5.7,1.6c.2.1.4.2.4.5v2.4a1.2,1.2,0,0,1-.7,1.1l-5.1,3A4.5,4.5,0,0,1,215.2,312.3Zm-19.5-13.8v1.8c0,.2.1.3.3.4l18.1,10.5a2.2,2.2,0,0,0,2.2,0l5.1-3a.5.5,0,0,0,.3-.5h0v-2.1l-5.6-1.6-13.9-8.1-4.8,2.7h-1.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4167" data-name="XMLID 4167">
                    <g id="XMLID_4172" data-name="XMLID 4172">
                      <path
                        id="XMLID_4173"
                        data-name="XMLID 4173"
                        class="cls-1"
                        d="M222,305.4l-5.7-1.6-1.2-.7v8.8a3.2,3.2,0,0,0,1.4-.3l5.1-3a1,1,0,0,0,.5-.8A19.3,19.3,0,0,0,222,305.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4168" data-name="XMLID 4168">
                      <path
                        id="XMLID_4169"
                        data-name="XMLID 4169"
                        class="cls-1"
                        d="M215.2,312.3h-.5v-9.9l1.7,1,5.7,1.6c.2.1.4.2.4.5v2.4a1.2,1.2,0,0,1-.7,1.1l-5.1,3Zm.3-8.5v7.7a1.1,1.1,0,0,0,.8-.3l5.1-3a.5.5,0,0,0,.3-.5v-2.1l-5.6-1.6Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4159" data-name="XMLID 4159">
                    <g id="XMLID_4164" data-name="XMLID 4164">
                      <path
                        id="XMLID_4166"
                        data-name="XMLID 4166"
                        class="cls-2"
                        d="M214,309.3l-18.2-10.6a1,1,0,0,1-.3-1.4l.3-.3,5.2-3a2.8,2.8,0,0,1,2.5,0l18.1,10.5a1,1,0,0,1,.3,1.4l-.3.3-5.2,3A2.3,2.3,0,0,1,214,309.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4160" data-name="XMLID 4160">
                      <path
                        id="XMLID_4161"
                        data-name="XMLID 4161"
                        class="cls-1"
                        d="M215.2,310a2.3,2.3,0,0,1-1.4-.4l-18.1-10.5a1.5,1.5,0,0,1-.7-1.2,1.4,1.4,0,0,1,.7-1.2l5.2-3a3,3,0,0,1,2.9,0l18.1,10.5a1.5,1.5,0,0,1,.7,1.2,1.4,1.4,0,0,1-.7,1.2l-5.2,3A2.8,2.8,0,0,1,215.2,310Zm-1-1.1a2,2,0,0,0,2.1,0l5.2-3a.6.6,0,0,0,.2-.8c-.1-.1-.1-.2-.2-.2l-18.2-10.5a2,2,0,0,0-2.1,0l-5.2,3a.6.6,0,0,0-.2.8c.1.1.1.2.2.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_4120" data-name="XMLID 4120">
                  <g id="XMLID_4150" data-name="XMLID 4150">
                    <g id="XMLID_4155" data-name="XMLID 4155">
                      <path
                        id="XMLID_4156"
                        data-name="XMLID 4156"
                        class="cls-3"
                        d="M225,290.1h-3l-31.5-18.2-21.9,18h-1.7v2.3a2.1,2.1,0,0,0,1,1.7l31.8,18.4a2.8,2.8,0,0,0,2.9-.2l21.7-17.9a1.6,1.6,0,0,0,.6-1.3v-2.8Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4151" data-name="XMLID 4151">
                      <path
                        id="XMLID_4152"
                        data-name="XMLID 4152"
                        class="cls-1"
                        d="M201.3,313.1a2.8,2.8,0,0,1-1.5-.4L168,294.4a2.8,2.8,0,0,1-1.2-1.8v-.2l-.2-2.8h2l22-18.1,31.6,18.3h3.3v.4l.2,2.8a2.4,2.4,0,0,1-.7,1.6l-21.9,17.8A2.4,2.4,0,0,1,201.3,313.1Zm-33.8-21v.2a1.3,1.3,0,0,0,.8,1.3L200.1,312a2.3,2.3,0,0,0,2.5-.2l21.7-17.9a1.4,1.4,0,0,0,.5-1v-2.4h-2.7l-31.5-18.1-21.8,18h-1.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4143" data-name="XMLID 4143">
                    <g id="XMLID_4148" data-name="XMLID 4148">
                      <path
                        id="XMLID_4149"
                        data-name="XMLID 4149"
                        class="cls-1"
                        d="M202.9,312.2l21.7-17.9a1.6,1.6,0,0,0,.6-1.3l-.2-2.8h-3l-1.6-.9-16,10.7-3.1,6.4v6.4A4.4,4.4,0,0,0,202.9,312.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4144" data-name="XMLID 4144">
                      <path
                        id="XMLID_4145"
                        data-name="XMLID 4145"
                        class="cls-1"
                        d="M200.9,313.1v-6.9h0l3.2-6.5,16.3-10.9,1.7,1h3.3v.4l.2,2.8a2.4,2.4,0,0,1-.7,1.6l-21.7,17.9a2.9,2.9,0,0,1-1.8.7Zm.8-6.7v5.8l.9-.4,21.7-17.9a1.4,1.4,0,0,0,.5-1v-2.4h-2.7l-1.4-.8-15.8,10.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4136" data-name="XMLID 4136">
                    <g id="XMLID_4141" data-name="XMLID 4141">
                      <path
                        id="XMLID_4142"
                        data-name="XMLID 4142"
                        class="cls-1"
                        d="M168.3,293.9v-2.7l.8-.6v-.8l-.3.2h-1.7v2.3a2.1,2.1,0,0,0,1,1.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4137" data-name="XMLID 4137">
                      <path
                        id="XMLID_4138"
                        data-name="XMLID 4138"
                        class="cls-1"
                        d="M168.4,294.5l-.3-.2a2.8,2.8,0,0,1-1.2-1.8v-.2l-.2-2.8h2l.8-.6v1.7l-.8.6v2.6Zm-.8-2.4v.2a1.1,1.1,0,0,0,.3.8v-2.2l.7-.6h-1.1Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4128" data-name="XMLID 4128">
                    <g id="XMLID_4134" data-name="XMLID 4134">
                      <path
                        id="XMLID_4135"
                        data-name="XMLID 4135"
                        class="cls-3"
                        d="M199.8,309.8,168,291.4a2,2,0,0,1-.8-2.7l.5-.6,21.4-17.7a2.3,2.3,0,0,1,2.6-.2l32.4,18.7a1.7,1.7,0,0,1,.6,2.3,1,1,0,0,1-.4.5l-21.7,17.9A2.3,2.3,0,0,1,199.8,309.8Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4130" data-name="XMLID 4130">
                      <path
                        id="XMLID_4131"
                        data-name="XMLID 4131"
                        class="cls-1"
                        d="M201.1,310.6a2.8,2.8,0,0,1-1.5-.4l-31.8-18.4a2.5,2.5,0,0,1-1.2-1.9,2.4,2.4,0,0,1,.9-2.1l21.4-17.7a2.9,2.9,0,0,1,3.1-.3l32.4,18.7a1.8,1.8,0,0,1,1,1.6,1.8,1.8,0,0,1-.8,1.8l-21.7,17.9A2.3,2.3,0,0,1,201.1,310.6Zm-10.5-40.3a1.7,1.7,0,0,0-1.2.4L168,288.4a2,2,0,0,0-.6,1.4,1.6,1.6,0,0,0,.8,1.3L200,309.5a2.3,2.3,0,0,0,2.5-.2l21.7-17.9a1.6,1.6,0,0,0,.5-1.1,1.3,1.3,0,0,0-.6-1l-32.4-18.7A2,2,0,0,0,190.6,270.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4121" data-name="XMLID 4121">
                    <g id="XMLID_4126" data-name="XMLID 4126">
                      <path
                        id="XMLID_4127"
                        data-name="XMLID 4127"
                        class="cls-2"
                        d="M200.3,307.7,170,290.1a.4.4,0,0,1-.2-.5c0-.1,0-.2.1-.2l20.4-17a.9.9,0,0,1,1-.1l30.6,17.6c.2.1.3.5.1.6l-20.5,17A1.1,1.1,0,0,1,200.3,307.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4122" data-name="XMLID 4122">
                      <path
                        id="XMLID_4123"
                        data-name="XMLID 4123"
                        class="cls-1"
                        d="M200.8,308.2l-.7-.2-30.4-17.6a.8.8,0,0,1-.4-.7.9.9,0,0,1,.3-.7L190,272a1.4,1.4,0,0,1,1.5-.1l30.6,17.6a.7.7,0,0,1,.4.6.9.9,0,0,1-.3.7l-20.5,17A1.1,1.1,0,0,1,200.8,308.2Zm-.3-.8a.6.6,0,0,0,.7-.1l20.5-17-30.6-17.6h-.6l-20.4,17h0Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_4091" data-name="XMLID 4091">
                  <g id="XMLID_4113" data-name="XMLID 4113">
                    <g id="XMLID_4118" data-name="XMLID 4118">
                      <path
                        id="XMLID_4119"
                        data-name="XMLID 4119"
                        class="cls-3"
                        d="M222.7,284.8v-2.3h-.1l-5.7-1.6-14-8.2h-.1l-4.9,2.8h-.1L196,275h-.1v2.2a1,1,0,0,0,.5.8l18.1,10.5a2.4,2.4,0,0,0,2.6,0l5.1-3A.8.8,0,0,0,222.7,284.8Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4114" data-name="XMLID 4114">
                      <path
                        id="XMLID_4115"
                        data-name="XMLID 4115"
                        class="cls-1"
                        d="M215.8,289.3a2.8,2.8,0,0,1-1.5-.4l-18.1-10.5a1.2,1.2,0,0,1-.7-1.1V275l.2-.4h.4l1.6.5,4.8-2.8a.5.5,0,0,1,.5,0l14,8.1,5.7,1.6c.2.1.4.2.4.5v2.4a1.2,1.2,0,0,1-.7,1.1l-5.1,3A4,4,0,0,1,215.8,289.3Zm-19.5-13.8v1.8c0,.2.1.3.3.4l18.1,10.5a2.2,2.2,0,0,0,2.2,0l5.1-3a.5.5,0,0,0,.3-.5v-2.1l-5.6-1.6-13.9-8.1-4.8,2.7h-1.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4106" data-name="XMLID 4106">
                    <g id="XMLID_4111" data-name="XMLID 4111">
                      <path
                        id="XMLID_4112"
                        data-name="XMLID 4112"
                        class="cls-1"
                        d="M222.7,282.4l-5.7-1.6-1.2-.7v8.8a3.2,3.2,0,0,0,1.4-.3l5.1-3a1,1,0,0,0,.5-.8A19.3,19.3,0,0,1,222.7,282.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4107" data-name="XMLID 4107">
                      <path
                        id="XMLID_4108"
                        data-name="XMLID 4108"
                        class="cls-1"
                        d="M215.8,289.3h-.5v-9.9l1.7,1,5.7,1.6c.2.1.4.2.4.5v2.4a1.2,1.2,0,0,1-.7,1.1l-5.1,3A4,4,0,0,1,215.8,289.3Zm.3-8.5v7.7a1.1,1.1,0,0,0,.8-.3l5.1-3a.5.5,0,0,0,.3-.5v-2.1l-5.6-1.6Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4099" data-name="XMLID 4099">
                    <g id="XMLID_4104" data-name="XMLID 4104">
                      <path
                        id="XMLID_4105"
                        data-name="XMLID 4105"
                        class="cls-1"
                        d="M197.4,276.2l.3-.9-1.6-.5H196v2.2a1,1,0,0,0,.5.8l.9.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4100" data-name="XMLID 4100">
                      <path
                        id="XMLID_4101"
                        data-name="XMLID 4101"
                        class="cls-1"
                        d="M197.8,279.2l-1.5-.9a1.2,1.2,0,0,1-.7-1.1v-2.3a.8.8,0,0,1,.2-.4h.4l2.1.6v.4a1.1,1.1,0,0,1-.3.8v3Zm-1.5-3.8v1.8c0,.2.1.3.3.4l.3.2v-1.7l.2-.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4092" data-name="XMLID 4092">
                    <g id="XMLID_4097" data-name="XMLID 4097">
                      <path
                        id="XMLID_4098"
                        data-name="XMLID 4098"
                        class="cls-2"
                        d="M214.6,286.3l-18.1-10.5a1,1,0,0,1-.3-1.4l.3-.3,5.2-3a2.8,2.8,0,0,1,2.5,0l18.1,10.5a1,1,0,0,1,.3,1.4l-.3.3-5.2,3A2.8,2.8,0,0,1,214.6,286.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4093" data-name="XMLID 4093">
                      <path
                        id="XMLID_4094"
                        data-name="XMLID 4094"
                        class="cls-1"
                        d="M215.8,287a2.3,2.3,0,0,1-1.4-.4l-18.1-10.5a1.5,1.5,0,0,1-.7-1.2,1.4,1.4,0,0,1,.7-1.2l5.2-3a3,3,0,0,1,2.9,0l18.1,10.5a1.5,1.5,0,0,1,.7,1.2,1.4,1.4,0,0,1-.7,1.2l-5.2,3A2.8,2.8,0,0,1,215.8,287Zm-1-1.1a2,2,0,0,0,2.1,0l5.2-3a.6.6,0,0,0,.2-.8c-.1-.1-.1-.2-.2-.2l-18.2-10.5a2,2,0,0,0-2.1,0l-5.2,3a.6.6,0,0,0-.2.8c.1.1.1.2.2.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g id="XMLID_4081" data-name="XMLID 4081">
                <g id="XMLID_4082" data-name="XMLID 4082">
                  <g id="XMLID_4088" data-name="XMLID 4088">
                    <path
                      id="XMLID_4089"
                      data-name="XMLID 4089"
                      class="cls-2"
                      d="M176.6,288.5l10.6,6.1,10.2-8.5-10.5-6.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4083" data-name="XMLID 4083">
                    <path
                      id="XMLID_4085"
                      data-name="XMLID 4085"
                      class="cls-1"
                      d="M187.2,295l-11.3-6.5,11-9.1,11.2,6.6Zm-9.9-6.6,9.8,5.7,9.6-7.9-9.7-5.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_4072" data-name="XMLID 4072">
                <g id="XMLID_4073" data-name="XMLID 4073">
                  <g id="XMLID_4079" data-name="XMLID 4079">
                    <path
                      id="XMLID_4080"
                      data-name="XMLID 4080"
                      class="cls-2"
                      d="M197.7,294.8l8,4.6,7.8-6.4-8-4.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4074" data-name="XMLID 4074">
                    <path
                      id="XMLID_4075"
                      data-name="XMLID 4075"
                      class="cls-1"
                      d="M205.8,299.9l-8.8-5,8.5-7,8.7,5.1Zm-7.4-5.2,7.3,4.2,7.1-5.9-7.2-4.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_4062" data-name="XMLID 4062">
                <g id="XMLID_4064" data-name="XMLID 4064">
                  <g id="XMLID_4069" data-name="XMLID 4069">
                    <path
                      id="XMLID_4071"
                      data-name="XMLID 4071"
                      class="cls-2"
                      d="M189.9,286.1l5.5,3.2,5.3-4.4-5.4-3.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4065" data-name="XMLID 4065">
                    <path
                      id="XMLID_4066"
                      data-name="XMLID 4066"
                      class="cls-1"
                      d="M195.5,289.8l-6.2-3.6,6-5,6.2,3.6Zm-4.9-3.8,4.8,2.7,4.7-3.9-4.7-2.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_4045" data-name="XMLID 4045">
                <g id="XMLID_4054" data-name="XMLID 4054">
                  <g id="XMLID_4060" data-name="XMLID 4060">
                    <path
                      id="XMLID_4061"
                      data-name="XMLID 4061"
                      class="cls-3"
                      d="M206.2,274.1c-.1,0-.3.1-.2.3l.7,3.7c0,.4.4.9,1.3,1.1h1.4c.9-.2,1.3-.7,1.3-1.1l.7-3.7c0-.1-.1-.3-.2-.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4055" data-name="XMLID 4055">
                    <path
                      id="XMLID_4057"
                      data-name="XMLID 4057"
                      class="cls-1"
                      d="M208.7,279.6h-.8c-1-.2-1.6-.8-1.6-1.4l-.7-3.6c0-.2,0-.4.2-.5l.5-.2h5l.5.2a.8.8,0,0,1,.2.5l-.7,3.7c0,.7-.6,1.2-1.6,1.4Zm-2.3-5.1.7,3.5c0,.2.3.5,1,.7h1.3c.7-.2,1-.5,1-.7h0l.7-3.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4046" data-name="XMLID 4046">
                  <g id="XMLID_4052" data-name="XMLID 4052">
                    <path
                      id="XMLID_4053"
                      data-name="XMLID 4053"
                      class="cls-1"
                      d="M210.7,273c1.1.6,1.1,1.6,0,2.3a4.5,4.5,0,0,1-3.9,0c-1.1-.6-1.1-1.6,0-2.3A3.9,3.9,0,0,1,210.7,273Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4048" data-name="XMLID 4048">
                    <path
                      id="XMLID_4049"
                      data-name="XMLID 4049"
                      class="cls-1"
                      d="M208.7,276.1a5.4,5.4,0,0,1-2.2-.5,1.5,1.5,0,0,1-.9-2.1,1.6,1.6,0,0,1,.9-.9,4.7,4.7,0,0,1,4.3,0,1.5,1.5,0,0,1,.9,2.1,1.6,1.6,0,0,1-.9.9A5,5,0,0,1,208.7,276.1Zm0-3.2a3.9,3.9,0,0,0-1.8.4.8.8,0,0,0,0,1.6h0a3.6,3.6,0,0,0,3.5,0,.8.8,0,1,0,0-1.6A3.3,3.3,0,0,0,208.7,272.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="XMLID_3509" data-name="XMLID 3509">
              <g id="XMLID_4012" data-name="XMLID 4012">
                <g id="XMLID_4034" data-name="XMLID 4034">
                  <g id="XMLID_4041" data-name="XMLID 4041">
                    <path
                      id="XMLID_4042"
                      data-name="XMLID 4042"
                      class="cls-4"
                      d="M177.2,338l2.9.7,3.2-1.2-.4-.8-1-.3s-1.3-.2-1.5-.9-2.1,0-2.1,0l-1.3,1.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4035" data-name="XMLID 4035">
                    <path
                      id="XMLID_4036"
                      data-name="XMLID 4036"
                      class="cls-1"
                      d="M180.1,339.2l-3.2-.8-.4-1.8,1.6-1.3a4.2,4.2,0,0,1,2.2-.2,1,1,0,0,1,.4.5c.1.3.8.5,1.2.6h.1l1.2.4.7,1.3Zm-2.6-1.5,2.5.6,2.6-1v-.2l-.8-.3a2.2,2.2,0,0,1-1.8-1.2,2.6,2.6,0,0,0-1.5.2l-1.1.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4026" data-name="XMLID 4026">
                  <g id="XMLID_4032" data-name="XMLID 4032">
                    <path
                      id="XMLID_4033"
                      data-name="XMLID 4033"
                      class="cls-2"
                      d="M167.1,321.5s5.9-1.9,7.4-3.3-1,2.1.2,5.6,1.4,9.2,1.7,11.5a1.3,1.3,0,0,0,1.1,1.1h.5c.6,0,1.9-.5,2-1.2.1-4.7.5-20.8-.6-22.2s-5.5-3.4-7.6-3l-8.4,1.4Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4027" data-name="XMLID 4027">
                    <path
                      id="XMLID_4028"
                      data-name="XMLID 4028"
                      class="cls-1"
                      d="M178.2,336.9h-.6a1.4,1.4,0,0,1-1.4-1.4c-.1-.6-.2-1.4-.3-2.3-.3-2.8-.7-7.1-1.5-9.1a8.7,8.7,0,0,1-.5-4.8,48.4,48.4,0,0,1-6.6,2.8h-.4l-3.9-11h.5l8.4-1.4c2.2-.4,6.6,1.3,8,3.2s.9,14.7.7,22.5a1.1,1.1,0,0,1-.5.9A6,6,0,0,1,178.2,336.9Zm-2.4-20.4-.9,1.8a7.5,7.5,0,0,0,.2,5.3c.8,2.1,1.2,6.3,1.5,9.3.1.9.2,1.7.3,2.3a.7.7,0,0,0,.7.7h.5a2.1,2.1,0,0,0,1.3-.5l.2-.3c.4-12.5.2-21.1-.5-22s-5.3-3.2-7.2-2.9l-7.9,1.3,3.3,9.4c1.3-.4,5.7-2,6.9-3.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4016" data-name="XMLID 4016">
                  <g id="XMLID_4023" data-name="XMLID 4023">
                    <path
                      id="XMLID_4024"
                      data-name="XMLID 4024"
                      class="cls-1"
                      d="M183.8,336.9a1.8,1.8,0,0,0-2-.4h.1c.4.3,0,.8-.6,1.1a2.7,2.7,0,0,1-3.6-.6v-.4l-.9-.9a.5.5,0,0,0-.7,0c0,.1-.1.1-.1.2a4.4,4.4,0,0,0,.1,3l.2,2.3a.8.8,0,0,0,.2.4h.7l.8-.2c.1,0,.2-.2.2-.3V340c0-.2.1-.3.3-.2l.3.2a1.7,1.7,0,0,0,1,.3,2,2,0,0,0,1.1-.2C182.5,339.2,184.5,338,183.8,336.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4017" data-name="XMLID 4017">
                    <path
                      id="XMLID_4018"
                      data-name="XMLID 4018"
                      class="cls-1"
                      d="M176.9,341.9h-.5a.7.7,0,0,1-.3-.6l-.2-2.2a4.7,4.7,0,0,1-.1-3.1,1,1,0,0,1,.6-.5.6.6,0,0,1,.7.2l.9.9h.1v.4a2.6,2.6,0,0,0,3.2.5.9.9,0,0,0,.6-.6h-.1l-.6-.4.6-.2c1.4-.4,2,.1,2.3.5a1.2,1.2,0,0,1,.1,1c-.2.8-1.2,1.6-3.2,2.6a2,2,0,0,1-1.3.2,2.1,2.1,0,0,1-1.1-.4h0v.9a.7.7,0,0,1-.4.6l-.8.2Zm-.1-.7h.4l.7-.2v-1.1a.8.8,0,0,1,.2-.5h.5l.4.2a1.6,1.6,0,0,0,.9.3,1.5,1.5,0,0,0,.9-.2c.6-.3,2.6-1.3,2.9-2.2a.4.4,0,0,0-.1-.5c-.2-.4-.7-.4-1.1-.4v.2c0,.5-.6.9-1,1a3.1,3.1,0,0,1-4-.7h0v-.3h0l-.8-.8h-.1c-.1,0-.1,0-.1.1h0a4.2,4.2,0,0,0,.1,2.7h0l.2,2.3c-.1,0-.1.1,0,.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4013" data-name="XMLID 4013">
                  <g id="XMLID_4014" data-name="XMLID 4014">
                    <path
                      id="XMLID_4015"
                      data-name="XMLID 4015"
                      class="cls-3"
                      d="M178.4,338h-.6l.2,1.3h.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_3995" data-name="XMLID 3995">
                <g id="XMLID_4004" data-name="XMLID 4004">
                  <g id="XMLID_4009" data-name="XMLID 4009">
                    <path
                      id="XMLID_4010"
                      data-name="XMLID 4010"
                      class="cls-3"
                      d="M185.1,295.8l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l5.1-4.3a.7.7,0,0,0,0-1h-.1l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-5.1,4.4a.6.6,0,0,0-.3.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4005" data-name="XMLID 4005">
                    <path
                      id="XMLID_4006"
                      data-name="XMLID 4006"
                      class="cls-1"
                      d="M188.6,298l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l5.1-4.4a1.5,1.5,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-5.1,4.3A1.3,1.3,0,0,1,188.6,298Zm2.4-7.6-.5.2-5.1,4.4v.4l2.9,1.7a.9.9,0,0,0,1-.1l5.1-4.3c.1-.1.1-.1.1-.2v-.2l-2.8-1.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3997" data-name="XMLID 3997">
                  <g id="XMLID_4002" data-name="XMLID 4002">
                    <path
                      id="XMLID_4003"
                      data-name="XMLID 4003"
                      class="cls-3"
                      d="M185.1,295l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l5.1-4.3a.7.7,0,0,0,0-1h-.1l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-5.1,4.4a.7.7,0,0,0-.2.8C185,294.9,185,295,185.1,295Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3998" data-name="XMLID 3998">
                    <path
                      id="XMLID_3999"
                      data-name="XMLID 3999"
                      class="cls-1"
                      d="M188.6,297.3l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l5.1-4.4a1.5,1.5,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-5.1,4.3A1.3,1.3,0,0,1,188.6,297.3Zm2.4-7.6-.5.2-5.1,4.4v.2c0,.1,0,.1.1.2l2.9,1.7a.9.9,0,0,0,1-.1l5.1-4.3v-.4l-2.8-1.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_3957" data-name="XMLID 3957">
                <g id="XMLID_3992" data-name="XMLID 3992">
                  <g id="XMLID_3993" data-name="XMLID 3993">
                    <path
                      id="XMLID_3994"
                      data-name="XMLID 3994"
                      class="cls-1"
                      d="M164.7,351.6l-.9-1.6,10.7-6.4a3.9,3.9,0,0,0,1.8-3.8l-1.5-10.5,1.8-.3,1.5,10.5a5.5,5.5,0,0,1-2.7,5.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3989" data-name="XMLID 3989">
                  <g id="XMLID_3990" data-name="XMLID 3990">
                    <path
                      id="XMLID_3991"
                      data-name="XMLID 3991"
                      class="cls-1"
                      d="M149.4,342.5l-.9-1.6,11-6.7a4.1,4.1,0,0,0,2-3.3l.4-10.2h1.8l-.4,10.2a5.8,5.8,0,0,1-2.8,4.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3959" data-name="XMLID 3959">
                  <g id="XMLID_3982" data-name="XMLID 3982">
                    <g id="XMLID_3987" data-name="XMLID 3987">
                      <path
                        id="XMLID_3988"
                        data-name="XMLID 3988"
                        class="cls-3"
                        d="M181.5,325.7v-2h-.1l-5.1-1.4-12.6-7.3h-.1l-12.1,6.9h-.1l-1.6-.4h-.1v2a1,1,0,0,0,.4.7l16.2,9.4a2.4,2.4,0,0,0,2.3,0l12.3-7A.9.9,0,0,0,181.5,325.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3983" data-name="XMLID 3983">
                      <path
                        id="XMLID_3984"
                        data-name="XMLID 3984"
                        class="cls-1"
                        d="M167.7,334.2a2.3,2.3,0,0,1-1.4-.4l-16.2-9.4a1.1,1.1,0,0,1-.6-1v-2l.2-.4h.4l1.5.4,12-6.8h.5l12.5,7.3,5.1,1.4a.5.5,0,0,1,.3.5v2.1a1.3,1.3,0,0,1-.6,1l-12.3,7A3.2,3.2,0,0,1,167.7,334.2Zm-17.4-12.4v1.5a.8.8,0,0,0,.2.4l16.2,9.4a2.1,2.1,0,0,0,1.9,0l12.3-7a.5.5,0,0,0,.2-.4v-1.8l-5-1.4-12.4-7.2-12.1,6.9h-.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_3975" data-name="XMLID 3975">
                    <g id="XMLID_3980" data-name="XMLID 3980">
                      <path
                        id="XMLID_3981"
                        data-name="XMLID 3981"
                        class="cls-1"
                        d="M151.2,321.6l-1.2-.3h-.1v2a1,1,0,0,0,.4.7l.9.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3976" data-name="XMLID 3976">
                      <path
                        id="XMLID_3977"
                        data-name="XMLID 3977"
                        class="cls-1"
                        d="M151.6,325.2l-1.5-.9a1.1,1.1,0,0,1-.6-1v-1.9h0l.2-.4h.4l1.5.4Zm-1.3-3.4v1.5a.8.8,0,0,0,.2.4l.3.2V322Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_3967" data-name="XMLID 3967">
                    <g id="XMLID_3972" data-name="XMLID 3972">
                      <path
                        id="XMLID_3974"
                        data-name="XMLID 3974"
                        class="cls-1"
                        d="M181.5,323.6l-5.1-1.4-8.7,6.4v5.2a2.7,2.7,0,0,0,1.2-.3l12.3-7a.8.8,0,0,0,.4-.7A16.2,16.2,0,0,1,181.5,323.6Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3968" data-name="XMLID 3968">
                      <path
                        id="XMLID_3969"
                        data-name="XMLID 3969"
                        class="cls-1"
                        d="M167.7,334.2h-.5v-5.8l9.1-6.7h.2l5.1,1.4a.5.5,0,0,1,.3.5v2.1a1.3,1.3,0,0,1-.6,1l-12.3,7A2.9,2.9,0,0,1,167.7,334.2Zm.3-5.4v4.6l.6-.2,12.3-7a.5.5,0,0,0,.2-.4V324l-4.7-1.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_3960" data-name="XMLID 3960">
                    <g id="XMLID_3965" data-name="XMLID 3965">
                      <path
                        id="XMLID_3966"
                        data-name="XMLID 3966"
                        class="cls-2"
                        d="M166.6,331.4,150.4,322a1,1,0,0,1-.3-1.2l.3-.3,12.3-7a2.2,2.2,0,0,1,2.2,0l16.2,9.4a.9.9,0,0,1,.5,1,1.2,1.2,0,0,1-.5.5l-12.3,7A2.2,2.2,0,0,1,166.6,331.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3961" data-name="XMLID 3961">
                      <path
                        id="XMLID_3962"
                        data-name="XMLID 3962"
                        class="cls-1"
                        d="M167.7,332.1a2,2,0,0,1-1.3-.4l-16.2-9.4a1.3,1.3,0,0,1-.6-1.1,1.1,1.1,0,0,1,.6-1.1l12.3-7a2.4,2.4,0,0,1,2.6,0l16.2,9.4a1.3,1.3,0,0,1,.6,1.1,1.1,1.1,0,0,1-.6,1.1l-12.3,7A2,2,0,0,1,167.7,332.1Zm-4-18.6-.9.2-12.3,7a.5.5,0,0,0-.1.7h.1l16.2,9.4a1.9,1.9,0,0,0,1.8,0l12.3-7a.5.5,0,0,0,.1-.7h-.1l-16.2-9.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g id="XMLID_3933" data-name="XMLID 3933">
                <g id="XMLID_3950" data-name="XMLID 3950">
                  <g id="XMLID_3955" data-name="XMLID 3955">
                    <path
                      id="XMLID_3956"
                      data-name="XMLID 3956"
                      class="cls-4"
                      d="M178.9,294.8l1.7-1.1a3.9,3.9,0,0,1,2.1-.6,2.1,2.1,0,0,1,2.1,1.2v.4l-1.7.6v.3l.5.3s-.5,1.8-3.5,1.3S178.9,294.8,178.9,294.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3951" data-name="XMLID 3951">
                    <path
                      id="XMLID_3952"
                      data-name="XMLID 3952"
                      class="cls-1"
                      d="M181.1,297.6h-.9c-1-.1-1.7-.5-1.9-1.1a2.1,2.1,0,0,1,.4-1.9h.1l1.7-1.1a3.5,3.5,0,0,1,2.4-.6,2.4,2.4,0,0,1,2.4,1.4h0v.8l-1.4.5h.3v.3A3,3,0,0,1,181.1,297.6Zm-1.9-2.5a2,2,0,0,0-.3,1.1,1.6,1.6,0,0,0,1.3.6c1.9.3,2.7-.4,2.9-.8l-.5-.2.2-.8,1.6-.6a1.7,1.7,0,0,0-1.7-.9,3.2,3.2,0,0,0-1.9.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3934" data-name="XMLID 3934">
                  <g id="XMLID_3940" data-name="XMLID 3940">
                    <path
                      id="XMLID_3941"
                      data-name="XMLID 3941"
                      class="cls-4"
                      d="M168,293.7c.3.7-.3-1,0,0l2.2,5.5a44,44,0,0,1,5-2.1,16.5,16.5,0,0,0,3.7-2h.1a2.3,2.3,0,0,1,1.6,2.1v.2c-.7.7-7.3,6.6-12.1,7.6a17.9,17.9,0,0,1-4.2-7.3C162.9,292.8,167.5,291.9,168,293.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3935" data-name="XMLID 3935">
                    <path
                      id="XMLID_3936"
                      data-name="XMLID 3936"
                      class="cls-1"
                      d="M168.4,305.4h-.2a18.2,18.2,0,0,1-4.3-7.5c-.8-2.9.4-4.7,1.9-5.2a2,2,0,0,1,2.2.5.5.5,0,0,1,.2.4h.1c.8,2,1.7,4.2,2,5.1l4.6-2a15.8,15.8,0,0,0,3.6-2h.5a2.6,2.6,0,0,1,1.9,2.5.8.8,0,0,1-.2.5c-.7.7-7.4,6.6-12.3,7.7Zm-1.7-12.2h-.6c-1.1.3-2.1,1.6-1.4,4.2a17.3,17.3,0,0,0,3.9,7c4.6-1.1,10.7-6.6,11.6-7.4a2.1,2.1,0,0,0-1.2-1.7,16.5,16.5,0,0,1-3.7,2,42.5,42.5,0,0,0-4.9,2.1l-.4.2-.2-.4-2.1-5.3c-.1-.1-.1-.2-.2-.4s-.4-.3-.8-.3Z"
                      transform="translate(0 0)"
                    />
                    <path
                      id="Vector_11"
                      data-name="Vector 11"
                      class="cls-5"
                      d="M179.8,294.6a5.2,5.2,0,0,1-1.1,1c-.3.5.9,2,1.4,1.6l.9-.4.6-.8C181.1,295.5,180,294.5,179.8,294.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_3899" data-name="XMLID 3899">
                <g id="XMLID_3925" data-name="XMLID 3925">
                  <g id="XMLID_3931" data-name="XMLID 3931">
                    <path
                      id="XMLID_3932"
                      data-name="XMLID 3932"
                      class="cls-4"
                      d="M189.7,335.5a2.8,2.8,0,0,0,1.9.9,2.2,2.2,0,0,1,1.8,1l-1.6,1.9h-3.1l-1.7-1.2-.5-2.1,1.9-.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3926" data-name="XMLID 3926">
                    <path
                      id="XMLID_3928"
                      data-name="XMLID 3928"
                      class="cls-1"
                      d="M192,339.6h-3.4l-1.9-1.4-.6-2.5,2.4-1.1,1.4.6h.1a2.4,2.4,0,0,0,1.6.7h.1a2.6,2.6,0,0,1,2.1,1.2l.2.2Zm-3.1-.9h2.8l1.2-1.5a1.4,1.4,0,0,0-1.2-.6h-.1a3.3,3.3,0,0,1-2.1-.9l-.9-.4-1.5.7.4,1.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3917" data-name="XMLID 3917">
                  <g id="XMLID_3923" data-name="XMLID 3923">
                    <path
                      id="XMLID_3924"
                      data-name="XMLID 3924"
                      class="cls-2"
                      d="M157,320.2s7.5,12.6,26.1-1.5c.1-.1.2,0,.2.1a8.9,8.9,0,0,0,.4,5.8c1.2,2.6,2.3,8.4,2.8,10.7a1.2,1.2,0,0,0,1.1,1h.5c.6,0,1.5-.6,1.5-1.3-.2-4.7-.9-20.7-2-22.1s-6-1.9-8-1.4l-14,3.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3918" data-name="XMLID 3918">
                    <path
                      id="XMLID_3919"
                      data-name="XMLID 3919"
                      class="cls-1"
                      d="M188.1,336.8h-.5a1.5,1.5,0,0,1-1.5-1.3V335c-.5-2.5-1.6-7.7-2.7-10.1a8.8,8.8,0,0,1-.5-5.3c-6.8,5-13,7.1-18.2,6a11.9,11.9,0,0,1-7.8-5.1l-.2-.3,8.9-5,14-3.9c2.3-.6,6.6-.7,8.5,1.5s1.5,7.8,2.1,22.1v.2a1.5,1.5,0,0,1-.4,1.1A3.5,3.5,0,0,1,188.1,336.8Zm-.5-.8h.5a1.8,1.8,0,0,0,.9-.4.8.8,0,0,0,.2-.5v-.2c-.7-16.8-1.4-21-1.9-21.6s-5.4-1.8-7.6-1.2l-14,3.9-8.1,4.5a12.2,12.2,0,0,0,7.1,4.4c5.2,1,11.3-1.1,18.2-6.4h.6a.4.4,0,0,1,.2.5,8.9,8.9,0,0,0,.3,5.6,62.5,62.5,0,0,1,2.7,10.3v.5a.9.9,0,0,0,.9.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3909" data-name="XMLID 3909">
                  <g id="XMLID_3915" data-name="XMLID 3915">
                    <path
                      id="XMLID_3916"
                      data-name="XMLID 3916"
                      class="cls-1"
                      d="M194.3,337.5c-.3-1.1-1.3-1.3-2.7-1.2a1.5,1.5,0,0,1,.9.6c.4.4,0,.8-.8,1.1a3,3,0,0,1-3.7-1l-.2-.2-.2-.3h-.1l-.8-1a.6.6,0,0,0-.8,0h-.1a4.4,4.4,0,0,0-.1,3V341a.5.5,0,0,0,.2.4h.3a2.1,2.1,0,0,0,1.1-.1c.1,0,.2-.2.3-.3v-1.2c0-.1.1-.2.2-.1l.2.2.7.5a2.5,2.5,0,0,0,1.7,0C192.3,340,194.7,339,194.3,337.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3911" data-name="XMLID 3911">
                    <path
                      id="XMLID_3912"
                      data-name="XMLID 3912"
                      class="cls-1"
                      d="M186.5,342h-.4l-.4-.2a.9.9,0,0,1-.3-.6v-2.4a5,5,0,0,1,.1-3.2.8.8,0,0,1,.7-.5,1.1,1.1,0,0,1,.8.3l.8,1-.2.3.2-.2.2.3.2.2h0a2.8,2.8,0,0,0,3.3.9c.5-.2.7-.4.7-.5h0a1.4,1.4,0,0,0-.8-.5l-1.5-.4,1.5-.2c.6-.1,2.6-.3,3,1.4s-2.7,3.1-4,3.5a2.7,2.7,0,0,1-2-.1,1.8,1.8,0,0,1-.7-.5v.9a.6.6,0,0,1-.5.6Zm-.1-6.4h0a.2.2,0,0,0-.2.2h0a5.3,5.3,0,0,0-.1,2.8h0v2.5c0,.1,0,.2.1.2h1.1v-1.3c0-.2.1-.3.3-.4s.3,0,.4.1l.2.2.6.4a1.9,1.9,0,0,0,1.5,0c1.7-.6,3.9-1.5,3.6-2.8s-.4-.9-1.4-.9h.1a.6.6,0,0,1,.2.7c-.1.5-.7.8-1.1,1a3.2,3.2,0,0,1-4-1.1l-.2-.2-.3-.4-.8-1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3905" data-name="XMLID 3905">
                  <g id="XMLID_3906" data-name="XMLID 3906">
                    <path
                      id="XMLID_3908"
                      data-name="XMLID 3908"
                      class="cls-3"
                      d="M187.9,337.9h-.6v1.6h.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3900" data-name="XMLID 3900">
                  <g id="XMLID_3901" data-name="XMLID 3901">
                    <path
                      id="XMLID_3904"
                      data-name="XMLID 3904"
                      class="cls-1"
                      d="M183.7,318.9h-.8a3,3,0,0,1,1.2-2.2l.5.6A2.6,2.6,0,0,0,183.7,318.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_3887" data-name="XMLID 3887">
                <g id="XMLID_3891" data-name="XMLID 3891">
                  <g id="XMLID_3897" data-name="XMLID 3897">
                    <path
                      id="XMLID_3898"
                      data-name="XMLID 3898"
                      class="cls-1"
                      d="M156,299.6s-1.6,10.3-2.4,15.9,6.4,8.5,11,9.1,9.5-2,11-4.3a9.6,9.6,0,0,1,3.7-3.5s-5.9-4.1-7.6-14.7-7.6-12.2-7.9-12.2S156,299.6,156,299.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3893" data-name="XMLID 3893">
                    <path
                      id="XMLID_3894"
                      data-name="XMLID 3894"
                      class="cls-1"
                      d="M165.9,325.1h-1.4c-3.5-.4-8-2.1-10.1-4.9a5.7,5.7,0,0,1-1.2-4.7c.9-5.6,2.4-15.8,2.4-15.8h.1c7.5-10,7.8-10,8-10s6.5,1.2,8.3,12.6,7.4,14.4,7.4,14.4l.5.4-.6.3a11.4,11.4,0,0,0-3.5,3.4C174.5,322.8,170.2,325.1,165.9,325.1Zm-9.5-25.3c-.2,1.1-1.6,10.5-2.4,15.8a5.4,5.4,0,0,0,1.1,4.1c2,2.6,6.2,4.2,9.6,4.6s9.3-2,10.6-4.1a13.3,13.3,0,0,1,3.3-3.4c-1.5-1.2-5.9-5.6-7.3-14.6s-6.6-11.6-7.4-11.9S158.9,296.4,156.4,299.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3888" data-name="XMLID 3888">
                  <g id="XMLID_3889" data-name="XMLID 3889">
                    <path
                      id="XMLID_3890"
                      data-name="XMLID 3890"
                      class="cls-3"
                      d="M177.1,317.6c-4.9-3.3-7.2-10.5-7.3-10.8l.6-.2c0,.1,2.3,7.3,7,10.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_3858" data-name="XMLID 3858">
                <g id="XMLID_3859" data-name="XMLID 3859">
                  <g id="XMLID_3864" data-name="XMLID 3864">
                    <g id="XMLID_3879" data-name="XMLID 3879">
                      <g id="XMLID_3884" data-name="XMLID 3884">
                        <path
                          id="XMLID_3886"
                          data-name="XMLID 3886"
                          class="cls-4"
                          d="M187.6,297.1a6.8,6.8,0,0,1,1.4-2.3c.6-.5,1,0,1.2.3h.3l1.7-1c.2-.1.5-.1.6.1a2.1,2.1,0,0,1,.1,2.3c-.7,1.8-3.7,2.4-3.7,2.4Z"
                          transform="translate(0 0)"
                        />
                      </g>
                      <g id="XMLID_3880" data-name="XMLID 3880">
                        <path
                          id="XMLID_3881"
                          data-name="XMLID 3881"
                          class="cls-1"
                          d="M189.1,299.5l-2-2.4v-.2a7.9,7.9,0,0,1,1.5-2.5,1.4,1.4,0,0,1,.9-.3,1.4,1.4,0,0,1,.8.5l1.6-.9a.8.8,0,0,1,1.1.3h0a2.7,2.7,0,0,1,.2,2.6c-.8,2-3.9,2.7-4,2.7Zm-1-2.5,1.4,1.6c.7-.2,2.7-.9,3.2-2.1s.2-1.6-.1-1.9h-.1l-1.7,1a.5.5,0,0,1-.7,0c0-.1-.1-.1-.1-.2s-.2-.3-.4-.3h-.3A3.9,3.9,0,0,0,188.1,297Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </g>
                    <g id="XMLID_3872" data-name="XMLID 3872">
                      <g id="XMLID_3877" data-name="XMLID 3877">
                        <path
                          id="XMLID_3878"
                          data-name="XMLID 3878"
                          class="cls-1"
                          d="M186.5,297.8l.9-1a.4.4,0,0,1,.5-.1,4.3,4.3,0,0,1,1.8,1.5.5.5,0,0,1-.1.7h0l-1.1.9c-.1.2-.4.2-.6,0h0l-1.4-1.3c-.2-.1-.2-.4-.1-.6Z"
                          transform="translate(0 0)"
                        />
                      </g>
                      <g id="XMLID_3873" data-name="XMLID 3873">
                        <path
                          id="XMLID_3874"
                          data-name="XMLID 3874"
                          class="cls-1"
                          d="M188.2,300.5l-.6-.2-1.4-1.3a1,1,0,0,1,0-1.4l.9-1a.8.8,0,0,1,1-.2,5.5,5.5,0,0,1,2,1.7.9.9,0,0,1-.2,1.3l-1.1.9Zm-1.5-2.4h0l1.4,1.3h.1l1.1-.9c.1,0,.1-.2,0-.2a5.4,5.4,0,0,0-1.6-1.4h-.1Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </g>
                    <g id="XMLID_3865" data-name="XMLID 3865">
                      <g id="XMLID_3870" data-name="XMLID 3870">
                        <path
                          id="XMLID_3871"
                          data-name="XMLID 3871"
                          class="cls-4"
                          d="M168.6,295.1a1.3,1.3,0,0,1,1.4-.6l.7.4a21.6,21.6,0,0,1,2.7,3.3c1.6,2.5,5.1,7.1,5.1,7.1s2.5-2.2,4.4-3.6a16.2,16.2,0,0,0,3.2-3.2h.1a2.1,2.1,0,0,1,2.1,1.6v.2c-.5.9-5.2,8.1-9.6,10.9a.7.7,0,0,1-.9-.1,43,43,0,0,1-7.8-8.7C167.5,298.1,168,296.1,168.6,295.1Z"
                          transform="translate(0 0)"
                        />
                      </g>
                      <g id="XMLID_3866" data-name="XMLID 3866">
                        <path
                          id="XMLID_3867"
                          data-name="XMLID 3867"
                          class="cls-1"
                          d="M178.4,311.6a1.1,1.1,0,0,1-.8-.3c-1.3-1.1-5.7-5.1-7.8-8.8s-2.5-5.9-1.5-7.7a1.8,1.8,0,0,1,1.8-.8,1.6,1.6,0,0,1,.9.5,18.1,18.1,0,0,1,2.8,3.4c1.3,2.1,4,5.6,4.8,6.7,1.3-1.2,2.7-2.3,4.1-3.4a15.2,15.2,0,0,0,3.1-3.1l.5-.2a2.6,2.6,0,0,1,2.5,1.9.4.4,0,0,1-.1.5c-.5.8-5.2,8.2-9.7,11.1A.7.7,0,0,1,178.4,311.6Zm-9.8-16.5.3.2c-.9,1.4-.3,3.8,1.5,6.9s6.4,7.5,7.7,8.6h.5c4.2-2.7,8.7-9.7,9.4-10.7a2.1,2.1,0,0,0-1.6-1.3,15.7,15.7,0,0,1-3.2,3.1c-1.8,1.4-4.3,3.6-4.3,3.6l-.3.3-.3-.3s-3.5-4.6-5.1-7.1a26,26,0,0,0-2.6-3.2l-.5-.3a1,1,0,0,0-1,.4Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </g>
                  </g>
                  <g id="XMLID_3860" data-name="XMLID 3860">
                    <g id="XMLID_3861" data-name="XMLID 3861">
                      <path
                        id="XMLID_3863"
                        data-name="XMLID 3863"
                        class="cls-1"
                        d="M179.1,307.2l-.8-.2a10.9,10.9,0,0,0-.1-1.8l.8-.2A16.2,16.2,0,0,1,179.1,307.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g id="XMLID_3551" data-name="XMLID 3551">
                <g id="XMLID_3850" data-name="XMLID 3850">
                  <g id="XMLID_3856" data-name="XMLID 3856">
                    <path
                      id="XMLID_3857"
                      data-name="XMLID 3857"
                      class="cls-3"
                      d="M167.8,288.4s-.8,2.5-.1,3.8-2.4.9-2.4.9l-3.1-2.3a7.1,7.1,0,0,0,.9-2.8c-.1-1.3-.2-1.4.1-1.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3851" data-name="XMLID 3851">
                    <path
                      id="XMLID_3852"
                      data-name="XMLID 3852"
                      class="cls-1"
                      d="M166.1,293.5h-1l-3.5-2.5.2-.3a5,5,0,0,0,.8-2.6,2.8,2.8,0,0,0-.1-.9c0-.4-.1-.6.2-.8a.4.4,0,0,1,.5-.1l4.7,1.8h.3v.4c-.2.7-.6,2.6-.1,3.4s.1.8,0,.9A5,5,0,0,1,166.1,293.5Zm-.7-.9c1,.1,1.9,0,2-.2h0c-.6-1.1-.2-2.9,0-3.7l-4-1.5a2.2,2.2,0,0,0,.1.8,6.5,6.5,0,0,1-.8,2.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3841" data-name="XMLID 3841">
                  <g id="XMLID_3848" data-name="XMLID 3848">
                    <path
                      id="XMLID_3849"
                      data-name="XMLID 3849"
                      class="cls-2"
                      d="M167.5,276s3.9-.2,5.1,3.2a5.6,5.6,0,0,1-1.3,5.8s-3.3-1-3.8-2.6S167.5,276,167.5,276Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3843" data-name="XMLID 3843">
                    <path
                      id="XMLID_3844"
                      data-name="XMLID 3844"
                      class="cls-1"
                      d="M171.5,285.5h-.2c-.4-.1-3.5-1.1-4.1-2.8s0-6.4,0-6.6v-.3h.3s4.2-.1,5.5,3.4a6.3,6.3,0,0,1-1.4,6.3Zm-3.6-9.1c-.2,1.5-.4,4.8,0,5.9s2.4,1.9,3.3,2.2a5.2,5.2,0,0,0,1.1-5.2,5.1,5.1,0,0,0-4.4-2.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3833" data-name="XMLID 3833">
                  <g id="XMLID_3839" data-name="XMLID 3839">
                    <path
                      id="XMLID_3840"
                      data-name="XMLID 3840"
                      class="cls-4"
                      d="M165.3,276.5s-2.7-2.3-3.7,3.4c-.7,3.9.8,6.3,3.7,8.5a3.1,3.1,0,0,0,2.8.5,4,4,0,0,0,2.4-2.8,13.9,13.9,0,0,0,.4-6.7c.6-2.3-1-2-3.7-2.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3834" data-name="XMLID 3834">
                    <path
                      id="XMLID_3835"
                      data-name="XMLID 3835"
                      class="cls-1"
                      d="M167.2,289.4a3.5,3.5,0,0,1-2.2-.8c-3.4-2.6-4.5-5.2-3.9-8.9s1.2-3.6,2.3-4a2.4,2.4,0,0,1,2,.3h1.9l1.6.4c1.1.2,1.9.4,2.3,1a2,2,0,0,1,.1,1.7,14.2,14.2,0,0,1-.4,6.8,4.4,4.4,0,0,1-2.7,3.1A1.8,1.8,0,0,1,167.2,289.4Zm-3.1-13h-.4c-.5.2-1.3,1-1.7,3.4a9.3,9.3,0,0,0,3.6,8.1,2.8,2.8,0,0,0,2.5.5,3.4,3.4,0,0,0,2.2-2.6,13,13,0,0,0,.4-6.5h0a2.4,2.4,0,0,0,0-1.2,3.6,3.6,0,0,0-1.8-.7l-1.6-.4h-2.1A1.7,1.7,0,0,0,164.1,276.4Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3825" data-name="XMLID 3825">
                  <g id="XMLID_3830" data-name="XMLID 3830">
                    <path
                      id="XMLID_3832"
                      data-name="XMLID 3832"
                      class="cls-3"
                      d="M167.1,294.9c1.2.2,3.2-1.4,2.3-2.3h-.1c-.8-.5-3.3.2-4.8-.8s-1.2-1.5-1.1-1.9a.6.6,0,0,0-.2-.7.8.8,0,0,0-.7-.2,1.6,1.6,0,0,0-1.2,2.1h0a5.6,5.6,0,0,0,3.2,3A7.7,7.7,0,0,0,167.1,294.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_3826" data-name="XMLID 3826">
                    <path
                      id="XMLID_3827"
                      data-name="XMLID 3827"
                      class="cls-1"
                      d="M167.3,295.3h-.2a12.8,12.8,0,0,1-2.8-.7,6.1,6.1,0,0,1-3.4-3.3,2.7,2.7,0,0,1,.2-2,1.6,1.6,0,0,1,1.3-.8q.8,0,.9.3a1.1,1.1,0,0,1,.3,1.1c-.1.3,0,.9.9,1.5a5.8,5.8,0,0,0,2.9.5,3.2,3.2,0,0,1,1.9.3h.2a1.2,1.2,0,0,1,.3,1.4A2.9,2.9,0,0,1,167.3,295.3Zm-4.8-5.9h0a.8.8,0,0,0-.7.4,2,2,0,0,0-.2,1.3,5.3,5.3,0,0,0,2.9,2.8,11.1,11.1,0,0,0,2.6.7,2.3,2.3,0,0,0,2-1.1c.1-.2,0-.4-.1-.4s-.1,0-.1-.1h0a2.6,2.6,0,0,0-1.5-.2,6.3,6.3,0,0,1-3.3-.6c-1.4-.9-1.4-1.9-1.3-2.3a.4.4,0,0,0-.1-.3c0-.2-.1-.2-.2-.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3620" data-name="XMLID 3620">
                  <g id="XMLID_3621" data-name="XMLID 3621">
                    <g id="XMLID_3627" data-name="XMLID 3627">
                      <path
                        id="XMLID_3628"
                        data-name="XMLID 3628"
                        class="cls-2"
                        d="M166.3,274.3c2.1.3,4.6,2,5.1,3.5s.3,2.8-1.5,2.6-1.3,1.9-1.6,2.5a1.4,1.4,0,0,1-1,.7c-.6-.1-1.3.7-1.4,1.5a2,2,0,0,0,.6,1.8c-1.2,2.8,4.4,5.9-1.1,8.1-.1.1,3.8,5.6-1.3,8.6s-12.9,1.6-14.9-3.3c-3.4-8.5,8.4-10.2,9-17.5C158.6,277,162.8,273.8,166.3,274.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3622" data-name="XMLID 3622">
                      <path
                        id="XMLID_3623"
                        data-name="XMLID 3623"
                        class="cls-1"
                        d="M158.3,305.2a12.1,12.1,0,0,1-4.6-.8,7.6,7.6,0,0,1-4.9-4.2c-2-5.1,1.1-7.9,4.2-10.6s4.6-4.1,4.8-7.1a10,10,0,0,1,3.5-7.2,6.8,6.8,0,0,1,5.1-1.6c2.3.3,4.9,2.1,5.4,3.7s.4,2.1-.1,2.6a2.4,2.4,0,0,1-1.8.5c-.1,0-.4.4-1,1.9a.6.6,0,0,0-.1.4,1.4,1.4,0,0,1-1.4.9c-.1,0-.2,0-.4.2a2.1,2.1,0,0,0-.6,1,1.5,1.5,0,0,0,.4,1.4l.3.2v.3c-.4.9.1,1.9.6,3s1.1,2.2.6,3.3a3.5,3.5,0,0,1-2.2,1.9c2.5,4.9.5,7.4-1.6,8.7A11.2,11.2,0,0,1,158.3,305.2Zm7.4-30.6a6.3,6.3,0,0,0-3.9,1.5,9.3,9.3,0,0,0-3.2,6.6c-.3,3.3-2.7,5.5-5.1,7.6s-5.7,5.1-3.9,9.7a6.6,6.6,0,0,0,4.4,3.7c3.2,1.1,7.4.9,9.9-.6s3.2-4.1,1.3-7.7a1.4,1.4,0,0,1-.2-.6v-.2h.2c1.2-.5,1.9-1,2.1-1.6a3.3,3.3,0,0,0-.6-2.7,4.5,4.5,0,0,1-.7-3.4,2.4,2.4,0,0,1,.4-3.5,1,1,0,0,1,1-.3c.2-.1.5-.2.6-.4s.1-.2.1-.4.9-2.5,1.8-2.4.9,0,1.1-.2.3-.7-.1-1.8-2.8-2.9-4.8-3.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_3563" data-name="XMLID 3563">
                  <g id="XMLID_3564" data-name="XMLID 3564">
                    <path
                      id="XMLID_3565"
                      data-name="XMLID 3565"
                      class="cls-1"
                      d="M170.3,280.3h-.8a2.6,2.6,0,0,0-1.2-2.9l.3-.7A3.4,3.4,0,0,1,170.3,280.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3560" data-name="XMLID 3560">
                  <g id="XMLID_3561" data-name="XMLID 3561">
                    <path
                      id="XMLID_3562"
                      data-name="XMLID 3562"
                      class="cls-1"
                      d="M165,295a4.5,4.5,0,0,0-1.2-2.1l.6-.5a7.2,7.2,0,0,1,1.4,2.4Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3556" data-name="XMLID 3556">
                  <g id="XMLID_3557" data-name="XMLID 3557">
                    <path
                      id="XMLID_3558"
                      data-name="XMLID 3558"
                      class="cls-1"
                      d="M160.5,282.6h-.8a7.3,7.3,0,0,1,2.1-4.8l.5.6-.3-.3.3.3A6.4,6.4,0,0,0,160.5,282.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3553" data-name="XMLID 3553">
                  <g id="XMLID_3554" data-name="XMLID 3554">
                    <path
                      id="XMLID_3555"
                      data-name="XMLID 3555"
                      class="cls-1"
                      d="M153.8,302a4.9,4.9,0,0,1-2.6-4h.8a4.2,4.2,0,0,0,2.2,3.4Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_3510" data-name="XMLID 3510">
                <g id="XMLID_3518" data-name="XMLID 3518">
                  <g id="XMLID_3543" data-name="XMLID 3543">
                    <g id="XMLID_3549" data-name="XMLID 3549">
                      <path
                        id="XMLID_3550"
                        data-name="XMLID 3550"
                        class="cls-2"
                        d="M167.7,321.5l-2.5-12.3a3,3,0,0,0-1.4-1.9l-15.1-8.7h-.6a3.3,3.3,0,0,0-2.2,1.6h0l1.8,1h.1l2,10.4a2.6,2.6,0,0,0,1.3,1.9l11.4,4.4,1.1,1.4,1.5,4.5c.3,0,2.4-.1,2.5-1.7h0A.5.5,0,0,0,167.7,321.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3544" data-name="XMLID 3544">
                      <path
                        id="XMLID_3546"
                        data-name="XMLID 3546"
                        class="cls-1"
                        d="M165,324.3V324l-1.5-4.5-1-1.3-11.4-4.4a3.2,3.2,0,0,1-1.5-2.1l-2-10.1-1.8-1a.5.5,0,0,1-.2-.6,3.6,3.6,0,0,1,2.5-1.8.8.8,0,0,1,.8.2l15.1,8.7a3.6,3.6,0,0,1,1.6,2.2l2.5,12.3a.9.9,0,0,1,0,.7h0c-.1,1.5-1.6,2.1-2.9,2.1Zm-16.8-23.7,2.1,10.9a2.1,2.1,0,0,0,1.1,1.6l11.5,4.5h.1l1.2,1.5,1.4,4.3c.6,0,1.8-.3,1.8-1.4h0v-.4l-2.5-12.3a2.2,2.2,0,0,0-1.2-1.6L148.6,299h-.3a2.7,2.7,0,0,0-1.8,1.1l1.3.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_3535" data-name="XMLID 3535">
                    <g id="XMLID_3541" data-name="XMLID 3541">
                      <path
                        id="XMLID_3542"
                        data-name="XMLID 3542"
                        class="cls-1"
                        d="M167.8,322.2h0v-.5l-2.5-12.3a3.7,3.7,0,0,0-.5-1.1,5.4,5.4,0,0,1-1.8,1.1l-2.4,1.4a46.8,46.8,0,0,0-3.8,3.9,4.9,4.9,0,0,0,.1,1.2l5.6,2.2,1.1,1.4,1.5,4.5C165.6,323.9,167.6,323.9,167.8,322.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3536" data-name="XMLID 3536">
                      <path
                        id="XMLID_3537"
                        data-name="XMLID 3537"
                        class="cls-1"
                        d="M165,324.3V324l-1.5-4.5-1-1.3-5.7-2.2v-.2c-.2-1.2-.2-1.3-.1-1.4a39.7,39.7,0,0,1,4-4.2l2.3-1.3h.1a5.4,5.4,0,0,0,1.6-1l.3-.3.3.4a3.1,3.1,0,0,1,.6,1.3l2.5,12.3a.9.9,0,0,1,0,.7h0c-.1,1.5-1.6,2.1-2.9,2.1Zm-7.6-8.8,5.5,2.1h.1l1.2,1.5,1.4,4.3c.6,0,1.8-.3,1.8-1.4h0v-.4l-2.5-12.3a1.4,1.4,0,0,0-.2-.6,6,6,0,0,1-1.5.9l-2.3,1.3c-.4.3-3.2,3.2-3.6,3.7a2.8,2.8,0,0,0,.1.9Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_3527" data-name="XMLID 3527">
                    <g id="XMLID_3533" data-name="XMLID 3533">
                      <path
                        id="XMLID_3534"
                        data-name="XMLID 3534"
                        class="cls-1"
                        d="M149.4,299l-.7-.4h-.6a3.3,3.3,0,0,0-2.2,1.6h0l1,.6.4-.4A6,6,0,0,1,149.4,299Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3528" data-name="XMLID 3528">
                      <path
                        id="XMLID_3530"
                        data-name="XMLID 3530"
                        class="cls-1"
                        d="M146.9,301.2l-1.2-.7a.5.5,0,0,1-.2-.6,3.6,3.6,0,0,1,2.5-1.8.8.8,0,0,1,.8.2l1.4.8-.8.3a11.8,11.8,0,0,0-1.9,1.1l-.5.5Zm-.4-1.2.4.2h.1a7.8,7.8,0,0,1,1.5-1h-.3a3.8,3.8,0,0,0-1.7.8Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_3519" data-name="XMLID 3519">
                    <g id="XMLID_3525" data-name="XMLID 3525">
                      <path
                        id="XMLID_3526"
                        data-name="XMLID 3526"
                        class="cls-3"
                        d="M166.1,322.9l-2.5-12.5a2.9,2.9,0,0,0-1.3-1.9l-15.2-8.7a.8.8,0,0,0-1.2.9l2.3,12.1a2.6,2.6,0,0,0,1.3,1.9l15.4,9.1C165.4,324.2,166.2,323.6,166.1,322.9Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_3520" data-name="XMLID 3520">
                      <path
                        id="XMLID_3521"
                        data-name="XMLID 3521"
                        class="cls-1"
                        d="M165.3,324.3l-.6-.2L149.3,315a3.2,3.2,0,0,1-1.5-2.1l-2.3-12.1a1.1,1.1,0,0,1,.5-1.2,1.2,1.2,0,0,1,1.3-.1l15.2,8.7a2.7,2.7,0,0,1,1.5,2.1l2.5,12.5a1.1,1.1,0,0,1-.5,1.2Zm-18.7-24.1h-.2c-.1,0-.2.2-.2.4l2.3,12.1a2.1,2.1,0,0,0,1.1,1.6l15.4,9.1c.2.1.4,0,.5,0s.2-.2.2-.4l-2.5-12.5a2.2,2.2,0,0,0-1.2-1.6l-15.2-8.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_3514" data-name="XMLID 3514">
                  <g id="XMLID_3516" data-name="XMLID 3516">
                    <path
                      id="XMLID_3517"
                      data-name="XMLID 3517"
                      class="cls-1"
                      d="M164.3,333.8a3.1,3.1,0,0,1-1.3-.3,2.6,2.6,0,0,1-1.3-2.2,18.1,18.1,0,0,0-.4-4L158.8,316a8.5,8.5,0,0,0-4.2-5.6l-.7-.4a1.2,1.2,0,0,0-1.3.1,1.1,1.1,0,0,0-.5,1.2l2.3,10.7a18.4,18.4,0,0,1,.4,4.1h0a1,1,0,0,0,.4.7.6.6,0,0,0,.8,0l1,1.6a2.7,2.7,0,0,1-2.6.1,2.6,2.6,0,0,1-1.3-2.2h0a15.5,15.5,0,0,0-.4-3.7l-2.3-10.7a3.1,3.1,0,0,1,4.5-3.3l.7.4a10.4,10.4,0,0,1,5.1,6.8l2.5,11.3a21.2,21.2,0,0,1,.5,4.4,1,1,0,0,0,.4.7.6.6,0,0,0,.8,0l1,1.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_3511" data-name="XMLID 3511">
                  <g id="XMLID_3512" data-name="XMLID 3512">
                    <path
                      id="XMLID_3513"
                      data-name="XMLID 3513"
                      class="cls-3"
                      d="M166.4,324v-.6c1.3-.3,1.2-1.2,1.2-1.3l-2.5-12.8h.6l2.5,12.8a1.8,1.8,0,0,1-1.7,1.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="XMLID_3409" data-name="XMLID 3409">
            <g id="XMLID_3499" data-name="XMLID 3499">
              <g id="XMLID_3505" data-name="XMLID 3505">
                <path
                  id="XMLID_3506"
                  data-name="XMLID 3506"
                  class="cls-3"
                  d="M229.3,317.4s-1-2.3-4.8-2.8a1.2,1.2,0,0,0-1,.2l-15.5,9a4.4,4.4,0,0,0-1.8,3.5v11.9a1.1,1.1,0,0,0,.3.8,8,8,0,0,0,4.3,2.6c1.5.4,5-4.4,8.1-9.2l5.4-3.1a2.6,2.6,0,0,0,1.1-2.1v-5.5l2.9-3.7Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3501" data-name="XMLID 3501">
                <path
                  id="XMLID_3502"
                  data-name="XMLID 3502"
                  class="cls-1"
                  d="M210.9,343h-.3a9.1,9.1,0,0,1-4.5-2.7,1.5,1.5,0,0,1-.4-1.1V327.3a4.8,4.8,0,0,1,2-3.8l15.5-9a2,2,0,0,1,1.3-.2c4,.5,5,2.9,5.1,3v.2l-4,5.2v5.4a3.1,3.1,0,0,1-1.3,2.5l-5.3,3.1C214,341.6,212,343,210.9,343Zm13.3-28.1-.5.2-15.5,9a4,4,0,0,0-1.6,3.2v11.9a.8.8,0,0,0,.2.5,8.3,8.3,0,0,0,4.1,2.5c.4.1,2.1-.2,7.6-9.1h.1l5.5-3.2a2.1,2.1,0,0,0,.9-1.8v-5.6l3.9-5.1a5.6,5.6,0,0,0-4.2-2.4h-.5Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3491" data-name="XMLID 3491">
              <g id="XMLID_3497" data-name="XMLID 3497">
                <path
                  id="XMLID_3498"
                  data-name="XMLID 3498"
                  class="cls-2"
                  d="M211.4,327.6c2.3.5,10.5-3.5,10.5-3.5l3.4-1.4v-.2l2.9-3.7,1.1-1.4s-.8-2.3-4.6-2.8h-.2a1.2,1.2,0,0,0-1,.2l-15.5,9a4.3,4.3,0,0,0-1.4,1.6A20.9,20.9,0,0,0,211.4,327.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3492" data-name="XMLID 3492">
                <path
                  id="XMLID_3494"
                  data-name="XMLID 3494"
                  class="cls-1"
                  d="M211.8,328h-.5a15.4,15.4,0,0,1-5-2.4l-.2-.2v-.2a3.8,3.8,0,0,1,1.5-1.8l15.5-9a1.5,1.5,0,0,1,1.3-.2h.1c4,.5,4.9,2.9,5,3v.2l-4,5.2v.3l-3.7,1.5C221.3,324.8,214.6,328,211.8,328Zm-4.7-2.8a13.5,13.5,0,0,0,4.4,2c1.7.4,8-2.4,10.2-3.5l3.2-1.3,3.9-5.1c-.3-.5-1.3-2-4.2-2.3h-.2c-.2-.1-.4,0-.7.1l-15.5,9C207.8,324.2,207.4,324.7,207.1,325.2Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3448" data-name="XMLID 3448">
              <g id="XMLID_3489" data-name="XMLID 3489">
                <path
                  id="XMLID_3490"
                  data-name="XMLID 3490"
                  class="cls-1"
                  d="M227.8,317.2l-15.5,9a4.4,4.4,0,0,0-1.8,3.5v11.9c0,.8.5,1.2,1.1.8l17-9.8a2.6,2.6,0,0,0,1.1-2.1V318.6C229.6,317.2,228.8,316.6,227.8,317.2Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3449" data-name="XMLID 3449">
                <path
                  id="XMLID_3450"
                  data-name="XMLID 3450"
                  class="cls-1"
                  d="M211.1,342.9h-.5a1.4,1.4,0,0,1-.6-1.2v-12a4.8,4.8,0,0,1,2-3.8l15.5-9a1.5,1.5,0,0,1,1.6-.1,2.3,2.3,0,0,1,.8,1.8v11.9a3.1,3.1,0,0,1-1.3,2.5l-17,9.8Zm17.4-25.5-.5.2-15.5,9a4,4,0,0,0-1.6,3.2v11.9a1.4,1.4,0,0,0,.2.6c.1.1.2,0,.3-.1h0l17-9.8a2.1,2.1,0,0,0,.9-1.8V318.7c0-.6-.2-1-.4-1.1Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3445" data-name="XMLID 3445">
              <g id="XMLID_3446" data-name="XMLID 3446">
                <path
                  id="XMLID_3447"
                  data-name="XMLID 3447"
                  class="cls-3"
                  d="M211.3,334.6h-.4a1.2,1.2,0,0,1-.7-.7l.7-.3q0,.1.3.3h.5l16.4-9.5a2.5,2.5,0,0,0,1.1-1.7l.8.2a3,3,0,0,1-1.5,2.1l-16.4,9.5Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3437" data-name="XMLID 3437">
              <g id="XMLID_3442" data-name="XMLID 3442">
                <path
                  id="XMLID_3443"
                  data-name="XMLID 3443"
                  class="cls-1"
                  d="M221.3,331.3l-2,1.2c-.2.1-.4,0-.4-.3v-4.4a.9.9,0,0,1,.4-.8l2-1.2c.2-.1.4,0,.4.3v4.4A1.2,1.2,0,0,1,221.3,331.3Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3438" data-name="XMLID 3438">
                <path
                  id="XMLID_3439"
                  data-name="XMLID 3439"
                  class="cls-3"
                  d="M219.1,332.9h-.3a.9.9,0,0,1-.3-.7v-4.4a1.4,1.4,0,0,1,.6-1.1l2-1.2a.9.9,0,0,1,.7,0,.9.9,0,0,1,.3.7v4.4a1.4,1.4,0,0,1-.6,1.1l-2,1.2Zm2.2-6.7-1.8,1c-.1,0-.2.3-.2.4v4.3l1.8-1c.1,0,.2-.3.2-.4Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3431" data-name="XMLID 3431">
              <g id="XMLID_3432" data-name="XMLID 3432">
                <path
                  id="XMLID_3433"
                  data-name="XMLID 3433"
                  class="cls-3"
                  d="M220.2,329.1h-.3a.5.5,0,0,1-.3-.5v-.3a1.2,1.2,0,0,1,.4-.8.6.6,0,0,1,.6,0,.5.5,0,0,1,.3.5v.3a1.2,1.2,0,0,1-.4.8Zm-.1-.7.2.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3427" data-name="XMLID 3427">
              <g id="XMLID_3428" data-name="XMLID 3428">
                <path
                  id="XMLID_3430"
                  data-name="XMLID 3430"
                  class="cls-3"
                  d="M227.9,318.5l-15.8,9.2.4.7,15.8-9.2Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3410" data-name="XMLID 3410">
              <g id="XMLID_3418" data-name="XMLID 3418">
                <g id="XMLID_3425" data-name="XMLID 3425">
                  <path
                    id="XMLID_3426"
                    data-name="XMLID 3426"
                    class="cls-3"
                    d="M224.6,316.9l-1.7,1-1-1a.8.8,0,0,0-1-.1l-4,2.3a2.3,2.3,0,0,0-1,1.2l-1,2.4-1.5.8a.9.9,0,0,1-.7,0l-1.3-.8a.2.2,0,0,1,0-.3h0l1.6-.9,1-2.4a2.9,2.9,0,0,1,1-1.2l4.2-2.4a.8.8,0,0,1,.9,0l1.5.9,1.3-.7h.7l1.3.8C224.7,316.7,224.7,316.9,224.6,316.9Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3419" data-name="XMLID 3419">
                  <path
                    id="XMLID_3420"
                    data-name="XMLID 3420"
                    class="cls-1"
                    d="M213,323.9l-.6-.2-1.3-.8a.6.6,0,0,1-.2-.8c.1-.1.1-.2.2-.2l1.4-.8.9-2.2a2.5,2.5,0,0,1,1.2-1.3l4.2-2.4a1.5,1.5,0,0,1,1.3,0l1.3.8,1-.6a1.1,1.1,0,0,1,1.1,0l1.3.8a.6.6,0,0,1,.2.8l-.2.2-2,1.1-1.3-1.2a.7.7,0,0,0-.6-.1l-4,2.3a1.6,1.6,0,0,0-.8,1l-1,2.5-1.6.9Zm-1.2-1.4,1,.6h.3l1.4-.8.9-2.2a2.5,2.5,0,0,1,1.2-1.3l4-2.3-.9-.6h-.5l-4.2,2.4a1.6,1.6,0,0,0-.8,1l-1,2.5Zm10.2-5.9h0l.9.9,1.2-.7-1-.6h-.3Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3414" data-name="XMLID 3414">
                <g id="XMLID_3416" data-name="XMLID 3416">
                  <path
                    id="XMLID_3417"
                    data-name="XMLID 3417"
                    class="cls-1"
                    d="M213.1,321.1l-.4.7,1.9,1.2.4-.7Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3411" data-name="XMLID 3411">
                <g id="XMLID_3412" data-name="XMLID 3412">
                  <path
                    id="XMLID_3413"
                    data-name="XMLID 3413"
                    class="cls-1"
                    d="M214.4,318l-.4.6,1.9,1.3.5-.7Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        id="Shadowjm_2"
        data-name="Shadow 2"
        class="cls-1"
        d="M86.2,283.8l.7-.4L68.2,272.6l.9-.4,23.6,13.7-.7.3,18.7,10.9-.9.3Zm21.4,15L83.8,285.2l.8-.4L65.9,274l.9-.5,23.6,13.8-.7.3,18.7,10.9ZM81.5,286.6l.7-.4L64,275.7c0-.3.2-.5.5-.7l23.6,13.7c-.1.2-.5.2-.8.3l18.9,10.9-.9.5ZM79,288l.9-.5,23.6,13.8-.7.3Zm-2.2,1.4.8-.5,23.7,13.6-.9.5Zm-2.3,1.4.7-.5L99,303.9l-.9.5Zm-2.4,1.4.8-.5,23.6,13.6-.8.5Zm-2,1.6a.7.7,0,0,1,.6-.7l23.6,13.6a2.1,2.1,0,0,1-1.1.4ZM90.9,281c.2-.2.6-.2.7-.4L72.9,269.8l.9-.5,23.6,13.6-.7.4,18.2,10.5c-.2.3-.2.5-.5.7Zm21.4,15.2L88.7,282.4l.7-.4L70.7,271.2l.8-.4,23.6,13.7-.7.3,18.8,10.9ZM86.9,271.5a1.8,1.8,0,0,1-.2-1l27.5,15.7a2.5,2.5,0,0,1-1.2.2l-10.7-6.1-.9.5L77.8,267.2l.9-.6ZM76.2,268l23.7,13.7-.9.5L75.4,268.6Zm11.4,1.1.9-.4L116.7,285l-.9.5-11.2-6.6-.9.5L80.1,265.8l.9-.6Zm21.7-12.3a4.1,4.1,0,0,1,1.9.2l9.3,5.4,7.2,4.4h.2l23.6,13.7-.9.5Zm39.9,24.9-.9.5-41.8-24.1.9-.6Zm-45-22.2.7-.6,41.9,24.2-.7.5Zm-2.4,1.4.9-.6,41.8,24.2-.9.5Zm-2.3,1.2.9-.4,41.8,24.2-.9.3Zm-2.4,1.4.8-.4,41.9,24.2-.9.3Zm-2.3,1.4.9-.4,41.8,24.2-.9.3Zm14,11c-.2.2-.2.5-.5.7L84.6,263a2.1,2.1,0,0,1,1.1-.4l6.6,3.9.9-.6L135,290.1a1.1,1.1,0,0,1-.8.3Zm-7.5-1.6,5.6,3.2-.9.5L82.4,264.4l.8-.6,6.9,3.9.8-.5L120.2,284a2.2,2.2,0,0,0-1.6,0Zm30.6-9.9a1.8,1.8,0,0,1,1-.4l23,13.3c0,.4-.2.5-.4.7Zm-2.5,1.4.9-.6,23.6,13.7-.8.5Z"
        transform="translate(0 0)"
      />
      <g id="Desk_3" data-name="Desk 3">
        <g id="XMLID_4833" data-name="XMLID 4833">
          <g id="XMLID_4878" data-name="XMLID 4878">
            <g id="XMLID_5157" data-name="XMLID 5157">
              <g id="XMLID_5278" data-name="XMLID 5278">
                <g id="XMLID_5376" data-name="XMLID 5376">
                  <g id="XMLID_5377" data-name="XMLID 5377">
                    <path
                      id="XMLID_5378"
                      data-name="XMLID 5378"
                      class="cls-1"
                      d="M99.1,238.5H97.3v-7.6a5.3,5.3,0,0,1,1.8-3.9l8.1-7a2.5,2.5,0,0,1,2.6-.4,2.4,2.4,0,0,1,1.4,2.2v6h-1.8v-6c0-.4-.3-.5-.4-.6s-.4-.1-.7.1l-8.1,7a3.3,3.3,0,0,0-1.2,2.5v7.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5373" data-name="XMLID 5373">
                  <g id="XMLID_5374" data-name="XMLID 5374">
                    <path
                      id="XMLID_5375"
                      data-name="XMLID 5375"
                      class="cls-1"
                      d="M131.9,285.7l-.9-1.6,11.8-6.9a4.4,4.4,0,0,0,1.9-3.3V243.7h1.8v30.2a5.8,5.8,0,0,1-2.8,4.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5370" data-name="XMLID 5370">
                  <g id="XMLID_5371" data-name="XMLID 5371">
                    <path
                      id="XMLID_5372"
                      data-name="XMLID 5372"
                      class="cls-1"
                      d="M97,268.2l-.9-1.6,14.5-8.5a4.4,4.4,0,0,0,1.9-3.3V224.6h1.8v30.2a5.8,5.8,0,0,1-2.8,4.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5348" data-name="XMLID 5348">
                  <g id="XMLID_5363" data-name="XMLID 5363">
                    <g id="XMLID_5368" data-name="XMLID 5368">
                      <path
                        id="XMLID_5369"
                        data-name="XMLID 5369"
                        class="cls-3"
                        d="M148.5,256.9v-2.3h-.1l-5.7-1.6-14-8.2h-.1l-4.9,2.8h-.1l-1.8-.5h-.1v2.2a1,1,0,0,0,.5.8l18.1,10.5a2.4,2.4,0,0,0,2.6,0l5.1-3C148.3,257.6,148.4,257.3,148.5,256.9Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5364" data-name="XMLID 5364">
                      <path
                        id="XMLID_5365"
                        data-name="XMLID 5365"
                        class="cls-1"
                        d="M141.6,261.5a2.8,2.8,0,0,1-1.5-.4L122,250.6a1.2,1.2,0,0,1-.7-1.1v-2.3a.5.5,0,0,1,.2-.4h.4l1.6.5,4.8-2.8h.5l14,8.1,5.7,1.6c.2.1.4.2.4.5V257a1.2,1.2,0,0,1-.7,1.1l-5.1,3A2.6,2.6,0,0,1,141.6,261.5Zm-19.5-13.8v1.8a.5.5,0,0,0,.3.5l18.1,10.5a2.2,2.2,0,0,0,2.2,0l5.1-3a.5.5,0,0,0,.3-.5v-2l-5.6-1.6-13.9-8.1-4.8,2.7h-.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5356" data-name="XMLID 5356">
                    <g id="XMLID_5361" data-name="XMLID 5361">
                      <path
                        id="XMLID_5362"
                        data-name="XMLID 5362"
                        class="cls-1"
                        d="M148.4,254.6l-5.7-1.6-1.2-.7v8.8a3.2,3.2,0,0,0,1.4-.3l5.1-3a1,1,0,0,0,.5-.8,19.3,19.3,0,0,0-.1-2.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5357" data-name="XMLID 5357">
                      <path
                        id="XMLID_5358"
                        data-name="XMLID 5358"
                        class="cls-1"
                        d="M141.6,261.5h-.5v-9.9l1.7,1,5.7,1.6c.2.1.4.2.4.5V257a1.5,1.5,0,0,1-.7,1.2l-5.1,3A4,4,0,0,1,141.6,261.5Zm.3-8.5v7.7a1.1,1.1,0,0,0,.8-.3l5.1-3a.5.5,0,0,0,.3-.5v-2l-5.6-1.6Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5349" data-name="XMLID 5349">
                    <g id="XMLID_5354" data-name="XMLID 5354">
                      <path
                        id="XMLID_5355"
                        data-name="XMLID 5355"
                        class="cls-2"
                        d="M140.3,258.5,122.2,248a1,1,0,0,1-.3-1.4l.3-.3,5.2-3a2.8,2.8,0,0,1,2.5,0L148,253.8a1,1,0,0,1,.3,1.4l-.3.3-5.2,3A2.8,2.8,0,0,1,140.3,258.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5350" data-name="XMLID 5350">
                      <path
                        id="XMLID_5351"
                        data-name="XMLID 5351"
                        class="cls-1"
                        d="M141.6,259.2a2.3,2.3,0,0,1-1.4-.4l-18.1-10.5a1.5,1.5,0,0,1-.7-1.2,1.4,1.4,0,0,1,.7-1.2l5.2-3a3,3,0,0,1,2.9,0l18.1,10.5a1.5,1.5,0,0,1,.7,1.2,1.4,1.4,0,0,1-.7,1.2l-5.2,3A2.8,2.8,0,0,1,141.6,259.2Zm-13-15.9a1.7,1.7,0,0,0-1,.3l-5.2,3a.6.6,0,0,0-.2.8l.2.2,18.1,10.5a2,2,0,0,0,2.1,0l5.2-3a.6.6,0,0,0,.2-.8l-.2-.2-18.1-10.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_5313" data-name="XMLID 5313">
                  <g id="XMLID_5341" data-name="XMLID 5341">
                    <g id="XMLID_5346" data-name="XMLID 5346">
                      <path
                        id="XMLID_5347"
                        data-name="XMLID 5347"
                        class="cls-3"
                        d="M151.4,239.4h-3l-31.5-18.2L95,239.2H93.3v2.3a2.1,2.1,0,0,0,1,1.7l31.8,18.4a2.8,2.8,0,0,0,2.9-.2l21.7-17.9a1.6,1.6,0,0,0,.6-1.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5342" data-name="XMLID 5342">
                      <path
                        id="XMLID_5343"
                        data-name="XMLID 5343"
                        class="cls-1"
                        d="M127.6,262.3a2.8,2.8,0,0,1-1.5-.4L94.3,243.5a2.8,2.8,0,0,1-1.2-1.8v-.2l-.2-2.8h2l22-18.1,31.6,18.3h3.3v.4l.2,2.8a2.4,2.4,0,0,1-.7,1.6l-21.7,17.9A3.1,3.1,0,0,1,127.6,262.3Zm-33.7-21v.2a1.3,1.3,0,0,0,.8,1.3l31.8,18.4a2.3,2.3,0,0,0,2.5-.2l21.7-17.9a1.4,1.4,0,0,0,.5-1v-2.4h-2.8l-31.2-18-21.8,18H94Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5334" data-name="XMLID 5334">
                    <g id="XMLID_5339" data-name="XMLID 5339">
                      <path
                        id="XMLID_5340"
                        data-name="XMLID 5340"
                        class="cls-1"
                        d="M129.2,261.4l21.7-17.9a1.6,1.6,0,0,0,.6-1.3l-.2-2.8h-3l-1.5-1-16,10.7-3.1,6.4v6.4A2.7,2.7,0,0,0,129.2,261.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5335" data-name="XMLID 5335">
                      <path
                        id="XMLID_5336"
                        data-name="XMLID 5336"
                        class="cls-1"
                        d="M127.3,262.3v-6.9h0l3.2-6.5L146.8,238l1.7,1h3.3v.4l.2,2.8a2.4,2.4,0,0,1-.7,1.6l-21.7,17.8a2.9,2.9,0,0,1-1.8.7Zm.8-6.6v5.8l.9-.4,21.7-17.9a1.4,1.4,0,0,0,.5-1v-2.4h-2.7l-1.4-.8-15.9,10.4Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5329" data-name="XMLID 5329">
                    <g id="XMLID_5332" data-name="XMLID 5332">
                      <path
                        id="XMLID_5333"
                        data-name="XMLID 5333"
                        class="cls-1"
                        d="M95.4,238.9l-.3.2H93.4v2.3a2.1,2.1,0,0,0,1,1.7h.1l3.5,2.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5330" data-name="XMLID 5330">
                      <path
                        id="XMLID_5331"
                        data-name="XMLID 5331"
                        class="cls-1"
                        d="M98,245.7l-3.2-2h-.1l-.3-.2a2.8,2.8,0,0,1-1.2-1.8v-.2l-.2-2.8h2.2l.5.6-.4.3H93.9v1.9a1.6,1.6,0,0,0,.5,1.1h0l3.9,2.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5321" data-name="XMLID 5321">
                    <g id="XMLID_5327" data-name="XMLID 5327">
                      <path
                        id="XMLID_5328"
                        data-name="XMLID 5328"
                        class="cls-3"
                        d="M126.2,259,94.4,240.6a2,2,0,0,1-.8-2.7l.5-.6,21.4-17.7a2.3,2.3,0,0,1,2.6-.2l32.4,18.7a1.7,1.7,0,0,1,.6,2.3,1,1,0,0,1-.4.5L129,258.8A2.3,2.3,0,0,1,126.2,259Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5322" data-name="XMLID 5322">
                      <path
                        id="XMLID_5323"
                        data-name="XMLID 5323"
                        class="cls-1"
                        d="M127.5,259.8a2.8,2.8,0,0,1-1.5-.4L94.2,241a2.5,2.5,0,0,1-1.2-1.9,2.4,2.4,0,0,1,.9-2.1l21.4-17.7a2.9,2.9,0,0,1,3.1-.3l32.4,18.7a1.8,1.8,0,0,1,1,1.6,2.3,2.3,0,0,1-.8,1.8L129.3,259A2.5,2.5,0,0,1,127.5,259.8Zm-1.1-1.1a2.3,2.3,0,0,0,2.5-.2l21.7-17.9a1.6,1.6,0,0,0,.5-1.1,1.3,1.3,0,0,0-.6-1l-32.4-18.7a2,2,0,0,0-2.2.2L94.5,237.7a2,2,0,0,0-.6,1.4,1.6,1.6,0,0,0,.8,1.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5314" data-name="XMLID 5314">
                    <g id="XMLID_5319" data-name="XMLID 5319">
                      <path
                        id="XMLID_5320"
                        data-name="XMLID 5320"
                        class="cls-2"
                        d="M126.6,256.9,96.3,239.3a.4.4,0,0,1-.2-.5c0-.1,0-.2.1-.2l20.4-17a.9.9,0,0,1,1-.1l30.6,17.6c.2.1.3.5.1.6l-20.5,17A.8.8,0,0,1,126.6,256.9Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5315" data-name="XMLID 5315">
                      <path
                        id="XMLID_5316"
                        data-name="XMLID 5316"
                        class="cls-1"
                        d="M127.1,257.4l-.7-.2L96.1,239.6a.8.8,0,0,1-.4-.7.9.9,0,0,1,.3-.7l20.4-17a1.4,1.4,0,0,1,1.5-.1l30.6,17.6a.7.7,0,0,1,.4.6.9.9,0,0,1-.3.7l-20.5,17A1.3,1.3,0,0,1,127.1,257.4Zm-9.9-35.6h-.3l-20.4,17h0l30.3,17.6a.6.6,0,0,0,.7-.1l20.5-17-30.6-17.6c0,.1-.1.1-.2.1Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_5279" data-name="XMLID 5279">
                  <g id="XMLID_5305" data-name="XMLID 5305">
                    <g id="XMLID_5310" data-name="XMLID 5310">
                      <path
                        id="XMLID_5312"
                        data-name="XMLID 5312"
                        class="cls-3"
                        d="M149.1,234v-2.3H149l-5.7-1.6-14-8.2h-.1l-4.9,2.8h-.1l-1.8-.5h-.1v2.2a1,1,0,0,0,.5.8l18.1,10.5a2.4,2.4,0,0,0,2.6,0l5.1-3A.8.8,0,0,0,149.1,234Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5306" data-name="XMLID 5306">
                      <path
                        id="XMLID_5307"
                        data-name="XMLID 5307"
                        class="cls-1"
                        d="M142.2,238.5a2.8,2.8,0,0,1-1.5-.4l-18.1-10.5a1.2,1.2,0,0,1-.7-1.1v-2.3a.5.5,0,0,1,.2-.4h.4l1.7.5,4.8-2.8h.5l14,8.1,5.7,1.6c.2.1.4.2.4.5V234a1.2,1.2,0,0,1-.7,1.1l-5.1,3A2.9,2.9,0,0,1,142.2,238.5Zm-19.5-13.8v1.8a.5.5,0,0,0,.3.5l18.1,10.5a2.2,2.2,0,0,0,2.2,0l5.1-3a.5.5,0,0,0,.3-.5v-2l-5.6-1.6-13.9-8.1-4.8,2.7H124Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5297" data-name="XMLID 5297">
                    <g id="XMLID_5302" data-name="XMLID 5302">
                      <path
                        id="XMLID_5303"
                        data-name="XMLID 5303"
                        class="cls-1"
                        d="M149,231.6l-5.7-1.6-1.2-.7v8.8a3.2,3.2,0,0,0,1.4-.3l5.1-3a1,1,0,0,0,.5-.8A19.3,19.3,0,0,0,149,231.6Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5298" data-name="XMLID 5298">
                      <path
                        id="XMLID_5299"
                        data-name="XMLID 5299"
                        class="cls-1"
                        d="M142.2,238.5h-.5v-9.9l1.7,1,5.7,1.6c.2.1.4.2.4.5V234a1.5,1.5,0,0,1-.7,1.2l-5.1,3A4,4,0,0,1,142.2,238.5Zm.3-8.5v7.7a1.1,1.1,0,0,0,.8-.3l5.1-3a.5.5,0,0,0,.3-.5v-2l-5.6-1.6Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5288" data-name="XMLID 5288">
                    <g id="XMLID_5294" data-name="XMLID 5294">
                      <path
                        id="XMLID_5295"
                        data-name="XMLID 5295"
                        class="cls-1"
                        d="M123.7,225.5l.3-.9-1.6-.5h-.1v2.2a1,1,0,0,0,.5.8l.9.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5290" data-name="XMLID 5290">
                      <path
                        id="XMLID_5291"
                        data-name="XMLID 5291"
                        class="cls-1"
                        d="M124.1,228.4l-1.5-.9a1.2,1.2,0,0,1-.7-1.1v-2.3a.5.5,0,0,1,.2-.4h.4l2.1.6v.4a1.1,1.1,0,0,1-.3.8v3Zm-1.4-3.8v1.8a.5.5,0,0,0,.3.5l.3.2v-1.7l.2-.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5281" data-name="XMLID 5281">
                    <g id="XMLID_5286" data-name="XMLID 5286">
                      <path
                        id="XMLID_5287"
                        data-name="XMLID 5287"
                        class="cls-2"
                        d="M140.9,235.5l-18.1-10.6a1,1,0,0,1-.3-1.4l.3-.3,5.2-3a2.8,2.8,0,0,1,2.5,0l18.1,10.5a1,1,0,0,1,.3,1.4l-.3.3-5.2,3A2.5,2.5,0,0,1,140.9,235.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5282" data-name="XMLID 5282">
                      <path
                        id="XMLID_5283"
                        data-name="XMLID 5283"
                        class="cls-1"
                        d="M142.2,236.2a2.3,2.3,0,0,1-1.4-.4l-18.1-10.5a1.5,1.5,0,0,1-.7-1.2,1.4,1.4,0,0,1,.7-1.2l5.2-3a3,3,0,0,1,2.9,0l18,10.5a1.5,1.5,0,0,1,.7,1.2,1.4,1.4,0,0,1-.7,1.2l-5.2,3A2.3,2.3,0,0,1,142.2,236.2Zm-13-15.9a1.7,1.7,0,0,0-1,.3l-5.2,3a.6.6,0,0,0-.2.8l.2.2,18.1,10.5a2,2,0,0,0,2.1,0l5.2-3a.6.6,0,0,0,.2-.8l-.2-.2-18.1-10.5a2,2,0,0,0-1.1-.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g id="XMLID_5261" data-name="XMLID 5261">
                <g id="XMLID_5270" data-name="XMLID 5270">
                  <g id="XMLID_5276" data-name="XMLID 5276">
                    <path
                      id="XMLID_5277"
                      data-name="XMLID 5277"
                      class="cls-3"
                      d="M106.3,238.7l15.8,9.1,10.2-8.5-15.7-9.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5271" data-name="XMLID 5271">
                    <path
                      id="XMLID_5272"
                      data-name="XMLID 5272"
                      class="cls-1"
                      d="M122.2,248.2l-16.5-9.5,11-9.1,16.4,9.6ZM107,238.6l15.1,8.7,9.6-7.9-15-8.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5262" data-name="XMLID 5262">
                  <g id="XMLID_5268" data-name="XMLID 5268">
                    <path
                      id="XMLID_5269"
                      data-name="XMLID 5269"
                      class="cls-2"
                      d="M102.2,238.2l15.8,9.1,10.2-8.5-15.7-9.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5263" data-name="XMLID 5263">
                    <path
                      id="XMLID_5264"
                      data-name="XMLID 5264"
                      class="cls-1"
                      d="M118.1,247.8l-16.5-9.5,11-9.1,16.4,9.6Zm-15.2-9.6,15.1,8.7,9.6-7.9-15-8.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5236" data-name="XMLID 5236">
                <g id="XMLID_5254" data-name="XMLID 5254">
                  <g id="XMLID_5259" data-name="XMLID 5259">
                    <path
                      id="XMLID_5260"
                      data-name="XMLID 5260"
                      class="cls-3"
                      d="M109.7,232l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l5.1-4.3a.7.7,0,0,0,0-1H119l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-5.1,4.4C109.2,231.2,109.3,231.7,109.7,232Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5255" data-name="XMLID 5255">
                    <path
                      id="XMLID_5256"
                      data-name="XMLID 5256"
                      class="cls-1"
                      d="M113.1,234.2l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l5.1-4.4a1.5,1.5,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-5.1,4.3A1.3,1.3,0,0,1,113.1,234.2Zm2.4-7.6-.5.2-5.1,4.4v.4l2.9,1.7a.9.9,0,0,0,1-.1l5.1-4.3v-.4l-2.8-1.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5237" data-name="XMLID 5237">
                  <g id="XMLID_5252" data-name="XMLID 5252">
                    <path
                      id="XMLID_5253"
                      data-name="XMLID 5253"
                      class="cls-3"
                      d="M109.7,231.2l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l5.1-4.3a.7.7,0,0,0,0-1H119l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-5.1,4.4a.5.5,0,1,0,0,1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5238" data-name="XMLID 5238">
                    <path
                      id="XMLID_5239"
                      data-name="XMLID 5239"
                      class="cls-1"
                      d="M113.1,233.5l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l5.1-4.4a1.5,1.5,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-5.1,4.3A1.3,1.3,0,0,1,113.1,233.5Zm-3.2-2.6,2.9,1.7a.9.9,0,0,0,1-.1l5.1-4.3v-.4l-2.8-1.7a.8.8,0,0,0-1,.1l-5.3,4.2v.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5218" data-name="XMLID 5218">
                <g id="XMLID_5229" data-name="XMLID 5229">
                  <g id="XMLID_5234" data-name="XMLID 5234">
                    <path
                      id="XMLID_5235"
                      data-name="XMLID 5235"
                      class="cls-3"
                      d="M123.2,251.9l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l1-.8a.7.7,0,0,0,0-1h-.1l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-1.1.8a.7.7,0,0,0,0,1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5230" data-name="XMLID 5230">
                    <path
                      id="XMLID_5231"
                      data-name="XMLID 5231"
                      class="cls-1"
                      d="M126.7,254.1l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l1.1-.8a1.7,1.7,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-1.1.8A1.7,1.7,0,0,1,126.7,254.1Zm-3.3-2.6,2.9,1.7a.9.9,0,0,0,1-.1l1.1-.8v-.4l-2.8-1.7a.8.8,0,0,0-1,.1l-1.1.8v.2C123.2,251.4,123.3,251.5,123.4,251.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5219" data-name="XMLID 5219">
                  <g id="XMLID_5227" data-name="XMLID 5227">
                    <path
                      id="XMLID_5228"
                      data-name="XMLID 5228"
                      class="cls-3"
                      d="M123.2,251.1l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l1-.8a.7.7,0,0,0,0-1h-.1l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-1.1.8a.7.7,0,0,0,0,1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5220" data-name="XMLID 5220">
                    <path
                      id="XMLID_5221"
                      data-name="XMLID 5221"
                      class="cls-1"
                      d="M126.7,253.4l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l1.1-.8a1.7,1.7,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-1.1.8Zm-3.3-2.6,2.9,1.7a.9.9,0,0,0,1-.1l1.1-.8v-.4l-2.8-1.7a.8.8,0,0,0-1,.1l-1.1.8v.2C123.2,250.6,123.3,250.7,123.4,250.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5201" data-name="XMLID 5201">
                <g id="XMLID_5211" data-name="XMLID 5211">
                  <g id="XMLID_5216" data-name="XMLID 5216">
                    <path
                      id="XMLID_5217"
                      data-name="XMLID 5217"
                      class="cls-3"
                      d="M121.2,235.7l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l1-.8a.7.7,0,0,0,0-1h-.1l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-1.1.8a.5.5,0,0,0-.2.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5212" data-name="XMLID 5212">
                    <path
                      id="XMLID_5213"
                      data-name="XMLID 5213"
                      class="cls-1"
                      d="M124.7,238l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l1.1-.8a1.7,1.7,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-1.1.8A1.7,1.7,0,0,1,124.7,238Zm-3.3-2.6,2.9,1.7a.9.9,0,0,0,1-.1l1.1-.8v-.4l-2.8-1.7a.8.8,0,0,0-1,.1l-1.1.8v.2c-.3.1-.2.2-.1.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5202" data-name="XMLID 5202">
                  <g id="XMLID_5208" data-name="XMLID 5208">
                    <path
                      id="XMLID_5209"
                      data-name="XMLID 5209"
                      class="cls-3"
                      d="M121.2,235l2.9,1.7a1.2,1.2,0,0,0,1.4-.1l1-.8a.7.7,0,0,0,0-1h-.1l-2.8-1.7a1.2,1.2,0,0,0-1.4.1l-1.1.8a.7.7,0,0,0,0,1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5204" data-name="XMLID 5204">
                    <path
                      id="XMLID_5205"
                      data-name="XMLID 5205"
                      class="cls-1"
                      d="M124.7,237.2l-.8-.2-2.9-1.7a1,1,0,0,1-.5-.8,1.1,1.1,0,0,1,.4-.9l1.1-.8a1.7,1.7,0,0,1,1.9-.1l2.8,1.7a1,1,0,0,1,.5.8,1.1,1.1,0,0,1-.4.9l-1.1.8A1.7,1.7,0,0,1,124.7,237.2Zm-1.8-4-.5.2-1.1.8v.4l2.9,1.7a.9.9,0,0,0,1-.1l1.1-.8V235l-2.8-1.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5193" data-name="XMLID 5193">
                <g id="XMLID_5198" data-name="XMLID 5198">
                  <g id="XMLID_5199" data-name="XMLID 5199">
                    <path
                      id="XMLID_5200"
                      data-name="XMLID 5200"
                      class="cls-1"
                      d="M136.5,241.3l-7.6,3.9.4.9,7.7-3.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5194" data-name="XMLID 5194">
                  <g id="XMLID_5195" data-name="XMLID 5195">
                    <path
                      id="XMLID_5197"
                      data-name="XMLID 5197"
                      class="cls-1"
                      d="M139.6,239.8l-5.3,6.1.7.6,5.3-6.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5176" data-name="XMLID 5176">
                <g id="XMLID_5185" data-name="XMLID 5185">
                  <g id="XMLID_5191" data-name="XMLID 5191">
                    <path
                      id="XMLID_5192"
                      data-name="XMLID 5192"
                      class="cls-3"
                      d="M143.1,251c-.1,0-.3.1-.2.3l.7,3.7c0,.4.4.9,1.3,1.1h1.4c.9-.2,1.3-.7,1.3-1.1l.7-3.7c0-.1-.1-.3-.2-.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5186" data-name="XMLID 5186">
                    <path
                      id="XMLID_5187"
                      data-name="XMLID 5187"
                      class="cls-1"
                      d="M145.6,256.5h-.8c-1-.2-1.6-.8-1.6-1.4l-.7-3.6c0-.2,0-.4.2-.5l.5-.2h5l.5.2a.8.8,0,0,1,.2.5l-.7,3.7c0,.7-.6,1.2-1.6,1.4Zm-2.3-5.1.7,3.5c0,.2.3.5,1,.7h1.3c.7-.2,1-.5,1-.7h0l.7-3.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5177" data-name="XMLID 5177">
                  <g id="XMLID_5183" data-name="XMLID 5183">
                    <path
                      id="XMLID_5184"
                      data-name="XMLID 5184"
                      class="cls-3"
                      d="M147.6,249.9c1.1.6,1.1,1.6,0,2.3a4.4,4.4,0,0,1-3.9,0c-1.1-.6-1.1-1.6,0-2.3A4.4,4.4,0,0,1,147.6,249.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5178" data-name="XMLID 5178">
                    <path
                      id="XMLID_5179"
                      data-name="XMLID 5179"
                      class="cls-1"
                      d="M145.6,253a5.4,5.4,0,0,1-2.2-.5,1.6,1.6,0,0,1-1-1.5,2,2,0,0,1,1-1.5,4.7,4.7,0,0,1,4.3,0,1.5,1.5,0,0,1,.9,2.1,1.6,1.6,0,0,1-.9.9A3.1,3.1,0,0,1,145.6,253Zm0-3.2a3.9,3.9,0,0,0-1.8.4.8.8,0,0,0,0,1.6,4.3,4.3,0,0,0,3.5,0,.8.8,0,1,0,0-1.6A3.3,3.3,0,0,0,145.6,249.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5159" data-name="XMLID 5159">
                <g id="XMLID_5168" data-name="XMLID 5168">
                  <g id="XMLID_5174" data-name="XMLID 5174">
                    <path
                      id="XMLID_5175"
                      data-name="XMLID 5175"
                      class="cls-3"
                      d="M127.5,218.2c-.1,0-.3.1-.2.3l.7,3.7c0,.4.4.9,1.3,1.1h1.4c.9-.2,1.3-.7,1.3-1.1l.7-3.7c0-.1-.1-.3-.2-.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5169" data-name="XMLID 5169">
                    <path
                      id="XMLID_5170"
                      data-name="XMLID 5170"
                      class="cls-1"
                      d="M130,223.7h-.8c-1-.2-1.6-.8-1.6-1.4l-.7-3.6c0-.2,0-.4.2-.5l.5-.2h5l.5.2a.8.8,0,0,1,.2.5l-.7,3.7c0,.7-.6,1.2-1.6,1.4Zm-2.3-5.2.7,3.5c0,.2.3.5,1,.7h1.3c.7-.2,1-.5,1-.7h0l.7-3.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5160" data-name="XMLID 5160">
                  <g id="XMLID_5165" data-name="XMLID 5165">
                    <path
                      id="XMLID_5167"
                      data-name="XMLID 5167"
                      class="cls-1"
                      d="M131.9,217c1.1.6,1.1,1.6,0,2.3a4.4,4.4,0,0,1-3.9,0c-1.1-.6-1.1-1.6,0-2.3A4.5,4.5,0,0,1,131.9,217Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5161" data-name="XMLID 5161">
                    <path
                      id="XMLID_5162"
                      data-name="XMLID 5162"
                      class="cls-1"
                      d="M130,220.1a5.4,5.4,0,0,1-2.2-.5,1.5,1.5,0,0,1-.9-2.1,1.6,1.6,0,0,1,.9-.9,4.7,4.7,0,0,1,4.3,0,1.5,1.5,0,0,1,.9,2.1,1.6,1.6,0,0,1-.9.9A3.1,3.1,0,0,1,130,220.1Zm0-3.1a3.9,3.9,0,0,0-1.8.4.8.8,0,0,0,0,1.6,4.3,4.3,0,0,0,3.5,0,.8.8,0,0,0,0-1.6A3.3,3.3,0,0,0,130,217Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="XMLID_4879" data-name="XMLID 4879">
              <g id="XMLID_5114" data-name="XMLID 5114">
                <g id="XMLID_5149" data-name="XMLID 5149">
                  <g id="XMLID_5155" data-name="XMLID 5155">
                    <path
                      id="XMLID_5156"
                      data-name="XMLID 5156"
                      class="cls-2"
                      d="M100.6,280.6a11,11,0,0,0-.3,3.6s2.2,1,3.8.2a3.4,3.4,0,0,1,3.1.1l4.4-.5c0,.1,1-1.8-.5-2.5l-4.9-2-1.8-.6-3.1.9A1,1,0,0,0,100.6,280.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5150" data-name="XMLID 5150">
                    <path
                      id="XMLID_5152"
                      data-name="XMLID 5152"
                      class="cls-1"
                      d="M102.7,285.1a5.4,5.4,0,0,1-2.5-.6H100v-.2a11.6,11.6,0,0,1,.3-3.7,1.5,1.5,0,0,1,1.1-1.1l3.2-.9,1.9.7,4.9,2a2,2,0,0,1,1,2.2c-.1.4-.3,1.1-.7,1.1h-.3l-2.4.3-1.9.2H107a2.9,2.9,0,0,0-2.7-.1Zm-2-1.2a4.2,4.2,0,0,0,3.3.1,3.7,3.7,0,0,1,3.4.1l1.5-.2,2.6-.3a2,2,0,0,0,.1-1.1.9.9,0,0,0-.6-.6l-4.9-2-1.7-.6-2.9.9c-.3.1-.5.3-.5.5A8.5,8.5,0,0,0,100.7,283.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5141" data-name="XMLID 5141">
                  <g id="XMLID_5147" data-name="XMLID 5147">
                    <path
                      id="XMLID_5148"
                      data-name="XMLID 5148"
                      class="cls-2"
                      d="M100.9,277.1l.3,2.3a2.5,2.5,0,0,0,2.5.9c1.7-.5.5-4.2.5-4.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5142" data-name="XMLID 5142">
                    <path
                      id="XMLID_5143"
                      data-name="XMLID 5143"
                      class="cls-1"
                      d="M103.1,280.7a2.7,2.7,0,0,1-2.2-1.1h0l-.4-2.7,4.1-1.2v.4c.1.3.8,2.7.1,3.9a1.3,1.3,0,0,1-.9.7Zm-1.5-1.5a1.9,1.9,0,0,0,2,.6l.4-.3c.4-.7.1-2.1-.1-2.9l-2.7.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5134" data-name="XMLID 5134">
                  <g id="XMLID_5139" data-name="XMLID 5139">
                    <path
                      id="XMLID_5140"
                      data-name="XMLID 5140"
                      class="cls-1"
                      d="M108.3,258.9l-7.9,2.9a8.1,8.1,0,0,0-.3,3.8,56.2,56.2,0,0,1,.1,11.6s1.7,2.1,4.5.2c0,0,1.9-13.4,3.5-18A.9.9,0,0,0,108.3,258.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5135" data-name="XMLID 5135">
                    <path
                      id="XMLID_5136"
                      data-name="XMLID 5136"
                      class="cls-1"
                      d="M102.5,278.6a3.3,3.3,0,0,1-2.5-1.1h-.1v-.2a55.3,55.3,0,0,0-.1-11.5,8.6,8.6,0,0,1,.3-3.9v-.2l8.8-3.3-.3.9c0,.1-.1.2-.1.4-1.6,4.5-3.5,17.8-3.5,18v.2h-.1A5.1,5.1,0,0,1,102.5,278.6Zm-1.9-1.5c.4.4,1.7,1.4,3.7.1.2-1.6,1.9-13.1,3.4-17.7l-6.9,2.6a7.8,7.8,0,0,0-.2,3.4A56.2,56.2,0,0,1,100.6,277.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5123" data-name="XMLID 5123">
                  <g id="XMLID_5131" data-name="XMLID 5131">
                    <g id="XMLID_5132" data-name="XMLID 5132">
                      <path
                        id="XMLID_5133"
                        data-name="XMLID 5133"
                        class="cls-1"
                        d="M108.9,280.6l-.4,1.1.8.3.4-1.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5128" data-name="XMLID 5128">
                    <g id="XMLID_5129" data-name="XMLID 5129">
                      <path
                        id="XMLID_5130"
                        data-name="XMLID 5130"
                        class="cls-1"
                        d="M107.3,280.1l-.3,1.1.7.3.4-1.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5125" data-name="XMLID 5125">
                    <g id="XMLID_5126" data-name="XMLID 5126">
                      <path
                        id="XMLID_5127"
                        data-name="XMLID 5127"
                        class="cls-1"
                        d="M106.1,279.5l-.4,1.1.8.3.3-1.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_5115" data-name="XMLID 5115">
                  <g id="XMLID_5121" data-name="XMLID 5121">
                    <path
                      id="XMLID_5122"
                      data-name="XMLID 5122"
                      class="cls-3"
                      d="M111.6,284a2.5,2.5,0,0,0,.3-1.7c-3.1.9-10.4.5-11.6.4v1.4s2.2,1,3.8.2a3.4,3.4,0,0,1,3.1.1C107.4,284.6,111.6,283.9,111.6,284Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5117" data-name="XMLID 5117">
                    <path
                      id="XMLID_5118"
                      data-name="XMLID 5118"
                      class="cls-1"
                      d="M102.7,285.1a5.4,5.4,0,0,1-2.5-.6H100v-2h.4c.9.1,8.4.5,11.5-.4h.4v.4a2.6,2.6,0,0,1-.3,2.1l-.2.2h-.2l-2.6.3-1.9.2H107a2.9,2.9,0,0,0-2.7-.1Zm-2-1.2a4.2,4.2,0,0,0,3.3.1,3.7,3.7,0,0,1,3.4.1l1.5-.2,2.6-.3a1.9,1.9,0,0,0,.2-.8c-3.1.7-9,.5-10.9.3A.8.8,0,0,0,100.7,283.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5074" data-name="XMLID 5074">
                <g id="XMLID_5111" data-name="XMLID 5111">
                  <g id="XMLID_5112" data-name="XMLID 5112">
                    <path
                      id="XMLID_5113"
                      data-name="XMLID 5113"
                      class="cls-1"
                      d="M91.2,298.8l-.9-1.6,10.7-6.4a3.9,3.9,0,0,0,1.8-3.8l-1.5-10.5,1.8-.3,1.5,10.5a5.5,5.5,0,0,1-2.7,5.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5108" data-name="XMLID 5108">
                  <g id="XMLID_5109" data-name="XMLID 5109">
                    <path
                      id="XMLID_5110"
                      data-name="XMLID 5110"
                      class="cls-1"
                      d="M76,289.7l-.9-1.6,11-6.7a4.1,4.1,0,0,0,2-3.3l.4-10.2h1.8l-.5,10.2a5.8,5.8,0,0,1-2.8,4.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5075" data-name="XMLID 5075">
                  <g id="XMLID_5100" data-name="XMLID 5100">
                    <g id="XMLID_5106" data-name="XMLID 5106">
                      <path
                        id="XMLID_5107"
                        data-name="XMLID 5107"
                        class="cls-3"
                        d="M108,272.8v-2h-.1l-5.1-1.4-12.6-7.3h-.1L78,269h-.1l-1.6-.4h-.1v2a1,1,0,0,0,.4.7l16.2,9.4a2.4,2.4,0,0,0,2.3,0l12.3-7A1.1,1.1,0,0,0,108,272.8Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5101" data-name="XMLID 5101">
                      <path
                        id="XMLID_5102"
                        data-name="XMLID 5102"
                        class="cls-1"
                        d="M94.2,281.3a2.3,2.3,0,0,1-1.4-.4l-16.2-9.4a1.1,1.1,0,0,1-.6-1v-2a.5.5,0,0,1,.2-.4h.4l1.5.4,12-6.8h.5l12.5,7.3,5.1,1.4a.5.5,0,0,1,.3.5V273h0a1.3,1.3,0,0,1-.6,1l-12.3,7A3.2,3.2,0,0,1,94.2,281.3ZM76.8,268.9v1.5a.8.8,0,0,0,.2.4l16.2,9.4a2.1,2.1,0,0,0,1.9,0l12.3-7a.5.5,0,0,0,.2-.4h0V271l-5-1.4-12.3-7.2-12.1,6.9H78Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5092" data-name="XMLID 5092">
                    <g id="XMLID_5097" data-name="XMLID 5097">
                      <path
                        id="XMLID_5099"
                        data-name="XMLID 5099"
                        class="cls-1"
                        d="M77.7,268.8l-1.2-.3c-.1,0-.1,0-.1.1h0v2a1,1,0,0,0,.4.7l.9.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5093" data-name="XMLID 5093">
                      <path
                        id="XMLID_5094"
                        data-name="XMLID 5094"
                        class="cls-1"
                        d="M78.1,272.4l-1.5-.9a1.1,1.1,0,0,1-.6-1v-2a.5.5,0,0,1,.2-.4h.4l1.5.4Zm-1.3-3.5v1.5a.8.8,0,0,0,.2.4l.3.2v-1.9Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5084" data-name="XMLID 5084">
                    <g id="XMLID_5089" data-name="XMLID 5089">
                      <path
                        id="XMLID_5090"
                        data-name="XMLID 5090"
                        class="cls-1"
                        d="M108,270.7l-5.1-1.4-8.7,6.4v5.2a2.7,2.7,0,0,0,1.2-.3l12.3-7a.8.8,0,0,0,.4-.7A16.2,16.2,0,0,1,108,270.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5085" data-name="XMLID 5085">
                      <path
                        id="XMLID_5086"
                        data-name="XMLID 5086"
                        class="cls-1"
                        d="M94.2,281.3h-.5v-5.8l9.1-6.7h.2l5.1,1.4a.5.5,0,0,1,.3.5v2.1h0a1.3,1.3,0,0,1-.6,1l-12.3,7Zm.3-5.4v4.6l.6-.2,12.3-7a.5.5,0,0,0,.2-.4v-1.8l-4.7-1.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5076" data-name="XMLID 5076">
                    <g id="XMLID_5082" data-name="XMLID 5082">
                      <path
                        id="XMLID_5083"
                        data-name="XMLID 5083"
                        class="cls-2"
                        d="M93.1,278.5l-16.3-9.4a1,1,0,0,1-.3-1.2l.3-.3,12.3-7a2.2,2.2,0,0,1,2.2,0l16.2,9.4a.9.9,0,0,1,.5,1l-.5.5-12.3,7A2,2,0,0,1,93.1,278.5Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_5077" data-name="XMLID 5077">
                      <path
                        id="XMLID_5079"
                        data-name="XMLID 5079"
                        class="cls-1"
                        d="M94.2,279.2a2,2,0,0,1-1.3-.4l-16.3-9.4a1.3,1.3,0,0,1-.6-1.1,1.1,1.1,0,0,1,.6-1.1l12.3-7a2.4,2.4,0,0,1,2.6,0l16.2,9.4a1.3,1.3,0,0,1,.6,1.1,1.1,1.1,0,0,1-.6,1.1l-12.3,7A1.7,1.7,0,0,1,94.2,279.2Zm-.9-1a1.9,1.9,0,0,0,1.8,0l12.3-7a.5.5,0,0,0,.1-.7h-.1L91.2,261a1.9,1.9,0,0,0-1.8,0l-12.3,7a.5.5,0,0,0-.1.7h.1Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g id="XMLID_5049" data-name="XMLID 5049">
                <g id="XMLID_5066" data-name="XMLID 5066">
                  <g id="XMLID_5072" data-name="XMLID 5072">
                    <path
                      id="XMLID_5073"
                      data-name="XMLID 5073"
                      class="cls-2"
                      d="M101.7,238.3l2.1-1.2a4.4,4.4,0,0,1,2.5-.6,2.8,2.8,0,0,1,2.5,1.3v.5l-2,.6v.3l.7.3s-.6,1.9-4.2,1.5S101.7,238.3,101.7,238.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5067" data-name="XMLID 5067">
                    <path
                      id="XMLID_5068"
                      data-name="XMLID 5068"
                      class="cls-1"
                      d="M104.3,241.3h-1.1a2.9,2.9,0,0,1-2.3-1.2,2.1,2.1,0,0,1,.5-2h.1l2.1-1.2a5.5,5.5,0,0,1,2.8-.7,3,3,0,0,1,2.8,1.5h0v.9l-1.7.5h.3v.3C107.8,239.6,107.3,241.3,104.3,241.3Zm-2.3-2.7a1.3,1.3,0,0,0-.3,1.2c.1.4.7.6,1.6.7s3.3-.4,3.6-.9l-.6-.2.2-.8,1.9-.6h0a2.2,2.2,0,0,0-2.1-1,3.7,3.7,0,0,0-2.3.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5058" data-name="XMLID 5058">
                  <g id="XMLID_5063" data-name="XMLID 5063">
                    <path
                      id="XMLID_5065"
                      data-name="XMLID 5065"
                      class="cls-1"
                      d="M99.8,239.1l1.1-.6h.5a4.9,4.9,0,0,1,1.4,1.8.4.4,0,0,1-.1.5h-.2l-1.3.5a.5.5,0,0,1-.6-.2l-1.1-1.5A.7.7,0,0,1,99.8,239.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5059" data-name="XMLID 5059">
                    <path
                      id="XMLID_5060"
                      data-name="XMLID 5060"
                      class="cls-1"
                      d="M101.1,241.9a.7.7,0,0,1-.7-.4L99.3,240a.9.9,0,0,1-.1-.7c.1-.2.2-.5.4-.6l1.1-.6a.9.9,0,0,1,1,.1,4.3,4.3,0,0,1,1.5,2,.8.8,0,0,1-.4,1.1h-.1l-1.3.5Zm.1-3.1h0l-1.2.6h0l1.1,1.5h.1l1.3-.5h.1A5.4,5.4,0,0,0,101.2,238.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5050" data-name="XMLID 5050">
                  <g id="XMLID_5055" data-name="XMLID 5055">
                    <path
                      id="XMLID_5056"
                      data-name="XMLID 5056"
                      class="cls-3"
                      d="M87.1,237.9c.2.8-.4-.9,0,0,1.1,2.7,2.4,5.6,2.4,5.6s3.2-1.4,5.5-2.2a16.5,16.5,0,0,0,4.2-2.1h.2a2.6,2.6,0,0,1,1.8,2.2v.2c-.8.7-8.1,6.7-13.5,7.8a17.4,17.4,0,0,1-4.7-7.5C81.4,237.1,86.4,236.1,87.1,237.9Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5051" data-name="XMLID 5051">
                    <path
                      id="XMLID_5052"
                      data-name="XMLID 5052"
                      class="cls-1"
                      d="M87.5,249.8h-.1a18.3,18.3,0,0,1-4.8-7.7c-1-3,.5-4.7,2-5.2a2.5,2.5,0,0,1,2.6.4l.3.4h.1c.9,2.1,1.9,4.4,2.3,5.2s3.3-1.4,5.2-2a22.2,22.2,0,0,0,4.1-2h.5a2.8,2.8,0,0,1,2.1,2.5.8.8,0,0,1-.2.5c-.8.7-8.2,6.7-13.7,7.9Zm-2-12.3h-.8c-1.2.4-2.3,1.7-1.5,4.2a16.1,16.1,0,0,0,4.4,7.1c5.2-1.1,12-6.7,13.1-7.6a1.9,1.9,0,0,0-1.4-1.7,20.6,20.6,0,0,1-4.2,2.1,37.1,37.1,0,0,0-5.5,2.2l-.4.2-.2-.4s-1.3-2.8-2.3-5.4l-.2-.4C86.4,237.6,86,237.5,85.5,237.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_5002" data-name="XMLID 5002">
                <g id="XMLID_5041" data-name="XMLID 5041">
                  <g id="XMLID_5047" data-name="XMLID 5047">
                    <path
                      id="XMLID_5048"
                      data-name="XMLID 5048"
                      class="cls-2"
                      d="M116,285.5a14.5,14.5,0,0,0,.2,3.6s2.3.7,3.8-.4a3.4,3.4,0,0,1,3.1-.3c.1,0,4.2-1.3,4.3-1.2s.7-2-.9-2.4l-5.2-1.2-1.9-.3-2.9,1.4C116.3,284.7,116.1,285,116,285.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5042" data-name="XMLID 5042">
                    <path
                      id="XMLID_5043"
                      data-name="XMLID 5043"
                      class="cls-1"
                      d="M117.9,289.6l-1.7-.2H116v-.3a11.6,11.6,0,0,1-.3-3.7,1.6,1.6,0,0,1,.9-1.2l3-1.4,2,.4,5.2,1.2a1.7,1.7,0,0,1,1.3,2c0,.4-.1,1.1-.5,1.2h-.3l-2.3.7-1.8.5h-.1a3.2,3.2,0,0,0-2.7.3A7,7,0,0,1,117.9,289.6Zm-1.3-.9a4.7,4.7,0,0,0,3.3-.4,3.7,3.7,0,0,1,3.4-.4l1.5-.4,2.5-.7a1.4,1.4,0,0,0-.1-1.1c-.1-.3-.3-.4-.6-.5l-5.2-1.2-1.7-.3-2.8,1.3a.7.7,0,0,0-.4.6A8.1,8.1,0,0,0,116.6,288.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5033" data-name="XMLID 5033">
                  <g id="XMLID_5039" data-name="XMLID 5039">
                    <path
                      id="XMLID_5040"
                      data-name="XMLID 5040"
                      class="cls-2"
                      d="M115.5,282.1l.7,2.2a2.3,2.3,0,0,0,2.6.5c1.6-.7-.1-4.2-.1-4.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5034" data-name="XMLID 5034">
                    <path
                      id="XMLID_5035"
                      data-name="XMLID 5035"
                      class="cls-1"
                      d="M117.8,285.4a2.7,2.7,0,0,1-1.9-.8h-.1L115,282l3.8-1.9.2.4c.1.3,1.2,2.5.7,3.9a1.4,1.4,0,0,1-.8.9Zm-1.3-1.3a2,2,0,0,0,2.1.3.8.8,0,0,0,.4-.4c.3-.7-.2-2.1-.5-2.9l-2.5,1.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5025" data-name="XMLID 5025">
                  <g id="XMLID_5030" data-name="XMLID 5030">
                    <path
                      id="XMLID_5032"
                      data-name="XMLID 5032"
                      class="cls-1"
                      d="M82.2,264.5s4.9,6.4,9.1,7.7a13.9,13.9,0,0,0,11.2-1.9,42.7,42.7,0,0,0,6-4.5c.1-.1.2,0,.3.1h0a13.6,13.6,0,0,0,1.8,6.8,53.6,53.6,0,0,1,4.7,10s2.5,1.2,4.1-1.7c0,0-4-13-4.5-17.8a5.8,5.8,0,0,0-3.3-5.1,4.2,4.2,0,0,0-2.2-.3l-1.2.2a34.2,34.2,0,0,0-6.3,1.6L92,263.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5026" data-name="XMLID 5026">
                    <path
                      id="XMLID_5027"
                      data-name="XMLID 5027"
                      class="cls-1"
                      d="M116.5,283.3a3.2,3.2,0,0,1-1.4-.3H115v-.2a49.6,49.6,0,0,0-4.6-9.9,14.8,14.8,0,0,1-1.9-6.5,59.8,59.8,0,0,1-5.7,4.2,14,14,0,0,1-11.6,1.9c-4.3-1.4-9.1-7.6-9.3-7.9l-.4-.5,10.4-1.3,9.8-3.7a35.5,35.5,0,0,1,6.4-1.7l1.2-.2a4.3,4.3,0,0,1,2.5.4,6.2,6.2,0,0,1,3.5,5.4c.5,4.8,4.4,17.6,4.5,17.7v.2h-.1C118.8,282.9,117.5,283.3,116.5,283.3Zm-.8-.9c.5.2,2.1.6,3.4-1.5-.5-1.6-4-13.1-4.5-17.7a5.8,5.8,0,0,0-3.1-4.8,3.4,3.4,0,0,0-2-.3l-1.2.2a34.2,34.2,0,0,0-6.3,1.6l-10,3.7-9.1,1.2c1.3,1.6,5.1,6,8.5,7.1a13.9,13.9,0,0,0,10.9-1.8,42.7,42.7,0,0,0,6-4.5.5.5,0,0,1,.6-.1.5.5,0,0,1,.3.5,13.9,13.9,0,0,0,1.8,6.6,51.9,51.9,0,0,1,4.7,9.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5021" data-name="XMLID 5021">
                  <g id="XMLID_5022" data-name="XMLID 5022">
                    <path
                      id="XMLID_5023"
                      data-name="XMLID 5023"
                      class="cls-3"
                      d="M109,265.8h-.8a6.8,6.8,0,0,1,1.3-3.3l.6.5A5.7,5.7,0,0,0,109,265.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_5011" data-name="XMLID 5011">
                  <g id="XMLID_5018" data-name="XMLID 5018">
                    <g id="XMLID_5019" data-name="XMLID 5019">
                      <path
                        id="XMLID_5020"
                        data-name="XMLID 5020"
                        class="cls-1"
                        d="M124.2,284.3l-.3,1.2.8.2.3-1.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5015" data-name="XMLID 5015">
                    <g id="XMLID_5016" data-name="XMLID 5016">
                      <path
                        id="XMLID_5017"
                        data-name="XMLID 5017"
                        class="cls-1"
                        d="M122.7,284l-.3,1.2.8.2.3-1.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_5012" data-name="XMLID 5012">
                    <g id="XMLID_5013" data-name="XMLID 5013">
                      <path
                        id="XMLID_5014"
                        data-name="XMLID 5014"
                        class="cls-1"
                        d="M121.2,283.6l-.2,1.2.8.2.2-1.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_5003" data-name="XMLID 5003">
                  <g id="XMLID_5009" data-name="XMLID 5009">
                    <path
                      id="XMLID_5010"
                      data-name="XMLID 5010"
                      class="cls-3"
                      d="M127.4,287.1a2.6,2.6,0,0,0,.1-1.5c-4,1.6-11.4,2.3-11.5,2.3a4.3,4.3,0,0,0,.2,1.1s2.3.7,3.8-.4a3.4,3.4,0,0,1,3.1-.3C123.3,288.3,127.4,287,127.4,287.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_5004" data-name="XMLID 5004">
                    <path
                      id="XMLID_5006"
                      data-name="XMLID 5006"
                      class="cls-1"
                      d="M117.8,289.6l-1.7-.2h-.2v-.3c-.1-.3-.1-.7-.2-1.2v-.4h.4c.1,0,7.4-.7,11.4-2.3l.4-.2v.4c.2.6.1,1.8-.3,2h-.3l-2.3.7-1.8.5h-.1a3.2,3.2,0,0,0-2.7.3A4.1,4.1,0,0,1,117.8,289.6Zm-1.3-.9a4.7,4.7,0,0,0,3.3-.4,3.7,3.7,0,0,1,3.4-.4l1.5-.4,2.5-.7c0-.1.1-.4.1-.6-3.6,1.3-9.2,1.9-10.7,2.1S116.5,288.5,116.5,288.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_4993" data-name="XMLID 4993">
                <g id="XMLID_4994" data-name="XMLID 4994">
                  <g id="XMLID_5000" data-name="XMLID 5000">
                    <path
                      id="XMLID_5001"
                      data-name="XMLID 5001"
                      class="cls-3"
                      d="M100.3,257.7s2.9,6.9,2.9,10.7a10.2,10.2,0,0,1-9.9,5.6c-3.1-.2-8.8-3.3-11.3-6.4-1-1.3,0-5.9-.3-7.5l-3.6-16.6s-1.3-4.7,1-7.1a2.3,2.3,0,0,1,1.2-.6,15.4,15.4,0,0,1,4.2.7c-2.5-.6,7.2,3.1,7.2,3.1l3.5,2.8,3.3,12.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4995" data-name="XMLID 4995">
                    <path
                      id="XMLID_4996"
                      data-name="XMLID 4996"
                      class="cls-1"
                      d="M94.2,274.4h-.9c-3.1-.2-8.9-3.2-11.5-6.6-.7-.9-.6-2.9-.4-4.9a12.2,12.2,0,0,0,0-2.7l-3.6-16.6c-.1-.2-1.3-4.9,1.1-7.4a2.7,2.7,0,0,1,1.4-.7,14,14,0,0,1,4.1.6h.2l.3.2H85l6.9,2.8H92l3.6,2.9,3.3,12.8,1.9,2.7c.1.3,2.9,7,2.9,10.8h0C103.6,268.6,100.8,274.4,94.2,274.4ZM80.5,236.2h-.3a1.1,1.1,0,0,0-.9.5c-2.1,2.2-.9,6.7-.9,6.7l3.7,16.7a14.1,14.1,0,0,1,0,2.9c-.1,1.7-.2,3.7.3,4.4,2.4,3.1,8.1,6.1,11,6.3a9.7,9.7,0,0,0,9.4-5.3c0-3.6-2.6-9.8-2.9-10.4L98,255.2l-3.2-12.6-3.3-2.7c-5.4-2.1-7.1-2.8-7.6-3.2A19.9,19.9,0,0,0,80.5,236.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_4960" data-name="XMLID 4960">
                <g id="XMLID_4989" data-name="XMLID 4989">
                  <g id="XMLID_4990" data-name="XMLID 4990">
                    <path
                      id="XMLID_4992"
                      data-name="XMLID 4992"
                      class="cls-1"
                      d="M119,239.3l-2,4.7,1,.4,1.9-4.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4961" data-name="XMLID 4961">
                  <g id="XMLID_4965" data-name="XMLID 4965">
                    <g id="XMLID_4982" data-name="XMLID 4982">
                      <g id="XMLID_4987" data-name="XMLID 4987">
                        <path
                          id="XMLID_4988"
                          data-name="XMLID 4988"
                          class="cls-2"
                          d="M113.7,246.1a9.2,9.2,0,0,1,1.9-2.5,1,1,0,0,1,1.4.3v.2c.1.1.2.2.3.1l2.3-.9a.6.6,0,0,1,.7.2,2.4,2.4,0,0,1,0,2.6c-1,2-4.8,2.4-4.8,2.4Z"
                          transform="translate(0 0)"
                        />
                      </g>
                      <g id="XMLID_4983" data-name="XMLID 4983">
                        <path
                          id="XMLID_4984"
                          data-name="XMLID 4984"
                          class="cls-1"
                          d="M115.4,248.9l-2.2-2.8v-.2a7.5,7.5,0,0,1,2.1-2.6,1.5,1.5,0,0,1,2,.5l2.2-.9a1,1,0,0,1,1.2.4,3.2,3.2,0,0,1,0,3c-1.1,2.1-5,2.6-5.1,2.6Zm-1.2-2.9,1.6,2c.8-.1,3.5-.7,4.3-2.2a2.2,2.2,0,0,0,.1-2.2H120l-2.3.9a.7.7,0,0,1-.8-.3c-.4-.7-.8-.5-1-.4a7.2,7.2,0,0,0-1.7,2.2Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </g>
                    <g id="XMLID_4974" data-name="XMLID 4974">
                      <g id="XMLID_4979" data-name="XMLID 4979">
                        <path
                          id="XMLID_4980"
                          data-name="XMLID 4980"
                          class="cls-1"
                          d="M112.4,247l1.1-.9a.7.7,0,0,1,.6-.1,5.2,5.2,0,0,1,1.9,1.7c.2.1.2.4,0,.6h-.2l-1.2.8a.6.6,0,0,1-.7-.1l-1.5-1.4C112.1,247.6,112.1,247.2,112.4,247Z"
                          transform="translate(0 0)"
                        />
                      </g>
                      <g id="XMLID_4975" data-name="XMLID 4975">
                        <path
                          id="XMLID_4976"
                          data-name="XMLID 4976"
                          class="cls-1"
                          d="M114.2,249.8a.7.7,0,0,1-.6-.3l-1.5-1.4a1,1,0,0,1,0-1.4l1.1-.9a.9.9,0,0,1,1-.1,4.9,4.9,0,0,1,2,1.8,1.1,1.1,0,0,1-.3,1.3l-1.2.8Zm-1.6-2.5h-.1l1.5,1.4h.2l1.2-.8c.1,0,.1-.1.1-.2a4.1,4.1,0,0,0-1.7-1.5h-.1Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </g>
                    <g id="XMLID_4967" data-name="XMLID 4967">
                      <g id="XMLID_4972" data-name="XMLID 4972">
                        <path
                          id="XMLID_4973"
                          data-name="XMLID 4973"
                          class="cls-3"
                          d="M93.2,242.8a1.6,1.6,0,0,1,1.6-.5l.8.4a19.1,19.1,0,0,1,2.7,3.5c1.6,2.6,5,7.4,5,7.4s2.9-2,5-3.2a20,20,0,0,0,3.7-2.8h.1a2.6,2.6,0,0,1,2.2,1.8v.2c-.6.8-6.2,7.6-11.2,10a.8.8,0,0,1-1-.2c-1.4-1.3-5.7-5.5-7.8-9.2S92.4,243.8,93.2,242.8Z"
                          transform="translate(0 0)"
                        />
                      </g>
                      <g id="XMLID_4968" data-name="XMLID 4968">
                        <path
                          id="XMLID_4969"
                          data-name="XMLID 4969"
                          class="cls-1"
                          d="M102.6,260a1.1,1.1,0,0,1-.9-.4c-1.3-1.2-5.8-5.5-7.8-9.3s-2.3-6.1-1.1-7.7a1.9,1.9,0,0,1,2-.6l.9.5a23.3,23.3,0,0,1,2.7,3.5c1.3,2.2,4,6,4.8,7.1l4.7-3a15.9,15.9,0,0,0,3.6-2.8l.5-.2a2.8,2.8,0,0,1,2.5,2.1.7.7,0,0,1-.1.5c-.6.8-6.3,7.7-11.4,10.1C103,260,102.8,260,102.6,260Zm-9.1-16.9c-1,1.4-.7,3.7,1.1,6.9s6.4,7.9,7.7,9.1a.7.7,0,0,0,.6.1c4.8-2.3,10.1-8.8,11-9.8a1.9,1.9,0,0,0-1.7-1.4,20,20,0,0,1-3.7,2.8c-2.1,1.2-5,3.2-5,3.2l-.3.2-.2-.3s-3.5-4.9-5-7.4a21.8,21.8,0,0,0-2.6-3.4l-.6-.3C94.2,242.6,93.7,242.7,93.5,243.1Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </g>
                  </g>
                  <g id="XMLID_4962" data-name="XMLID 4962">
                    <g id="XMLID_4963" data-name="XMLID 4963">
                      <path
                        id="XMLID_4964"
                        data-name="XMLID 4964"
                        class="cls-1"
                        d="M103.6,255.7l-.8-.2a2.5,2.5,0,0,0,0-1.7l.8-.2A3.8,3.8,0,0,1,103.6,255.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g id="XMLID_4922" data-name="XMLID 4922">
                <g id="XMLID_4926" data-name="XMLID 4926">
                  <g id="XMLID_4951" data-name="XMLID 4951">
                    <g id="XMLID_4957" data-name="XMLID 4957">
                      <path
                        id="XMLID_4958"
                        data-name="XMLID 4958"
                        class="cls-2"
                        d="M94.3,268.7l-2.5-12.3a3,3,0,0,0-1.4-1.9l-15.1-8.7h-.6a3.3,3.3,0,0,0-2.2,1.6h0l1.8,1h.1l2,10.4a2.6,2.6,0,0,0,1.3,1.9l11.4,4.4,1.1,1.4,1.5,4.5c.3,0,2.4-.1,2.5-1.7h0A1.5,1.5,0,0,0,94.3,268.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4953" data-name="XMLID 4953">
                      <path
                        id="XMLID_4954"
                        data-name="XMLID 4954"
                        class="cls-1"
                        d="M91.5,271.4v-.3L90,266.6l-1-1.3-11.4-4.4a3.2,3.2,0,0,1-1.5-2.1l-1.9-10.1-1.9-1.1v-.5a3.6,3.6,0,0,1,2.5-1.8.8.8,0,0,1,.8.2l15.1,8.7a3.6,3.6,0,0,1,1.6,2.2l2.5,12.3a.9.9,0,0,1,0,.7h0c-.1,1.5-1.6,2.1-2.9,2.1ZM77.9,260.2l11.5,4.5h.1l1.2,1.5,1.4,4.3c.6,0,1.8-.3,1.8-1.4h0v-.4l-2.5-12.3a2.2,2.2,0,0,0-1.2-1.6l-15.1-8.7h-.3a2.7,2.7,0,0,0-1.8,1.1l1.3.7.4-.2,2.1,10.9A2.1,2.1,0,0,0,77.9,260.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4943" data-name="XMLID 4943">
                    <g id="XMLID_4949" data-name="XMLID 4949">
                      <path
                        id="XMLID_4950"
                        data-name="XMLID 4950"
                        class="cls-1"
                        d="M94.3,269.3h0v-.5l-2.5-12.3a3.7,3.7,0,0,0-.5-1.1,5.4,5.4,0,0,1-1.8,1.1l-2.4,1.4a46.8,46.8,0,0,0-3.8,3.9,4.9,4.9,0,0,0,.1,1.2l5.6,2.2,1.1,1.4,1.5,4.5C92.1,271.1,94.2,271,94.3,269.3Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4944" data-name="XMLID 4944">
                      <path
                        id="XMLID_4946"
                        data-name="XMLID 4946"
                        class="cls-1"
                        d="M91.5,271.5v-.3L90,266.7l-1-1.3-5.7-2.2V263c-.2-1.2-.2-1.3-.1-1.4a39.7,39.7,0,0,1,4-4.2l2.3-1.3h.1a5.4,5.4,0,0,0,1.6-1l.3-.3.3.4a3.1,3.1,0,0,1,.6,1.3l2.5,12.3c0,.1.1.5,0,.6h0c-.1,1.5-1.6,2.1-2.9,2.1Zm-7.6-8.9,5.5,2.1h.1l1.2,1.5,1.4,4.3c.6,0,1.8-.3,1.8-1.4h0v-.4l-2.5-12.3a1.4,1.4,0,0,0-.2-.6,6,6,0,0,1-1.5.9L87.4,258c-.4.3-3.2,3.2-3.6,3.7A2.8,2.8,0,0,0,83.9,262.6Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4935" data-name="XMLID 4935">
                    <g id="XMLID_4941" data-name="XMLID 4941">
                      <path
                        id="XMLID_4942"
                        data-name="XMLID 4942"
                        class="cls-1"
                        d="M75.9,246.2l-.7-.4h-.6a3.3,3.3,0,0,0-2.2,1.6h0l1,.6.4-.4A6,6,0,0,1,75.9,246.2Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4936" data-name="XMLID 4936">
                      <path
                        id="XMLID_4937"
                        data-name="XMLID 4937"
                        class="cls-1"
                        d="M73.4,248.3l-1.3-.8V247a3.6,3.6,0,0,1,2.5-1.8.8.8,0,0,1,.8.2l1.4.8-.8.3a11.8,11.8,0,0,0-1.9,1.1,1.2,1.2,0,0,1-.5.5Zm-.4-1.1.4.2h.1a7.8,7.8,0,0,1,1.5-1h-.3a3,3,0,0,0-1.7.8Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                  <g id="XMLID_4927" data-name="XMLID 4927">
                    <g id="XMLID_4933" data-name="XMLID 4933">
                      <path
                        id="XMLID_4934"
                        data-name="XMLID 4934"
                        class="cls-3"
                        d="M92.6,270l-2.5-12.5a2.9,2.9,0,0,0-1.3-1.9l-15.2-8.7a.8.8,0,0,0-1.2.9l2.3,12.1a2.6,2.6,0,0,0,1.3,1.9l15.4,9.1a.8.8,0,0,0,1.2-.9Z"
                        transform="translate(0 0)"
                      />
                    </g>
                    <g id="XMLID_4928" data-name="XMLID 4928">
                      <path
                        id="XMLID_4929"
                        data-name="XMLID 4929"
                        class="cls-1"
                        d="M91.8,271.4l-.6-.2-15.4-9.1a3.2,3.2,0,0,1-1.5-2.1L72,247.9a1.1,1.1,0,0,1,.5-1.2,1.2,1.2,0,0,1,1.3-.1L89,255.3a2.7,2.7,0,0,1,1.5,2.1L93,269.9a1.1,1.1,0,0,1-.5,1.2A.9.9,0,0,1,91.8,271.4ZM73.1,247.3h-.2c-.1,0-.2.2-.2.4L75,259.8a2.1,2.1,0,0,0,1.1,1.6l15.4,9.1c.2.1.4,0,.5,0s.2-.2.2-.4l-2.5-12.5a2.2,2.2,0,0,0-1.2-1.6l-15.2-8.7Z"
                        transform="translate(0 0)"
                      />
                    </g>
                  </g>
                </g>
                <g id="XMLID_4923" data-name="XMLID 4923">
                  <g id="XMLID_4924" data-name="XMLID 4924">
                    <path
                      id="XMLID_4925"
                      data-name="XMLID 4925"
                      class="cls-1"
                      d="M90.8,280.9a3.1,3.1,0,0,1-1.3-.3,2.6,2.6,0,0,1-1.3-2.2,18.1,18.1,0,0,0-.4-4l-2.5-11.3a8.5,8.5,0,0,0-4.2-5.6l-.7-.4a1.2,1.2,0,0,0-1.3.1,1.1,1.1,0,0,0-.5,1.2l2.3,10.7a18.4,18.4,0,0,1,.4,4.1h0a1,1,0,0,0,.4.7.6.6,0,0,0,.8,0l1,1.6a2.7,2.7,0,0,1-2.6.1,2.6,2.6,0,0,1-1.3-2.2h0a15.5,15.5,0,0,0-.4-3.7l-2.4-10.9a3.1,3.1,0,0,1,4.5-3.3l.7.4a10.6,10.6,0,0,1,5.1,6.8L89.6,274a21.2,21.2,0,0,1,.5,4.4,1,1,0,0,0,.4.7.6.6,0,0,0,.8,0l1,1.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
              <g id="XMLID_4880" data-name="XMLID 4880">
                <g id="XMLID_4915" data-name="XMLID 4915">
                  <g id="XMLID_4920" data-name="XMLID 4920">
                    <path
                      id="XMLID_4921"
                      data-name="XMLID 4921"
                      class="cls-2"
                      d="M84.8,235.6l5.5,2.4s2.5.1,2,2.4c0,0-3.5,2.4-7.8-.8S84.8,235.6,84.8,235.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4916" data-name="XMLID 4916">
                    <path
                      id="XMLID_4917"
                      data-name="XMLID 4917"
                      class="cls-1"
                      d="M89,241.7a7.8,7.8,0,0,1-4.8-1.7c-1.6-1.2-2.2-2.2-2-3.1s2.3-1.6,2.5-1.7h.1l5.5,2.4a3.7,3.7,0,0,1,2,.9,2.8,2.8,0,0,1,.4,2v.2h-.1A7.5,7.5,0,0,1,89,241.7ZM84.8,236c-.5.1-1.6.4-1.8,1s.5,1.3,1.7,2.3c3.6,2.7,6.6,1.2,7.2.8a1.4,1.4,0,0,0-.2-1.1,2,2,0,0,0-1.4-.6h-.1Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4908" data-name="XMLID 4908">
                  <g id="XMLID_4913" data-name="XMLID 4913">
                    <path
                      id="XMLID_4914"
                      data-name="XMLID 4914"
                      class="cls-2"
                      d="M85.1,232.3s.4,3.2-.3,4.5a4.4,4.4,0,0,0,5.4,1.5l.4-.2h0c-.2-.2-1.3-1.4-.5-4l-2.5-2.7Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4909" data-name="XMLID 4909">
                    <path
                      id="XMLID_4910"
                      data-name="XMLID 4910"
                      class="cls-1"
                      d="M88.3,239a4.6,4.6,0,0,1-3.8-2v-.4c.5-.9.4-3.3.3-4.2v-.3l3-1.2,2.8,3v.2c-.7,2.3.2,3.4.4,3.6h.1v.2c0,.1-.1.3-.2.3l-.4.2A4.3,4.3,0,0,1,88.3,239Zm-3-2.2a3.9,3.9,0,0,0,4.7,1.1,4.3,4.3,0,0,1-.3-3.8l-2.2-2.3-1.9.7A10.5,10.5,0,0,1,85.3,236.8Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4900" data-name="XMLID 4900">
                  <g id="XMLID_4906" data-name="XMLID 4906">
                    <path
                      id="XMLID_4907"
                      data-name="XMLID 4907"
                      class="cls-2"
                      d="M88.5,234.6s.9,1.4,4.1.5c0,0,2.4-4.2.6-8.1H89.5l-4.4,1.9,1.4,4.5Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4901" data-name="XMLID 4901">
                    <path
                      id="XMLID_4902"
                      data-name="XMLID 4902"
                      class="cls-1"
                      d="M90.6,235.7a3.4,3.4,0,0,1-2.4-.9l-2-1.4-1.6-4.9,4.8-2h4.1v.2c1.8,4-.5,8.3-.6,8.5h-.3A4.6,4.6,0,0,1,90.6,235.7Zm-1.7-1.4c0,.1.9,1.1,3.5.3.4-.7,1.9-4.2.6-7.4H89.6l-4,1.7,1.3,4Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4892" data-name="XMLID 4892">
                  <g id="XMLID_4898" data-name="XMLID 4898">
                    <path
                      id="XMLID_4899"
                      data-name="XMLID 4899"
                      class="cls-1"
                      d="M83.2,225.6s-2.2,1.7-.4,5.1.8,3.4.8,3.4.6.8,2-.1,1.3,2.1,2.9.4c0,0,.9-3.3-.3-4.8h.1a6.8,6.8,0,0,0,6.3-3.6s-.9-4-5.8-4S83.2,225.6,83.2,225.6Z"
                      transform="translate(0 0)"
                    />
                  </g>
                  <g id="XMLID_4893" data-name="XMLID 4893">
                    <path
                      id="XMLID_4894"
                      data-name="XMLID 4894"
                      class="cls-1"
                      d="M87.2,235.6H87a2.4,2.4,0,0,1-1.5-.9c-1.5.7-2.2-.2-2.2-.2v-.4s.3-.9-.8-3.1a6.2,6.2,0,0,1,.4-5.5c.4-.4,1.4-3.9,6-3.9a6,6,0,0,1,6.2,4.3H95a7.2,7.2,0,0,1-6.1,3.9,7.6,7.6,0,0,1,0,4.7h-.1A2.3,2.3,0,0,1,87.2,235.6Zm-1.5-2,.2.3a2.2,2.2,0,0,0,1.2.9,2.1,2.1,0,0,0,1.1-.4c.1-.6.7-3.2-.3-4.4a.7.7,0,0,1-.1-.5c.1-.2.3-.3.4-.2a6.5,6.5,0,0,0,5.9-3.3c-.2-.7-1.3-3.6-5.4-3.6a5.1,5.1,0,0,0-5.2,3.4h-.1c-.1.1-1.9,1.5-.3,4.6a5.4,5.4,0,0,1,.9,3.5c.2.1.6.2,1.4-.2Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4888" data-name="XMLID 4888">
                  <g id="XMLID_4890" data-name="XMLID 4890">
                    <path
                      id="XMLID_4891"
                      data-name="XMLID 4891"
                      class="cls-3"
                      d="M85.9,226.9a2,2,0,0,0-1.1-1.1,2.6,2.6,0,0,0-1.5.1l-.3-.5a2.5,2.5,0,0,1,1.9-.2,2.9,2.9,0,0,1,1.5,1.4Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4885" data-name="XMLID 4885">
                  <g id="XMLID_4886" data-name="XMLID 4886">
                    <path
                      id="XMLID_4887"
                      data-name="XMLID 4887"
                      class="cls-1"
                      d="M89.6,241.4l-.8-.2a2.1,2.1,0,0,0-.6-2.2l.5-.6A2.7,2.7,0,0,1,89.6,241.4Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
                <g id="XMLID_4882" data-name="XMLID 4882">
                  <g id="XMLID_4883" data-name="XMLID 4883">
                    <path
                      id="XMLID_4884"
                      data-name="XMLID 4884"
                      class="cls-1"
                      d="M83.2,238.3l-.6-.5a4.6,4.6,0,0,1,2.3-1.2v.8A3.2,3.2,0,0,0,83.2,238.3Z"
                      transform="translate(0 0)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="XMLID_4834" data-name="XMLID 4834">
            <g id="XMLID_4870" data-name="XMLID 4870">
              <g id="XMLID_4876" data-name="XMLID 4876">
                <path
                  id="XMLID_4877"
                  data-name="XMLID 4877"
                  class="cls-3"
                  d="M141.1,268.7a3.5,3.5,0,0,0-3-1.8.7.7,0,0,0-.6.1l-6.2,3.6a2.7,2.7,0,0,0-1.1,2.2v14.6a.8.8,0,0,0,.2.5,5,5,0,0,0,2.7,1.6c.9.3,3.2-9.8,5.1-12.8h-.1a1.7,1.7,0,0,0,.7-1.3v-3.3l1.8-2.3Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_4871" data-name="XMLID 4871">
                <path
                  id="XMLID_4872"
                  data-name="XMLID 4872"
                  class="cls-1"
                  d="M133,289.9h-.2a5.9,5.9,0,0,1-2.9-1.8,1.1,1.1,0,0,1-.3-.8V272.8a3.1,3.1,0,0,1,1.3-2.5l6.2-3.6.9-.2c2.6.3,3.3,1.9,3.3,2v.2l-2.5,3.3v3.3a2.4,2.4,0,0,1-.7,1.6,44.8,44.8,0,0,0-2.8,7.2C134.1,288.6,133.6,289.9,133,289.9Zm5-22.6h-.3l-6.2,3.6a2.1,2.1,0,0,0-.9,1.8v14.6c0,.1,0,.2.1.2a4.5,4.5,0,0,0,2.4,1.4,31.3,31.3,0,0,0,1.9-5.1c.7-2.2,1.5-4.6,2.2-6.3l-1.3.7,2-2.1a1.4,1.4,0,0,0,.5-1v-3.6l2.4-3.1a2.8,2.8,0,0,0-2.4-1.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_4862" data-name="XMLID 4862">
              <g id="XMLID_4868" data-name="XMLID 4868">
                <path
                  id="XMLID_4869"
                  data-name="XMLID 4869"
                  class="cls-2"
                  d="M133.4,273c1.4.3,5.4-.8,5.4-.8l-.2-.2h0l1.8-2.3.7-.9s-.5-1.4-2.9-1.7h-.1a.7.7,0,0,0-.6.1l-6.2,3.6a4.3,4.3,0,0,0-.9,1A18.8,18.8,0,0,0,133.4,273Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_4863" data-name="XMLID 4863">
                <path
                  id="XMLID_4864"
                  data-name="XMLID 4864"
                  class="cls-1"
                  d="M134,273.5h-.7a10.4,10.4,0,0,1-3.2-1.5l-.2-.2v-.2a2.9,2.9,0,0,1,1-1.2l6.2-3.6.9-.2h.1c2.6.3,3.2,1.9,3.2,2v.2l-2.5,3.2.4.5-.6.2A23.3,23.3,0,0,1,134,273.5Zm-3.1-2a12.3,12.3,0,0,0,2.6,1.2,14.9,14.9,0,0,0,4.7-.7v-.2l2.4-3.1a3.4,3.4,0,0,0-2.5-1.3h-.5l-6.2,3.6c-.1,0-.3.2-.5.5Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_4854" data-name="XMLID 4854">
              <g id="XMLID_4859" data-name="XMLID 4859">
                <path
                  id="XMLID_4861"
                  data-name="XMLID 4861"
                  class="cls-1"
                  d="M140.2,268.6l-6.2,3.6a2.7,2.7,0,0,0-1.1,2.2V289c0,.5.3.7.7.5l7.1-4.1a1.7,1.7,0,0,0,.7-1.3V269.5C141.3,268.6,140.8,268.2,140.2,268.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_4855" data-name="XMLID 4855">
                <path
                  id="XMLID_4856"
                  data-name="XMLID 4856"
                  class="cls-1"
                  d="M133.1,289.8h-.4a1.1,1.1,0,0,1-.4-.9V274.3a3.1,3.1,0,0,1,1.3-2.5l6.2-3.6a1.1,1.1,0,0,1,1.1-.1,1.4,1.4,0,0,1,.6,1.3V284a2,2,0,0,1-.9,1.7l-7.1,4.1Zm7.5-21h-.3l-6.2,3.6a2.1,2.1,0,0,0-.9,1.8v14.9h.1l7.1-4.1a1.2,1.2,0,0,0,.5-1V269.5c0-.4-.1-.6-.3-.7Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_4850" data-name="XMLID 4850">
              <g id="XMLID_4851" data-name="XMLID 4851">
                <path
                  id="XMLID_4852"
                  data-name="XMLID 4852"
                  class="cls-3"
                  d="M133.3,279.1H133l-.5-.5.7-.3h.3l6.8-3.9c.3-.1.5-.5.6-.9l.8.2a2.1,2.1,0,0,1-1,1.4l-6.8,3.9C133.7,279,133.5,279.1,133.3,279.1Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_4842" data-name="XMLID 4842">
              <g id="XMLID_4848" data-name="XMLID 4848">
                <path
                  id="XMLID_4849"
                  data-name="XMLID 4849"
                  class="cls-1"
                  d="M137.9,278.3l-1.2.7c-.1.1-.3,0-.3-.2v-2.7a.5.5,0,0,1,.3-.5l1.2-.7c.1-.1.3,0,.3.2v2.7A.5.5,0,0,1,137.9,278.3Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_4843" data-name="XMLID 4843">
                <path
                  id="XMLID_4844"
                  data-name="XMLID 4844"
                  class="cls-3"
                  d="M136.6,279.4h-.3a.7.7,0,0,1-.3-.6v-2.7a1,1,0,0,1,.5-.8l1.2-.7h.6a.7.7,0,0,1,.3.6v2.7a1,1,0,0,1-.5.8l-1.2.7Zm1.2-4-.9.5h-.1v2.4l.9-.5h.1Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_4839" data-name="XMLID 4839">
              <g id="XMLID_4840" data-name="XMLID 4840">
                <path
                  id="XMLID_4841"
                  data-name="XMLID 4841"
                  class="cls-3"
                  d="M140.2,269.3l-6.4,3.6.4.7,6.4-3.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_4835" data-name="XMLID 4835">
              <g id="XMLID_4836" data-name="XMLID 4836">
                <path
                  id="XMLID_4837"
                  data-name="XMLID 4837"
                  class="cls-3"
                  d="M140.1,283.6l-6.4,3.7.4.7,6.4-3.7Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        id="Shadowjm_4"
        data-name="Shadow 4"
        class="cls-1"
        d="M260.2,335.8l.7-.4-18.7-10.8.9-.4,23.6,13.7-.7.3,18.7,10.9-.9.3Zm21.4,15-23.8-13.6.8-.4L239.9,326l.9-.5,23.6,13.8-.7.3,18.7,10.9Zm-26.1-12.2.7-.4L238,327.7c0-.3.2-.5.5-.7l23.6,13.7c-.1.2-.5.2-.8.3l18.9,10.9-.9.5Zm-2.4,1.4.8-.5,23.6,13.8-.7.3Zm-2.3,1.4.8-.5,23.7,13.6-.9.5Zm-2.3,1.4.7-.5L273,355.9l-.9.5Zm-2.5,1.4.9-.5,23.6,13.6-.8.5Zm-1.9,1.6a.7.7,0,0,1,.6-.7l23.6,13.6a2.1,2.1,0,0,1-1.1.4ZM264.9,333c.2-.2.6-.2.7-.4l-18.7-10.8.9-.5,23.6,13.6-.7.4,18.2,10.5c-.2.3-.2.5-.5.7Zm21.4,15.2-23.6-13.8.7-.4-18.7-10.8.8-.4,23.6,13.7-.7.3,18.8,10.9Zm-25.4-24.7a1.8,1.8,0,0,1-.2-1l27.5,15.7a2.5,2.5,0,0,1-1.2.2l-10.7-6.1-.9.5-23.6-13.6.9-.6ZM250.2,320l23.7,13.7-.9.5-23.6-13.6Zm11.4,1.1.9-.4L290.7,337l-.9.5-11.2-6.6-.9.5-23.6-13.6.9-.6Zm21.7-12.3a4.1,4.1,0,0,1,1.9.2l9.3,5.4,7.2,4.4h.2l23.6,13.7-.9.5Zm39.9,24.9-.9.5-41.8-24.1.9-.6Zm-45-22.2.7-.6,41.9,24.2-.7.5Zm-2.4,1.4.9-.6,41.8,24.2-.9.5Zm-2.3,1.2.9-.4,41.8,24.2-.9.3Zm-2.4,1.4.8-.4,41.9,24.2-.9.3Zm-2.3,1.4.9-.4,41.8,24.2-.9.3Zm14,11c-.2.2-.2.5-.5.7L258.6,315a2.1,2.1,0,0,1,1.1-.4l6.6,3.9.9-.6L309,342.1a1.1,1.1,0,0,1-.8.3Zm-7.5-1.6,5.6,3.2-.9.5-23.6-13.6.8-.6,6.9,3.9.8-.5L294.2,336a2.2,2.2,0,0,0-1.6,0Zm30.6-9.9a1.8,1.8,0,0,1,1-.4l23,13.3c0,.4-.2.5-.4.7Zm-2.5,1.4.9-.6,23.6,13.7-.8.5Z"
        transform="translate(0 0)"
      />
      <g id="Desk_2" data-name="Desk 2">
        <g id="XMLID_1074" data-name="XMLID 1074">
          <g id="XMLID_1801" data-name="XMLID 1801">
            <g id="XMLID_1838_2" data-name="XMLID 1838 2">
              <path
                id="XMLID_1842_2"
                data-name="XMLID 1842 2"
                class="cls-1"
                d="M261.8,294.6v25.3a.9.9,0,0,0,.3.7l.3.2,1.3,1,.6-1.5,21.3-12.2a1.9,1.9,0,0,0,.9-1.5v-19Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1839_2"
                data-name="XMLID 1839 2"
                class="cls-1"
                d="M262.2,321.1l-.3-.2-.2-.2a1.9,1.9,0,0,1-.2-.7V294.4l25.3-7.2v19.4a2.2,2.2,0,0,1-1,1.8l-21.3,12.1-.7,1.8Zm-.1-26.2V320a.8.8,0,0,0,.2.5h.2l1,.8.5-1.3,21.4-12.2a1.5,1.5,0,0,0,.7-1.3V288Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1833_2" data-name="XMLID 1833 2">
              <path
                id="XMLID_1837"
                data-name="XMLID 1837"
                class="cls-3"
                d="M287.9,284.2v23.3a1.6,1.6,0,0,1-.9,1.5l-22.3,12.8a1,1,0,0,1-1.4-.4.7.7,0,0,1-.1-.5V295.6Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1834_2"
                data-name="XMLID 1834 2"
                class="cls-1"
                d="M263.5,322.1a1.3,1.3,0,0,1-.6-1.1V295.5l25.3-11.6v23.8a2.2,2.2,0,0,1-1,1.8l-22.3,12.7-.6.2Zm-.1-26.3V321c-.1.3.1.5.4.6h.7l22.3-12.7a1.5,1.5,0,0,0,.7-1.3V284.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1828_2" data-name="XMLID 1828 2">
              <path
                id="XMLID_1832_2"
                data-name="XMLID 1832 2"
                class="cls-1"
                d="M295.2,313.7V339a.9.9,0,0,0,.3.7l.3.2,1.3,1,.6-1.5L319,327.2a1.9,1.9,0,0,0,.9-1.5V305.8Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1829"
                data-name="XMLID 1829"
                class="cls-1"
                d="M295.6,340.2l-.3-.2h-.2a.8.8,0,0,1-.2-.7V313.5l25.3-8.1v20.3a2.2,2.2,0,0,1-1,1.8l-21.3,12-.7,1.8Zm-.1-26.3V339a.8.8,0,0,0,.2.5h.2l1,.8.5-1.3,21.4-12.2a1.5,1.5,0,0,0,.7-1.3V306.1Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1823" data-name="XMLID 1823">
              <path
                id="XMLID_1827_2"
                data-name="XMLID 1827 2"
                class="cls-3"
                d="M321.3,305.1v21.5a1.6,1.6,0,0,1-.9,1.5l-22.3,12.7a1,1,0,0,1-1.4-.4.7.7,0,0,1-.1-.5V314.6Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1824_2"
                data-name="XMLID 1824 2"
                class="cls-1"
                d="M296.9,341.1a1.3,1.3,0,0,1-.6-1.1V314.5l25.3-9.7v21.9a2.2,2.2,0,0,1-1,1.8l-22.3,12.7-.6.2Zm-.1-26.3V340c-.1.3.1.5.4.6h.7l22.3-12.7a1.5,1.5,0,0,0,.7-1.3V305.5Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1818_2" data-name="XMLID 1818 2">
              <path
                id="XMLID_1822"
                data-name="XMLID 1822"
                class="cls-1"
                d="M324.6,307.1h0v-1.2l-4-1.6L283,282.5a3.7,3.7,0,0,0-3.4.1l-19.5,11h-1.2v1.5c0,.3.2.5.6.7l41,23.8a3.7,3.7,0,0,0,3.4-.1l19.8-11.4C324.3,307.8,324.6,307.5,324.6,307.1Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1819_2"
                data-name="XMLID 1819 2"
                class="cls-1"
                d="M300.4,319.7l-41-23.8a1.4,1.4,0,0,1-.7-.8v-2h1.4l19.4-11a4,4,0,0,1,3.7-.1l37.6,21.8,4.2,1.6v1.7h0a1.7,1.7,0,0,1-1,1.2l-19.8,11.2a5.4,5.4,0,0,1-2.1.5A2.5,2.5,0,0,1,300.4,319.7Zm24.2-12.6h-.3v-1l-3.8-1.5-37.6-21.8a3.4,3.4,0,0,0-3.1.1l-19.5,11h-1.1v1h0c0,.3.3.4.4.5l41,23.7a3.4,3.4,0,0,0,3.1-.1l19.8-11.2a1.2,1.2,0,0,0,.7-.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1812_2" data-name="XMLID 1812 2">
              <path
                id="XMLID_1817_2"
                data-name="XMLID 1817 2"
                class="cls-3"
                d="M300.5,318.1l-41-23.8c-.9-.5-.8-1.4.3-2l19.8-11.2a3.7,3.7,0,0,1,3.4-.1l41,23.8c.9.5.8,1.4-.3,2L303.9,318A3.7,3.7,0,0,1,300.5,318.1Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1816"
                data-name="XMLID 1816"
                class="cls-2"
                d="M303.9,318a3.7,3.7,0,0,1-3.4.1l-41-23.8-.3-.2c.2-.2.4-.5.7-.6l19.8-11.2a3.7,3.7,0,0,1,3.4-.1l41,23.8.3.2c-.2.2-.4.5-.7.6Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1813_2"
                data-name="XMLID 1813 2"
                class="cls-1"
                d="M300.4,318.4l-41-23.8a1.2,1.2,0,0,1-.7-1.1,2.1,2.1,0,0,1,1-1.4l19.8-11.2a4,4,0,0,1,3.7-.1l41,23.8a1.2,1.2,0,0,1,.7,1.1,2.1,2.1,0,0,1-1,1.4l-19.8,11.2a5.4,5.4,0,0,1-2.1.5A4.2,4.2,0,0,1,300.4,318.4Zm-20.7-37-19.8,11.3a1.3,1.3,0,0,0-.7.9.7.7,0,0,0,.4.6l41,23.8a3.4,3.4,0,0,0,3.1-.1l19.8-11.2a1.3,1.3,0,0,0,.7-.9.7.7,0,0,0-.4-.6l-41-23.8a3.2,3.2,0,0,0-1.4-.3,2.5,2.5,0,0,0-1.7.3Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1807_2" data-name="XMLID 1807 2">
              <path
                id="XMLID_1811_2"
                data-name="XMLID 1811 2"
                class="cls-3"
                d="M274.1,313v-1.4l21.1,12.2v1.3Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1808"
                data-name="XMLID 1808"
                class="cls-1"
                d="M273.8,313.2v-2l21.6,12.5v2Zm.6-1.1v.7l20.5,11.8v-.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1802" data-name="XMLID 1802">
              <path
                id="XMLID_1806_2"
                data-name="XMLID 1806 2"
                class="cls-1"
                d="M274.1,311.6l6.4-3.7,14.7,8.4v7.5Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1803_2"
                data-name="XMLID 1803 2"
                class="cls-1"
                d="M273.6,311.6l7-4.1,14.9,8.6v8.2Zm6.9-3.4-5.8,3.4,20.2,11.7v-6.8Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_1796" data-name="XMLID 1796">
            <path
              id="XMLID_1800"
              data-name="XMLID 1800"
              class="cls-3"
              d="M297.4,314.1l-32.3-18.6c-.6-.3-.5-.9.2-1.3l16.1-9.1a2.4,2.4,0,0,1,2.2-.1l32.3,18.6c.6.3.5.9-.2,1.3L299.6,314A2.4,2.4,0,0,1,297.4,314.1Z"
              transform="translate(0 0)"
            />
            <path
              id="XMLID_1797"
              data-name="XMLID 1797"
              class="cls-1"
              d="M297.2,314.3l-32.3-18.6a1,1,0,0,1-.5-.8c0-.4.3-.7.7-1l16.1-9.1a2.8,2.8,0,0,1,2.5-.1L316,303.3a1,1,0,0,1,.5.8c0,.4-.3.7-.7,1l-16.1,9.1a3.2,3.2,0,0,1-1.4.3A1.4,1.4,0,0,1,297.2,314.3Zm-15.7-29-16.1,9.1a.7.7,0,0,0-.4.5l.2.3,32.3,18.6a2.1,2.1,0,0,0,1.9-.1l16.1-9.1a.7.7,0,0,0,.4-.5c0-.1-.1-.2-.2-.3l-32.3-18.6-.8-.2Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_1767_2" data-name="XMLID 1767 2">
            <g id="XMLID_1791" data-name="XMLID 1791">
              <path
                id="XMLID_1795"
                data-name="XMLID 1795"
                class="cls-3"
                d="M297.1,299.8v2l-3.5,1.9,1.4-2.5Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1792"
                data-name="XMLID 1792"
                class="cls-1"
                d="M294.7,301.1l2.7-1.8V302l-4.5,2.5Zm2.2-.8-1.7,1.1-.9,1.6,2.5-1.4v-1.3Z"
                transform="translate(0 0)"
              />
            </g>
            <path
              id="XMLID_1790"
              data-name="XMLID 1790"
              class="cls-1"
              d="M287.4,300.1l1.5-2.3,6.1,3.4-1.4,2.5Z"
              transform="translate(0 0)"
            />
            <g id="XMLID_1784" data-name="XMLID 1784">
              <path
                id="XMLID_1789"
                data-name="XMLID 1789"
                class="cls-3"
                d="M288.9,297.8l2.2-1.3,6,3.3-2.1,1.4Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1785"
                data-name="XMLID 1785"
                class="cls-1"
                d="M293.7,304.1l1.5-2.7,2.5-1.7-6.6-3.6-2.2,1.3h-.2l-.2.3L287,300Zm2.9-4.3-1.6,1.1-5.5-3.1,1.7-1Zm-2,1.5-1.1,2-5.7-3.3,1.2-1.8Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1779_2" data-name="XMLID 1779 2">
              <path
                id="XMLID_1783_2"
                data-name="XMLID 1783 2"
                class="cls-3"
                d="M305,286l-20.6-11.8c-.2-.1-.5-.2-.6-.1h-.2l-1.4.9,1.1,1.5v13.2a2.6,2.6,0,0,0,1.1,2.1l17.4,10,2.2,3,1.6-1c.3-.1.5-.4.5-.9V288.2A2.7,2.7,0,0,0,305,286Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1780_2"
                data-name="XMLID 1780 2"
                class="cls-1"
                d="M301.6,302.1l-17.3-10a2.7,2.7,0,0,1-1.2-2.3V276.7l-1.2-1.7,1.6-1,.3-.2a1,1,0,0,1,.9.1l20.6,11.8a2.7,2.7,0,0,1,1.2,2.3v14.8a1.1,1.1,0,0,1-.6,1.2l-1.9,1.2Zm-17.7-27.7h-.1l-1.1.7,1,1.3v13.3a2.1,2.1,0,0,0,.9,1.8l17.4,10,2.1,2.8,1.5-.9a.7.7,0,0,0,.3-.6V288.1a2.1,2.1,0,0,0-.9-1.8l-20.6-11.8h-.5Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1774_2" data-name="XMLID 1774 2">
              <path
                id="XMLID_1778"
                data-name="XMLID 1778"
                class="cls-1"
                d="M303.4,304.7l-20.6-11.8a2.6,2.6,0,0,1-1.1-2.1V276c0-.8.5-1.2,1.1-.8L303.4,287a2.6,2.6,0,0,1,1.1,2.1v14.8C304.5,304.7,304,305,303.4,304.7Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1775_2"
                data-name="XMLID 1775 2"
                class="cls-1"
                d="M303.2,304.9l-20.6-11.8a2.7,2.7,0,0,1-1.2-2.3V276a1.6,1.6,0,0,1,.5-1.1c.3-.2.6-.1,1,.1l20.6,11.8a2.7,2.7,0,0,1,1.2,2.3v14.8a1.6,1.6,0,0,1-.5,1.1h-1Zm-20.9-29.5a1.4,1.4,0,0,0-.2.6v14.8a2.1,2.1,0,0,0,.9,1.8l20.6,11.8h.4a1.4,1.4,0,0,0,.2-.6V289.1a2.1,2.1,0,0,0-.9-1.8l-20.6-11.8h-.4Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1768_2" data-name="XMLID 1768 2">
              <path
                id="XMLID_1773_2"
                data-name="XMLID 1773 2"
                class="cls-3"
                d="M301.8,302l-17.9-10.3a1.4,1.4,0,0,1-.6-1.2V278.4a.5.5,0,0,1,.5-.5h.1l17.9,10.3a1.4,1.4,0,0,1,.6,1.2v12.1C302.4,301.9,302.2,302.2,301.8,302Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1772_2"
                data-name="XMLID 1772 2"
                class="cls-2"
                d="M285.6,281.5a.5.5,0,0,1,.5-.5h.1l16.4,9.4v10.9a.5.5,0,0,1-.5.5H302l-16.4-9.4Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1769_2"
                data-name="XMLID 1769 2"
                class="cls-1"
                d="M301.7,302.2l-17.9-10.3a1.6,1.6,0,0,1-.8-1.4V278.4a.7.7,0,0,1,.4-.7h.7L302,288a1.6,1.6,0,0,1,.8,1.4v12.1a.7.7,0,0,1-.4.7Zm-18-24v12.3a1.1,1.1,0,0,0,.5.9L302,301.7h.1c.1-.1.1-.1.1-.2V289.4a1.1,1.1,0,0,0-.5-.9l-17.9-10.3Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_1730_2" data-name="XMLID 1730 2">
            <g id="XMLID_1743_2" data-name="XMLID 1743 2">
              <path
                id="XMLID_1766_2"
                data-name="XMLID 1766 2"
                class="cls-1"
                d="M299.4,307.3v-.8l-6.2-2.9-9-5.3a1.7,1.7,0,0,0-1.7.1l-4.8,2.7-1.5.2v1.1q0,.2.3.3l14.9,8.6a1.7,1.7,0,0,0,1.7-.1l5.9-3.3C299.3,307.7,299.5,307.5,299.4,307.3Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1744_2"
                data-name="XMLID 1744 2"
                class="cls-1"
                d="M291.2,311.6,276.3,303c-.3-.2-.4-.4-.4-.5v-1.3l1.7-.3,4.8-2.7a2.3,2.3,0,0,1,2-.1l9,5.3,6.4,2.9v1a1.1,1.1,0,0,1-.6.9l-5.9,3.3a2,2,0,0,1-1.1.3Zm1.9-7.7-9-5.3a1.4,1.4,0,0,0-1.4.1l-4.8,2.7-1.4.2v.6h0c0,.1.1.1.1.2l14.9,8.6a1.4,1.4,0,0,0,1.4-.1l5.9-3.3.3-.3v-.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1737_2" data-name="XMLID 1737 2">
              <path
                id="XMLID_1742"
                data-name="XMLID 1742"
                class="cls-3"
                d="M284.2,297.5l14.9,8.6c.4.3.4.7-.1,1l-5.9,3.3a2,2,0,0,1-1.7.1l-14.9-8.6c-.4-.3-.4-.7.1-1l5.9-3.3A1.7,1.7,0,0,1,284.2,297.5Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1741"
                data-name="XMLID 1741"
                class="cls-2"
                d="M291.4,310.5l-14-8.1,5.2-2.9a2,2,0,0,1,1.7-.1l14,8.1-5.2,2.9A2,2,0,0,1,291.4,310.5Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1738_2"
                data-name="XMLID 1738 2"
                class="cls-1"
                d="M291.2,310.7l-14.9-8.6a.8.8,0,0,1-.4-.7.9.9,0,0,1,.6-.8l5.9-3.3a2.3,2.3,0,0,1,2-.1l14.9,8.6a.8.8,0,0,1,.4.7.9.9,0,0,1-.6.8l-5.9,3.3a2,2,0,0,1-1.1.3A1.5,1.5,0,0,1,291.2,310.7Zm-7.1-13a1.4,1.4,0,0,0-1.4.1l-5.9,3.3-.3.3.2.2,14.9,8.6a1.4,1.4,0,0,0,1.4-.1l5.9-3.3q.3-.2.3-.3c0-.1-.1-.1-.1-.2Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1731_2" data-name="XMLID 1731 2">
              <g id="XMLID_1732_2" data-name="XMLID 1732 2">
                <path
                  id="XMLID_1736_2"
                  data-name="XMLID 1736 2"
                  class="cls-3"
                  d="M279.7,302l-.7.4h-.5l-.8-.5q-.3-.1,0-.3l.7-.4h.5l.8.5a.2.2,0,0,1,0,.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1733_2"
                  data-name="XMLID 1733 2"
                  class="cls-1"
                  d="M278.3,302.6l-.8-.5c-.2-.1-.3-.2-.3-.4a.5.5,0,0,1,.2-.4l.7-.4h.8l.8.5c.2.1.3.2.3.4a.5.5,0,0,1-.2.4l-.7.4Zm.3-1.1h-.2l-.5.3.7.4h.2l.5-.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_1707_2" data-name="XMLID 1707 2">
            <g id="XMLID_1719" data-name="XMLID 1719">
              <g id="XMLID_1725_2" data-name="XMLID 1725 2">
                <path
                  id="XMLID_1729_2"
                  data-name="XMLID 1729 2"
                  class="cls-1"
                  d="M310,300v8.1c0,.7,1,1.3,2.3,1.3s2.3-.6,2.3-1.3V300Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1726"
                  data-name="XMLID 1726"
                  class="cls-1"
                  d="M309.7,308.1v-8.4h5.1v8.4c0,.9-1.1,1.6-2.6,1.6S309.7,309,309.7,308.1Zm.6-7.8v7.8c0,.5.8,1,2,1s2-.6,2-1v-7.8Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1720" data-name="XMLID 1720">
                <path
                  id="XMLID_1724_2"
                  data-name="XMLID 1724 2"
                  class="cls-3"
                  d="M314.6,300.1c0,.7-1,1.3-2.3,1.3s-2.3-.6-2.3-1.3,1-1.3,2.3-1.3S314.6,299.3,314.6,300.1Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1721_2"
                  data-name="XMLID 1721 2"
                  class="cls-1"
                  d="M309.7,300.1c0-.9,1.1-1.6,2.6-1.6s2.6.7,2.6,1.6-1.1,1.6-2.6,1.6S309.7,301,309.7,300.1Zm.6,0c0,.5.8,1,2,1s2-.6,2-1-.8-1-2-1S310.3,299.6,310.3,300.1Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_1708_2" data-name="XMLID 1708 2">
              <g id="XMLID_1714_2" data-name="XMLID 1714 2">
                <path
                  id="XMLID_1718_2"
                  data-name="XMLID 1718 2"
                  class="cls-1"
                  d="M311.1,297.6v2.3c0,.4.5.7,1.2.7s1.2-.3,1.2-.7v-2.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1715_2"
                  data-name="XMLID 1715 2"
                  class="cls-1"
                  d="M310.8,299.8v-2.6h3v2.6c0,.6-.7,1-1.5,1S310.8,300.4,310.8,299.8Zm.6-2v2c0,.2.4.4.9.4s.9-.2.9-.4v-2Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1709_2" data-name="XMLID 1709 2">
                <path
                  id="XMLID_1713"
                  data-name="XMLID 1713"
                  class="cls-3"
                  d="M313.5,297.6c0,.4-.5.7-1.2.7s-1.2-.3-1.2-.7.5-.7,1.2-.7S313.5,297.2,313.5,297.6Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1710_2"
                  data-name="XMLID 1710 2"
                  class="cls-1"
                  d="M310.8,297.6c0-.6.7-1,1.5-1s1.5.4,1.5,1-.7,1-1.5,1S310.8,298.1,310.8,297.6Zm.6,0c0,.2.4.4.9.4s.9-.2.9-.4-.4-.4-.9-.4-.9.2-.9.4Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_1684_2" data-name="XMLID 1684 2">
            <g id="XMLID_1695_2" data-name="XMLID 1695 2">
              <g id="XMLID_1696_2" data-name="XMLID 1696 2">
                <g id="XMLID_1702_2" data-name="XMLID 1702 2">
                  <path
                    id="XMLID_1706"
                    data-name="XMLID 1706"
                    class="cls-3"
                    d="M299.4,308l-.2.2h0l.9,4.3c0,.8,1,1.4,2.3,1.4s2.3-.6,2.3-1.4l.9-4.3a.2.2,0,0,0-.2-.2h-6Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1703_2"
                    data-name="XMLID 1703 2"
                    class="cls-1"
                    d="M299.8,312.6l-.9-4.3a.6.6,0,0,1,.1-.4l.4-.2h6.1l.4.2a.6.6,0,0,1,.1.4l-.9,4.2c0,1-1.2,1.7-2.6,1.7S299.8,313.5,299.8,312.6Zm-.3-4.3.9,4.2c0,.6.9,1.1,2.1,1.1s2.1-.5,2.1-1.2l.9-4.2h-6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1697" data-name="XMLID 1697">
                  <path
                    id="XMLID_1701_2"
                    data-name="XMLID 1701 2"
                    class="cls-3"
                    d="M305.7,308.2c-.1.9-1.6,1.7-3.2,1.7s-3.1-.7-3.2-1.7,1.3-2,3.2-2S305.8,307.1,305.7,308.2Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1698"
                    data-name="XMLID 1698"
                    class="cls-1"
                    d="M298.9,308.2a1.4,1.4,0,0,1,.4-1.2,5.2,5.2,0,0,1,6.4,0,1.7,1.7,0,0,1,.4,1.2c-.2,1.1-1.7,1.9-3.5,1.9S299.1,309.3,298.9,308.2Zm6.5-.1a.8.8,0,0,0-.2-.7,3.3,3.3,0,0,0-2.7-.9,3.8,3.8,0,0,0-2.7.9.6.6,0,0,0-.2.7c.1.8,1.4,1.4,3,1.4S305.3,308.9,305.4,308.1Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_1690" data-name="XMLID 1690">
              <path
                id="XMLID_1694_2"
                data-name="XMLID 1694 2"
                class="cls-3"
                d="M305,308.1c-.1.6-1.2,1.1-2.5,1.1s-2.4-.5-2.5-1.1,1-1.3,2.5-1.3S305.1,307.4,305,308.1Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1691_2"
                data-name="XMLID 1691 2"
                class="cls-1"
                d="M299.6,308.2a.8.8,0,0,1,.2-.8,3.5,3.5,0,0,1,2.6-.9,3.1,3.1,0,0,1,2.6.9.8.8,0,0,1,.2.8c-.2.9-1.5,1.4-2.8,1.4S299.8,309.1,299.6,308.2Zm.7-.5a.4.4,0,0,0-.1.3c.1.4,1,.9,2.3.9s2.2-.5,2.3-.9a.4.4,0,0,0-.1-.3,3.1,3.1,0,0,0-2.1-.7A3.9,3.9,0,0,0,300.3,307.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_1685_2" data-name="XMLID 1685 2">
              <path
                id="XMLID_1689"
                data-name="XMLID 1689"
                class="cls-1"
                d="M300.2,308.6a4.3,4.3,0,0,1,4.4,0,3.3,3.3,0,0,1-2.2.6A2.9,2.9,0,0,1,300.2,308.6Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_1686_2"
                data-name="XMLID 1686 2"
                class="cls-1"
                d="M300.1,308.8l-.3-.2.3-.2a4.6,4.6,0,0,1,4.8,0l.3.2-.3.2a4,4,0,0,1-2.4.7A3.4,3.4,0,0,1,300.1,308.8Zm.7-.2a4.7,4.7,0,0,0,3.3,0A4.7,4.7,0,0,0,300.8,308.6Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_1075" data-name="XMLID 1075">
            <g id="XMLID_1666" data-name="XMLID 1666">
              <g id="XMLID_1677_2" data-name="XMLID 1677 2">
                <g id="XMLID_1678_2" data-name="XMLID 1678 2">
                  <path
                    id="XMLID_1683_2"
                    data-name="XMLID 1683 2"
                    class="cls-3"
                    d="M260,334.3s-.4,0-.6.9-.8,1.6-.2,2.2a5.2,5.2,0,0,0,3.2,1.1l1.5-.4,5.9-1.9s.5-.5.4-.9A2,2,0,0,0,269,334l-3.7-.3a14,14,0,0,1-2.9-.9Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1682"
                    data-name="XMLID 1682"
                    class="cls-2"
                    d="M259.3,335.2l2.2-1.2a14,14,0,0,0,2.9.9l3.7.3a2.3,2.3,0,0,1,1.2,1.2l-5.4,1.7-1.5.4a6.2,6.2,0,0,1-3.2-1.1C258.5,336.8,259.1,336.1,259.3,335.2Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1679_2"
                    data-name="XMLID 1679 2"
                    class="cls-1"
                    d="M259,337.6c-.6-.5-.4-1.2-.1-1.8a1.9,1.9,0,0,0,.2-.7c.2-.9.6-1.1.8-1.2l2.5-1.3h.1l2.8.9c3.6.2,3.7.3,3.9.4a2,2,0,0,1,1.3,1.4,1.6,1.6,0,0,1-.5,1.1h-.1l-5.9,1.9h-.2l-1.4.3h-.2A6.3,6.3,0,0,1,259,337.6Zm11-2.1a1.8,1.8,0,0,0-1-1.1l-3.6-.3a13.1,13.1,0,0,1-2.8-.9l-2.3,1.2h-.1s-.2.1-.4.7l-.3.8c-.2.6-.3.9,0,1.1a6.4,6.4,0,0,0,3,1.1l1.3-.3h.2l5.8-1.9C269.9,335.9,270,335.6,270,335.5Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1672_2" data-name="XMLID 1672 2">
                <path
                  id="XMLID_1676_2"
                  data-name="XMLID 1676 2"
                  class="cls-4"
                  d="M261.1,331.7l-.4,2.1a3.5,3.5,0,0,0,1.6.8,2,2,0,0,0,1.4-.6l.5-2.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1673"
                  data-name="XMLID 1673"
                  class="cls-1"
                  d="M262.3,334.9a3.1,3.1,0,0,1-1.8-.9h-.1l.5-2.5h3.6l-.5,2.7h-.1a2.1,2.1,0,0,1-1.4.7Zm1.5-2.9h-2.5l-.3,1.7a3.5,3.5,0,0,0,1.4.6c.5.1.9-.3,1.1-.4Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1667" data-name="XMLID 1667">
                <path
                  id="XMLID_1671_2"
                  data-name="XMLID 1671 2"
                  class="cls-3"
                  d="M265.1,318.6a3.8,3.8,0,0,0-1.3,2.2c-.2.9-1.4,5.1-1.4,5.1l-1.4,5.7a1.4,1.4,0,0,0,1.2,1.6h.3a1.3,1.3,0,0,0,1.5-1l5.5-12a6.8,6.8,0,0,0-1.9-4C266,314.8,265.1,318.6,265.1,318.6Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1668_2"
                  data-name="XMLID 1668 2"
                  class="cls-1"
                  d="M262.5,333.6h-.3a2.4,2.4,0,0,1-1.1-.6,1.5,1.5,0,0,1-.3-1.3l1.4-5.8s1.3-4.2,1.4-5.1a4.4,4.4,0,0,1,1.3-2.4c.1-.5.7-2.4,1.7-2.7a1.5,1.5,0,0,1,1.3.4,6.9,6.9,0,0,1,2,4.1h0l-5.5,12.1a1.7,1.7,0,0,1-1.6,1.2Zm5-17.1c-.4-.4-.7-.3-.7-.3a8.2,8.2,0,0,0-1.3,2.4h-.1a3.2,3.2,0,0,0-1.2,2c-.2.9-1.4,4.9-1.4,5.1l-1.4,5.7a1.5,1.5,0,0,0,.2.9l.7.4h.3a1.1,1.1,0,0,0,1.2-.8l5.5-12A7.5,7.5,0,0,0,267.5,316.5Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_1177" data-name="XMLID 1177">
              <g id="XMLID_1631" data-name="XMLID 1631">
                <g id="XMLID_1657" data-name="XMLID 1657">
                  <path
                    id="XMLID_1665"
                    data-name="XMLID 1665"
                    class="cls-3"
                    d="M272.9,334.3a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8C272.3,333.5,272.7,333.6,272.9,334.3Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1662"
                    data-name="XMLID 1662"
                    class="cls-1"
                    d="M272,336.5a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1.9.9,0,0,1-.6.3Zm.1-2.4a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2a2,2,0,0,0,.3-1.5c-.1-.3-.2-.4-.3-.4Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1645" data-name="XMLID 1645">
                  <path
                    id="XMLID_1656"
                    data-name="XMLID 1656"
                    class="cls-3"
                    d="M273.5,334.6a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8C272.9,333.8,273.4,334,273.5,334.6Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1653"
                    data-name="XMLID 1653"
                    class="cls-1"
                    d="M272.6,336.8a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1.9.9,0,0,1-.6.3Zm.7-2.2c-.1-.3-.2-.4-.3-.4h-.2a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2C273.3,335.9,273.4,335.2,273.3,334.6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1632" data-name="XMLID 1632">
                  <path
                    id="XMLID_1644"
                    data-name="XMLID 1644"
                    class="cls-3"
                    d="M273.2,334.9a1.2,1.2,0,0,1-.2,1c-.2.2-.5.1-.6-.2a1.2,1.2,0,0,1,.2-1C272.9,334.4,273.2,334.5,273.2,334.9Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1633"
                    data-name="XMLID 1633"
                    class="cls-1"
                    d="M272.7,336.3l-.5-.5a1.5,1.5,0,0,1,.3-1.3.7.7,0,0,1,.6-.2l.5.5a1.5,1.5,0,0,1-.3,1.3l-.4.2Zm.2-1.5a1.1,1.1,0,0,0-.1.8h.1a1.1,1.1,0,0,0,.1-.8Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1615" data-name="XMLID 1615">
                <g id="XMLID_1626" data-name="XMLID 1626">
                  <path
                    id="XMLID_1630"
                    data-name="XMLID 1630"
                    class="cls-3"
                    d="M257.5,334.1a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8C256.9,333.3,257.3,333.5,257.5,334.1Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1627"
                    data-name="XMLID 1627"
                    class="cls-1"
                    d="M256.6,336.4a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1l-.6.3Zm.1-2.5a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2a2,2,0,0,0,.3-1.5c-.1-.3-.2-.4-.3-.4Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1621" data-name="XMLID 1621">
                  <path
                    id="XMLID_1625"
                    data-name="XMLID 1625"
                    class="cls-3"
                    d="M258.1,334.4a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8C257.5,333.6,258,333.8,258.1,334.4Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1622"
                    data-name="XMLID 1622"
                    class="cls-1"
                    d="M257.2,336.7a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1.9.9,0,0,1-.6.3Zm.2-2.5a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2a2,2,0,0,0,.3-1.5c-.1-.3-.2-.4-.3-.4Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1616" data-name="XMLID 1616">
                  <path
                    id="XMLID_1620"
                    data-name="XMLID 1620"
                    class="cls-3"
                    d="M257.8,334.7a1.2,1.2,0,0,1-.2,1c-.2.2-.5.1-.6-.2a1.2,1.2,0,0,1,.2-1C257.5,334.3,257.7,334.4,257.8,334.7Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1617"
                    data-name="XMLID 1617"
                    class="cls-1"
                    d="M257.3,336.1l-.5-.5a1.5,1.5,0,0,1,.3-1.3.7.7,0,0,1,.6-.2l.5.5a1.5,1.5,0,0,1-.3,1.3l-.4.2Zm.2-1.4a1.1,1.1,0,0,0-.1.8c0,.1,0,.1.1.1h0a1.1,1.1,0,0,0,.1-.8Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1578" data-name="XMLID 1578">
                <g id="XMLID_1610" data-name="XMLID 1610">
                  <path
                    id="XMLID_1614"
                    data-name="XMLID 1614"
                    class="cls-3"
                    d="M272.8,343.2a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8C272.2,342.4,272.6,342.6,272.8,343.2Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1611"
                    data-name="XMLID 1611"
                    class="cls-1"
                    d="M271.8,345.5a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1.9.9,0,0,1-.6.3Zm.2-2.5a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2a2,2,0,0,0,.3-1.5c-.1-.3-.2-.4-.3-.4Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1603" data-name="XMLID 1603">
                  <path
                    id="XMLID_1609"
                    data-name="XMLID 1609"
                    class="cls-3"
                    d="M273.4,343.5a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8C272.8,342.7,273.2,342.9,273.4,343.5Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1604"
                    data-name="XMLID 1604"
                    class="cls-1"
                    d="M272.4,345.8a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1.9.9,0,0,1-.6.3Zm.7-2.2c-.1-.3-.2-.4-.3-.4h-.2a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2A1.6,1.6,0,0,0,273.1,343.6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1579" data-name="XMLID 1579">
                  <path
                    id="XMLID_1583"
                    data-name="XMLID 1583"
                    class="cls-3"
                    d="M273.1,343.8a1.2,1.2,0,0,1-.2,1c-.2.2-.5.1-.6-.2a1.2,1.2,0,0,1,.2-1C272.8,343.4,273,343.5,273.1,343.8Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1580"
                    data-name="XMLID 1580"
                    class="cls-1"
                    d="M272.5,345.2l-.5-.5a1.5,1.5,0,0,1,.3-1.3.7.7,0,0,1,.6-.2,1.2,1.2,0,0,1,.5.5,1.5,1.5,0,0,1-.3,1.3l-.4.2Zm.3-1.4a1.1,1.1,0,0,0-.1.8h.1a1.1,1.1,0,0,0,.1-.8Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1403" data-name="XMLID 1403">
                <g id="XMLID_1457" data-name="XMLID 1457">
                  <path
                    id="XMLID_1577"
                    data-name="XMLID 1577"
                    class="cls-3"
                    d="M257.6,343.3a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8.6.6,0,0,1,.8,0A.8.8,0,0,1,257.6,343.3Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1554"
                    data-name="XMLID 1554"
                    class="cls-1"
                    d="M256.7,345.6a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1.9.9,0,0,1-.6.3Zm.2-2.4a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2a2,2,0,0,0,.3-1.5c-.1-.3-.2-.4-.3-.4Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1410" data-name="XMLID 1410">
                  <path
                    id="XMLID_1440"
                    data-name="XMLID 1440"
                    class="cls-3"
                    d="M258.3,343.7a2,2,0,0,1-.4,1.8c-.4.4-.8.2-1-.4a2,2,0,0,1,.4-1.8C257.6,342.9,258.1,343.1,258.3,343.7Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1411"
                    data-name="XMLID 1411"
                    class="cls-1"
                    d="M257.3,345.9a1,1,0,0,1-.7-.8,2.6,2.6,0,0,1,.4-2.1.8.8,0,0,1,1.1-.3.7.7,0,0,1,.4.8,2.6,2.6,0,0,1-.4,2.1l-.6.3Zm.2-2.4a2,2,0,0,0-.3,1.5c.1.3.2.4.3.4h.2a2,2,0,0,0,.3-1.5c-.1-.3-.2-.4-.3-.4Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_1405" data-name="XMLID 1405">
                  <path
                    id="XMLID_1409"
                    data-name="XMLID 1409"
                    class="cls-3"
                    d="M258,344a1.2,1.2,0,0,1-.2,1c-.2.2-.5.1-.6-.2a1.2,1.2,0,0,1,.2-1C257.6,343.5,257.9,343.6,258,344Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1406"
                    data-name="XMLID 1406"
                    class="cls-1"
                    d="M257.4,345.4a1.2,1.2,0,0,1-.5-.5,1.5,1.5,0,0,1,.3-1.3.7.7,0,0,1,.6-.2l.5.5a1.5,1.5,0,0,1-.3,1.3l-.4.2Zm.2-1.5a1.1,1.1,0,0,0-.1.8h.1a1.1,1.1,0,0,0,.1-.8Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1393" data-name="XMLID 1393">
                <path
                  id="XMLID_1402"
                  data-name="XMLID 1402"
                  class="cls-3"
                  d="M265.7,336.3l7.3,6.5c.4.3.8,1.7-1.2.7l-14.4-8.4c-2.2-1.4-.6-1.7.2-1.5l7.1,2.5C265,336.3,265.5,336.2,265.7,336.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1394"
                  data-name="XMLID 1394"
                  class="cls-1"
                  d="M271.7,343.8l-14.4-8.4c-.4-.2-1.5-.9-1.2-1.6s1.1-.5,1.6-.3l7.1,2.5c.2.1.7-.1,1,.2l7.3,6.5a1.1,1.1,0,0,1,.3,1.3.7.7,0,0,1-.6.3Zm1.3-.2a.8.8,0,0,0-.2-.5l-7.3-6.5h-.9l-7.1-2.5a1.4,1.4,0,0,0-.9.1s0,.3.9.9l14.4,8.4C272.8,343.7,273,343.6,273,343.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1358" data-name="XMLID 1358">
                <path
                  id="XMLID_1392"
                  data-name="XMLID 1392"
                  class="cls-3"
                  d="M263.9,336.3l-7.3,6.5c-.4.3-.8,1.7,1.2.7l14.4-8.4c2.2-1.4.6-1.7-.2-1.5l-7.1,2.5C264.6,336.3,264.1,336.2,263.9,336.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1384"
                  data-name="XMLID 1384"
                  class="cls-1"
                  d="M256.2,343.9a1.1,1.1,0,0,1,.3-1.3l7.3-6.5c.3-.3.8-.1,1-.2l7.1-2.5c.5-.2,1.4-.1,1.6.3s-.8,1.4-1.2,1.6l-14.4,8.5-1.2.4A.5.5,0,0,1,256.2,343.9Zm15.9-10-7.1,2.5h-.9l-7.3,6.5c-.1.2-.2.3-.2.5s.2.1,1-.3l14.4-8.4c1-.6,1-.9,1-.9h-.5Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1348" data-name="XMLID 1348">
                <path
                  id="XMLID_1357"
                  data-name="XMLID 1357"
                  class="cls-3"
                  d="M267.1,337.6c0,.9-1.1,1.7-2.5,1.7s-2.5-.8-2.5-1.7a2.5,2.5,0,0,1,5,0Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1349"
                  data-name="XMLID 1349"
                  class="cls-1"
                  d="M261.8,337.6a2.9,2.9,0,0,1,2.8-2.7,3.3,3.3,0,0,1,2.8,2.7c0,1.1-1.2,2-2.8,2S261.8,338.7,261.8,337.6Zm.6,0c0,.8,1,1.4,2.2,1.4s2.2-.6,2.2-1.4a2.2,2.2,0,1,0-4.4,0Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1333" data-name="XMLID 1333">
                <path
                  id="XMLID_1347"
                  data-name="XMLID 1347"
                  class="cls-1"
                  d="M266.4,336.3c0,.7-.8,1.2-1.8,1.2s-1.8-.6-1.8-1.2.8-1.2,1.8-1.2S266.4,335.7,266.4,336.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1339"
                  data-name="XMLID 1339"
                  class="cls-1"
                  d="M262.5,336.3c0-.9.9-1.5,2.1-1.5s2.1.7,2.1,1.5-.9,1.5-2.1,1.5S262.5,337.2,262.5,336.3Zm.6,0c0,.5.7.9,1.5.9s1.5-.4,1.5-.9-.7-.9-1.5-.9S263.1,335.8,263.1,336.3Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1205" data-name="XMLID 1205">
                <g id="XMLID_1309" data-name="XMLID 1309">
                  <path
                    id="XMLID_1332"
                    data-name="XMLID 1332"
                    class="cls-3"
                    d="M264.6,336.3a1.1,1.1,0,0,1-1.1-1.1h0V324.3a1.1,1.1,0,1,1,2.2,0h0v10.9a1.1,1.1,0,0,1-1.1,1.1Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1323"
                    data-name="XMLID 1323"
                    class="cls-1"
                    d="M263.2,335.2V324.3a1.4,1.4,0,1,1,2.8,0v10.9a1.4,1.4,0,0,1-2.8,0Zm.6-10.9v10.9a.8.8,0,1,0,1.6,0V324.3a.9.9,0,0,0-.8-.8C264.2,323.4,263.8,323.8,263.8,324.3Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1199" data-name="XMLID 1199">
                <path
                  id="XMLID_1203"
                  data-name="XMLID 1203"
                  class="cls-1"
                  d="M274.4,321h-1.1l-.5-.3-2.6-1.4c-2.3-1.3-6.2-1-8.8.6l-3.5,2.2-2.7.9v1.8a1.4,1.4,0,0,0,.9,1.3l5.9,3.3a5.6,5.6,0,0,0,5.2-.4l5.2-3.1a3.8,3.8,0,0,0,2.1-2.8v-2Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1200"
                  data-name="XMLID 1200"
                  class="cls-1"
                  d="M261.8,329.5l-5.9-3.3a1.9,1.9,0,0,1-1.1-1.4v-2.1l2.9-.9,3.5-2.2c2.6-1.6,6.7-1.9,9.1-.6l2.6,1.4.4.3h1.3v2.4h0a4.1,4.1,0,0,1-2.2,2.9l-5.2,3.1a6.2,6.2,0,0,1-3.2.9A5.4,5.4,0,0,1,261.8,329.5Zm12.3-8.2h-1l-.4-.3-2.6-1.4c-2.2-1.2-6-.9-8.5.6l-3.6,2.2-2.5.8v1.6a1.5,1.5,0,0,0,.8,1.1l5.9,3.3a6,6,0,0,0,4.9-.3l5.2-3.1a3.5,3.5,0,0,0,1.9-2.5v-1.9Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1178" data-name="XMLID 1178">
                <path
                  id="XMLID_1198"
                  data-name="XMLID 1198"
                  class="cls-3"
                  d="M262,327.6l-5.9-3.3c-1.3-.7-1.2-2.1.3-3l5-3.1c2.6-1.6,6.5-1.9,8.8-.6l2.6,1.4c2.3,1.3,2.1,3.6-.5,5.2l-5.2,3.1A5.7,5.7,0,0,1,262,327.6Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1182"
                  data-name="XMLID 1182"
                  class="cls-2"
                  d="M256.5,323.1l5-3.1c2.6-1.6,6.5-1.9,8.8-.6l2.6,1.4a3.7,3.7,0,0,1,1.3,1.2,3.8,3.8,0,0,1-1.9,2.2l-5.2,3.1a6,6,0,0,1-5.2.4l-5.9-3.3a1,1,0,0,1-.5-.4Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1179"
                  data-name="XMLID 1179"
                  class="cls-1"
                  d="M261.8,327.8l-5.9-3.3a1.9,1.9,0,0,1-1.1-1.5,2.5,2.5,0,0,1,1.4-2l5-3.1c2.6-1.6,6.7-1.9,9.1-.6l2.6,1.4a2.9,2.9,0,0,1,1.7,2.4,4,4,0,0,1-2.2,3.2l-5.2,3.1a6.2,6.2,0,0,1-3.2.9A4.2,4.2,0,0,1,261.8,327.8Zm-.3-9.5-5,3.1a1.9,1.9,0,0,0-1.1,1.5,1,1,0,0,0,.8,1l5.9,3.3a6,6,0,0,0,4.9-.3l5.2-3.1c1.3-.8,2-1.8,1.9-2.7a2.2,2.2,0,0,0-1.4-1.9l-2.6-1.4a7.7,7.7,0,0,0-3.4-.8,10.6,10.6,0,0,0-5.2,1.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_1095" data-name="XMLID 1095">
              <g id="XMLID_1170" data-name="XMLID 1170">
                <g id="XMLID_1171" data-name="XMLID 1171">
                  <path
                    id="XMLID_1176"
                    data-name="XMLID 1176"
                    class="cls-3"
                    d="M274,339.9s-.4,0-.6.9-.8,1.6-.2,2.1a5.8,5.8,0,0,0,3.1,1.1l1.5-.3,5.7-1.8s.5-.5.4-.8a1.8,1.8,0,0,0-1.2-1.2l-3.6-.3a12.9,12.9,0,0,1-2.8-.8Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1175"
                    data-name="XMLID 1175"
                    class="cls-2"
                    d="M273.4,340.6l1.5-.8a12.9,12.9,0,0,0,2.8.8l3.6.3a1.8,1.8,0,0,1,1.1,1l-4.5,1.5-1.5.3a5.1,5.1,0,0,1-3.1-1.1C272.6,342.1,273.1,341.5,273.4,340.6Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1172"
                    data-name="XMLID 1172"
                    class="cls-1"
                    d="M273,343.2c-.6-.5-.4-1.1-.1-1.7a1.9,1.9,0,0,0,.2-.7c.2-.9.6-1.1.8-1.1l2.4-1.3h.1a13.8,13.8,0,0,0,2.7.8l3.7.3a2.3,2.3,0,0,1,1.3,1.4c.1.5-.4,1-.4,1.1h-.1l-5.7,1.8h-.2l-1.3.3h-.2A5.9,5.9,0,0,1,273,343.2Zm10.5-2.1a1.5,1.5,0,0,0-.9-1l-3.5-.3a9.2,9.2,0,0,1-2.7-.8l-2.2,1.2h-.1s-.2.1-.3.7l-.3.8c-.2.6-.3.8,0,1.1a5.1,5.1,0,0,0,2.9,1l1.2-.3h.2l5.6-1.8C283.4,341.5,283.5,341.2,283.5,341.1Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1162" data-name="XMLID 1162">
                <path
                  id="XMLID_1169"
                  data-name="XMLID 1169"
                  class="cls-4"
                  d="M274.3,337.4v2.4a4.1,4.1,0,0,0,1.9.5,2,2,0,0,0,1.3-.9v-2.6Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1163"
                  data-name="XMLID 1163"
                  class="cls-1"
                  d="M274.2,340h-.1v-2.9l3.9-.8v3h0a2.3,2.3,0,0,1-1.6,1.1h-.2A3.4,3.4,0,0,1,274.2,340Zm3.1-2.9-2.7.6v2a2.9,2.9,0,0,0,1.6.4,1.9,1.9,0,0,0,1.1-.7Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1157" data-name="XMLID 1157">
                <path
                  id="XMLID_1161"
                  data-name="XMLID 1161"
                  class="cls-4"
                  d="M269.1,296.7c-.3-.6-.6-1.1,0-1.3a6.8,6.8,0,0,0,2.4-1.3l.8-1.8.4-.5,4.9-3.7a12.4,12.4,0,0,1,0,4.7,7.8,7.8,0,0,1-.9,2.1,1.2,1.2,0,0,1-1,.5h-.3a1.2,1.2,0,0,0-1.1,1.3h0a8.3,8.3,0,0,0,.4,1.5,1.2,1.2,0,0,1-.9,1.5h-.3l-2.7-.3a1,1,0,0,1-.9-.7Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1158"
                  data-name="XMLID 1158"
                  class="cls-1"
                  d="M273.6,300.1l-2.7-.3a1.5,1.5,0,0,1-1.1-.8l-1.1-2.4c-.2-.4-.4-.7-.2-1.1a.7.7,0,0,1,.5-.4,10.1,10.1,0,0,0,2.3-1.2,14.2,14.2,0,0,0,.8-1.8l.5-.6,5.2-4v.5a12.9,12.9,0,0,1,0,4.8,8.5,8.5,0,0,1-.9,2.2,1.5,1.5,0,0,1-1.2.7h-.3a.7.7,0,0,0-.6.3.8.8,0,0,0-.2.7,8.3,8.3,0,0,0,.4,1.5,1.5,1.5,0,0,1-.3,1.3,1.6,1.6,0,0,1-1.1.5C273.7,300.1,273.7,300.1,273.6,300.1Zm-.7-8-.3.3-.8,1.8c-.3.6-1.9,1.2-2.6,1.5H269a1.4,1.4,0,0,0,.2.6l1.1,2.4a.8.8,0,0,0,.7.5l2.7.3a.9.9,0,0,0,.7-.3,1.1,1.1,0,0,0,.2-.8c-.1-.5-.3-1.1-.4-1.5a1.3,1.3,0,0,1,.3-1.2,1.6,1.6,0,0,1,1.1-.5h.3a.8.8,0,0,0,.7-.4,7,7,0,0,0,.8-2,11.3,11.3,0,0,0,.1-4.1Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1123" data-name="XMLID 1123">
                <path
                  id="XMLID_1156"
                  data-name="XMLID 1156"
                  class="cls-3"
                  d="M261,313.3a1.5,1.5,0,0,0-1.4,1.5c0,1.6,0,4,.7,5.2a8.7,8.7,0,0,0,5.2,3.8c3.1,1,9,.6,10,.6h-.3a9.1,9.1,0,0,0-.6,4c0,2.8-.1,5.3-.3,7.3v1a1.5,1.5,0,0,0,.7,1.5l.7.5a1.4,1.4,0,0,0,1.7,0,2.1,2.1,0,0,0,.6-1l3.3-11.7v-.3a4.4,4.4,0,0,0-1.1-5.4c-1.2-.9-8.1-4.7-8.8-5h-.1l-5.5-2.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1125"
                  data-name="XMLID 1125"
                  class="cls-1"
                  d="M275.4,339l-.7-.5a1.7,1.7,0,0,1-.8-1.7v-1c.2-2.4.3-4.9.3-7.3a15.5,15.5,0,0,1,.4-3.7h-.4c-2.1,0-6.5.1-9-.7a9.2,9.2,0,0,1-5.4-4c-1-1.8-.7-3.6-.7-5.3a1.8,1.8,0,0,1,1.6-1.8,25.9,25.9,0,0,1,4.8-.4c.4.1,5.3,2.3,5.6,2.3h.1c1.3.7,7.7,4.1,8.8,5.1a4.7,4.7,0,0,1,1.2,5.8v.2l-3.3,11.7a1.9,1.9,0,0,1-.7,1.2,1.7,1.7,0,0,1-1,.3ZM261,313.6a1.3,1.3,0,0,0-1.1,1.2c0,1.4,0,3.9.6,5s1.9,2.7,5,3.7,6.8.7,8.8.6h1.1v.6h-.1a15,15,0,0,0-.5,3.7c0,2.4-.1,4.9-.3,7.3v1a1.1,1.1,0,0,0,.5,1.2l.7.5a1.2,1.2,0,0,0,1.4,0,1.4,1.4,0,0,0,.5-.8l3.3-11.7v-.3a4.4,4.4,0,0,0-1-5.1c-1.2-.9-8-4.6-8.8-5H271l-5.4-2.3h-.1Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1107" data-name="XMLID 1107">
                <path
                  id="XMLID_1114"
                  data-name="XMLID 1114"
                  class="cls-4"
                  d="M288.1,306.5l.9-.4,2.3-.3c.8.1,3,1.2,2.3,1.9a1.6,1.6,0,0,1-.8.6l-.9-.4-1,.6a2,2,0,0,1-2.6-.5l-.8-1Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1108"
                  data-name="XMLID 1108"
                  class="cls-1"
                  d="M288,308.2l-1-1.2,1-.7,1-.5,2.4-.3a3.5,3.5,0,0,1,2.6,1.6.8.8,0,0,1-.1.8,1.8,1.8,0,0,1-.9.6h-.1l-.9-.4-.9.6a2.7,2.7,0,0,1-1.2.3A2,2,0,0,1,288,308.2Zm4.9-.3.6-.5c.1-.1.1-.1,0-.2a4.6,4.6,0,0,0-2.1-1.3l-2.3.3-.8.4-.5.4.7.8a1.7,1.7,0,0,0,2.3.4l1.1-.7Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1101" data-name="XMLID 1101">
                <path
                  id="XMLID_1106"
                  data-name="XMLID 1106"
                  class="cls-3"
                  d="M264.1,298a7.3,7.3,0,0,1,4.7-2.5c1-.1,0,.7,1.2,1.4a5,5,0,0,0,3.6.4,3.6,3.6,0,0,1,3.3,2.1c.9,1.8,2.1,4.7,2.4,5.5s1.1,3.8,1.1,3.8l7.8-2.6c.8-.3,1.1,2.4.8,3.2s-9.8,4.5-10.8,4.2-2.6-3.4-3.1-5.5c0,0-.3-.2-.7.5a22.5,22.5,0,0,0-1.5,6.2c0,1.5,2.5,2.7-.9,4.1s-9.7,2.7-12.5-.6c-.6-.7.7-12.2,2.2-15.9S264.1,298,264.1,298Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1105"
                  data-name="XMLID 1105"
                  class="cls-2"
                  d="M263.5,300.2a7.3,7.3,0,0,1,4.7-2.5c1-.1,0,.7,1.2,1.4a5,5,0,0,0,3.6.4,3.6,3.6,0,0,1,3.3,2.1c.9,1.8,2.1,4.7,2.4,5.5s1.1,3.8,1.1,3.8l7.8-2.6c.5-.2.8.7.9,1.6-2,1.3-9.4,4-10.3,3.8s-2.6-3.4-3.1-5.5c0,0-.3-.2-.7.5a24,24,0,0,0-1.2,3.8,31.2,31.2,0,0,0-.9,4.4,3.9,3.9,0,0,0,.6,1.5l-.9.5c-4.5,1.9-9.7,2.7-12.5-.6-.5-.6.3-8.2,1.4-13l.3-.8C262.7,300.7,263.5,300.2,263.5,300.2Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1102"
                  data-name="XMLID 1102"
                  class="cls-1"
                  d="M259.4,318.4c-.8-.9.8-12.7,2.2-16.2s2.2-4.2,2.4-4.4a7,7,0,0,1,4.8-2.6h.6c.2.1.2.4.2.5a.9.9,0,0,0,.5.8,4.5,4.5,0,0,0,3.2.4h.2a3.6,3.6,0,0,1,3.6,2.3,53.8,53.8,0,0,1,2.4,5.5c.2.6.8,2.7,1,3.5l7.5-2.5a.6.6,0,0,1,.7.1c.6.6.8,2.7.6,3.5s-.2.4-.9.8-9.3,3.9-10.3,3.6-2.7-3.4-3.2-5.5c-.1,0-.1.1-.2.3a20.3,20.3,0,0,0-1.5,6,2.8,2.8,0,0,0,.4,1.2,2.1,2.1,0,0,1,.4,1.7c-.2.6-.8,1-1.9,1.5a20,20,0,0,1-7.2,1.7A7,7,0,0,1,259.4,318.4Zm16-10.6v.2c.6,2.2,2.1,5.1,2.9,5.3s10-3.3,10.5-4a4.8,4.8,0,0,0-.4-2.9l-7.9,2.6h-.3v-.3s-.9-3-1.1-3.8a44.1,44.1,0,0,0-2.4-5.4,3.3,3.3,0,0,0-3-2h-.2a4.6,4.6,0,0,1-3.6-.5,1.3,1.3,0,0,1-.8-1.3h-.2a6.5,6.5,0,0,0-4.5,2.4h-.1s-.8.6-2.2,4.1-2.7,14.9-2.3,15.6c3,3.5,8.9,1.8,12.1.5a3.6,3.6,0,0,0,1.6-1.1,2.7,2.7,0,0,0-.3-1.2,3.4,3.4,0,0,1-.5-1.4,22.3,22.3,0,0,1,1.5-6.3,1.2,1.2,0,0,1,.7-.7h.1Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1096" data-name="XMLID 1096">
                <path
                  id="XMLID_1100"
                  data-name="XMLID 1100"
                  class="cls-1"
                  d="M264.3,299.3c-.9,0,0-3.3.6-4s3.2-2.1,3.4-3.9.7-4.7,2.7-6.1,5.9-1.2,6.8.2,1.2,2.6.9,3.3l-.6,1.7-.9-1.8-.5,1.5c-.3,1-.1,3.8-1.1,5.2s-2.7,3.4-6.7,2.6Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1097"
                  data-name="XMLID 1097"
                  class="cls-1"
                  d="M264.3,299.6a.7.7,0,0,1-.6-.4c-.4-.9.4-3.4,1-4l1.4-1.2c1-.8,1.8-1.4,1.9-2.5.3-3,1.2-5.1,2.8-6.3a7.3,7.3,0,0,1,5.2-.8,2.8,2.8,0,0,1,2,1.2c.9,1.5,1.2,2.8.9,3.6l-.9,2.3-.9-1.7-.3.8c-.1.3-.1.8-.2,1.4a8.7,8.7,0,0,1-1,3.9c-1.6,2.2-2.8,3.5-6.9,2.7Zm4.6-1.8c3.9.8,4.9-.3,6.4-2.4a7.4,7.4,0,0,0,.9-3.6c.1-.6.1-1.2.2-1.6a6.5,6.5,0,0,0,.4-1.3h0c0-.2.2-.3.4-.3s.2.1.2.3l.6,1.1.4-1.1c.2-.6-.1-1.7-.9-3.1s-.8-.7-1.7-.9a6.5,6.5,0,0,0-4.7.8c-1.4,1-2.3,3-2.5,5.9s-1.1,2.1-2.1,2.9l-1.3,1.1a6.2,6.2,0,0,0-.9,3.2.4.4,0,0,0,.1.3l4.4-1.2Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_1076" data-name="XMLID 1076">
              <g id="XMLID_1089" data-name="XMLID 1089">
                <g id="XMLID_1090" data-name="XMLID 1090">
                  <path
                    id="XMLID_1094"
                    data-name="XMLID 1094"
                    class="cls-3"
                    d="M258.5,327.9a2.8,2.8,0,0,1-1.3-.3A2.2,2.2,0,0,1,256,326v-4.7a.8.8,0,0,1,.7-.8.7.7,0,0,1,.7.7h0v4.3a1,1,0,0,0,.5.6,1.7,1.7,0,0,0,1,.1.7.7,0,0,1,.9.5.7.7,0,0,1-.3.9h-1Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1091"
                    data-name="XMLID 1091"
                    class="cls-1"
                    d="M257,327.8a2.8,2.8,0,0,1-1.4-1.8v-4.7a1,1,0,0,1,2,0v4.3l.3.4h.8a1.1,1.1,0,0,1,1.2.7,1,1,0,0,1-.1.9c-.2.3-.4.5-.7.5h-.7Zm1.9-1.2a2.5,2.5,0,0,1-1.2-.1,1.1,1.1,0,0,1-.6-.7v-4.4a.5.5,0,0,0-1,0v4.4h0a1.9,1.9,0,0,0,1.1,1.4,2.8,2.8,0,0,0,1.8.2c.1,0,.3-.1.3-.2a.3.3,0,0,0,0-.4c.1-.2-.1-.3-.4-.3Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_1082" data-name="XMLID 1082">
                <path
                  id="XMLID_1088"
                  data-name="XMLID 1088"
                  class="cls-3"
                  d="M260.1,302.5l-2.9-1.7a2.6,2.6,0,0,0-2.7-.3h-.2l-1.6.8.3.8a7.6,7.6,0,0,0-.3,2.1v9.4a6.4,6.4,0,0,0,2.6,5.1l5.9,3.5.6,1.4,1.8-.9a2.3,2.3,0,0,0,1-2.2v-9.4C264.6,307.8,262.6,303.9,260.1,302.5Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1087"
                  data-name="XMLID 1087"
                  class="cls-2"
                  d="M259.8,303.1l-2.9-1.7a2.6,2.6,0,0,0-2.7-.3H254l-1.6.8.3.8a7.6,7.6,0,0,0-.3,2.1v9.4a6.4,6.4,0,0,0,2.6,5.1l5.9,3.5.2.9,2.1-.3-.3-.5c.6-.3,1.3-.6,1.3-1.7v-9.4C264.3,308.5,262.3,304.6,259.8,303.1Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1083"
                  data-name="XMLID 1083"
                  class="cls-1"
                  d="M261.1,322.5l-5.8-3.4a6.9,6.9,0,0,1-2.8-5.4v-9.4a7.6,7.6,0,0,1,.3-2.1l-.4-1,2.3-1.1a3.1,3.1,0,0,1,2.8.5l2.9,1.7c2.6,1.5,4.6,5.5,4.6,9v9.4a2.6,2.6,0,0,1-1,2.3l-2.2,1.1Zm2.4.1a2,2,0,0,0,.8-1.9v-9.4c0-3.3-2-7.1-4.4-8.5l-2.9-1.7a2.8,2.8,0,0,0-2.5-.3l-1.5.7.3.7h0a6.4,6.4,0,0,0-.3,2v9.4a6,6,0,0,0,2.5,4.9l5.9,3.5h.1l.5,1.2,1.3-.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_1077" data-name="XMLID 1077">
                <path
                  id="XMLID_1081"
                  data-name="XMLID 1081"
                  class="cls-1"
                  d="M260.2,323.5l-6.6-3.9a6.4,6.4,0,0,1-2.6-5.1v-9.4c0-3.4,2-4.9,4.5-3.4l2.9,1.7c2.5,1.5,4.5,5.4,4.5,8.7v9.4C262.9,323.4,261.7,324.4,260.2,323.5Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_1078"
                  data-name="XMLID 1078"
                  class="cls-1"
                  d="M260.1,323.7l-6.6-3.9a6.9,6.9,0,0,1-2.8-5.4V305c0-1.9.6-3.3,1.7-4a3.1,3.1,0,0,1,3.2.3l2.9,1.7c2.6,1.5,4.6,5.5,4.6,9v9.4a2.5,2.5,0,0,1-1.1,2.4l-.8.2A1.1,1.1,0,0,1,260.1,323.7Zm-7.3-22.1c-.9.5-1.4,1.8-1.4,3.5v9.4a6,6,0,0,0,2.5,4.9l6.6,3.9a1.2,1.2,0,0,0,1.4.1,2,2,0,0,0,.8-1.9v-9.4c0-3.3-2-7.1-4.4-8.5l-2.9-1.7a3,3,0,0,0-1.6-.5A1.8,1.8,0,0,0,252.8,301.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        id="Shadowjm_1"
        data-name="Shadow 1"
        class="cls-1"
        d="M22.2,227.8l.7-.4L4.2,216.6l.9-.4,23.6,13.7-.7.3,18.7,10.9-.9.3Zm21.4,15L19.8,229.2l.8-.4L1.9,218l.9-.5,23.6,13.8-.7.3,18.7,10.9ZM17.5,230.6l.7-.4L0,219.7c0-.3.2-.5.5-.7l23.6,13.7c-.1.2-.5.2-.8.3l18.9,10.9-.9.5ZM15,232l.9-.5,23.6,13.8-.7.3Zm-2.2,1.4.8-.5,23.7,13.6-.9.5Zm-2.3,1.4.7-.5L35,247.9l-.9.5Zm-2.4,1.4.8-.5,23.6,13.6-.8.5Zm-2,1.6a.7.7,0,0,1,.6-.7l23.6,13.6a2.1,2.1,0,0,1-1.1.4ZM26.9,225c.2-.2.6-.2.7-.4L8.9,213.8l.9-.5,23.6,13.6-.7.4,18.2,10.5c-.2.3-.2.5-.5.7Zm21.4,15.2L24.7,226.4l.7-.4L6.7,215.2l.8-.4,23.6,13.7-.7.3,18.8,10.9ZM22.9,215.5a1.8,1.8,0,0,1-.2-1l27.5,15.7a2.5,2.5,0,0,1-1.2.2l-10.7-6.1-.9.5L13.8,211.2l.9-.6ZM12.2,212l23.7,13.7-.9.5L11.4,212.6Zm11.4,1.1.9-.4L52.7,229l-.9.5-11.2-6.6-.9.5L16.1,209.8l.9-.6Zm21.7-12.3a4.1,4.1,0,0,1,1.9.2l9.3,5.4,7.2,4.4h.2l23.6,13.7-.9.5Zm39.9,24.9-.9.5L42.5,202.1l.9-.6Zm-45-22.2.7-.6,41.9,24.2-.7.5Zm-2.4,1.4.9-.6,41.8,24.2-.9.5Zm-2.3,1.2.9-.4,41.8,24.2-.9.3Zm-2.4,1.4.8-.4,41.9,24.2-.9.3Zm-2.3,1.4.9-.4,41.8,24.2-.9.3Zm14,11c-.2.2-.2.5-.5.7L20.6,207a2.1,2.1,0,0,1,1.1-.4l6.6,3.9.9-.6L71,234.1a1.1,1.1,0,0,1-.8.3Zm-7.5-1.6,5.6,3.2-.9.5L18.4,208.4l.8-.6,6.9,3.9.8-.5L56.2,228a2.2,2.2,0,0,0-1.6,0Zm30.6-9.9a1.8,1.8,0,0,1,1-.4l23,13.3c0,.4-.2.5-.4.7Zm-2.5,1.4.9-.6,23.6,13.7-.8.5Z"
        transform="translate(0 0)"
      />
      <g id="Desk_1" data-name="Desk 1">
        <g id="x34_3" data-name="x34 3">
          <g id="XMLID_3404" data-name="XMLID 3404">
            <g id="XMLID_3443_2" data-name="XMLID 3443 2">
              <path
                id="XMLID_3447_2"
                data-name="XMLID 3447 2"
                class="cls-1"
                d="M17.4,190.7v25.8a.9.9,0,0,0,.3.7l.3.2,1.4,1,.6-1.6,21.8-12.4a1.6,1.6,0,0,0,.9-1.5V183.5Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3444"
                data-name="XMLID 3444"
                class="cls-1"
                d="M19.5,218.9l.7-1.8,21.7-12.4a2.2,2.2,0,0,0,1-1.8V183.1l-25.8,7.3v26.1a1.9,1.9,0,0,0,.2.7l.3.2.3.2Zm22.8-35v19a1.6,1.6,0,0,1-.8,1.3L19.6,216.7l-.5,1.3-1.1-.8h-.2a.8.8,0,0,1-.2-.5V191Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3438_2" data-name="XMLID 3438 2">
              <path
                id="XMLID_3442_2"
                data-name="XMLID 3442 2"
                class="cls-3"
                d="M44,180.1v23.8a1.6,1.6,0,0,1-.9,1.5l-22.8,13a1,1,0,0,1-1.4-.4.7.7,0,0,1-.1-.5V191.7Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3439_2"
                data-name="XMLID 3439 2"
                class="cls-1"
                d="M19.8,218.8l.7-.2,22.8-13a2.2,2.2,0,0,0,1-1.8V179.6L18.5,191.5v26a1.2,1.2,0,0,0,.7,1.1A.7.7,0,0,0,19.8,218.8Zm23.9-38.3v23.3a1.6,1.6,0,0,1-.8,1.3l-22.8,13h-.7a.7.7,0,0,1-.4-.6V191.8Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3433_2" data-name="XMLID 3433 2">
              <path
                id="XMLID_3437_2"
                data-name="XMLID 3437 2"
                class="cls-1"
                d="M51.5,210.1v25.8a.9.9,0,0,0,.3.7l.3.2,1.4,1,.6-1.6,21.8-12.4a1.6,1.6,0,0,0,.9-1.5V202Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3434"
                data-name="XMLID 3434"
                class="cls-1"
                d="M53.5,238.3l.7-1.8,21.7-12.4a2.2,2.2,0,0,0,1-1.8V201.6l-25.8,8.3V236a1.9,1.9,0,0,0,.2.7h.2l.3.2Zm22.9-35.9v19.9a1.6,1.6,0,0,1-.8,1.3L53.7,236.1l-.5,1.3-1.1-.8h-.2a.8.8,0,0,1-.2-.5V210.4Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3428_2" data-name="XMLID 3428 2">
              <path
                id="XMLID_3432_2"
                data-name="XMLID 3432 2"
                class="cls-3"
                d="M78.1,201.4v21.9a1.6,1.6,0,0,1-.9,1.5l-22.8,13a1,1,0,0,1-1.4-.4.7.7,0,0,1-.1-.5V211.1Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3429"
                data-name="XMLID 3429"
                class="cls-1"
                d="M53.9,238.2l.7-.2,22.8-13a2.2,2.2,0,0,0,1-1.8V200.9l-25.8,9.9v26a1.2,1.2,0,0,0,.7,1.1C53.4,238.2,53.7,238.2,53.9,238.2Zm23.9-36.4v21.5a1.6,1.6,0,0,1-.8,1.3l-22.8,13h-.7a.7.7,0,0,1-.4-.6V211.4Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3423" data-name="XMLID 3423">
              <path
                id="XMLID_3427_2"
                data-name="XMLID 3427 2"
                class="cls-1"
                d="M81.5,203.4h0v-1.3l-4.1-1.6L39.1,178.2a3.9,3.9,0,0,0-3.5.1L15.7,189.6H14.5v1.5a.9.9,0,0,0,.6.8l41.8,24.2a3.9,3.9,0,0,0,3.5-.1l20.2-11.6A1.8,1.8,0,0,0,81.5,203.4Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3424"
                data-name="XMLID 3424"
                class="cls-1"
                d="M58.5,216.7a5.4,5.4,0,0,0,2.1-.5l20.2-11.5a1.7,1.7,0,0,0,1-1.2h0v-1.7L77.6,200,39.3,177.8a4.2,4.2,0,0,0-3.8.1L15.7,189.1H14.3v2a2.7,2.7,0,0,0,.7.8l41.9,24.2A2.3,2.3,0,0,0,58.5,216.7Zm22.7-13.3c0,.3-.3.6-.7.8L60.3,215.7a3.6,3.6,0,0,1-3.2.1L15.3,191.6a.7.7,0,0,1-.4-.5h0V190H16l19.9-11.3a3.6,3.6,0,0,1,3.2-.1l38.4,22.2,3.9,1.5v1.1Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3417_2" data-name="XMLID 3417 2">
              <path
                id="XMLID_3422"
                data-name="XMLID 3422"
                class="cls-3"
                d="M56.9,214.6,15.1,190.4c-.9-.5-.8-1.4.3-2l20.2-11.5a3.9,3.9,0,0,1,3.5-.1L80.9,201c.9.5.8,1.4-.3,2L60.4,214.5A3.9,3.9,0,0,1,56.9,214.6Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3421"
                data-name="XMLID 3421"
                class="cls-2"
                d="M60.3,214.4a3.9,3.9,0,0,1-3.5.1L15,190.3l-.3-.2c.2-.2.4-.5.7-.6L35.6,178a3.9,3.9,0,0,1,3.5-.1L81,202.2l.3.2c-.2.2-.4.5-.7.6Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3418_2"
                data-name="XMLID 3418 2"
                class="cls-1"
                d="M58.5,215.3a5.4,5.4,0,0,0,2.1-.5l20.2-11.5a2.1,2.1,0,0,0,1-1.4,1.4,1.4,0,0,0-.7-1.1L39.3,176.6a4.2,4.2,0,0,0-3.8.1L15.3,188.2a2.1,2.1,0,0,0-1,1.4,1.4,1.4,0,0,0,.7,1.1l41.8,24.2A3.3,3.3,0,0,0,58.5,215.3Zm-21-38.5a3.2,3.2,0,0,1,1.4.3l41.8,24.2c.2.1.5.3.5.6s-.3.6-.7.9L60.3,214.2a3.6,3.6,0,0,1-3.2.1L15.3,190.1c-.2-.1-.5-.3-.5-.6s.3-.6.7-.9l20.2-11.4A3.9,3.9,0,0,1,37.5,176.8Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3412_2" data-name="XMLID 3412 2">
              <path
                id="XMLID_3416_2"
                data-name="XMLID 3416 2"
                class="cls-3"
                d="M30,209.4V208l21.5,12.4v1.3Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3413_2"
                data-name="XMLID 3413 2"
                class="cls-1"
                d="M51.8,222.2v-2l-22-12.7v2.1Zm-.6-1.6v.7l-20.9-12v-.7Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3405" data-name="XMLID 3405">
              <path
                id="XMLID_3411_2"
                data-name="XMLID 3411 2"
                class="cls-1"
                d="M30,208l6.5-3.8,15,8.5v7.7Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3406"
                data-name="XMLID 3406"
                class="cls-1"
                d="M51.8,220.9v-8.3l-15.2-8.7-7.1,4.2Zm-.6-8v7L30.6,208l5.9-3.5Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_3399" data-name="XMLID 3399">
            <path
              id="XMLID_3403"
              data-name="XMLID 3403"
              class="cls-3"
              d="M53.7,210.5l-32.9-19c-.6-.3-.5-.9.2-1.3l16.5-9.3a2.7,2.7,0,0,1,2.3-.1l32.9,19c.6.3.5.9-.2,1.3L56,210.4A2.7,2.7,0,0,1,53.7,210.5Z"
              transform="translate(0 0)"
            />
            <path
              id="XMLID_3400"
              data-name="XMLID 3400"
              class="cls-1"
              d="M54.7,211a3.2,3.2,0,0,0,1.4-.3l16.5-9.3c.4-.3.7-.6.7-1a1,1,0,0,0-.5-.8l-32.9-19a2.8,2.8,0,0,0-2.5.1L20.9,190c-.4.3-.7.6-.7,1a1,1,0,0,0,.5.8l32.9,19Zm-16-30.1.8.2,32.9,19,.2.3-.4.5-16.5,9.3a2.3,2.3,0,0,1-2,.1l-32.9-19-.2-.3c0-.2.2-.3.4-.5l16.5-9.3Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="XMLID_3370" data-name="XMLID 3370">
            <g id="XMLID_3394" data-name="XMLID 3394">
              <path
                id="XMLID_3398"
                data-name="XMLID 3398"
                class="cls-3"
                d="M53.5,195.9v2l-3.6,2,1.4-2.5Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3395"
                data-name="XMLID 3395"
                class="cls-1"
                d="M49.1,200.7l4.6-2.6v-2.7l-2.8,1.9Zm4.1-2.9-2.6,1.4.9-1.6,1.7-1.1Z"
                transform="translate(0 0)"
              />
            </g>
            <path
              id="XMLID_3393"
              data-name="XMLID 3393"
              class="cls-1"
              d="M43.5,196.2l1.5-2.3,6.3,3.5-1.4,2.5Z"
              transform="translate(0 0)"
            />
            <g id="XMLID_3387" data-name="XMLID 3387">
              <path
                id="XMLID_3392"
                data-name="XMLID 3392"
                class="cls-3"
                d="M45,193.9l2.3-1.4,6.2,3.4-2.2,1.5Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3388"
                data-name="XMLID 3388"
                class="cls-1"
                d="M43.1,196.3l1.5-2.3.2-.3H45l2.3-1.4L54,196l-2.6,1.7-1.5,2.7Zm4.2-3.4-1.7,1,5.6,3.2,1.7-1.1Zm-2.2,1.4-1.2,1.8,5.8,3.4,1.1-2Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3382" data-name="XMLID 3382">
              <path
                id="XMLID_3386"
                data-name="XMLID 3386"
                class="cls-3"
                d="M61.4,181.9l-21-12c-.2-.1-.5-.2-.6-.1h-.2l-1.4.9,1.1,1.5v13.4a2.6,2.6,0,0,0,1.1,2.1l17.7,10.2,2.2,3,1.7-1.1c.3-.1.5-.4.5-.9v-15A2.1,2.1,0,0,0,61.4,181.9Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3383"
                data-name="XMLID 3383"
                class="cls-1"
                d="M60.3,201.4l1.9-1.2c.4-.1.6-.6.6-1.2V183.9a2.9,2.9,0,0,0-1.3-2.4l-21-12a1,1,0,0,0-.9-.1l-.3.2-1.6,1,1.2,1.7v13.3a2.9,2.9,0,0,0,1.3,2.4L58,198.2ZM40,170h.3l21,12a2.6,2.6,0,0,1,1,1.9v15.2a.9.9,0,0,1-.3.7l-1.5.9-2.1-2.9L40.7,187.6a2.6,2.6,0,0,1-1-1.9V172.2l-1-1.4,1.1-.7H40Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3377" data-name="XMLID 3377">
              <path
                id="XMLID_3381"
                data-name="XMLID 3381"
                class="cls-1"
                d="M59.8,200.9l-21-12a2.6,2.6,0,0,1-1.1-2.1V171.7c0-.8.5-1.2,1.1-.8l21,12a2.6,2.6,0,0,1,1.1,2.1v15.1C60.9,200.9,60.4,201.3,59.8,200.9Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3378"
                data-name="XMLID 3378"
                class="cls-1"
                d="M60.3,201.3h.4a1.6,1.6,0,0,0,.5-1.1V185a2.9,2.9,0,0,0-1.3-2.4l-21-12a1.2,1.2,0,0,0-1-.1,1.6,1.6,0,0,0-.5,1.1v15.1a2.9,2.9,0,0,0,1.3,2.4l21,12A.7.7,0,0,0,60.3,201.3ZM38.4,171h.3l21,12a2.6,2.6,0,0,1,1,1.9v15.2c0,.3-.1.6-.2.6h-.4l-21-12a2.6,2.6,0,0,1-1-1.9V171.6c0-.3.1-.6.2-.6Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3371" data-name="XMLID 3371">
              <path
                id="XMLID_3376"
                data-name="XMLID 3376"
                class="cls-3"
                d="M58.2,198.1,39.9,187.6a1.4,1.4,0,0,1-.6-1.2V174.1c0-.5.3-.7.6-.5l18.3,10.5a1.4,1.4,0,0,1,.6,1.2v12.3C58.9,198.1,58.6,198.3,58.2,198.1Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3375"
                data-name="XMLID 3375"
                class="cls-2"
                d="M41.7,177.3c0-.5.3-.7.6-.5L59,186.4v11.1c0,.5-.3.7-.6.5l-16.7-9.6Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3372"
                data-name="XMLID 3372"
                class="cls-1"
                d="M58.5,198.5h.3a.9.9,0,0,0,.4-.8V185.3a1.6,1.6,0,0,0-.8-1.4L40.1,173.4c-.2-.1-.5-.2-.7,0a.9.9,0,0,0-.4.8v12.3a1.6,1.6,0,0,0,.8,1.4l18.3,10.5ZM39.7,173.9h.1l18.3,10.5a1.1,1.1,0,0,1,.5.9v12.3c0,.2-.1.2-.1.2h-.1L40.1,187.3a1.1,1.1,0,0,1-.5-.9V173.9Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
          <g id="XMLID_3349" data-name="XMLID 3349">
            <g id="XMLID_3364" data-name="XMLID 3364">
              <path
                id="XMLID_3369"
                data-name="XMLID 3369"
                class="cls-1"
                d="M55.4,203.9v-.8l-6.3-2.9-9.2-5.4a1.7,1.7,0,0,0-1.7.1l-4.9,2.8-1.6.3v1.1a.3.3,0,0,0,.3.3h0l15.2,8.8a1.7,1.7,0,0,0,1.7-.1l6.1-3.4C55.3,204.3,55.4,204.1,55.4,203.9Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3365"
                data-name="XMLID 3365"
                class="cls-1"
                d="M47.9,208.4a2,2,0,0,0,1.1-.3l6.1-3.4a1,1,0,0,0,.6-.9v-1l-6.5-3L40,194.4a2,2,0,0,0-2,.1l-4.9,2.7-1.8.3v1.3c0,.2.2.5.4.5L47,208.2A1.5,1.5,0,0,0,47.9,208.4Zm7.2-5.2v.7l-.3.3-6.1,3.4a1.7,1.7,0,0,1-1.4.1l-15.2-8.8c-.1,0-.1-.1-.1-.2h0v-.6l1.4-.2,4.9-2.8a1.7,1.7,0,0,1,1.4-.1l9.2,5.4Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3358" data-name="XMLID 3358">
              <path
                id="XMLID_3363"
                data-name="XMLID 3363"
                class="cls-3"
                d="M39.9,193.9l15.2,8.8c.4.3.4.7-.1,1l-6.1,3.4a2,2,0,0,1-1.7.1L32,198.4c-.4-.3-.4-.7.1-1l6.1-3.4A1.5,1.5,0,0,1,39.9,193.9Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3362"
                data-name="XMLID 3362"
                class="cls-2"
                d="M47.2,207.1l-14.3-8.2,5.3-3a2,2,0,0,1,1.7-.1L54.2,204l-5.3,3A2,2,0,0,1,47.2,207.1Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_3359"
                data-name="XMLID 3359"
                class="cls-1"
                d="M47.9,207.6a2,2,0,0,0,1.1-.3l6.1-3.4a.9.9,0,0,0,.6-.8,1,1,0,0,0-.4-.7l-15.2-8.8a2,2,0,0,0-2,.1L32,197.1a.9.9,0,0,0-.6.8,1,1,0,0,0,.4.7L47,207.4Zm-8.2-13.5,15.2,8.8.2.2-.3.3-6.1,3.4a1.7,1.7,0,0,1-1.4.1l-15.2-8.8-.2-.2q0-.2.3-.3l6.1-3.4A1.4,1.4,0,0,1,39.7,194.1Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_3350" data-name="XMLID 3350">
              <g id="XMLID_3352" data-name="XMLID 3352">
                <path
                  id="XMLID_3356"
                  data-name="XMLID 3356"
                  class="cls-3"
                  d="M35.6,198.1l-.7.4h-.5l-.8-.5q-.3-.1,0-.3l.7-.4h.5l.8.5C35.8,197.9,35.8,198.1,35.6,198.1Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3353"
                  data-name="XMLID 3353"
                  class="cls-1"
                  d="M34.7,198.9h.4l.7-.4c.2-.1.2-.2.2-.4s-.1-.3-.3-.4l-.8-.5h-.8l-.7.4c-.2.1-.2.2-.2.4s.1.3.3.4l.8.5Zm.6-.9-.5.3h-.2l-.7-.4.5-.3h.2Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_3326" data-name="XMLID 3326">
            <g id="XMLID_3338" data-name="XMLID 3338">
              <g id="XMLID_3344" data-name="XMLID 3344">
                <path
                  id="XMLID_3348"
                  data-name="XMLID 3348"
                  class="cls-1"
                  d="M66.6,196.1v8.2c0,.8,1,1.4,2.3,1.4s2.3-.6,2.3-1.4v-8.2Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3345"
                  data-name="XMLID 3345"
                  class="cls-1"
                  d="M68.9,206c1.5,0,2.6-.7,2.6-1.7v-8.5H66.3v8.5C66.3,205.3,67.5,206,68.9,206Zm2.1-9.6v7.9c0,.5-.8,1.1-2,1.1s-2-.6-2-1.1v-7.9Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3339" data-name="XMLID 3339">
                <path
                  id="XMLID_3343"
                  data-name="XMLID 3343"
                  class="cls-3"
                  d="M71.3,196.2c0,.8-1,1.4-2.3,1.4s-2.3-.6-2.3-1.4,1-1.4,2.3-1.4S71.3,195.5,71.3,196.2Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3340"
                  data-name="XMLID 3340"
                  class="cls-1"
                  d="M68.9,197.9c1.5,0,2.6-.7,2.6-1.7s-1.2-1.7-2.6-1.7-2.6.7-2.6,1.7S67.5,197.9,68.9,197.9Zm0-2.8c1.2,0,2,.6,2,1.1s-.8,1.1-2,1.1-2-.6-2-1.1S67.7,195.1,68.9,195.1Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3327" data-name="XMLID 3327">
              <g id="XMLID_3333" data-name="XMLID 3333">
                <path
                  id="XMLID_3337"
                  data-name="XMLID 3337"
                  class="cls-1"
                  d="M67.7,193.6v2.3c0,.4.5.7,1.2.7s1.2-.3,1.2-.7v-2.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3334"
                  data-name="XMLID 3334"
                  class="cls-1"
                  d="M68.9,197c.9,0,1.5-.4,1.5-1v-2.6h-3V196C67.4,196.5,68.1,197,68.9,197Zm1-3.1v2c0,.2-.4.4-.9.4s-.9-.2-.9-.4v-2Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3328" data-name="XMLID 3328">
                <path
                  id="XMLID_3332"
                  data-name="XMLID 3332"
                  class="cls-3"
                  d="M70.2,193.7c0,.4-.5.7-1.2.7s-1.2-.3-1.2-.7.5-.7,1.2-.7S70.2,193.3,70.2,193.7Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3329"
                  data-name="XMLID 3329"
                  class="cls-1"
                  d="M68.9,194.7c.9,0,1.5-.4,1.5-1s-.7-1-1.5-1-1.5.4-1.5,1S68.1,194.7,68.9,194.7Zm0-1.5c.6,0,.9.3.9.4a1.1,1.1,0,0,1-.9.4c-.5,0-.9-.2-.9-.4A1.1,1.1,0,0,1,68.9,193.2Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_2991" data-name="XMLID 2991">
            <g id="XMLID_3305" data-name="XMLID 3305">
              <g id="XMLID_3319" data-name="XMLID 3319">
                <g id="XMLID_3320" data-name="XMLID 3320">
                  <path
                    id="XMLID_3325"
                    data-name="XMLID 3325"
                    class="cls-3"
                    d="M17.9,232.2s-.4,0-.6,1-.9,1.7-.2,2.3a7,7,0,0,0,3.4,1.2l1.6-.4,6.3-2s.5-.5.4-.9a2.1,2.1,0,0,0-1.3-1.3l-3.9-.3-3-.9Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3321"
                    data-name="XMLID 3321"
                    class="cls-1"
                    d="M20.2,236.9h.2l1.5-.3h.2l6.3-2h.1a1.7,1.7,0,0,0,.5-1.2,2.3,2.3,0,0,0-1.4-1.5l-4-.4h-.1a17.1,17.1,0,0,1-3-.9h-.1L17.8,232c-.2,0-.6.2-.8,1.2l-.3.8c-.2.6-.5,1.3.1,1.8A6,6,0,0,0,20.2,236.9Zm8-2.9L22,235.9h-.2l-1.4.3a5.2,5.2,0,0,1-3.2-1.1c-.3-.3-.2-.5,0-1.2l.3-.8c.2-.7.4-.8.4-.8H18l2.5-1.3,3,.9h.1l3.7.3h.1a1.6,1.6,0,0,1,1,1.1.7.7,0,0,1-.2.7Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3314" data-name="XMLID 3314">
                <path
                  id="XMLID_3318"
                  data-name="XMLID 3318"
                  class="cls-6"
                  d="M19,229.6l-.4,2.2a3.8,3.8,0,0,0,1.7.8,1.8,1.8,0,0,0,1.4-.6l.5-2.4Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3315"
                  data-name="XMLID 3315"
                  class="cls-1"
                  d="M20.4,232.9a2.1,2.1,0,0,0,1.5-.7h0l.6-2.8H18.7l-.5,2.6h.1a3.4,3.4,0,0,0,1.9.9Zm1-1.1a1.5,1.5,0,0,1-1.1.4,2.7,2.7,0,0,1-1.4-.7l.4-1.8h2.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3306" data-name="XMLID 3306">
                <path
                  id="XMLID_3313"
                  data-name="XMLID 3313"
                  class="cls-3"
                  d="M23.3,216a4.3,4.3,0,0,0-1.4,2.3c-.2.9-1.5,5.3-1.5,5.3l-1.5,5.9a1.6,1.6,0,0,0,1.3,1.7h.3a1.4,1.4,0,0,0,1.6-1l5.8-12.5a6.9,6.9,0,0,0-2-4.1C24.2,212,23.3,216,23.3,216Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3307"
                  data-name="XMLID 3307"
                  class="cls-1"
                  d="M20.7,231.5a1.7,1.7,0,0,0,1.7-1.3l5.8-12.5h0a7,7,0,0,0-2.1-4.3c-.5-.4-.9-.6-1.4-.4a7.5,7.5,0,0,0-1.8,2.8,3.3,3.3,0,0,0-1.4,2.4c-.2.9-1.5,5.2-1.5,5.2l-1.5,6a1.7,1.7,0,0,0,.3,1.4,1.9,1.9,0,0,0,1.2.7Zm7-13.8-5.8,12.4a1.3,1.3,0,0,1-1.3.9h-.3a1.2,1.2,0,0,1-1-1.4h0l1.4-5.9a46.1,46.1,0,0,0,1.5-5.3,3,3,0,0,1,1.3-2.1h.1c.2-.9.8-2.3,1.4-2.5s.5,0,.8.3a7,7,0,0,1,1.9,3.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3201" data-name="XMLID 3201">
              <g id="XMLID_3289" data-name="XMLID 3289">
                <g id="XMLID_3300" data-name="XMLID 3300">
                  <path
                    id="XMLID_3304"
                    data-name="XMLID 3304"
                    class="cls-3"
                    d="M31.5,232.2a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C30.9,231.4,31.3,231.6,31.5,232.2Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3301"
                    data-name="XMLID 3301"
                    class="cls-1"
                    d="M30.7,234.6l.6-.3a2.3,2.3,0,0,0,.5-2.1,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.2-2.7c.1,0,.2.1.3.4a2.2,2.2,0,0,1-.3,1.6h-.3c-.1,0-.2-.1-.3-.4a2.2,2.2,0,0,1,.3-1.6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3295" data-name="XMLID 3295">
                  <path
                    id="XMLID_3299"
                    data-name="XMLID 3299"
                    class="cls-3"
                    d="M32.2,232.5a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C31.5,231.7,32,231.9,32.2,232.5Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3296"
                    data-name="XMLID 3296"
                    class="cls-1"
                    d="M31.3,234.9l.6-.3a2.3,2.3,0,0,0,.5-2.1,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.6-2.3a2.2,2.2,0,0,1-.3,1.6h-.3c-.1,0-.2-.1-.3-.4a2.2,2.2,0,0,1,.3-1.6c.1-.1.2-.2.3-.1A1.1,1.1,0,0,1,31.9,232.6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3290" data-name="XMLID 3290">
                  <path
                    id="XMLID_3294"
                    data-name="XMLID 3294"
                    class="cls-3"
                    d="M31.9,232.8a1.4,1.4,0,0,1-.2,1.1c-.2.2-.5.1-.6-.2a1.4,1.4,0,0,1,.2-1.1C31.5,232.4,31.8,232.5,31.9,232.8Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3291"
                    data-name="XMLID 3291"
                    class="cls-1"
                    d="M31.4,234.3l.5-.2a1.7,1.7,0,0,0,.3-1.4,1,1,0,0,0-.5-.6c-.2-.1-.4,0-.6.2a1.7,1.7,0,0,0-.3,1.4,1,1,0,0,0,.5.6Zm.1-1.5h.1a.8.8,0,0,1-.2.8h-.1A.7.7,0,0,1,31.5,232.8Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3273" data-name="XMLID 3273">
                <g id="XMLID_3284" data-name="XMLID 3284">
                  <path
                    id="XMLID_3288"
                    data-name="XMLID 3288"
                    class="cls-3"
                    d="M15.2,232a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C14.6,231.2,15,231.4,15.2,232Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3285"
                    data-name="XMLID 3285"
                    class="cls-1"
                    d="M14.4,234.4l.6-.3a2.3,2.3,0,0,0,.5-2.1,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.2-2.7c.1,0,.2.1.3.4a2.2,2.2,0,0,1-.3,1.6h-.3c-.1,0-.2-.1-.3-.4a2.2,2.2,0,0,1,.3-1.6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3279" data-name="XMLID 3279">
                  <path
                    id="XMLID_3283"
                    data-name="XMLID 3283"
                    class="cls-3"
                    d="M15.9,232.4a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C15.3,231.6,15.7,231.7,15.9,232.4Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3280"
                    data-name="XMLID 3280"
                    class="cls-1"
                    d="M15,234.7a.7.7,0,0,0,.6-.3,2.3,2.3,0,0,0,.5-2.1,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.3-2.7c.1,0,.2.1.3.4a2.2,2.2,0,0,1-.3,1.6H15c-.1,0-.2-.1-.3-.4A2.2,2.2,0,0,1,15,232Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3274" data-name="XMLID 3274">
                  <path
                    id="XMLID_3278"
                    data-name="XMLID 3278"
                    class="cls-3"
                    d="M15.6,232.7a1.4,1.4,0,0,1-.2,1.1c-.2.2-.5.1-.6-.2a1.4,1.4,0,0,1,.2-1.1C15.2,232.2,15.5,232.3,15.6,232.7Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3275"
                    data-name="XMLID 3275"
                    class="cls-1"
                    d="M15.1,234.2l.5-.2a1.7,1.7,0,0,0,.3-1.4,1,1,0,0,0-.5-.6c-.2-.1-.4,0-.6.2a1.7,1.7,0,0,0-.3,1.4,1,1,0,0,0,.5.6Zm.2-1.5a.8.8,0,0,1-.2.8H15a.8.8,0,0,1,.2-.8Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3257" data-name="XMLID 3257">
                <g id="XMLID_3268" data-name="XMLID 3268">
                  <path
                    id="XMLID_3272"
                    data-name="XMLID 3272"
                    class="cls-3"
                    d="M31.4,241.5a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C30.7,240.6,31.2,240.8,31.4,241.5Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3269"
                    data-name="XMLID 3269"
                    class="cls-1"
                    d="M30.5,243.8l.6-.3a2.5,2.5,0,0,0,.5-2.2,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.6-2.3a2.2,2.2,0,0,1-.3,1.6h-.3c-.1,0-.2-.1-.3-.4a2.2,2.2,0,0,1,.3-1.6c.1-.1.2-.2.3-.1Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3263" data-name="XMLID 3263">
                  <path
                    id="XMLID_3267"
                    data-name="XMLID 3267"
                    class="cls-3"
                    d="M32,241.8a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C31.4,241,31.9,241.2,32,241.8Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3264"
                    data-name="XMLID 3264"
                    class="cls-1"
                    d="M31.2,244.2l.6-.3a2.3,2.3,0,0,0,.5-2.1,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.5-2.3a2.2,2.2,0,0,1-.3,1.6h-.3c-.1,0-.2-.1-.3-.4a2.2,2.2,0,0,1,.3-1.6c.1-.1.2-.2.3-.1A.6.6,0,0,1,31.7,241.9Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3258" data-name="XMLID 3258">
                  <path
                    id="XMLID_3262"
                    data-name="XMLID 3262"
                    class="cls-3"
                    d="M31.7,242.1a1.4,1.4,0,0,1-.2,1.1c-.2.2-.5.1-.6-.2a1.4,1.4,0,0,1,.2-1.1C31.4,241.6,31.6,241.7,31.7,242.1Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3259"
                    data-name="XMLID 3259"
                    class="cls-1"
                    d="M31.2,243.6l.5-.2A1.7,1.7,0,0,0,32,242a1,1,0,0,0-.5-.6c-.2-.1-.4,0-.6.2a1.7,1.7,0,0,0-.3,1.4,1,1,0,0,0,.5.6Zm.2-1.4a.8.8,0,0,1-.2.8h-.1a.8.8,0,0,1,.2-.8C31.4,242,31.4,242.1,31.4,242.2Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3241" data-name="XMLID 3241">
                <g id="XMLID_3252" data-name="XMLID 3252">
                  <path
                    id="XMLID_3256"
                    data-name="XMLID 3256"
                    class="cls-3"
                    d="M15.3,241.6a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C14.7,240.8,15.2,241,15.3,241.6Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3253"
                    data-name="XMLID 3253"
                    class="cls-1"
                    d="M14.5,244a.9.9,0,0,0,.6-.3,2.3,2.3,0,0,0,.5-2.1,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.6-2.3a2.2,2.2,0,0,1-.3,1.6h-.3c-.1,0-.2-.1-.3-.4a2.2,2.2,0,0,1,.3-1.6h.3c.1,0,.2.1.3.4Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3247" data-name="XMLID 3247">
                  <path
                    id="XMLID_3251"
                    data-name="XMLID 3251"
                    class="cls-3"
                    d="M16,241.9a2.1,2.1,0,0,1-.4,1.9c-.4.4-.9.2-1-.4a2.1,2.1,0,0,1,.4-1.9C15.4,241.1,15.8,241.3,16,241.9Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3248"
                    data-name="XMLID 3248"
                    class="cls-1"
                    d="M15.2,244.3a.7.7,0,0,0,.6-.3,2.3,2.3,0,0,0,.5-2.1,1,1,0,0,0-.7-.8.7.7,0,0,0-.8.3,2.3,2.3,0,0,0-.5,2.1,1,1,0,0,0,.7.8Zm.2-2.7c.1,0,.2.1.3.4a2.2,2.2,0,0,1-.3,1.6c-.1.1-.2.2-.3.1a.7.7,0,0,1-.3-.4,2.2,2.2,0,0,1,.3-1.6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_3242" data-name="XMLID 3242">
                  <path
                    id="XMLID_3246"
                    data-name="XMLID 3246"
                    class="cls-3"
                    d="M15.7,242.3a1.4,1.4,0,0,1-.2,1.1c-.2.2-.5.1-.6-.2a1.4,1.4,0,0,1,.2-1.1C15.3,241.8,15.6,241.9,15.7,242.3Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3243"
                    data-name="XMLID 3243"
                    class="cls-1"
                    d="M15.2,243.8l.5-.2a1.7,1.7,0,0,0,.3-1.4,1,1,0,0,0-.5-.6c-.2-.1-.4,0-.6.2a1.7,1.7,0,0,0-.3,1.4,1,1,0,0,0,.5.6Zm.2-1.5a.8.8,0,0,1-.2.8h-.1a.8.8,0,0,1,.2-.8Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3233" data-name="XMLID 3233">
                <path
                  id="XMLID_3238"
                  data-name="XMLID 3238"
                  class="cls-3"
                  d="M23.9,234.4l7.7,6.7c.4.3.8,1.8-1.2.7l-15.2-8.7c-2.3-1.4-.6-1.8.2-1.5l7.5,2.6C23.2,234.3,23.7,234.2,23.9,234.4Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3234"
                  data-name="XMLID 3234"
                  class="cls-1"
                  d="M31.5,242.5a.9.9,0,0,0,.6-.3c.3-.4-.1-1.1-.3-1.3l-7.7-6.7c-.3-.3-.9-.1-1.1-.2l-7.6-2.6a1.5,1.5,0,0,0-1.7.4c-.3.7.8,1.4,1.2,1.7l15.2,8.7C30.4,242.2,31,242.5,31.5,242.5Zm-7.8-7.9,7.7,6.7c.2.1.3.5.2.6s-.2.1-1.1-.3l-15.2-8.7c-1-.6-1-.9-1-.9a1.7,1.7,0,0,1,.9-.1l7.6,2.6h.9Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3228" data-name="XMLID 3228">
                <path
                  id="XMLID_3232"
                  data-name="XMLID 3232"
                  class="cls-3"
                  d="M22,234.4l-7.7,6.7c-.4.3-.8,1.8,1.2.7l15.2-8.7c2.3-1.4.6-1.8-.2-1.5l-7.6,2.6C22.7,234.3,22.2,234.2,22,234.4Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3229"
                  data-name="XMLID 3229"
                  class="cls-1"
                  d="M14.4,242.5l1.3-.4,15.2-8.8c.4-.2,1.6-1,1.2-1.7s-1.1-.6-1.7-.4l-7.6,2.6c-.2.1-.8-.1-1.1.2L14,240.7a1.1,1.1,0,0,0-.3,1.3C13.9,242.4,14.1,242.5,14.4,242.5Zm16.7-10.7h.5s0,.3-1,.9l-15.2,8.7c-.9.5-1.1.3-1.1.3a.8.8,0,0,1,.2-.5l7.7-6.7h.9l7.6-2.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3223" data-name="XMLID 3223">
                <path
                  id="XMLID_3227"
                  data-name="XMLID 3227"
                  class="cls-3"
                  d="M25.4,235.6c0,1-1.2,1.7-2.6,1.7s-2.6-.8-2.6-1.7a3,3,0,0,1,2.6-2.5A3.1,3.1,0,0,1,25.4,235.6Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3224"
                  data-name="XMLID 3224"
                  class="cls-1"
                  d="M22.7,237.7c1.6,0,2.9-.9,2.9-2a3.2,3.2,0,0,0-2.9-2.8,3.2,3.2,0,0,0-2.9,2.8C19.8,236.8,21.1,237.7,22.7,237.7Zm0-4.3a2.6,2.6,0,0,1,2.3,2.3c0,.8-1.1,1.4-2.3,1.4s-2.3-.7-2.3-1.4A2.6,2.6,0,0,1,22.7,233.4Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3218" data-name="XMLID 3218">
                <path
                  id="XMLID_3222"
                  data-name="XMLID 3222"
                  class="cls-1"
                  d="M24.7,234.4c0,.7-.9,1.3-1.9,1.3s-1.9-.6-1.9-1.3.9-1.3,1.9-1.3S24.7,233.7,24.7,234.4Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3219"
                  data-name="XMLID 3219"
                  class="cls-1"
                  d="M22.7,235.9c1.3,0,2.2-.7,2.2-1.6s-1-1.6-2.2-1.6-2.2.7-2.2,1.6S21.5,235.9,22.7,235.9Zm0-2.5c.9,0,1.6.4,1.6,1s-.8,1-1.6,1-1.6-.4-1.6-1S21.8,233.4,22.7,233.4Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3212" data-name="XMLID 3212">
                <g id="XMLID_3213" data-name="XMLID 3213">
                  <path
                    id="XMLID_3217"
                    data-name="XMLID 3217"
                    class="cls-3"
                    d="M22.7,234.4a1.2,1.2,0,0,1-1.2-1.2V221.9a1.2,1.2,0,1,1,2.4,0v11.3A1.2,1.2,0,0,1,22.7,234.4Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3214"
                    data-name="XMLID 3214"
                    class="cls-1"
                    d="M22.7,234.7a1.5,1.5,0,0,0,1.5-1.5V221.9a1.5,1.5,0,0,0-3,0v11.3A1.5,1.5,0,0,0,22.7,234.7Zm0-13.7a.9.9,0,0,1,.9.9v11.3a.9.9,0,0,1-1.8,0h0V221.9a.9.9,0,0,1,.9-.9Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3207" data-name="XMLID 3207">
                <path
                  id="XMLID_3211"
                  data-name="XMLID 3211"
                  class="cls-1"
                  d="M33,218.5H31.8l-.5-.3-2.8-1.5c-2.4-1.3-6.6-1-9.3.6l-3.7,2.3-2.9.9v1.8a1.8,1.8,0,0,0,1,1.4l6.2,3.4a6,6,0,0,0,5.5-.4l5.5-3.2a3.8,3.8,0,0,0,2.2-2.9Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3208"
                  data-name="XMLID 3208"
                  class="cls-1"
                  d="M22.1,227.8a6.7,6.7,0,0,0,3.4-.9l5.5-3.2a4.5,4.5,0,0,0,2.3-2.9v-2.6H31.9l-.5-.3-2.8-1.6c-2.5-1.3-6.8-1.1-9.6.6l-3.7,2.3-3,1v2.2a2.1,2.1,0,0,0,1.1,1.5l6.2,3.4A7,7,0,0,0,22.1,227.8Zm10.6-7.5v.3a3.8,3.8,0,0,1-2,2.6l-5.5,3.2a6,6,0,0,1-5.2.4l-6.2-3.4a1.5,1.5,0,0,1-.8-1.1v-1.6l2.7-.9,3.8-2.3c2.6-1.6,6.6-1.9,9-.6l2.8,1.5.5.3h1.1v1.5Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3202" data-name="XMLID 3202">
                <path
                  id="XMLID_3206"
                  data-name="XMLID 3206"
                  class="cls-2"
                  d="M19.9,225.3l-6.2-3.4c-1.4-.8-1.3-2.2.3-3.1l5.3-3.2c2.7-1.6,6.9-1.9,9.3-.6l2.8,1.5c2.4,1.3,2.2,3.7-.5,5.3L25.4,225A6.6,6.6,0,0,1,19.9,225.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3203"
                  data-name="XMLID 3203"
                  class="cls-1"
                  d="M22.1,226.1a6.7,6.7,0,0,0,3.4-.9L31,222c1.5-.9,2.4-2.1,2.3-3.3a3,3,0,0,0-1.8-2.5l-2.8-1.5c-2.5-1.3-6.8-1.1-9.6.6l-5.3,3.2a2.6,2.6,0,0,0-1.4,2.1,1.9,1.9,0,0,0,1.1,1.6l6.2,3.4A6.9,6.9,0,0,0,22.1,226.1Zm2.7-11.8a9,9,0,0,1,3.6.8l2.8,1.5a2.3,2.3,0,0,1,1.5,2c0,1-.7,2-2.1,2.8l-5.5,3.2a6,6,0,0,1-5.2.4l-6.2-3.4a1.5,1.5,0,0,1-.8-1.1A1.9,1.9,0,0,1,14,219l5.3-3.2A10.8,10.8,0,0,1,24.8,214.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_3026_2" data-name="XMLID 3026 2">
              <g id="XMLID_3057" data-name="XMLID 3057">
                <g id="XMLID_3058" data-name="XMLID 3058">
                  <path
                    id="XMLID_3200"
                    data-name="XMLID 3200"
                    class="cls-3"
                    d="M32.6,238.1s-.4,0-.6.9-.9,1.6-.2,2.2a5.7,5.7,0,0,0,3.3,1.1l1.5-.4,6-1.9s.5-.5.4-.9a2,2,0,0,0-1.2-1.3l-3.8-.3a14,14,0,0,1-2.9-.9Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3059"
                    data-name="XMLID 3059"
                    class="cls-1"
                    d="M34.9,242.6h.2l1.4-.3h.2l6-1.9h.1c.1-.1.6-.6.5-1.1a2,2,0,0,0-1.3-1.4l-3.9-.4a13.1,13.1,0,0,1-2.8-.9h-.1l-2.5,1.3c-.2,0-.6.2-.8,1.2a1.9,1.9,0,0,0-.2.7c-.2.6-.5,1.2.1,1.8A5.7,5.7,0,0,0,34.9,242.6Zm7.6-2.8-5.9,1.9h-.2l-1.3.3a4.8,4.8,0,0,1-3-1.1c-.3-.2-.2-.5,0-1.1l.3-.8c.2-.6.4-.7.4-.7h.1l2.4-1.2a9.6,9.6,0,0,0,2.9.8l3.7.3a2.4,2.4,0,0,1,1,1Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_3052" data-name="XMLID 3052">
                <path
                  id="XMLID_3056"
                  data-name="XMLID 3056"
                  class="cls-6"
                  d="M33,235.4v2.4a5,5,0,0,0,2.1.5,1.9,1.9,0,0,0,1.4-.9v-2.7Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3053"
                  data-name="XMLID 3053"
                  class="cls-1"
                  d="M34.8,238.7H35a1.9,1.9,0,0,0,1.6-1.1h0v-3.1l-4.1.8v2.8h.1A7.9,7.9,0,0,0,34.8,238.7Zm1.4-1.3a1.4,1.4,0,0,1-1.2.7,3.3,3.3,0,0,1-1.7-.4v-2l2.9-.6Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3047" data-name="XMLID 3047">
                <path
                  id="XMLID_3051"
                  data-name="XMLID 3051"
                  class="cls-6"
                  d="M27.5,193.4c-.3-.6-.6-1.1,0-1.4s2.4-.9,2.6-1.4l.8-1.8a1,1,0,0,1,.4-.5l5.2-3.8a13.5,13.5,0,0,1,0,4.9,8.5,8.5,0,0,1-.9,2.2,1.1,1.1,0,0,1-1,.6h-.3a1.1,1.1,0,0,0-1.1,1.1v.3c.1.4.3,1,.4,1.5a1.2,1.2,0,0,1-.9,1.5h-.4l-2.8-.3a1.2,1.2,0,0,1-1-.7Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3048"
                  data-name="XMLID 3048"
                  class="cls-1"
                  d="M32.4,196.9a1.6,1.6,0,0,0,1.1-.5,1.5,1.5,0,0,0,.3-1.3,8.3,8.3,0,0,1-.4-1.5.6.6,0,0,1,.2-.7.9.9,0,0,1,.7-.3h.3a1.7,1.7,0,0,0,1.3-.7,9.2,9.2,0,0,0,.9-2.3,14,14,0,0,0,0-5v-.5l-5.5,4.1-.5.6-.8,1.8a5.5,5.5,0,0,1-2.4,1.2.7.7,0,0,0-.5.4,1.4,1.4,0,0,0,.2,1.1l1.1,2.4a1.6,1.6,0,0,0,1.2.9ZM36.2,185a12.4,12.4,0,0,1-.1,4.3,7.8,7.8,0,0,1-.9,2.1.9.9,0,0,1-.8.4h-.3a1.6,1.6,0,0,0-1.1.5,1.3,1.3,0,0,0-.3,1.2c.1.5.3,1,.4,1.6a.8.8,0,0,1-.2.8.8.8,0,0,1-.8.3l-2.8-.3a.8.8,0,0,1-.7-.5L27.5,193c-.1-.2-.3-.5-.2-.6h.2c.7-.3,2.5-.9,2.7-1.5a14.2,14.2,0,0,0,.8-1.8l.3-.4Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3042_2" data-name="XMLID 3042 2">
                <path
                  id="XMLID_3046"
                  data-name="XMLID 3046"
                  class="cls-1"
                  d="M18.9,210.5a1.7,1.7,0,0,0-1.5,1.6c0,1.6,0,4.2.7,5.4a9.4,9.4,0,0,0,5.5,4c3.3,1.1,9.5.6,10.6.7h-.3a10,10,0,0,0-.6,4.2,62.8,62.8,0,0,1-.4,7.5V235a1.5,1.5,0,0,0,.7,1.5l.7.5a1.5,1.5,0,0,0,1.8,0,1.8,1.8,0,0,0,.7-1l3.5-12.1v-.3a4.8,4.8,0,0,0-1.2-5.6c-1.3-1-8.6-4.8-9.3-5.2h-.2l-5.8-2.4C23.6,210.1,20.7,210.4,18.9,210.5Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3043_2"
                  data-name="XMLID 3043 2"
                  class="cls-1"
                  d="M35.2,237.4a2,2,0,0,0,1.1-.3,2,2,0,0,0,.8-1.2l3.5-12.1v-.2a4.9,4.9,0,0,0-1.3-6c-1.3-1-8.5-4.8-9.4-5.2h-.2l-5.8-2.4a29.2,29.2,0,0,0-5.1.4,1.8,1.8,0,0,0-1.7,1.8c0,1.8.1,4.3.8,5.5s2.2,3,5.7,4.1,7.3.7,9.5.7h.4a12,12,0,0,0-.5,3.8q0,3.8-.3,7.5v1.1a1.8,1.8,0,0,0,.8,1.8l.7.5A1.7,1.7,0,0,0,35.2,237.4Zm-11.5-27h0l5.8,2.4h.2c.3.2,8,4.2,9.3,5.2a4.4,4.4,0,0,1,1.1,5.3.4.4,0,0,0-.1.3l-3.5,12.1a2.6,2.6,0,0,1-.5.9,1.4,1.4,0,0,1-1.5,0l-.7-.5a1.4,1.4,0,0,1-.6-1.2v-1.1c.2-2,.3-4.5.4-7.6a17.4,17.4,0,0,1,.5-3.9h.1v-.6H33.1c-2.2,0-6.7.2-9.3-.7s-4.4-2.1-5.3-3.8-.7-2.7-.7-5.2a1.3,1.3,0,0,1,1.2-1.3Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3037_2" data-name="XMLID 3037 2">
                <path
                  id="XMLID_3041_2"
                  data-name="XMLID 3041 2"
                  class="cls-6"
                  d="M44.6,204.5l2.7-.4c.7,0,2.8,1.1,2.2,1.8s-.7.5-.7.5l-.9-.4-1,.6a2.2,2.2,0,0,1-1.9.3l-1.5-1.7Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3038_2"
                  data-name="XMLID 3038 2"
                  class="cls-1"
                  d="M45.5,207.4A2.8,2.8,0,0,0,47,207l.8-.5.8.4h.1a1.8,1.8,0,0,0,.9-.6.8.8,0,0,0,.2-.8c-.3-.8-1.9-1.5-2.5-1.6a13.5,13.5,0,0,0-2.8.4h-.1l-1.3,1,1.8,2h.6Zm2.3-1.6-1.1.7a2.2,2.2,0,0,1-1.6.3l-1.2-1.4.8-.6,2.6-.4a3.2,3.2,0,0,1,2,1.2h0l-.5.4Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3032" data-name="XMLID 3032">
                <path
                  id="XMLID_3036_2"
                  data-name="XMLID 3036 2"
                  class="cls-2"
                  d="M22.2,194.7a7.2,7.2,0,0,1,4.9-2.6c1.1-.1,0,.7,1.3,1.5a5.5,5.5,0,0,0,3.8.4,3.7,3.7,0,0,1,3.5,2.2c1,1.8,2.4,7.2,2.7,8a4,4,0,0,1,.3,1.5l6.3-1.5c.8-.3,1.1,2.5.9,3.3s-7.6,3.5-8.7,3.2-3.1-4.7-3.7-6.9.1,1-.4,1.7a23.1,23.1,0,0,0-1.6,6.4c0,1.6,2.6,2.8-1,4.2s-10.2,2.8-13.2-.6c-.7-.7.8-12.6,2.3-16.5S22.2,194.7,22.2,194.7Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3033"
                  data-name="XMLID 3033"
                  class="cls-1"
                  d="M23.1,218.1a22.1,22.1,0,0,0,7.6-1.7c1.2-.5,1.8-1,2-1.5a2.3,2.3,0,0,0-.4-1.8,2.8,2.8,0,0,1-.4-1.2,22.7,22.7,0,0,1,1.6-6.2,1.4,1.4,0,0,0,.2-.6c.8,2.2,2.4,5.6,3.5,5.9s6.4-1.6,8.2-2.6.8-.5.9-.8.1-3-.6-3.6a.6.6,0,0,0-.7-.1l-5.9,1.4a5,5,0,0,0-.2-1.2l-.2-.8a48.4,48.4,0,0,0-2.5-7.3,4.2,4.2,0,0,0-3.8-2.4h-.2a4.5,4.5,0,0,1-3.4-.4,1.6,1.6,0,0,1-.6-.8c0-.2,0-.4-.2-.5h-.7a7.8,7.8,0,0,0-5.1,2.7c-.2.2-1.1,1-2.5,4.5s-3.1,15.8-2.3,16.8A7.2,7.2,0,0,0,23.1,218.1Zm10.4-14.8h0c-.3,0-.3.3-.3.6a3.9,3.9,0,0,1-.2,1.5,21.4,21.4,0,0,0-1.6,6.5,4.4,4.4,0,0,0,.5,1.5,2,2,0,0,1,.4,1.3c-.1.4-.7.8-1.7,1.2-3.4,1.4-9.6,3.2-12.9-.5-.4-.8.8-12.2,2.4-16.2s2.3-4.3,2.3-4.3h.1a7.3,7.3,0,0,1,4.8-2.5h.2a1.4,1.4,0,0,0,.9,1.3,5.6,5.6,0,0,0,3.8.5h.2a3.4,3.4,0,0,1,3.2,2.1,55.5,55.5,0,0,1,2.5,7.2,2.4,2.4,0,0,1,.2.8,6.8,6.8,0,0,1,.2,1.4v.4h.4l6.3-1.5h.1a5.1,5.1,0,0,1,.4,3c-.4.7-7.3,3.2-8.3,2.9s-2.9-4.4-3.5-6.7C33.8,203.5,33.7,203.3,33.5,203.3Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_3027_2" data-name="XMLID 3027 2">
                <path
                  id="XMLID_3031_2"
                  data-name="XMLID 3031 2"
                  class="cls-1"
                  d="M30.1,190.5s-2.5-.4-2.8-2.5a6.7,6.7,0,0,1,2.2-6.5c2-1.4,5.5-1.3,6.6,0a3.8,3.8,0,0,1,1.2,3.2c-.2,1.8-.7.8-.7.8l-.5-.3-.5,1.5c-.7,2.1-4.3,3.8-4.3,3.8Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3028_2"
                  data-name="XMLID 3028 2"
                  class="cls-1"
                  d="M30.1,190.8h1.2c.1-.1,3.7-1.8,4.4-4l.4-1.2h.1a.6.6,0,0,0,.7.4c.3-.1.5-.5.6-1.3s0-1.8-1.2-3.4-4.8-1.6-7-.1-2.7,4.6-2.3,6.8S30,190.8,30.1,190.8Zm1-.6h-1c-.2,0-2.3-.5-2.6-2.2s.2-4.9,2.1-6.2,5.2-1.2,6.2,0a3.8,3.8,0,0,1,1.1,3,1.7,1.7,0,0,1-.1.7h-.2l-.4-.2-.2-.2c-.1,0-.3-.1-.4.3v.2a6.5,6.5,0,0,0-.4,1.3c-.6,1.5-3.6,3.1-4.1,3.3Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
            <g id="XMLID_2992" data-name="XMLID 2992">
              <g id="XMLID_3020_2" data-name="XMLID 3020 2">
                <g id="XMLID_3021" data-name="XMLID 3021">
                  <path
                    id="XMLID_3025_2"
                    data-name="XMLID 3025 2"
                    class="cls-3"
                    d="M16.2,225.6a3.2,3.2,0,0,1-1.4-.3,2.6,2.6,0,0,1-1.3-1.6v-4.8a.8.8,0,0,1,1.6,0v4.5l.5.6a1.7,1.7,0,0,0,1,.1.8.8,0,0,1,.9.4h0a.7.7,0,0,1-.3.9h-1Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_3022"
                    data-name="XMLID 3022"
                    class="cls-1"
                    d="M16.2,225.9h.7l.8-.5a1,1,0,0,0,.1-.9,1.1,1.1,0,0,0-1.2-.7,1.4,1.4,0,0,1-.9-.1l-.4-.4v-4.4a1.1,1.1,0,0,0-2.2,0v4.8a2.9,2.9,0,0,0,1.5,1.9A4.5,4.5,0,0,0,16.2,225.9Zm.6-1.7a.5.5,0,0,1,.5.3v.4l-.4.3A4.1,4.1,0,0,1,15,225a2.9,2.9,0,0,1-1.2-1.5v-4.8a.5.5,0,0,1,1,0v4.6a1.2,1.2,0,0,0,.7.7,1.7,1.7,0,0,0,1.2.1Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
              <g id="XMLID_2998_2" data-name="XMLID 2998 2">
                <path
                  id="XMLID_3003"
                  data-name="XMLID 3003"
                  class="cls-3"
                  d="M18,199.3l-3-1.7a3.3,3.3,0,0,0-2.9-.4h-.2l-1.7.8.4.9a5.4,5.4,0,0,0-.4,2.2v9.8a6.9,6.9,0,0,0,2.8,5.3l6.3,3.6.6,1.5,1.9-.9a2.5,2.5,0,0,0,1-2.3v-9.8C22.7,204.8,20.6,200.8,18,199.3Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_3002_2"
                  data-name="XMLID 3002 2"
                  class="cls-2"
                  d="M18,200.6l-3-1.7a3.3,3.3,0,0,0-2.9-.4h-.2l-1.7.8.4.9a5.4,5.4,0,0,0-.4,2.2v9.8a6.9,6.9,0,0,0,2.8,5.3l6.3,3.6.6,1.5,1.9-.9a2.5,2.5,0,0,0,1-2.3v-9.8C22.7,206.1,20.6,202.1,18,200.6Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_2999_2"
                  data-name="XMLID 2999 2"
                  class="cls-1"
                  d="M19.7,221.7l2.3-1.1a2.8,2.8,0,0,0,1-2.4v-9.8c0-3.6-2.2-7.7-4.9-9.3l-3-1.7a3.3,3.3,0,0,0-2.9-.5l-.4.2-2,.9.4,1a8.3,8.3,0,0,0-.3,2.2V211a7.3,7.3,0,0,0,2.9,5.6l6.2,3.5Zm1.7-1.5-1.4.7-.5-1.3h-.1L13.1,216a6.3,6.3,0,0,1-2.7-5.1v-9.8a7.6,7.6,0,0,1,.3-2.1h0l-.3-.7,1.6-.8a3,3,0,0,1,2.6.3l3,1.7c2.5,1.5,4.6,5.4,4.6,8.8v9.8a2,2,0,0,1-.9,2Z"
                  transform="translate(0 0)"
                />
              </g>
              <g id="XMLID_2993" data-name="XMLID 2993">
                <path
                  id="XMLID_2997_2"
                  data-name="XMLID 2997 2"
                  class="cls-1"
                  d="M18.1,221.1l-7-4a6.9,6.9,0,0,1-2.8-5.3V202c0-3.5,2.1-5.1,4.8-3.6l3,1.7c2.6,1.5,4.8,5.6,4.8,9v9.8C20.9,221,19.7,221.9,18.1,221.1Z"
                  transform="translate(0 0)"
                />
                <path
                  id="XMLID_2994"
                  data-name="XMLID 2994"
                  class="cls-1"
                  d="M19.2,221.7l.9-.2a2.7,2.7,0,0,0,1.1-2.5v-9.8c0-3.6-2.2-7.7-4.9-9.3l-3-1.7a3.2,3.2,0,0,0-3.4-.2,4.4,4.4,0,0,0-1.8,4.1v9.8a7.3,7.3,0,0,0,2.9,5.6l7,4Zm-8-23.6a4.1,4.1,0,0,1,1.8.5l3,1.7c2.5,1.5,4.6,5.4,4.6,8.8v9.8a2.2,2.2,0,0,1-.8,2,1.6,1.6,0,0,1-1.5-.1l-7-4a6.3,6.3,0,0,1-2.7-5.1v-9.8c0-1.7.5-3,1.5-3.6Z"
                  transform="translate(0 0)"
                />
              </g>
            </g>
          </g>
          <g id="XMLID_2965" data-name="XMLID 2965">
            <g id="XMLID_2976" data-name="XMLID 2976">
              <g id="XMLID_2977" data-name="XMLID 2977">
                <g id="XMLID_2983_2" data-name="XMLID 2983 2">
                  <path
                    id="XMLID_2990"
                    data-name="XMLID 2990"
                    class="cls-3"
                    d="M55.8,204.3l-.2.2.9,4.4c0,.8,1.1,1.4,2.4,1.4s2.4-.6,2.4-1.4l.9-4.4-.2-.2Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_2984_2"
                    data-name="XMLID 2984 2"
                    class="cls-1"
                    d="M58.9,210.6c1.5,0,2.7-.8,2.7-1.7l.9-4.3a.6.6,0,0,0-.1-.4L62,204H55.8l-.4.2a.6.6,0,0,0-.1.4l.9,4.4C56.2,209.9,57.4,210.6,58.9,210.6Zm2.9-6-.9,4.2c0,.7-1,1.2-2.1,1.2s-2.1-.5-2.1-1.2l-.9-4.3h6Z"
                    transform="translate(0 0)"
                  />
                </g>
                <g id="XMLID_2978" data-name="XMLID 2978">
                  <path
                    id="XMLID_2982_2"
                    data-name="XMLID 2982 2"
                    class="cls-3"
                    d="M62.2,204.5c-.2,1-1.6,1.7-3.3,1.7s-3.2-.7-3.3-1.7,1.3-2,3.3-2S62.3,203.4,62.2,204.5Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_2979_2"
                    data-name="XMLID 2979 2"
                    class="cls-1"
                    d="M58.9,206.4c1.9,0,3.4-.8,3.6-1.9a1.4,1.4,0,0,0-.4-1.2,5.1,5.1,0,0,0-6.4,0,1.7,1.7,0,0,0-.4,1.2C55.5,205.6,57,206.4,58.9,206.4Zm3-2c-.1.8-1.5,1.4-3,1.4s-2.9-.6-3-1.4a.8.8,0,0,1,.2-.7,3.7,3.7,0,0,1,2.8-.9,4.7,4.7,0,0,1,2.8.9A.8.8,0,0,1,61.9,204.4Z"
                    transform="translate(0 0)"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_2971" data-name="XMLID 2971">
              <path
                id="XMLID_2975"
                data-name="XMLID 2975"
                class="cls-3"
                d="M61.5,204.4c-.1.7-1.3,1.2-2.6,1.2s-2.5-.5-2.6-1.2,1-1.4,2.6-1.4S61.6,203.7,61.5,204.4Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_2972"
                data-name="XMLID 2972"
                class="cls-1"
                d="M58.9,205.9c1.3,0,2.7-.5,2.9-1.4a.8.8,0,0,0-.2-.8,4.1,4.1,0,0,0-2.6-.9,3.1,3.1,0,0,0-2.6.9.8.8,0,0,0-.2.8C56.2,205.4,57.6,205.9,58.9,205.9Zm0-2.6a2.9,2.9,0,0,1,2.2.7.4.4,0,0,1,.1.3c-.1.4-1,.9-2.3.9s-2.2-.5-2.3-.9a.4.4,0,0,1,.1-.3A3.4,3.4,0,0,1,58.9,203.3Z"
                transform="translate(0 0)"
              />
            </g>
            <g id="XMLID_2966" data-name="XMLID 2966">
              <path
                id="XMLID_2970"
                data-name="XMLID 2970"
                class="cls-1"
                d="M56.6,204.9a3.3,3.3,0,0,1,2.2-.6,4.3,4.3,0,0,1,2.2.6,4,4,0,0,1-2.2.6A2.9,2.9,0,0,1,56.6,204.9Z"
                transform="translate(0 0)"
              />
              <path
                id="XMLID_2967"
                data-name="XMLID 2967"
                class="cls-1"
                d="M58.9,205.9a4,4,0,0,0,2.4-.7l.3-.2-.3-.2a4.6,4.6,0,0,0-4.8,0l-.3.2.3.2A4,4,0,0,0,58.9,205.9Zm1.7-1a5,5,0,0,1-3.4,0A5,5,0,0,1,60.6,204.9Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <path
        class="cls-2"
        d="M108.6,59.3V43.5L94.9,35.6a.6.6,0,0,0,.1.4,2.8,2.8,0,0,0,.1.9c0,.3.1.6.1.8a3.7,3.7,0,0,0,.2.9,2.9,2.9,0,0,0,.2.9c.1.3.1.6.2.8l.3,1.2c.1.1.1.3.2.5l.6,1.6h0A35.8,35.8,0,0,0,108.6,59.3Z"
        transform="translate(0 0)"
      />
      <polygon class="cls-2" points="111.8 45.4 111.7 60.5 117.7 57.1 124.8 52.9 111.8 45.4" />
      <path
        class="cls-2"
        d="M112.5,61.6a11.6,11.6,0,0,0,5.8,1.1h.1l.9-.2a6.8,6.8,0,0,0,2-.7c2.3-1.4,3.8-4.1,4.2-7.7Z"
        transform="translate(0 0)"
      />
      <polygon class="cls-2" points="125.7 34.3 121.9 36.6 112.5 42.1 125.7 49.8 125.7 34.3" />
      <polygon class="cls-2" points="111.9 25.7 111.8 40.9 124.9 33.3 111.9 25.7" />
      <g id="jamstackshadow">
        <path
          class="cls-1"
          d="M149.2,57.1c4.3-2.5,6.8-7.8,6.8-14.9h0V16.7h0a.9.9,0,0,0-.3-.6h-.2L133.6,3.3h-.1C127.3-.4,121.4-1,117,1.6L94.1,14.9H94c-4.3,2.6-6.7,7.8-6.7,14.8,0,14.3,10.1,31.8,22.5,39a19.8,19.8,0,0,0,10.3,3.2,13.2,13.2,0,0,0,6.2-1.5l.6-.4ZM94.8,16a11.8,11.8,0,0,1,5.5-1.4,19.7,19.7,0,0,1,9.7,3l21.9,12.7V55.5h0c0,6.6-2.3,11.5-6.2,13.8s-9.4,1.8-15.2-1.6c-12.1-7-21.9-24-21.9-37.9C88.6,23.2,90.8,18.3,94.8,16Z"
          transform="translate(0 0)"
        />
        <path
          class="cls-1"
          d="M343.7,151.7l6.8-5.2.4-.2c.2-.2.4-.4.4-.6h-.1a.6.6,0,0,0-.1-.4l-.4-.2-7-4.1H343l-4.7,2.8V130.3a.7.7,0,0,0-.3-.6l-6.1-3.5h-.6l-7.4,4.3a21.4,21.4,0,0,0-5.9-5.3c-3.1-1.8-6.1-2-8.3-.7l-5.7,3.3v-9.4a.7.7,0,0,0-.3-.6l-6.1-3.5c-.1-.2-.4-.2-.6,0h0l-.5.3a15,15,0,0,0-5-4.7c-3.7-2.2-6.2-1.7-7.7-.8l-6.3,3.6v-.5l2.6-1.6a.7.7,0,0,0,.4-.5v-5.4a.7.7,0,0,0-.4-.5h0l-2.5-1.4V95.2h0a.7.7,0,0,0-.4-.6l-6-3.5h-.6l-7,4.1a17.4,17.4,0,0,0-5-4.4c-2.7-1.5-5.2-1.8-6.8-.8l-4.2,2.4a16.5,16.5,0,0,0-2.2-6.8,14,14,0,0,0-5.6-5.7h-.2c-2.7-1.5-4.6-1.1-5.7-.4l-.6.3a14.5,14.5,0,0,0-5.7-7c-2.3-1.2-4.1-1.5-5.5-.8V71h0a.7.7,0,0,0-.3-.6h-.2l-5.5-3.2a.9.9,0,0,0-.7,0l-3.5,1.9V65h0a.9.9,0,0,0-.3-.6l-6.1-3.5h-.6l-.5.3a14.4,14.4,0,0,0-4.9-4.6c-3.7-2.2-6.3-1.6-7.7-.8l-5.3,3.1V42.5h0a.7.7,0,0,0-.4-.6l-6.9-4h-.6L156,51.2h-.2a.7.7,0,0,0-.3.6v7.4l-11.3,6.5a.9.9,0,0,0-.3.6h0a19,19,0,0,0,5.6,13.5,28.8,28.8,0,0,0,3.9,3,10.8,10.8,0,0,0,4.9,1.5,5.5,5.5,0,0,0,2.5-.7h.3l4.7-2.7c1.1,6.3,5,12.3,10.2,15.3,2.3,1.3,4.4,1.7,5.7.9v1.2a.7.7,0,0,0,.3.6l6.1,3.5h.7l3.4-2v4.2a.7.7,0,0,0,.3.6l6.1,3.5h.7l.2-.3,5.4-3.1v6.6c0,.2.2.4.4.6l6,3.5h.7c.1-.1.1-.2.2-.2l5.4-3.2V119a.7.7,0,0,0,.3.6l6.1,3.5h.3c.1,0,.2,0,.2.2a.5.5,0,0,0,.2-.4l2.9-1.7a18.5,18.5,0,0,0,7.7,9.1,10,10,0,0,0,4.8,1.5,6.9,6.9,0,0,0,2.4-.5,1,1,0,0,0,.5-.4l4.6-2.6v7.9a.9.9,0,0,0,.3.6l6.1,3.5h.7l4.4-2.5a22.2,22.2,0,0,0,9.2,11.7c2.3,1.3,4.4,1.6,5.7.9v1.2a.7.7,0,0,0,.4.5l6,3.5h.8l4.2-2.4c1.9,4.8,5.4,9.2,9.5,11.5a10,10,0,0,0,5.3,1.6,5.8,5.8,0,0,0,2.6-.6h.6l4.9-2.8v8.6a.7.7,0,0,0,.3.6l6.1,3.5h.6l3.1-1.7,1.9,4.8.2.3,6.9,4h.8v-.2l22.6-13.1a.8.8,0,0,0,.2-.9Zm-28.2,11.7c0-.1-.1-.3-.2-.3h-.7a.7.7,0,0,0-.4.6v10.2l-4.8-2.8v-30l4.8,2.8v16c0,.3.2.4.4.6h0a.6.6,0,0,0,.8,0l5.3-5,6,3.5-7,5.3a.8.8,0,0,0-.2.8l6.7,15.7-5-2.9Zm-20.2.3c-6-3.5-10.6-11.5-10.6-18.3,0-3.2,1.1-5.5,2.9-6.5a4,4,0,0,1,2.4-.7,10.3,10.3,0,0,1,4.5,1.4c4.8,2.8,8.8,8.5,10.2,14.3l-4.8-2.8a11.2,11.2,0,0,0-4.7-6c-1.9-1.1-3.2-.8-3.9-.4a5.5,5.5,0,0,0-1.8,4.2,11,11,0,0,0,5.2,9.3c2.6,1.6,4.1.7,4.9-.3l5.3,3.1a5.2,5.2,0,0,1-2.9,3.7c-1.8.8-4.2.5-6.7-1Zm-20.2-14.6a.9.9,0,0,0-.3-.6h-.1a.5.5,0,0,0-.7,0v.2c-.9,1.4-3.3.7-5.1-.4-5.8-3.3-9.9-10.8-9.9-17.9,0-3.3,1-5.7,2.8-6.8s3.9-.7,6.5.8a13.6,13.6,0,0,1,5.7,6.4c.1.2.1.3.3.3h.7a.7.7,0,0,0,.3-.6v-1.3h.3l4.5,2.7v22l-4.8-2.8Zm-26.3-30.9a.7.7,0,0,0-.3-.6l-2.8-1.6v-3.8l2.1,1.2h.7a.9.9,0,0,0,.3-.6v-6.7l4.8,2.8v7.5a.5.5,0,0,0,.3.5l2.6,1.5v3.9l-2-1.2h-.6a.7.7,0,0,0-.3.6v17l-4.8-2.8Zm-13,11.1a16.3,16.3,0,0,1-7.8-10.8l4.5,2.8a5.6,5.6,0,0,0,2.6,3.6,2.6,2.6,0,0,0,2.4.3,1.5,1.5,0,0,0,.7-1.4c0-1.8-1.4-3.2-2.5-4.4l-.4-.4-2.6-2.6c-3.1-3-4.7-6-4.7-8.5a3.8,3.8,0,0,1,1.4-3.3h.2a2.9,2.9,0,0,1,1.6-.4,8.1,8.1,0,0,1,3.7,1.2,14.6,14.6,0,0,1,7.3,10.1l-4.5-2.6a4.2,4.2,0,0,0-2.2-3.1,2,2,0,0,0-2-.2,2,2,0,0,0-.6,1.4c0,1.8,1.6,3.3,3.8,5.3s6.4,5.9,6.4,10.5q0,2.7-1.5,3.6c-1.3.7-3.5.3-5.8-1.1Zm-16.9-22.7c0-3-.4-5.9-3.5-7.6-1.3-.8-2.2-.9-3-.4s-1.4,2.5-1.4,3.9v11.6l-4.8-2.7V99c0-3.6-1.1-6-3.4-7.3s-2.3-.9-3.1-.4-1.4,2.7-1.4,4.2v11.3l-4.8-2.8V82l4.4,2.6v2.1c0,.3.2.6.4.6a.8.8,0,0,0,.8-.2c.9-1.2,2.5-1.2,4.8.2a13.8,13.8,0,0,1,5.6,7.2c.1.2.2.4.5.4s.5,0,.6-.2c1.6-2,3.9-1.3,5.6-.3a12.8,12.8,0,0,1,5.1,5.2c2.1,3.8,2.1,6.4,2.1,9.6v12.2l-4.8-2.8ZM183,95.8a.7.7,0,0,0-.3-.6h-.1a.5.5,0,0,0-.8.2c-.9,1.5-3.3.7-5.1-.3-5.8-3.3-9.9-10.8-9.9-17.9,0-3.3,1-5.8,2.8-6.8s3.9-.7,6.5.8a13.6,13.6,0,0,1,5.7,6.4l.2.3h.8c.1-.2.3-.4.3-.6V76l4.8,2.7v22l-4.8-2.8ZM145.3,67.5l6.1,3.6c.1,1.8.5,3.9,2.4,5a2,2,0,0,0,2,.2c1-.6,1.1-2.1,1.1-3.6V53l5.6,3.2V74.9c0,2.8,0,6-1.5,7.3s-4.2,1.1-6.9-.4a19.3,19.3,0,0,1-3.6-2.8A16.8,16.8,0,0,1,145.3,67.5Z"
          transform="translate(0 0)"
        />
      </g>
      <path
        class="cls-3"
        d="M110.5,67.7c5.8,3.4,11.1,3.9,15.2,1.6s6.2-7.2,6.2-13.8h0V30.3L110,17.6a19.7,19.7,0,0,0-9.7-3A11.8,11.8,0,0,0,94.8,16c-4,2.3-6.2,7.2-6.2,13.8C88.6,43.7,98.4,60.7,110.5,67.7Zm-1.3-6.4-.3-.2c-8.4-5.3-15-16.8-15.4-26.6a.7.7,0,0,1,.3-.6c.2-.2.5-.2.6,0l15.2,8.7a.9.9,0,0,1,.3.6V60.7c0,.2-.2.4-.4.6S109.3,61.3,109.2,61.3Zm17.4-8.9a.9.9,0,0,1,.3.6c-.2,4.6-2,8.1-5,9.8a7.8,7.8,0,0,1-4.5,1.2,13.8,13.8,0,0,1-6.6-1.7.7.7,0,0,1-.4-.6V44.3a.7.7,0,0,1,.3-.6.5.5,0,0,1,.7,0Zm.1-19.6a.9.9,0,0,1,.3.6V50.9a.9.9,0,0,1-.3.6h-.6l-15.2-8.9a.7.7,0,0,1-.3-.6V24.7a.7.7,0,0,1,.3-.6c.1-.2.4-.2.6,0h0Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-1"
        d="M109.9,60.7V43.2a.9.9,0,0,0-.3-.6L94.4,33.9c-.1-.2-.4-.2-.6,0a.7.7,0,0,0-.3.6c.4,9.8,7,21.3,15.4,26.6l.3.2h.3C109.5,61.4,109.9,60.9,109.9,60.7Zm-13-17.1L96.3,42c-.1-.2-.1-.4-.2-.5l-.3-1.2c-.1-.2-.1-.5-.2-.8a2.9,2.9,0,0,1-.2-.9c-.1-.3-.1-.6-.2-.9a2.2,2.2,0,0,1-.1-.8A2.8,2.8,0,0,1,95,36a.6.6,0,0,1-.1-.4l13.7,7.9V59.3A35.5,35.5,0,0,1,96.9,43.7Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-1"
        d="M111.5,43.7a.5.5,0,0,0-.7,0,.7.7,0,0,0-.3.6V61.7a.7.7,0,0,0,.4.6,13.8,13.8,0,0,0,6.6,1.7,7.8,7.8,0,0,0,4.5-1.2c3-1.7,4.8-5.2,5-9.8a.9.9,0,0,0-.3-.6Zm9.8,18.1a6.8,6.8,0,0,1-2,.7l-.9.2h-.1a11.6,11.6,0,0,1-5.8-1.1l13-7.5C125.1,57.7,123.6,60.4,121.3,61.8Zm-3.6-4.7-6,3.4V45.4l13,7.5Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-1"
        d="M110.9,24.1a.7.7,0,0,0-.3.6V42a.7.7,0,0,0,.3.6l15.2,8.9h.6a.9.9,0,0,0,.3-.6V33.4a.9.9,0,0,0-.3-.6l-15.2-8.7c-.1-.2-.4-.2-.6,0Zm1.6,18,9.4-5.5,3.8-2.2V49.8Zm-.7-1.2V25.8l13,7.5Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M154.1,81.8c2.7,1.5,5.3,1.7,6.9.4s1.5-4.5,1.5-7.3V56.2L156.8,53V72.7c0,1.5-.1,3-1.1,3.6a2,2,0,0,1-2-.2c-1.9-1.1-2.3-3.2-2.4-5l-6.1-3.6A17.1,17.1,0,0,0,150.4,79,20,20,0,0,0,154.1,81.8Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M187.8,84.5V78.7L183,76v1.3c0,.2-.2.4-.3.6h-.8l-.2-.3a13.6,13.6,0,0,0-5.7-6.4c-2.6-1.5-4.8-1.8-6.5-.8s-2.8,3.5-2.8,6.8c0,7.1,4.1,14.6,9.9,17.9,1.8,1,4.2,1.8,5.1.3a.5.5,0,0,1,.8-.2h.1a.7.7,0,0,1,.3.6v2.1l4.8,2.8ZM179.6,91a6.2,6.2,0,0,1-2.7-.9,11.6,11.6,0,0,1-5.3-9.4c0-1.9.6-3.4,1.8-4.1a4.2,4.2,0,0,1,4.2.4,11.8,11.8,0,0,1,5.4,9.5c0,1.9-.6,3.4-1.8,4A3,3,0,0,1,179.6,91Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-1"
        d="M183,86.5a11.8,11.8,0,0,0-5.4-9.5,4.2,4.2,0,0,0-4.2-.4c-1.2.7-1.8,2.2-1.8,4.1a11.6,11.6,0,0,0,5.3,9.4,6.2,6.2,0,0,0,2.7.9,3,3,0,0,0,1.6-.5C182.4,89.9,183,88.4,183,86.5Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M223.6,109.2c0-3.2,0-5.8-2.1-9.6a12.8,12.8,0,0,0-5.1-5.2c-1.7-1-4-1.7-5.6.3-.1.2-.4.2-.6.2a.7.7,0,0,1-.5-.4,13.8,13.8,0,0,0-5.6-7.2c-2.3-1.4-3.9-1.4-4.8-.2a.8.8,0,0,1-.8.2c-.2,0-.4-.3-.4-.6V84.6L193.7,82v22l4.8,2.8V95.5c0-1.5.1-3.5,1.4-4.2s1.9-.3,3.1.4,3.4,3.7,3.4,7.3v12.4l4.8,2.7V102.5c0-1.4.2-3.2,1.4-3.9s1.7-.4,3,.4c3.1,1.7,3.5,4.6,3.5,7.6l-.2,12,4.8,2.8Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M241.6,130.3q1.5-.9,1.5-3.6c0-4.6-3.6-7.9-6.4-10.5s-3.8-3.5-3.8-5.3a2,2,0,0,1,.6-1.4,2,2,0,0,1,2,.2,4.2,4.2,0,0,1,2.2,3.1l4.5,2.6a14.6,14.6,0,0,0-7.3-10.1,8.1,8.1,0,0,0-3.7-1.2,2.9,2.9,0,0,0-1.6.4h-.2a3.8,3.8,0,0,0-1.4,3.3c0,2.5,1.6,5.5,4.7,8.5l2.6,2.6.4.4c1.1,1.2,2.5,2.6,2.5,4.4a1.5,1.5,0,0,1-.7,1.4,2.6,2.6,0,0,1-2.4-.3,5.6,5.6,0,0,1-2.6-3.6l-4.5-2.8a16.3,16.3,0,0,0,7.8,10.8C238.1,130.7,240.3,131.1,241.6,130.3Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M253.6,121.7a.7.7,0,0,1,.3-.6h.6l2,1.2v-3.9l-2.6-1.5a.5.5,0,0,1-.3-.5v-7.5l-4.8-2.8v6.7a.9.9,0,0,1-.3.6h-.7l-2.1-1.2V116l2.8,1.6a.7.7,0,0,1,.3.6v17.7l4.8,2.8Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M280,137.8v-5.7l-4.5-2.7h-.3v1.3a.7.7,0,0,1-.3.6h-.7c-.2,0-.2-.1-.3-.3a13.6,13.6,0,0,0-5.7-6.4c-2.6-1.5-4.8-1.8-6.5-.8s-2.8,3.5-2.8,6.8c0,7.1,4.1,14.6,9.9,17.9,1.8,1.1,4.2,1.8,5.1.4a.4.4,0,0,1,.6-.3h.3a.9.9,0,0,1,.3.6v2.2l4.8,2.8Zm-11,5.7a11.9,11.9,0,0,1-5.3-9.4c0-2,.6-3.5,1.9-4.1a4.1,4.1,0,0,1,4.1.4,11.4,11.4,0,0,1,5.4,9.5c0,2-.6,3.4-1.8,4a2.6,2.6,0,0,1-1.5.4A5.4,5.4,0,0,1,269,143.5Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-1"
        d="M273.3,143.9c1.2-.6,1.8-2,1.8-4a11.4,11.4,0,0,0-5.4-9.5c-1.6-.9-3-1.1-4.1-.4a4.6,4.6,0,0,0-1.9,4.1,11.9,11.9,0,0,0,5.3,9.4,5.4,5.4,0,0,0,2.8.8A2.6,2.6,0,0,0,273.3,143.9Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M304.9,161l-5.3-3.1c-.8,1-2.3,1.9-4.9.3a11,11,0,0,1-5.2-9.3c0-2,.7-3.5,1.8-4.2s2-.7,3.9.4a11.2,11.2,0,0,1,4.7,6l4.8,2.8c-1.4-5.8-5.4-11.5-10.2-14.3a10.3,10.3,0,0,0-4.5-1.4,4,4,0,0,0-2.4.7c-1.8,1-2.9,3.3-2.9,6.5,0,6.8,4.6,14.8,10.6,18.3,2.5,1.5,4.9,1.8,6.7,1A5.2,5.2,0,0,0,304.9,161Z"
        transform="translate(0 0)"
      />
      <path
        class="cls-2"
        d="M321.2,177.9l5,2.9-6.7-15.7a.8.8,0,0,1,.2-.8l7-5.3-6-3.5-5.3,5a.6.6,0,0,1-.8,0h0c-.2-.2-.4-.3-.4-.6v-16l-4.8-2.8V171l4.8,2.8V163.6a.7.7,0,0,1,.4-.6h.7c.1,0,.2.2.2.3Z"
        transform="translate(0 0)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    virtual() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-virtual",
            toggleActions: this.toggleConfig,
            start: "center 60%",
          },
          defaults: {
            duration: 1,
            transformOrigin: "50% 50%",
            ease: "back.out(1)",
          },
        })
        .add("virtual")
        .from(
          "#Conference > g",
          {
            opacity: 0,
            scale: 0,
            stagger: 0.06,
          },
          "virtual"
        )
        .from(
          "#Shadowjm_1, #Shadowjm_2, #Shadowjm_3, #Shadowjm_4",
          {
            opacity: 0,
          },
          "virtual+=1"
        );
    },
  },
  mounted() {
    this.virtual();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #0e1e25;
}

.cls-2 {
  fill: #fff;
}

.cls-3 {
  fill: #ffad43;
}

.cls-4 {
  fill: #caa677;
}

.cls-5 {
  fill: #caa577;
}

.cls-6 {
  fill: #8e6f46;
}
</style>